
<style>


.pov90
{
  writing-mode: tb-rl;
  transform: rotate(180deg);
  max-width:100px;
  max-height:100px;
  line-height:0.8rem

}


  @page {
      size:A4 portrait;
      margin-left: 0px;
      margin-right: 0px;
      margin-top: 0px;
      margin-bottom: 0px;
      margin: 0;
      -webkit-print-color-adjust: exact;
      background: rgb(255, 255, 255);
  }

  body
    {

      background-image: url("/fon.png") ;
      background-repeat: repeat;;

    }

  </body>
  .sortable-chosen {
    opacity: 0.7;
    background-color: #dcdcdc;
  }

    #toplivotable .v-input.v-text-field>.v-input__control>.v-input__slot:before {
    border: none;

  }

  #toplivotable .v-input.v-text-field {

  font-size:11pt;
  padding-left:5px;
}

  #toplivotable
  {
    border-collapse: collapse;
  }



  #toplivotable th,  #toplivotable td
  {
    border: 1px solid rgb(224, 224, 224);
     color:rgb(0, 0, 0);
     text-indent: 5px;
     text-align: center;
         font-size: 0.875rem;


  }
  #toplivotable  .v-textarea textarea {

    line-height: 0.95rem;
    color:#205643

  }

  #toplivotable  .v-textarea {


    margin-top:-20px;
  }

  .sortable-ghost {
    background-color: #dcdcdc;
  }

  .flip-list-move {
    transition: transform 0.1s;
  }

  .no-move {
    transition: transform 0s;
  }

  .ghost {
    opacity: 0.85;
    background: #64fa6a;
  }

  .list-group {
    min-height: 20px;
  }

  <style>.image {

    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    border: 10px solid #ebebeb;

    margin: 0 auto;


  }

  .link {
    border-top: 35px solid transparent;
    padding: 5px;
    -moz-background-clip: padding;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    display: inline-block;
    padding-top: 78px;
    margin-top: -78px;
  }

  .head_podacha {
    margin: 0 auto;
    margin-top: 15px;
    margin-bottom: 5px;
    padding: 10px;
    border-radius: 10px;
    background: #f0f0f0;
    color: #717171;
    word-wrap: break-word;
    font-size: 1.2rem;
    max-width: 95%;
    min-width: 400px;
    line-height: 2.1rem;
    text-align: justify;
    border: 1px solid rgb(219, 218, 218);
    box-shadow: 2px 2px 1px rgba(142, 139, 139, 0.15);
    z-index: 35;



  }

  .head_podacha_green {
    margin: 0 auto;
    margin-top: 15px;
    margin-bottom: 5px;
    padding: 10px;
    border-radius: 10px;
    background: #dfffd0;
    color: #3ab800;
    font-size: 1.2rem;
    width: 95%;
    line-height: 2.1rem;
    text-align: left;
    border: 1px solid rgb(219, 218, 218);
    box-shadow: 2px 2px 1px rgba(142, 139, 139, 0.15);
    z-index: 35;



  }

  .selected {
    background-color: #f9c7c8;
    border: solid red 1px;
  }

  .flip-list-move {
    transition: transform 0.1s;
  }

  .no-move {
    transition: transform 0s;
  }

  .ghost {
    opacity: 0.85;
    background: #64fa6a;
  }

  .list-group {
    min-height: 20px;

  }


  @page WordSection1
  {size:841.9pt 595.3pt;
    mso-page-orientation:landscape;
    margin:3.0cm 2.0cm 42.5pt 2.0cm;
    mso-header-margin:35.4pt;
    mso-footer-margin:35.4pt;
    mso-paper-source:0;}

.pe-read-only .v-window-item input,
.pe-read-only .v-window-item textarea,
.pe-read-only .v-window-item [contenteditable="true"],
.pe-read-only .v-window-item .v-input,
.pe-read-only .v-window-item .v-btn {
  pointer-events: none !important;
}

.pe-read-only .v-window-item .v-input,
.pe-read-only .v-window-item .v-btn {
  opacity: 0.72;
}
</style>


<template>

<div class="">


  <v-dialog
        v-model="dialogpe"
        transition="dialog-bottom-transition"
        persistent
        fullscreen


      >
  <v-card :class="{'pe-read-only': peReadOnly}" elevation="8" style="border-radius:25px; border:1px solid rgb(233, 233, 233);min-width:750px;">

  <v-system-bar color="#009d10" outlined class="white--text" style="height:50px; font-size:0.9rem; padding-left:20px;">

  Программа энергосбережения
  <v-icon  v-if="pe.sphere" large class="white--text">mdi mdi-menu-right</v-icon> {{pe.sphere}}
  <span v-if="(pe.god_ot!==''&& pe.god_do!=='' )" > <v-icon  large class="white--text">mdi mdi-menu-right</v-icon> на {{peperiodtext()}}</span>
  <v-icon v-if="pe.priznak" large class="white--text">mdi mdi-menu-right</v-icon> {{pe.priznak}}
  <v-icon v-if="pe.invest" large class="white--text">mdi mdi-menu-right</v-icon>{{ (pe.invest)?'К инвестпрограмме':'' }}


  <v-spacer />
  <v-spacer />
  <v-spacer />

  <span class="caption mx-2" v-if="lastsavetime">Сохранено в {{lastsavetime}}</span>
  <v-btn :disabled="peReadOnly" rounded v-on="on" small fab outlined style="border-color: rgb(50, 210, 43); background-color:rgb(27, 108, 24); float:right; ">
      <v-icon style="color: rgb(50, 210, 43);" @click="saveDelo();">mdi-content-save</v-icon>
  </v-btn>


</v-system-bar>
<v-alert
  v-if="peReadOnly"
  dense
  tile
  type="warning"
  class="mb-0"
>
  ПЭ открыта другим пользователем. Данные обновляются с сервера каждые 20 секунд; редактирование временно недоступно.
</v-alert>
<v-system-bar v-if="showwidth()<1200" class="body-0 pr-2 mt-4 pl-2 mb-4 text-center" style="line-height:1.2rem; color:#333; border:1px solid rgb(207, 212, 207);  min-height:60px; border-radius:15px;"><v-icon large  class="mr-2" >mdi-monitor-screenshot</v-icon><v-icon large  class="mr-2" >mdi-cellphone-off</v-icon> Используйте монитор</v-system-bar>


  <v-tabs vertical  outlined v-model="tabpe" color="success"   class="mb-5 mr-5 black--text" style="justify-content:left;" slider-color="rgb(180, 182, 181)" slider-size="7" active-class="grey lighten-4" >

    <v-tab style="justify-content:left; "  @click="closeallmer();closeallter();showwordpe=false; showwordreport=false;">
      <v-icon class="mr-1">
      mdi-tag-text-outline
      </v-icon>
      Наименование
    </v-tab>
    <v-tab style="justify-content:left;" @click="closeallmer();closeallter();showwordpe=false;showwordreport=false;">

      <v-icon class="mr-1">
      mdi-fire
      </v-icon>
      Расходы ТЭР
    </v-tab>




    <v-tab style="justify-content:left;"  @click="closeallmer();closeallter();showwordpe=false;showwordreport=false;">
      <v-icon class="mr-1">
      mdi-table-star
      </v-icon>
      Показатели
    </v-tab>
    <v-tab style="justify-content:left;"  @click="closeallmer();closeallter();showwordpe=false;showwordreport=false;">
      <v-icon class="mr-1">
      mdi-clipboard-list-outline
      </v-icon>
      Мероприятия
    </v-tab>
    <v-tab style="justify-content:left;"  @click="closeallmer();closeallter();showwordpe=false;showwordreport=false;">
      <v-icon class="mr-1">
      mdi-file-document-check
      </v-icon>
      Приложения к ПЭ
    </v-tab>

    <v-tab style="justify-content:left;"  @click="closeallmer();closeallter();showwordpe=false;showwordreport=false;">
      <v-icon class="mr-1">
      mdi-folder-text-outline
      </v-icon>
      Описания
    </v-tab>
    <v-tab style="justify-content:left; border-top: 3px solid rgba(203, 202, 202, 0.32); "  @click="closeallmer();closeallter();showwordpe=true;showwordreport=false;">
      <v-icon class="mr-1">
        mdi-book-open-page-variant
      </v-icon>
      ПЭ
    </v-tab>
    <v-tab style="justify-content:left;"  @click="closeallmer();closeallter();showwordreport=false;showwordpe=false;setgodotcheta();">
      <v-icon class="mr-1">
      mdi-poll
      </v-icon>
      Отчёт к ПЭ
    </v-tab>
    <v-tab style="justify-content:left; border-top: 3px solid rgba(203, 202, 202, 0.32)"  @click="closeallmer();closeallter();">
      <v-icon class="mr-1">
      mdi-cog
      </v-icon>
      Настройки
    </v-tab>


    <v-tab-item   >
      <v-app-bar


          floating
          light
          dense
          style="background:url('/fon-3.png');; width:100%"
          elevation="0"

      >
        <v-card-title>
          <table>
            <tr>
              <td style="width:90vw">
                <v-icon class="mr-2">
                  mdi-tag-text-outline
                </v-icon>Описание программы энергосбережения
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                <sup>
                  <v-btn
                  v-bind="attrs"
                  v-on="on"


                  @click=" closeallmer();closeallter();tabpe=6; showwordpe=true;"
                  href="#passport"

                    text
                  x-small
                  :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"


                  color="success"  style="text-shadow:  #8af025 0px 0px 2px; margin-left:-7px ;  "

      > ПЭ
      <v-icon small  color="success"  style="text-shadow:  #8af025 0px 0px 2px;
      ">
       mdi-open-in-new
      </v-icon>

              </v-btn></sup>
            </template>
            <span>Просмотреть паспорт программы энергосбережения</span>
          </v-tooltip>

                </td>

              <td style="width:10vw; min-width:250px"> </td>
            </tr>
          </table>









        </v-card-title>

      </v-app-bar>

      <v-card elevation="2" class="pb-5   mb-0" style="  border: 1px solid  rgb(194, 194, 194);border-radius:0px;background:url('/fon-5.png'); height:81vh; width:89vw; min-width:530px; overflow-y:scroll;
">



      <v-container>
          <v-row>



            <v-col
              style="width:510px; height:420px;"
                >

            <v-card elevation="8" class="mt-2 mb-2 mr-2 ml-2" style="border-radius:20px;  min-height:380px; min-width:500px"
            max-width="500"
            >

                        <v-card-title >
                          <v-icon class="mr-2 ml-3">
                            mdi-tag-outline
                        </v-icon>Наименование программы
                        </v-card-title>


                        <v-card-text>


                          <v-container>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="4"

                          @mouseup="(pe.date_sogl==='')? pe.date_sogl=((new Date().getFullYear())+'-04-01'):pe.date_sogl=pe.date_sogl;"
                          >





                          <v-menu
                          v-model="menusogl"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"

                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :v-model="pe.date_sogl"



                              readonly
                              v-bind="attrs "
                              :value="pe.date_sogl | datarus"
                              v-on="on"
                              dense
                              filled
                              persistent-hint
                              hint="Дата утверждения программы"
                              style="margin-top:-12px;"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="pe.date_sogl"
                            @input="menusogl = false"
                            locale="ru-ru"

                            :first-day-of-week="1"
                          ></v-date-picker>
                        </v-menu>






                          </v-col>

                          <v-col
                          cols="12"

                          sm="4"
                          >
                          <v-autocomplete
                          style="margin-top:-12px;"
                            v-model.number="pe.god_ot"
                            filled
                            :items="new Array(100).fill(null).map((_, i) => i +(new Date().getFullYear())-20)"

                            persistent-hint
                            hint="Год начала программы"

                            :rules="[v => (/^[0-9]*$/.test(v) & v>2021& v<2100) || 'Неверный ввод']"
                            @click="(pe.god_ot==='')? pe.god_ot=(new Date().getFullYear())+1:pe.god_ot=pe.god_ot; "



                            dense

                          ></v-autocomplete>

                          </v-col>


                          <v-col
                          cols="12"

                          sm="4"
                          >
                          <v-autocomplete
                          style="margin-top:-12px;"
                            v-model="pe.god_do"
                            persistent-hint
                            hint="Год окончания программы"

                            :items="new Array(100).fill(null).map((_, i) => i +(pe.god_ot))"
                            :rules="[v => (/^[0-9]*$/.test(v) & v>=pe.god_ot& v<2100) || 'Неверный ввод']"
                            @click="(pe.god_do==='')? pe.god_do=Number(pe.god_ot)+4:pe.god_do=pe.god_do; "
                            dense
                            filled

                          ></v-autocomplete>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                          >

                            <v-autocomplete
                      v-model="pe.sphere"
                      :items="show_pe_vd()"
                      dense
                                  label="Вид деятельности для разработки программы"
                    ></v-autocomplete>
                          </v-col>

                          <v-col
                            cols="12"
                            sm="12"
                          >
                          <v-text-field
                            style="margin-top:-12px;"
                            v-model="pe.priznak"
                            label="Дифференцирующий признак (если требуется)"
                            dense

                          ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="12"
                          >


                          <v-checkbox
                          v-model="pe.invest"
                          color="success"
                          style="margin-top:-12px;"
                          label="Является частью инвестпрограммы"
              ></v-checkbox>
                          </v-col>




                        </v-row>
                      </v-container>










                    </v-card-text>
                  </v-card>

                </v-col>




              <v-col
                style="width:510px; height:420px;"
                  >

<v-card elevation="8" class="mt-2 mb-2 mr-2 ml-2" style="border-radius:20px;  min-height:380px; min-width:500px"
    max-width="500"
  >

      <v-card-title >
        <v-icon class="mr-2 ml-3">
        mdi-factory
      </v-icon>Карточка организации



      <v-btn
          rounded
          :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
          small
          style="box-shadow: #2DA820 1px 1px 2px; text-shadow:  #ffffff 0px 0px 3px;;
          background-image: radial-gradient( circle 100px at 1.1% 15.3%,  rgba(212,171,255,0.82) 50%, rgba(0,246,153,0.52) 100% );
          ;border-radius:20px; text-shadow: #001c5c 1px 1px 2px;margin-left: 10px  "

        @click="innfill=true;" color="success">
        <v-icon class="mr-1">
          mdi-checkbox-marked-circle-auto-outline
        </v-icon>заполнить по ИНН
      </v-btn>
      </v-card-title>


      <v-card-text>


        <v-container>
      <v-row>
        <v-col
          cols="12"
          sm="12"
        >
          <v-text-field
            v-model="pe.org"
            label="Организация"
            dense
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          sm="12"
        >
        <v-text-field
          rows="2"
          style="margin-top:-12px;"
          v-model="pe.pocht_address"
          label="Почтовый адрес"
          dense

        ></v-text-field>
        </v-col>





      </v-row>
    </v-container>
    <v-container>
  <v-row>
    <v-col
      cols="12"
      sm="12"
    >
      <v-text-field
        v-model="pe.ruk_dolg"
        style="margin-top:-12px"
        label="Должность руководителя (лица, утвердившего ПЭ)"
        dense
      ></v-text-field>
    </v-col>

    <v-col
      cols="12"
      sm="12"
    >
    <v-text-field
      style="margin-top:-12px;"
      v-model="pe.ruk_fio"
      @input="pe.ruk_sokr=sokr_fio_make(pe.ruk_fio)"
      @change="firma.sokr_fio_dir=sokr_fio_make(firma.fio_dir)"
      label="ФИО руководителя (лица, утвердившего ПЭ)"
      dense

    ></v-text-field>
    </v-col>
    <v-col
      cols="12"
      sm="12"
    >
    <v-text-field
      style="margin-top:-12px;"
      v-model="pe.ruk_sokr"
      label="ФИО (сокращенно, для подписания документов)"
      dense

    ></v-text-field>
    </v-col>




  </v-row>
</v-container>










  </v-card-text>
</v-card>

</v-col
  >
            <v-col
                style="width:510px; height:420px;"
            >

              <v-card elevation="8" class="mt-2 mb-2 mr-2 ml-2" style="border-radius:20px;  min-height:380px; min-width:500px"
                      max-width="500"
              >

                <v-card-title >
                  <v-icon class="mr-2 ml-3">
                    mdi-id-card
                  </v-icon>Реквизиты организации


                </v-card-title>


                <v-card-text>


                  <v-container>
                    <v-row>
                      <v-col
                          cols="12"
                          sm="12"
                      >
                        <v-text-field
                            v-model="pe.inn"
                            label="ИНН"
                            dense
                            style="width:49%;display:inline-block; margin-right:10px"
                        ></v-text-field>

                        <v-text-field
                            rows="2"
                            style="margin-top:-12px; width:48%; display:inline-block"
                            v-model="pe.kpp"
                            label="КПП"
                            dense

                        ></v-text-field>
                      </v-col>





                    </v-row>
                  </v-container>
                  <v-container>
                    <v-row>
                      <v-col
                          cols="12"
                          sm="12"
                      >
                        <v-text-field
                            v-model="pe.okpo"
                            style="margin-top:-12px"
                            label="ОКПО"
                            dense
                        ></v-text-field>
                      </v-col>

                      <v-col
                          cols="12"
                          sm="12"
                      >
                        <v-text-field
                            style="margin-top:-12px;"
                            v-model="pe.ogrn"

                            label="ОГРН"
                            dense

                        ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="12"
                      >

                        <v-row>
                          <v-col
                              cols="12"
                              sm="12"
                          >
                            <v-text-field
                                v-model="pe.osn_vd"
                                style="margin-top:-12px"
                                label="Основной вид деятельности"
                                dense
                            ></v-text-field>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="12"
                          >
                            <v-text-field
                                v-model="pe.phone"
                                label="Телефон"
                                dense
                                filled
                                style="width:49%;display:inline-block;margin-top:-35px;margin-bottom:-20px;  margin-right:10px"
                            ></v-text-field>

                            <v-text-field
                                rows="2"
                                style="margin-top:-35px; margin-bottom:-20px; width:48%; display:inline-block"
                                v-model="pe.email"
                                label="E-mail"
                                dense
                                filled

                            ></v-text-field>
                          </v-col>






                        </v-row>


                      </v-col>




                    </v-row>
                  </v-container>










                </v-card-text>
              </v-card>

            </v-col
            >




  <v-col
    style="width:510px; height:420px;"
      >

<v-card elevation="8" class="mt-2 mb-2 mr-2 ml-2" style="border-radius:20px;  min-height:380px; min-width:500px"
max-width="500"
>


    <v-card-title >
      <v-icon class="mr-2">
      mdi-information-variant
    </v-icon>Индексы, коэффициенты и другое


    </v-card-title>
    <v-card-text style=" margin-top:0px;">



      <v-text-field
      style="min-width:250px;"

        filled
        v-model="pe.discont"




        persistent-hint
        hint="Ставка дисконтирования (по умолчанию), %"
        type="number"
        :rules="[v => (/^[0-9]/.test(v) & v>0& v<100) || 'Неверный ввод']"

        dense

      ></v-text-field>

      <v-text-field
      style="min-width:250px;"
        v-model="pe.inflation"
        filled

        persistent-hint
        hint="Ожидаемая среднегодовая инфляция (по умолчанию), %"
        type="number"
        :rules="[v => (/^[0-9]/.test(v) & v>0& v<100) || 'Неверный ввод']"

        dense

      ></v-text-field>


      <v-text-field
      style="min-width:250px;"
        v-model="pe.fact_god"
        filled

        persistent-hint

        hint="Последний завершённый год"
        type="number"

        @click="pe.fact_god===''?pe.fact_god=(new Date().getFullYear())-1:pe.fact_god=pe.fact_god "
        :rules="[v => (/^[0-9]/.test(v) & v<(new Date().getFullYear())) || 'Неверный ввод']"

        dense

      ></v-text-field>


            <v-text-field
                style="min-width:250px;"
                v-model="pe.summa_po_invest"
                filled

                persistent-hint

                hint="Затраты по инвестпрограмме (при наличии ИП), рублей"
                type="number"

                @click="pe.fact_god===''?pe.fact_god=(new Date().getFullYear())-1:pe.fact_god=pe.fact_god "
                :rules="[v => /^[0-9]/.test(v) || 'Неверный ввод']"

                dense

            ></v-text-field>












</v-card-text>

  </v-card>

  </v-col>







      <v-col
        style="width:510px; height:420px;"
          >

<v-card elevation="8" class="mt-2 mb-2 mr-2 ml-2" style="border-radius:20px;  min-height:380px; min-width:500px"
max-width="500"
>

            <v-card-title >
              <v-icon class="mr-2 ml-3">
              mdi-account-multiple
            </v-icon>Согласующие лица

            <v-btn x-small class="ml-3" rounded dense @click="pe.sogl.push({
              sogl_dolg:'',
              sogl_fio:'',
              sogl_sokr:'',
            })"
            color="success"
            ><v-icon  small class="mr-1">
              mdi-plus
            </v-icon>добавить</v-btn>

            <v-btn x-small rounded fab class="ml-2"
            style="box-shadow: #2DA820 1px 1px 2px; text-shadow:  #ffffff 0px 0px 3px;;
            background-image: radial-gradient( circle 30px at 1.1% 15.3%,  rgba(212,171,255,0.82) 50%, rgba(0,246,153,0.52) 100% );
            ;border-radius:20px; text-shadow: #001c5c 1px 1px 2px;margin-left: 10px  "

            dense @click="copysogl();"
                   color="success lighten-1"
            ><v-icon  >
              mdi-content-copy
            </v-icon>
            </v-btn>

            <v-btn x-small rounded fab class="ml-2"
            style="box-shadow: #2DA820 1px 1px 2px; text-shadow:  #ffffff 0px 0px 3px;;
            background-image: radial-gradient( circle 30px at 1.1% 15.3%,  rgba(212,171,255,0.82) 50%, rgba(0,246,153,0.52) 100% );
            ;border-radius:20px; text-shadow: #001c5c 1px 1px 2px;margin-left: 10px  "

            dense @click="pastesogl()"
                   color="success lighten-1"
            ><v-icon  >
              mdi-content-paste
            </v-icon>
            </v-btn>
            </v-card-title>



            <v-card-text style=" margin-top:-15px;">


              <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
              >






                      <v-data-table single-select id="persons" height="280" :headers="headers2" :items="pe.sogl" dense :items-per-page="100000" light :hide-default-footer="true" class="elevation-1">



                        <template  v-slot:item.sogl_fio="{ item }">

                          <div style="line-height:0.8rem;padding-top:7px; border:1px solid rgb(198, 198, 198); border-radius:7px; padding:7px; margin:10px; box-shadow:1px 1px rgb(208, 208, 208); background:rgba(226, 255, 212, 0.21)">


                            <v-btn icon outlined x-small color="rgba(231, 17, 17, 0.42)" style="margin-top:0%;margin-left:0%" @click="  {pe.sogl.splice(pe.sogl.indexOf(item), 1)}">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          <span style="font-size:8pt; color:grey">ФИО: </span>
                            <input @input="item.sogl_sokr=sokr_fio_make(item.sogl_fio)" @change="item.sogl_sokr=sokr_fio_make(item.sogl_fio)" light
                            style="width:85%;height:50%; border-bottom:1px solid rgb(180, 180, 180);" v-model="item.sogl_fio">
                            <br/><span style="font-size:8pt; color:grey">Долж: </span>
                            <input light style="width:90%;height:50%; border-bottom:1px solid rgb(180, 180, 180);" v-model="item.sogl_dolg">
                            <br/><span style="font-size:8pt; color:grey">ФИО (сокр.): </span>
                            <input light style="width:81%;height:50%; border-bottom:1px solid rgb(180, 180, 180);margin-bottom:7px" v-model="item.sogl_sokr">
                          </div>
                        </template>









                      </v-data-table>

              </v-col>




            </v-row>
          </v-container>










        </v-card-text>

      </v-card>

      </v-col>

      <v-col
        style="width:510px; height:420px;"
          >

<v-card elevation="8" class="mt-2 mb-2 mr-2 ml-2" style="border-radius:20px;  min-height:380px; min-width:500px"
max-width="500"
>


        <v-card-title >
          <v-icon class="mr-2 ml-3">
          mdi-account-multiple
        </v-icon>Ответственные лица

        <v-btn x-small rounded class="ml-3" dense @click="pe.otv.push({
          otv_dolg:'',
          otv_fio:'',
          otv_sokr:'',
          phone:''
        })"
               color="success"
        ><v-icon small class="mr-1">
          mdi-plus
        </v-icon>добавить
        </v-btn>

        <v-btn x-small rounded fab class="ml-2"
        style="box-shadow: #2DA820 1px 1px 2px; text-shadow:  #ffffff 0px 0px 3px;;
        background-image: radial-gradient( circle 30px at 1.1% 15.3%,  rgba(212,171,255,0.82) 50%, rgba(0,246,153,0.52) 100% );
        ;border-radius:20px; text-shadow: #001c5c 1px 1px 2px;margin-left: 10px  "

        dense @click="copyotv();"
               color="success lighten-1"
        ><v-icon  >
          mdi-content-copy
        </v-icon>
        </v-btn>

        <v-btn x-small rounded fab class="ml-2"
        style="box-shadow: #2DA820 1px 1px 2px; text-shadow:  #ffffff 0px 0px 3px;;
        background-image: radial-gradient( circle 30px at 1.1% 15.3%,  rgba(212,171,255,0.82) 50%, rgba(0,246,153,0.52) 100% );
        ;border-radius:20px; text-shadow: #001c5c 1px 1px 2px;margin-left: 10px  "

        dense @click="pasteotv();"
               color="success lighten-1"
        ><v-icon  >
          mdi-content-paste
        </v-icon>
        </v-btn>


        </v-card-title>
        <v-card-text style=" margin-top:-15px;">


          <v-container>
        <v-row>
          <v-col
            cols="12"
            sm="12"
          >


          <v-data-table single-select id="persons" height="280" :headers="headers3" :items="pe.otv" dense :items-per-page="100000" light :hide-default-footer="true" class="elevation-1">



            <template v-slot:item.otv_fio="{ item }">

              <div style="line-height:0.8rem;padding-top:7px; border:1px solid rgb(198, 198, 198); border-radius:7px; padding:4px; margin-top:5px;margin-bottom:5px;box-shadow:1px 1px rgb(208, 208, 208);background:rgba(226, 255, 212, 0.21)">


                <v-btn icon outlined x-small color="rgba(231, 17, 17, 0.42)" style="margin-top:0%;margin-left:0%" @click="  {pe.otv.splice(pe.otv.indexOf(item), 1)}">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <div style="font-size:8pt; color:grey; width:28px; display: inline-block; text-align:right;">ФИО:</div> &nbsp;
                <input @input="item.otv_sokr=sokr_fio_make(item.otv_fio)" @change="item.otv_sokr=sokr_fio_make(item.otv_fio)" light style="width:83%;height:50%; border-bottom:1px solid rgb(180, 180, 180);" v-model="item.otv_fio">
                  <br/>
                <span style="font-size:8pt; color:grey">Долж: </span>
                <input light style="width:89%;height:50%; border-bottom:1px solid rgb(180, 180, 180);" v-model="item.otv_dolg">
                <br/>
                <span style="font-size:8pt; color:grey">ФИО (сокр.): </span>
                <input light style="width:81%;height:50%; border-bottom:1px solid rgb(180, 180, 180); margin-bottom:2px" v-model="item.otv_sokr">
                <span style="font-size:8pt; color:grey">Телефон: </span>
                <input light style="width:85%;height:50%; border-bottom:1px solid rgb(180, 180, 180);margin-bottom:2px" v-model="item.phone">
                <br/>
                <span style="font-size:8pt; color:grey"> E-mail: </span>
                <input light style="width:89%;height:50%; border-bottom:1px solid rgb(180, 180, 180);margin-bottom:7px" v-model="item.email">
              </div>
            </template>








          </v-data-table>
          </v-col>




        </v-row>
      </v-container>










    </v-card-text>

      </v-card>

      </v-col>










    </v-row>
  </v-container>



</v-card>








</v-tab-item>
<v-tab-item >

  <v-app-bar


      floating
      light
      dense
      style="background:url('/fon-3.png');; width:100%"
      elevation="0"

  >
    <v-card-title>
      <table>
        <tr>
          <td   style="width:90vw">
            <v-icon class="mr-0" style="margin-top:-5px">
              mdi-fire
            </v-icon>
            Расходы ТЭР

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
            <sup>
              <v-btn
              v-bind="attrs"
              v-on="on"


              @click=" closeallmer();closeallter();tabpe=6; showwordpe=true;"
              href="#passport"

                text
              x-small
              :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"


              color="success"  style="text-shadow:  #8af025 0px 0px 2px; margin-left:-7px ;  "

  > ПЭ
  <v-icon small  color="success"  style="text-shadow:  #8af025 0px 0px 2px;
  ">
   mdi-open-in-new
  </v-icon>

          </v-btn></sup>
        </template>
        <span>Просмотреть паспорт программы энергосбережения</span>
      </v-tooltip>



            <v-btn
                rounded
                :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
                small
                style="color:rgb(255, 255, 255);  "
                class="ml-4 "
                @click="newTER=true" color="success">
              <v-icon class="mr-1">
                mdi-plus
              </v-icon>
              Добавить ТЭР
            </v-btn>
            
            <span class="white--text">{{tut}}</span>

            <span class="white--text">{{tut}}</span></td>

          <td style="width:10vw; min-width:250px"> </td>
        </tr>
      </table>









    </v-card-title>

  </v-app-bar>

  <v-card id="topl" elevation="2" class="pb-5   mb-0" style="  border: 1px solid  rgb(194, 194, 194);border-radius:0px; height:81vh; width:89vw; background:url('/fon-5.png'); min-width:530px; overflow-y:scroll;
">




<v-alert v-if="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
      icon="mdi-arrow-top-left"
      prominent
      text
      type="purple lighten-1"
    >


      Для добавления ТЭР заполните на вкладке "Наименование":<br/>1) год начала программы,<br/>2) год окончания программы, <br/>3) последний завершённый год (панель "Индексы" на вкладке "Наименование").
    </v-alert>











<v-card v-for="(toplivo,indextoplivo) in pe.ter" :key="toplivo" elevation="4" class="mx-3 my-3"
  style="border-radius:20px;  min-height:40px; min-width:calc(100vw - 285px); max-width:calc(85vw - 285px);">

  <v-card-title>
    <v-btn :disabled="!(indextoplivo>0)"
      @click="element=pe.ter[indextoplivo-1];pe.ter.splice(indextoplivo-1,1,pe.ter[indextoplivo]);pe.ter[indextoplivo]=element;"
      outlined rounded icon style="margin:2px; border:3px solid #F3D3FF; color:#CA77FF; margin-top:-5px;">
      <v-icon>
        mdi-arrow-up-thin
      </v-icon>
    </v-btn>
    <v-btn :disabled="!(indextoplivo<pe.ter.length-1)"
      @click="element=pe.ter[indextoplivo+1];pe.ter.splice(indextoplivo+1,1,pe.ter[indextoplivo]);pe.ter[indextoplivo]=element;"
      outlined rounded icon style="margin:2px; border:3px solid #F3D3FF;color:#CA77FF; margin-top:-5px;">
      <v-icon>
        mdi-arrow-down-thin
      </v-icon>
    </v-btn>

    <v-btn @click="pe.ter.splice(indextoplivo,1);" color="#FFA6B1" outlined rounded icon
      style="margin:2px; border:3px solid #F3D3FF; margin-top:-5px;">
      <v-icon>
        mdi-delete
      </v-icon>
    </v-btn>

    <v-btn class="mr-3" @click="$set(pe.ter[indextoplivo],'edit',!toplivo.edit)" color="success lighten-1" outlined
      rounded icon style="margin:2px; border:3px solid #F3D3FF; margin-top:-5px;">
      <v-icon>
        {{toplivo.edit?'mdi-chevron-up':'mdi-pencil'}}
      </v-icon>
    </v-btn>
    {{toplivo.name}} <v-spacer />

    

  </v-card-title>


  <v-dialog
          v-model="toplivo.edit"
          transition="none"
          fullscreen
        >

         <v-card>
            <v-card-title class="text-h5 grey lighten-2 " style="word-break: keep-all;">
              <v-autocomplete v-model="toplivo.name" :items="show_pe_topl()" @change="
toplivo.ed=TOPL.find(element => element.name==toplivo.name).ed;
toplivo.pk_plan.fill(parseFloat(TOPL.find(element => element.name==toplivo.name).per_koef));
toplivo.pk_fact.fill(parseFloat(TOPL.find(element => element.name==toplivo.name).per_koef));
pe.ter[0].pk_plan.push(0); pe.ter[0].pk_plan.splice(-1, 1);" dense hide-details rounded label="Вид ТЭР"
      style="box-shadow: #d104c7ec 0px 0px 4px;
          background-image: radial-gradient( circle 700px at 1.1% 65.3%,  rgba(37, 247, 83, 0.664) 60%, rgba(255, 255, 255, 0.747) 100% );
          ;border-radius:5px; color:black;  margin: 6px; padding:5px; padding-top:18px; padding-bottom:10px  "></v-autocomplete> <v-spacer />

    
    <v-spacer />
              <v-btn    class=" white--text mr-2 ml-2  mt-2 mb-2  " color="rgba(203, 65, 6, 0.8)"  @click="$set(pe.ter[indextoplivo],'edit',!toplivo.edit)" 
              style=" ;border:2px solid rgba(198, 0, 0, 0.32)"><span class="pl-2 pr-2 ">Закрыть</span></v-btn>

            </v-card-title>


  <v-card-text  style="overflow-x:scroll; max-width:calc(100vw - 60px); margin-left:20px;">


<v-checkbox v-model="toplivo.autoplan" color="purple lighten-3" style="" label="Автозаполнение плана"></v-checkbox> <v-spacer/>
    <v-spacer />


    <table id="toplivotable" border="1" cellpadding="0" cellspacing="0">
      <thead>
        <tr>
          <th class="text-center" style="min-width:380px">
            Показатели / Периоды
          </th>
          <th v-for="item in yearsprognoz" :key="item" class="text-center" style="min-width:106px">
            <span>{{item}}</span>
          </th>
        </tr>
        <tr>
          <th class="text-left" style="min-width:90px">

          </th>
          <th v-for="item in yearsprognoz" :key="item" class="text-center">


            <span>

              {{ (yearspe.indexOf(item)>-1 )&& (item>=
              pe.god_ot)?'ПЭ':''}}

              {{item==pe.fact_god?'Факт':''}}
              {{(item==pe.fact_god) && (pe.fact_god==(pe.god_ot-1))?' / ':''}}
              {{item==(pe.god_ot-1)?'Базовый год':''}}

            </span>
          </th>
        </tr>
      </thead>
      <tbody>

        <tr>
          <td class="text-left " style="background: rgba(147, 219, 152, 0.11)" :colspan="yearsprognoz.length+1">
            <b>Показатели без учёта ПЭ</b>
          </td>

        </tr>



        <tr>
          <td class="text-left">
            Переводной коэфф. из {{toplivo.ed}} в т.у.т.
          </td>
          <td v-for="(item,index) in yearspe" :key="item" class="text-left">



            <FormulaEdit :value.sync="toplivo.pk_plan[index]" :nocalc="true" :formulavalue="true" :decimal="3"
              @change="autofillplan(toplivo.autoplan,toplivo.pk_plan,index,yearsprognoz.length-1,toplivo.pk_plan[index]);"
              :color="((item>pe.fact_god) && (item<=pe.god_do))?'rgba(245, 230, 255, 0.43);':'rgba(210, 255, 153, 0.63)'"
              v-if="item>=pe.fact_god"></FormulaEdit>

          </td>
        </tr>


        <tr>
          <td class="text-left">
            Объём ресурса ({{toplivo.ed}})
          </td>
          <td v-for="(item,index) in yearspe" :key="item" class="text-left">



            <FormulaEdit :value.sync="toplivo.volume_plan_do_mer[index]" :nocalc="true" :formulavalue="true"
              :decimal="3"
              @change="autofillplan(toplivo.autoplan,toplivo.volume_plan_do_mer,index,yearsprognoz.length-1,toplivo.volume_plan_do_mer[index]);"
              :color="((item>pe.fact_god) && (item<=pe.god_do))?'rgba(245, 230, 255, 0.43);':'rgba(210, 255, 153, 0.63)'"
              v-if="item>=pe.fact_god"></FormulaEdit>

          </td>
        </tr>

        <tr>
          <td class="text-left">
            Объём ресурса (т.у.т.)
          </td>
          <td v-for="(item,index) in yearspe" :key="item" class="text-left">


            <FormulaEdit :value.sync="toplivo.tut_plan_do_mr[index]" :nocalc="true" :formulavalue="true"
              :readonly="true" :decimal="3"
              @change="autofillplan(toplivo.autoplan,toplivo.tut_plan_do_mr,index,yearsprognoz.length-1,toplivo.tut_plan_do_mr[index]);"
              color="#ffffff" v-if="item>=pe.fact_god"></FormulaEdit>

          </td>
        </tr>

        <tr>
          <td class="text-left">
            Затраты на ресурс (тыс. руб.)
          </td>
          <td v-for="(item,index) in yearspe" :key="item" class="text-left">




            <FormulaEdit :value.sync="toplivo.rub_plan_do_mer[index]" :nocalc="true" :formulavalue="true" :decimal="3"
              :color="((item>pe.fact_god) && (item<=pe.god_do))?'rgba(255, 255, 255, 1);':'rgba(210, 255, 153, 0.63)'"
              v-if="item>=pe.fact_god"></FormulaEdit>






          </td>
        </tr>

        <tr>
          <td class="text-left">
            Индекс роста цены, %
          </td>
          <td v-for="(item,index) in yearsprognoz" :key="item" class="text-left">



            <FormulaEdit :value.sync="toplivo.index[index]" :nocalc="true" :formulavalue="true" :decimal="3"
              @change="autofillplan(toplivo.autoplan,toplivo.index,index,yearsprognoz.length-1,toplivo.index[index]);"
              :color="((item>pe.god_ot-1))?'rgba(245, 230, 255, 0.43);':'rgba(210, 255, 153, 0.63)'"
              v-if="item>pe.fact_god"></FormulaEdit>

          </td>
        </tr>

        <tr>
          <td class="text-left">
            Цена ресурса (руб./{{toplivo.ed}})
          </td>
          <td v-for="(item,index) in yearsprognoz" :key="item" class="text-center">


            <FormulaEdit :value.sync="toplivo.price[index]" :nocalc="true" :formulavalue="true" :readonly="true"
              :decimal="3" color="#ffffff" v-if="item>=pe.fact_god"></FormulaEdit>

          </td>
        </tr>

        <tr>
          <td class="text-left " style="background: rgba(147, 219, 152, 0.11)" :colspan="yearsprognoz.length+1">
            <b>Показатели с учётом ПЭ</b>
          </td>

        </tr>


        <tr>
          <td class="text-left">
            Объём ресурса с учётом ПЭ ({{toplivo.ed}})
          </td>
          <td v-for="(item,index) in yearspe" :key="item" class="text-center">


            <FormulaEdit :value.sync="toplivo.volume_plan_posle_mer[index]" :nocalc="true" :formulavalue="true"
              :readonly="true" :decimal="3" color="#ffffff" v-if="item>=pe.god_ot"></FormulaEdit>



          </td>
        </tr>
        <tr>
          <td class="text-left">
            Объём ресурса с учётом ПЭ (т.у.т.)
          </td>
          <td v-for="(item,index) in yearspe" :key="item" class="text-center">

            <FormulaEdit :value.sync="toplivo.tut_plan_posle_mer[index]" :nocalc="true" :formulavalue="true"
              :readonly="true" :decimal="3" color="#ffffff" v-if="item>=pe.god_ot"></FormulaEdit>

          </td>
        </tr>
        <tr>
          <td class="text-left">
            Затраты на ресурс с учётом ПЭ (тыс. руб.)
          </td>
          <td v-for="(item,index) in yearspe" :key="item" class="text-center">


            <FormulaEdit :value.sync="toplivo.rub_plan_posle_mer[index]" :nocalc="true" :formulavalue="true"
              :readonly="true" :decimal="3" color="#ffffff" v-if="item>=pe.god_ot"></FormulaEdit>

          </td>
        </tr>

        <tr>
          <td class="text-left">
            Плановая экономия ресурса ({{toplivo.ed}})
          </td>
          <td v-for="(item,index) in yearspe" :key="item" class="text-center">


            <FormulaEdit :value.sync="toplivo.economy_volume_plan[index]" :nocalc="true" :formulavalue="true"
              :readonly="true" :decimal="3" color="#ffffff" v-if="item>=pe.god_ot"></FormulaEdit>

          </td>
        </tr>


        <tr>
          <td class="text-left">
            Плановая экономия ресурса (т.у.т.)
          </td>
          <td v-for="(item,index) in yearspe" :key="item" class="text-center">

            <FormulaEdit :value.sync="toplivo.economy_tut_plan[index]" :nocalc="true" :formulavalue="true"
              :readonly="true" :decimal="3" color="#ffffff" v-if="item>=pe.god_ot"></FormulaEdit>

          </td>
        </tr>
        <tr>
          <td class="text-left">
            Плановая экономия затрат на ресурс (тыс. руб.)
          </td>
          <td v-for="(item,index) in yearspe" :key="item" class="text-center">


            <FormulaEdit :value.sync="toplivo.economy_rub_plan[index]" :nocalc="true" :formulavalue="true"
              :readonly="true" :decimal="3" color="#ffffff" v-if="item>=pe.god_ot"></FormulaEdit>

          </td>
        </tr>




        <tr>
          <td class="text-left" style="background: rgba(147, 219, 152, 0.11)" :colspan="yearsprognoz.length+1">
            <b>Показатели для отчёта к ПЭ (заполняется после окончания каждого года периода ПЭ)</b>
          </td>

        </tr>

        <tr>
          <td class="text-left">
            Фактический пер. коэфф. из {{toplivo.ed}} в т.у.т.
          </td>
          <td v-for="(item,index) in yearspe" :key="item" class="text-left">





            <FormulaEdit :value.sync="toplivo.pk_fact[index]" :nocalc="true" :formulavalue="true" :decimal="4"
              :color="(!((item>=pe.god_ot) && (item<=pe.god_do)))?'rgba(245, 230, 255, 0.43);':'rgba(210, 255, 153, 0.63)'"
              v-if="item>=pe.god_ot"></FormulaEdit>



          </td>
        </tr>

        <tr>
          <td class="text-left">
            Фактический объём ресурса ({{toplivo.ed}})
          </td>
          <td v-for="(item,index) in yearspe" :key="item" class="text-left">




            <FormulaEdit :value.sync="toplivo.volume_fact[index]" :nocalc="true" :formulavalue="true" :decimal="3"
              :color="(!((item>=pe.god_ot) && (item<=pe.god_do)))?'rgba(245, 230, 255, 0.43);':'rgba(210, 255, 153, 0.63)'"
              v-if="item>=pe.god_ot"></FormulaEdit>

          </td>
        </tr>


        <tr>
          <td class="text-left">
            Фактический объём ресурса (т.у.т.)
          </td>
          <td v-for="(item,index) in yearspe" :key="item" class="text-left">





            <FormulaEdit :value.sync="toplivo.tut_fact[index]" :nocalc="true" :formulavalue="true" :readonly="true"
              :decimal="3" color="#ffffff" v-if="item>=pe.god_ot"></FormulaEdit>

          </td>
        </tr>
        <tr>
          <td class="text-left">
            Фактические затраты на ресурс (тыс. руб.)
          </td>
          <td v-for="(item,index) in yearspe" :key="item" class="text-left">





            <FormulaEdit :value.sync="toplivo.rub_fact[index]" :nocalc="true" :formulavalue="true" :decimal="3"
              :color="(!((item>=pe.god_ot) && (item<=pe.god_do)))?'rgba(245, 230, 255, 0.43);':'rgba(210, 255, 153, 0.63)'"
              v-if="item>=pe.god_ot"></FormulaEdit>

          </td>
        </tr>


        <tr>
          <td class="text-left">
            Фактическая цена ресурса (руб./{{toplivo.ed}})
          </td>
          <td v-for="(item,index) in yearspe" :key="item" class="text-center">


            <FormulaEdit :value.sync="toplivo.price_fact[index]" :nocalc="true" :formulavalue="true" :readonly="true"
              :decimal="3" color="#ffffff" v-if="item>=pe.god_ot"></FormulaEdit>

          </td>
        </tr>







        <tr>
          <td class="text-left">
            Фактическая экономия ресурса ({{toplivo.ed}})
          </td>
          <td v-for="(item,index) in yearspe" :key="item" class="text-center">


            <FormulaEdit :value.sync="toplivo.economy_volume_fact[index]" :nocalc="true" :formulavalue="true"
              :readonly="true" :decimal="3" color="#ffffff" v-if="item>=pe.god_ot"></FormulaEdit>

          </td>
        </tr>


        <tr>
          <td class="text-left">
            Фактическая экономия ресурса (т.у.т.)
          </td>
          <td v-for="(item,index) in yearspe" :key="item" class="text-center">


            <FormulaEdit :value.sync="toplivo.economy_tut_fact[index]" :nocalc="true" :formulavalue="true"
              :readonly="true" :decimal="3" color="#ffffff" v-if="item>=pe.god_ot"></FormulaEdit>

          </td>
        </tr>
        <tr>
          <td class="text-left">
            Фактическая экономия затрат на ресурс (тыс. руб.)
          </td>
          <td v-for="(item,index) in yearspe" :key="item" class="text-center">


            <FormulaEdit :value.sync="toplivo.economy_rub_fact[index]" :nocalc="true" :formulavalue="true"
              :readonly="true" :decimal="3" color="#ffffff" v-if="item>=pe.god_ot"></FormulaEdit>

          </td>
        </tr>





      </tbody>
    </table>

  </v-card-text>
  </v-card>
  </v-dialog>
</v-card>




</v-card>

</v-tab-item>



    <v-tab-item >
      <v-app-bar


          floating
          light
          dense
          style="background:url('/fon-3.png'); width:100%"
          elevation="0"

      >
        <v-card-title>
            <table>
              <tr>
                <td style="width:60vw">
                  <v-icon class="mr-0" style="margin-top:-2px">
                  mdi-table-star
                </v-icon>
                  Целевые и прочие показатели программы <span class="white--text">

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                    <sup>
                      <v-btn
                      v-bind="attrs"
                      v-on="on"


                      @click=" closeallmer();closeallter();tabpe=6; showwordpe=true;"
                      href="#celevie"

                        text
                      x-small
                      :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"


                      color="success"  style="text-shadow:  #8af025 0px 0px 2px; margin-left:-9px ;  "

        > ПЭ
        <v-icon small  color="success"  style="text-shadow:  #8af025 0px 0px 2px;
         ">
           mdi-open-in-new
        </v-icon>

                  </v-btn></sup>
                </template>
                <span>Просмотреть таблицу целевых показателей в программе энергосбережения</span>
              </v-tooltip>



                  {{cpp}}</span>


                  <span class="white--text">{{tut}}</span>
                  <v-btn
                    rounded
                    :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
                    small
                    style="color:rgb(255, 255, 255);  "
                    class="ml-4 my-4"
                    @click="cpp_settings=true" color="success">
                  <v-icon class="mr-1">
                    mdi-cog
                  </v-icon>Настройка
                </v-btn>
                <v-btn
                    rounded
                    :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
                    small
                    style="box-shadow: #2DA820 1px 1px 2px; text-shadow:  #ffffff 0px 0px 3px;;
                    background-image: radial-gradient( circle 100px at 1.1% 15.3%,  rgba(212,171,255,0.82) 50%, rgba(0,246,153,0.52) 100% );
                    ;border-radius:20px; text-shadow: #001c5c 1px 1px 2px;margin:20px;  "

                  @click="getCP();celevmaster=true;" color="success">
                  <v-icon small class="mr-1"   style="color:rgb(255, 255, 255); text-shadow:  #000000 0px 0px 2px;
                   ">
                     mdi-star
                  </v-icon>по шаблону
                </v-btn>
                <v-btn
                    rounded
                    :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
                    small
                    style="box-shadow: #2DA820 1px 1px 2px; text-shadow:  #ffffff 0px 0px 3px;;
                    background-image: radial-gradient( circle 100px at 1.1% 15.3%,  rgba(212,171,255,0.82) 50%, rgba(0,246,153,0.52) 100% );
                    ;border-radius:20px; text-shadow: #001c5c 1px 1px 2px;margin:5px;  "

                  @click="copcpmaster=true;" color="success">
                  <v-icon small class="mr-1"   style="color:rgb(255, 255, 255); text-shadow:  #000000 0px 0px 2px;
                   ">
                     mdi-content-copy
                  </v-icon>Копировать из другой ПЭ
                </v-btn>





              </td>

                <td style="min-width:180px">
                  <v-checkbox
                    v-model="pe.autofillcpp"
                    color="purple lighten-3"
                    style="margin-top:30px"
                    dense
                    hide-details

                    label="Автозаполнение "
                ></v-checkbox>
              </td>
              <td style="min-width:180px">
                <v-checkbox
                    v-model="shortmodecpp"
                    color="purple lighten-3"
                    style="margin-top:30px"
                    dense
                    hide-details

                    label="Краткая версия"
                ></v-checkbox>

              </td>
              </tr>
            </table>









        </v-card-title>

      </v-app-bar>

     

      <v-card elevation="2" class="pb-5   mb-0" style="  border: 1px solid  rgb(194, 194, 194);border-radius:0px;background:url('/fon-5.png'); height:81vh; width:89vw; min-width:530px; overflow-y:scroll;
">


        <v-card-text>
          <v-alert v-if="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
                   icon="mdi-arrow-top-left"
                   prominent
                   text
                   type="purple lighten-1"
          >


            Для добавления показателей заполните на вкладке "Наименование":<br/>1) год начала программы,<br/>2) год окончания программы, <br/>3) последний завершённый год (панель "Индексы" на вкладке "Наименование").
          </v-alert>




          <v-card elevation="8" class="mx-3 my-3" style="border-radius:20px;  min-height:380px; min-width:calc(100vw - 285px); max-width:calc(85vw - 285px);"
          >
            <v-card-text style="overflow-x:scroll; max-width:calc(100vw - 325px); margin-left:20px;">

              <table id="toplivotable" border="1" cellpadding="0" cellspacing="0">
                <thead>
                <tr>
                  <th class="text-center" style="min-width:300px;max-width:300px" rowspan="2">
                    Показатели / Периоды
                  </th>

                    <th class="text-center" style="min-width:95px;max-width:95px"  rowspan="2">
                      Ед. изм.
                    </th>

                      <th class="text-center" style="min-width:160px;max-width:160px"  rowspan="2">
                        Средние показатели по отрасли
                      </th>
                  <th class="text-center" style="min-width:160px;max-width:160px" rowspan="2">
                    Лучшие мировые показатели по отрасли
                  </th>
                  <th v-for="item in yearspe" :key="item" class="text-center" style="min-width:110px;max-width:110px">
                    <span>{{item}}</span>
                  </th>
                </tr>
                <tr>



                  <th v-for="item in yearspe" :key="item" style="min-width:110px;max-width:110px; line-height: 0.95rem">

      <span>

        {{item==pe.fact_god?'Факт':''}}
        {{(item==pe.fact_god) && (pe.fact_god==(pe.god_ot-1))?' / ':''}}
        {{item==(pe.god_ot-1)?'Базовый год':''}}
        {{ (item>=pe.god_ot)?' ПЭ ':''}}
      </span>
                  </th>
                </tr>
                </thead>
                <tbody>

                <tr>
                  <td class="text-left " style="background: rgba(147, 219, 152, 0.11)" :colspan="yearspe.length+4">
                    <b>Базовые (начальные) значения показателей (без учёта программы энергосбережения)</b>
                    <v-btn style="display:inline-block" rounded x-small color="purple"  class="white--text ml-4" dense v-if="!pe.autofillcpp" @click="pe.autofillcpp=true;">включить автозаполнение</v-btn>
                  </td>
                </tr>

                  <tr>

                </tr>

                  <tr v-for="cp in pe.celev" :key="cp">
                    <template v-if="isbase(cp)">


                    <td class="text-left pl-2" style="text-indent: 0px"  >
                     <span class="green--text">{{cp.kind}}: </span>
                      <span >{{ cp.name }}</span>
                    </td>
                    <td class="text-left">
                      {{ cp.ed }}
                    </td>
                    <td class="text-left" style="background:#ffffeb " >

                      <FormulaEdit
                          :value.sync="cp.sred_otrasl"
                          :formula.sync="cp.sred_otrasl_formula"
                          :decimal="cp.decimal"
                          color="#ffffeb"

                      />

                    </td>
                    <td class="text-left" style="background:#ffffeb ">
                      <FormulaEdit
                          :value.sync="cp.best_mir"
                          :formula.sync="cp.best_mir_formula"
                          :decimal="cp.decimal"
                          color="#ffffeb"/>
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" class="text-left" :style="((item>pe.fact_god) && (item<=pe.god_do))?'background:#fbf4ff':'background:#e3ffbf'">

                      <FormulaEdit
                          :value.sync="cp.base[index]"
                          :formula.sync="cp.base_formula[index]"
                          :decimal="cp.decimal"
                          @change="autofillplan(pe.autofillcpp,cp.base_formula,index,yearsprognoz.length-1,cp.base_formula[index]);
                                  autofillplan(pe.autofillcpp,cp.base,index,yearsprognoz.length-1,cp.base[index])"
                          :color="((item>pe.fact_god) && (item<=pe.god_do))?'#fbf4ff':'#e3ffbf'"
                          :mark="item===pe.fact_god?isbase(cp,true):false"

                          />

                    </td>

                  </template>
                </tr>






                <tr>
                  <td class="text-left " style="background: rgba(147, 219, 152, 0.11)" :colspan="yearspe.length+4">
                    <b>Изменение показателей по Программе энергосбережения (план)</b>
                  </td>


                </tr>


                <tr v-for="cp in pe.celev" :key="cp">
                    <template v-if="iseffect(cp,'plan')">
                  <td class="text-left pl-2" style="text-indent: 0px"  >
                    <span class="green--text">{{cp.kind}}: </span>
                    <span >{{ cp.name }}</span>
                  </td>
                  <td class="text-left">
                    {{ cp.ed }}
                  </td>
                   <td class="text-left">
                  </td>
                   <td class="text-left">
                  </td>
                  <td v-for="(item,index) in yearspe" :key="item" class="text-left">
                    {{decimal(cp.effect_plan[index],cp.decimal)}}
                  </td>
                  </template>
                </tr>

                <tr>
                  <td class="text-left " style="background: rgba(147, 219, 152, 0.11)" :colspan="yearspe.length+4">
                    <b>Изменение показателей по Программе энергосбережения (факт)</b>
                  </td>


                  <tr v-for="cp in pe.celev" :key="cp">
                      <template v-if="iseffect(cp,'fact')">
                    <td class="text-left pl-2" style="text-indent: 0px"  >
                      <span class="green--text">{{cp.kind}}: </span>
                      <span >{{ cp.name }}</span>
                    </td>
                    <td class="text-left">
                      {{ cp.ed }}
                    </td>
                    <td class="text-left">
                    </td>
                    <td class="text-left">
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" class="text-left">
                      {{decimal(cp.effect_fact[index],cp.decimal)}}
                    </td>


                    </template>
                </tr>


                <tr>
                  <td class="text-left " style="background: rgba(147, 219, 152, 0.11)" :colspan="yearspe.length+4">
                    <b>Результирующие показатели (план)</b>
                    <v-btn style="display:inline-block" rounded x-small color="purple"  class="white--text ml-4" dense  v-if="!pe.autofillcpp" @click="pe.autofillcpp=true;">включить автозаполнение</v-btn>
                  </td>

                </tr>


                <tr v-for="cp in pe.celev" :key="cp">
                  <td class="text-left pl-2" style="text-indent: 0px"  >
                    <span class="green--text">{{cp.kind}}: </span>
                    <span >{{ cp.name }}</span>
                  </td>
                  <td class="text-left">
                    {{ cp.ed }}
                  </td>
                  <td class="text-left">
                    {{ cp.sred_otrasl }}
                  </td>
                  <td class="text-left">
                    {{ cp.best_mir }}
                  </td>
                  <td v-for="(item,index) in yearspe" :key="item" class="text-left" :style="((item>pe.fact_god) && (item<=pe.god_do))?'background:#fbf4ff':'background:#ffffeb'" >


                    <FormulaEdit
                        :value="cp.value_plan[index]"
                        :formula.sync="cp.formula_plan[index]"
                        :decimal="cp.decimal"
                        :nocalc="true"
                        @change="autofillplan(pe.autofillcpp,cp.formula_plan,index,yearsprognoz.length-1,cp.formula_plan[index]);
                                  autofillplan(pe.autofillcpp,cp.value_plan,index,yearsprognoz.length-1,cp.value_plan[index])"
                        :color="((item>pe.fact_god) && (item<=pe.god_do))?'#fbf4ff':'#ffffeb'"/>

                  </td>
                </tr>
                  <tr v-for="topl in pe.ter" :key="topl">
                    <td  class="text-left pl-2" style="text-indent: 0px"  >
                      <span class="green--text">Прочие: </span>
                      <span >Экономия ТЭР: {{ topl.name }}</span>
                    </td>
                    <td class="text-left pl-2" style="text-indent: 0px">
                      {{ topl.ed }}<br/>
                      тыс.руб.
                    </td>
                    <td class="text-left">

                    </td>
                    <td class="text-left">

                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" class="text-left pl-2" style="text-indent: 0px" >

                      <span >{{ decimal((topl.economy_volume_plan[index]),2) }}</span>
                      <br/>
                      <span>{{ decimal((topl.economy_rub_plan[index]),2) }}</span>


                    </td>
                  </tr>






                <tr>
                  <td class="text-left " style="background: rgba(147, 219, 152, 0.11)" :colspan="yearspe.length+4">
                      <b>Результирующие  показатели (факт)</b>
                      <v-btn style="display:inline-block" rounded x-small color="purple"  class="white--text ml-4" dense  v-if="pe.autofillcpp" @click="pe.autofillcpp=false;">отключить автозаполнение</v-btn>
                    </td>

                  </tr>



                  <tr v-for="cp in pe.celev" :key="cp">
                    <td class="text-left pl-2" style="text-indent: 0px"  >
                      <span class="green--text">{{cp.kind}}: </span>
                      <span >{{ cp.name }}</span>
                    </td>
                    <td class="text-left">
                      {{ cp.ed }}
                    </td>
                    <td class="text-left">
                      {{ cp.sred_otrasl }}
                    </td>
                    <td class="text-left">
                      {{ cp.best_mir }}
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" class="text-left" :style="((item>pe.fact_god) && (item<=pe.god_do))?'background:#fbf4ff':'background:#ffffeb'">


                      <FormulaEdit
                          :value="cp.value_fact[index]"
                          :formula.sync="cp.formula_fact[index]"
                          :decimal="cp.decimal"
                          :nocalc="true"
                          :mark="item>pe.fact_god?iseffect(cp,'fact',true):false"
                          @change="autofillplan(pe.autofillcpp,cp.formula_fact,index,yearsprognoz.length-1,cp.formula_fact[index]);
                                  autofillplan(pe.autofillcpp,cp.value_fact,index,yearsprognoz.length-1,cp.value_fact[index])"
                          :color="((item>pe.fact_god) && (item<=pe.god_do))?'#fbf4ff':'#ffffeb'"/>

                    </td>
                  </tr>

                  <tr v-for="topl in pe.ter" :key="topl">
                    <td  class="text-left pl-2" style="text-indent: 0px"  >
                      <span class="green--text">Прочие: </span>
                      <span >Экономия ТЭР: {{ topl.name }}</span>
                    </td>
                    <td class="text-left pl-2" style="text-indent: 0px">
                      {{ topl.ed }}<br/>
                      тыс.руб.
                    </td>
                    <td class="text-left">

                    </td>
                    <td class="text-left">

                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" class="text-left pl-2" style="text-indent: 0px" >

                      <span >{{decimal(topl.economy_volume_fact[index]) }}</span>
                        <br/>
                      <span>{{ decimal(topl.economy_rub_fact[index]) }}</span>


                    </td>
                  </tr>






                </tbody>
              </table>



            </v-card-text>

            
          </v-card>





        </v-card-text>

      </v-card>
       
    </v-tab-item>


    <v-tab-item >
      <v-app-bar


          floating
          light
          dense
          style="background:url('/fon-3.png'); width:100%"
          elevation="0"

      >
        <v-card-title>

          <v-icon class="mr-1">
            mdi-clipboard-list-outline
          </v-icon>
          Мероприятия
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
          <sup>
            <v-btn
            v-bind="attrs"
            v-on="on"


            @click=" closeallmer();closeallter();tabpe=6; showwordpe=true;"
            href="#meropriyatia"

              text
            x-small
            :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"


            color="success"  style="text-shadow:  #8af025 0px 0px 2px; margin-left:-3px ;  "

> ПЭ
<v-icon small  color="success"  style="text-shadow:  #8af025 0px 0px 2px;
">
 mdi-open-in-new
</v-icon>

        </v-btn></sup>
      </template>
      <span>Просмотреть таблицу мероприятий в программе энергосбережения</span>
    </v-tooltip>


           <span class="white--text">{{cpp}}{{tut}}{{meropriyatiya}}{{pe.trigger}}</span>

          <v-btn
              rounded
              :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
              small
              style="box-shadow: #2DA820 1px 1px 2px; text-shadow:  #ffffff 0px 0px 3px;;
              background-image: radial-gradient( circle 100px at 1.1% 15.3%,  rgba(212,171,255,0.82) 50%, rgba(0,246,153,0.52) 100% );
              ;border-radius:20px; text-shadow: #001c5c 1px 1px 2px; "
              class="ml-4 "
              @click="meropmaster=true;getSMETA();getMER();" color="success">
            <v-icon class="mr-1">
              mdi-star-shooting-outline
            </v-icon>Мастер
          </v-btn>

          <v-btn
              rounded
              :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
              small
              style="color:rgb(255, 255, 255);  "
              class="ml-4 "
              @click="addmer();" color="success">
            <v-icon class="mr-1">
              mdi-plus
            </v-icon>добавить
          </v-btn>
          
          <v-btn
              rounded
              :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
              small
              style="color:rgb(255, 255, 255);  "
              class="ml-4 "

              @click="sortmer();"
               color="success">
            <v-icon  class="mr-1">
              mdi-sort-clock-ascending-outline
            </v-icon>Упорядочить
          </v-btn>







        </v-card-title>

      </v-app-bar>
      <v-card elevation="2" class="pb-5   mb-0" style="  border: 1px solid  rgb(194, 194, 194);border-radius:0px; background:url('/fon-3.png');height:81vh; width:89vw; min-width:530px; overflow-y:scroll;
">




        <v-card-text>
          <v-alert v-if="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
                   icon="mdi-arrow-top-left"
                   prominent
                   text
                   type="purple lighten-1"
          >


            Для добавления показателей заполните на вкладке "Наименование":<br/>1) год начала программы,<br/>2) год окончания программы, <br/>3) последний завершённый год (панель "Индексы" на вкладке "Наименование").
          </v-alert>






          <v-card elevation="8" class="mx-3 my-3" style="border-radius:20px;  min-height:380px; min-width:1100px; max-width:1100px;"
          >
            <v-card-text style="  padding-top:35px;padding-left:35px">



              <div  v-for="(merop,index) in pe.mer" :key="index" style="background:url('/fon-3.png'); ">
              <table  id="toplivotable" border="1" cellpadding="0" cellspacing="0"   style="margin-top:0px" >

                <tbody>

                <tr>

                  <td style="text-indent: 0px;padding: 10px; vertical-align: top;  ">

                  <table style="border:2px solid #f1d1ff; margin:5px;background-image: radial-gradient( circle 329px at 3.1% 9.3%,  rgb(238,255,233) 28.1%, rgba(230,197,255,0.15) 100.7% );;border-radius:20px;min-height:100px ">

                    <tbody  >
                      <tr>
                        <td rowspan="2" style=" width:330px;border-right:0px ; border-top:0px ; border-bottom:0px;border-left:0px ; padding-top: 5px; text-indent:0px; text-align:left ">


                          <v-btn :disabled="!(index>0)" @click="element=pe.mer[index-1];pe.mer.splice(index-1,1,pe.mer[index]);pe.mer[index]=element;"
                                 outlined rounded icon style="margin:2px; border:3px solid #F3D3FF; color:#CA77FF; margin-top:-30px; margin-left:10px;" >
                            <v-icon>
                              mdi-arrow-up-thin
                            </v-icon>
                          </v-btn>
                          <v-btn :disabled="!(index<pe.mer.length-1)" @click="element=pe.mer[index+1];pe.mer.splice(index+1,1,pe.mer[index]);pe.mer[index]=element;"
                                 outlined rounded icon style="margin:2px; border:3px solid #F3D3FF;color:#CA77FF; margin-top:-30px;" >
                            <v-icon>
                              mdi-arrow-down-thin
                            </v-icon>
                          </v-btn>

                          <v-btn    @click="pe.mer.splice(index,1);" color="#FFA6B1"    outlined rounded icon style="margin:2px; border:3px solid #F3D3FF; margin-top:-30px;" >
                            <v-icon>
                              mdi-close
                            </v-icon>
                          </v-btn>

                          <v-btn    @click="merop.edit=!merop.edit" color="success lighten-1"    outlined rounded icon style="margin:2px; border:3px solid #F3D3FF; margin-top:-30px;" >
                            <v-icon>
                              {{merop.edit?'mdi-chevron-up':'mdi-pencil'}}
                            </v-icon>
                          </v-btn>








                          <span class="display-3 " style="color:#F1FCD5; font-weight:bold; text-shadow: 0px 0px 3px #AF3EFC"> {{merop.start_god}}</span>





                        </td>
                        <td style="padding:15px;border-top:0px;border-right:0px; border-top:0px ; border-bottom:0px;padding-top: 20px; width:659px;text-indent:0px" class="text-left">
                          <span class="body-1 purple--text"> {{merop.name}} <br/> Затраты: 
                            {{ decimal(merop.zatrati_plan.slice(pe.god_ot-pe.fact_god,yearspe.length).reduce(function (a, b) {
                    return Number(a) + Number(b);
                  }),) }} руб. / Экономия: 
                            {{ decimal(merop.cf.slice(pe.god_ot-pe.fact_god,Math.min(end_effect_god_index(merop)+1,(pe.god_do-pe.fact_god)+1)).reduce(function (a, b) {
                    return Number(a) + Number(b);
                  }),) }} руб.</span>
                          <div style="margin-top:5px">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                            <v-btn x-small   @click=";pe.mer.splice(index+1,0,JSON.parse(JSON.stringify(pe.mer[index])));"
                            v-bind="attrs"
                             v-on="on"
                                  icon style="margin:2px; color:#7f26cd" >
                              <v-icon small>
                              mdi-numeric-1-box-multiple-outline
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Скопировать один раз</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn x-small   @click=";pe.mer.splice(index+1,0,JSON.parse(JSON.stringify(pe.mer[index])));pe.mer.splice(index+1,0,JSON.parse(JSON.stringify(pe.mer[index])));"
                            v-bind="attrs"
                             v-on="on"
                                    icon style="margin:2px;color:#7f26cd" >
                              <v-icon small>
                              mdi-numeric-2-box-multiple-outline
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Скопировать два раза</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                            v-bind="attrs"
                             v-on="on"
                             x-small   @click=";pe.mer.splice(index+1,0,JSON.parse(JSON.stringify(pe.mer[index])));pe.mer.splice(index+1,0,JSON.parse(JSON.stringify(pe.mer[index])));pe.mer.splice(index+1,0,JSON.parse(JSON.stringify(pe.mer[index])));"
                                      icon style="margin:2px;color:#7f26cd" >
                              <v-icon small>
                              mdi-numeric-3-box-multiple-outline
                              </v-icon>
                                </v-btn>
                              </template>
                              <span>Скопировать три раза</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs"
                             v-on="on"
                            x-small   @click="ztr=merop.summa_zatrat; new Array(pe.god_do-pe.god_ot+1).fill(null).map((_, i) => pe.god_do-i).forEach((item) => {if (item!==merop.start_god){pe.mer.splice(index+1,0,JSON.parse(JSON.stringify(pe.mer[index])));pe.mer[index+1].start_god=item; pe.mer[index+1].zatrati_plan[item-pe.fact_god]=ztr;cleandonachala(pe.mer[index+1])}});"
                                       icon style="margin:2px;color:#7f26cd" >
                              <v-icon small>
                              mdi-text-box-multiple-outline
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Скопировать, чтобы такое мероприятия было по каждому году</span>
                        </v-tooltip>


                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  </td>
                </tr>
                </tbody>
              </table>





 <v-dialog
          v-model="merop.edit"
          transition="none"
          fullscreen
        >

         <v-card>
            <v-card-title class="text-h5 grey lighten-2 " style="word-break: keep-all;">
              {{merop.name}} <v-spacer />

    
    <v-spacer />
              <v-btn    class=" white--text mr-2 ml-2  mt-2 mb-2  " color="rgba(203, 65, 6, 0.8)"  @click="merop.edit=!merop.edit" 
              style=" ;border:2px solid rgba(198, 0, 0, 0.32)"><span class="pl-2 pr-2 ">Закрыть</span></v-btn>

            </v-card-title>


  <v-card-text  style="overflow-x:scroll; max-width:calc(100vw - 60px); margin-left:20px;">


              <table  id="toplivotable"  cellpadding="0" cellspacing="0"  style="margin:15px auto; "   >

                <tbody>

                <tr>

                  <td style="text-indent: 0px;padding: 10px; vertical-align: top;  ">

                    <table style="border:2px solid #f1d1ff; margin:5px;background-image: radial-gradient( circle 329px at 3.1% 9.3%,  rgb(238,255,233) 28.1%, rgba(230,197,255,0.15) 100.7% );;border-radius:20px" cellpadding="0" cellspacing="0" >
                      <tr>
                        <td colspan="2"   style="text-align: right; border-top:0px ;border-left:0px ; padding-top: 10px;border-right:0px; ">
                          <v-btn
                          color="success"
                           @click="getMER();selectedmerop=index; mertempmaster=true"
                                 x-small  style="margin-right: 15px; margin-bottom:10px;box-shadow: #2DA820 1px 1px 2px; text-shadow:  #ffffff 0px 0px 3px;;
                                 background-image: radial-gradient( circle 100px at 1.1% 15.3%,  rgba(212,171,255,0.82) 50%, rgba(0,246,153,0.52) 100% );
                                 ;border-radius:20px; text-shadow: #0040d4 1px 1px 3px;"

                                 >
                            Заполнить по шаблону</v-btn>
                          <v-btn
                          @click="copmermaster=true;merimport=[];merindextoimport=index;"
                                                   color="success"
                                 x-small  style="margin-right: 15px; margin-bottom:10px;box-shadow: #2DA820 1px 1px 2px; text-shadow:  #ffffff 0px 0px 3px;;
                                 background-image: radial-gradient( circle 100px at 1.1% 15.3%,  rgba(212,171,255,0.82) 50%, rgba(0,246,153,0.52) 100% );
                                 ;border-radius:20px; text-shadow: #0040d4 1px 1px 3px;">
                            Скопировать из другой программы</v-btn>
                          <v-btn @click="mercopy=JSON.parse(JSON.stringify(merop))"
                          color="success"
                                 x-small  style="margin-right: 15px; margin-bottom:10px;box-shadow: #2DA820 1px 1px 2px; text-shadow:  #ffffff 0px 0px 3px;;
                                 background-image: radial-gradient( circle 100px at 1.1% 15.3%,  rgba(212,171,255,0.82) 50%, rgba(0,246,153,0.52) 100% );
                                 ;border-radius:20px; text-shadow: #0040d4 1px 1px 3px;">
                            копировать мероприятие</v-btn>
                          <v-btn :disabled="mercopy==''" @click="$set(pe.mer,index,mercopy);mercopy='';"
                          color="success"
                                 x-small  style="margin-right: 15px; margin-bottom:10px;box-shadow: #2DA820 1px 1px 2px; text-shadow:  #ffffff 0px 0px 3px;;
                                 background-image: radial-gradient( circle 100px at 1.1% 15.3%,  rgba(212,171,255,0.82) 50%, rgba(0,246,153,0.52) 100% );
                                 ;border-radius:20px; text-shadow: #0040d4 1px 1px 3px;">
                            вставить мероприятие</v-btn>


                        </td>
                      </tr>
                      <tr>
                        <td rowspan="2" style=" width:315px;border-right:0px ; border-top:0px ;border-left:0px ; padding-top: 15px ">

                          <FormulaEditTextArea
                              :value.sync="merop.name"
                              rows="8"
                              :allowenter="false"



                              label="Наименование мероприятия"

                              :noresize="true"


                              style=" display: inline-block; margin:7px;  margin-top:10px ;width:300px;background: #ffffff; "

                          />

                        </td>
                        <td style="padding:15px;border-top:0px;border-right:0px; padding-top: 25px">

                          <FormulaEditTextArea
                              :value.sync="merop.object"
                              label="Объект"
                              color="#ffffff"
                              :width="620"
                              rows="2"
                              :allowenter="true"
                              :noresize="true"
                              style="margin-left:7px"
                          ></FormulaEditTextArea>

                        </td>
                        </tr>

                      <tr>
                        <td style="padding:15px;border-top:0px;border-right:0px">


                          <v-combobox
                              v-model="merop.istochnik"
                              dense
                              outlined
                              hide-details
                              :items="['Тариф','Бюждет','Собственные средства','Не требуется']"


                              label="Источник финансирования"

                              style=" display: inline-block; width:310px ;background: #ffffff;   "

                          ></v-combobox>

                          <v-combobox
                              v-model="merop.statia"
                              dense
                              outlined
                              hide-details
                              :items="['Ремонт','Прибыль','Амортизация','Без затрат']"


                              label="Статья затрат"

                              style=" display: inline-block; width:310px;background: #ffffff;    "

                          ></v-combobox>

                        </td>
                      </tr>
                      <tr>
                        <td style="padding:15px;border-top:0px;border-right:0px; border-left:0px">


                          <v-combobox
                              outlined
                              v-model="merop.obosnovanie_doc"
                              dense
                              hide-details
                              label="Обоснование затрат (№ сметы/справки в ПЭ)"
                              :items="itemsformerssmeta()"
                              style="width:300px; display: inline-block;background: #ffffff;"

                          ></v-combobox>
                        </td>
                        <td style="padding:15px;border-top:0px;border-right:0px">
                          <v-autocomplete
                              v-model="merop.start_god"
                              dense
                              :items="new Array(pe.god_do-pe.god_ot+1).fill(null).map((_, i) => i +pe.god_ot)"
                              outlined
                              hide-details
                              label="Год начала мероприятия"
                              style="width:206px; display: inline-block;background: #ffffff;"
                              @change="cleandonachala(merop)"



                          ></v-autocomplete>
                          <v-text-field
                              v-model="merop.discont"
                              dense
                              outlined
                              hide-details
                              type="number"
                              step="0.1"
                              label="Ставка дисконтирования, %"
                              style="width:206px; display: inline-block;background: #ffffff;"



                          ></v-text-field>



                          <v-autocomplete
                              v-model="merop.amort"
                              dense
                              outlined
                              :items="new Array(101).fill(null).map((_, i) => i )"

                              hide-details
                              label="Срок амортизации, лет"
                              style="width:206px; display: inline-block;background: #ffffff;"



                          ></v-autocomplete>
                        </td>
                        </tr>
                      <tr>
                        <td style="padding:15px;border-top:0px;border-right:0px; border-left:0px">


                          <v-text-field
                              :value="decimal(merop.srok_okup,3)"
                              dense
                              outlined
                              hide-details

                              readonly
                              label="Пр. срок окуп., лет"
                              style="width:150px; display: inline-block; "
                          ></v-text-field>
                          <v-text-field
                              :value="decimal(merop.disk_srok_okup,3)"
                              dense
                              outlined
                              hide-details


                              readonly
                              label="Диск. ср. окуп., лет"
                              style="width:150px; display: inline-block;  "
                          ></v-text-field>




                        </td>
                        <td style="padding:15px;border-top:0px;border-right:0px">

                          <v-text-field
                              :value="decimal(merop.summa_zatrat)"
                              dense
                              outlined
                              hide-details

                              readonly
                              label="Затраты, руб."
                              style="width:155px; display: inline-block; "
                          ></v-text-field>
                          <v-text-field
                              :value="decimal(merop.dolya_invest)+'%'"
                              dense
                              outlined
                              hide-details

                              readonly
                              label="Доля в ИП, %"
                              style="width:155px; display: inline-block;  "
                          ></v-text-field>
                          <v-text-field
                              :value="decimal(merop.vnd,3)"
                              dense
                              outlined
                              hide-details

                              readonly
                              label="ВНД, %"
                              style="width:155px; display: inline-block; "
                          ></v-text-field>
                          <v-text-field
                              :value="decimal(merop.chdd)"
                              dense
                              outlined
                              hide-details

                              readonly
                              label="ЧДД, руб."
                              style="width:155px; display: inline-block; "
                          ></v-text-field>


                        </td>
                      </tr>
                      <tr>
                        <td style="padding:15px;border-top:0px;border-right:0px; border-left:0px;" colspan="2">

                          <div class="subtitle-2 text-left " style="margin-left:15px;"> Финансовые показатели</div>

                          <div style="max-width:952px; margin-left:10px; overflow-x: scroll; padding:20px;border-radius: 5px; border: 1px solid #9F8F8B ; ">


                            <table id="toplivotable" border="1" cellpadding="0" cellspacing="0" style="background-color: #FFFFFF" >
                              <thead>
                              <tr>


                                <th class="text-center" style="min-width:230px;max-width:230px"  rowspan="3">
                                  Показатели
                                </th>

                                <th v-for="item in yearsprognoz" :key="item" class="text-center" style="min-width:110px;max-width:110px"
                                    v-show="item>=merop.start_god " >
                                  <span>{{item}}</span>
                                </th>
                              </tr>
                              <tr>



                                <th v-for="item in yearsprognoz" :key="item" style="min-width:110px;max-width:110px; line-height: 0.95rem" v-show="item>=merop.start_god ">

      <span>

        {{item==pe.fact_god?'Факт':''}}
        {{(item==pe.fact_god) && (pe.fact_god==(pe.god_ot-1))?' / ':''}}
        {{item==(pe.god_ot-1)?'Базовый год':''}}
        {{ (item>=pe.god_ot && !(item>pe.god_do))?' ПЭ ':''}}
      </span>
                                </th>
                              </tr>



                              <tr>



                                <th v-for="(item,index) in yearsprognoz" :key="item" style="min-width:110px;max-width:110px; line-height: 0.95rem" v-show="item>=merop.start_god ">

      <span>

        {{index-(merop.start_god-pe.fact_god)+1}}
      </span>
                                </th>
                              </tr>

                              </thead>
                              <tbody>


                              <tr >

                                <td class="text-left" style="text-indent: 0px" >
                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;"
                                      readonly
                                      value="Инвестиции, руб."
                                      hide-details
                                  />
                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;"
                                      readonly
                                      value="Денежный поток, руб."
                                      hide-details
                                  />
                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;"
                                      readonly
                                      value="Доход, руб."
                                      hide-details
                                  />
                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;"
                                      readonly
                                      value="Диск. денежный поток, руб."
                                      hide-details
                                  />

                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;"
                                      readonly
                                      value="Чистый диск. доход, руб."
                                      hide-details
                                  />

                                </td>
                                <td v-for="(item,index) in yearsprognoz" :key="item" class="text-left" v-show="item>=merop.start_god " >

                                  <v-text-field
                                      :value="decimal(merop.zatrati_plan[index])"
                                      dense
                                      style="margin:0px;border-bottom:1px solid #D6C4BE;"
                                      readonly
                                      hide-details


                                  />
                                  <v-text-field
                                      :value="decimal(merop.cf[index])"
                                      dense
                                      style="margin:0px;border-bottom:1px solid #D6C4BE;"
                                      readonly
                                      hide-details


                                  />
                                  <v-text-field
                                      :value="decimal(merop.dohodarray[index])"
                                      dense
                                      style="margin:0px;border-bottom:1px solid #D6C4BE;"
                                      readonly
                                      hide-details
                                  />
                                  <v-text-field
                                      :value="decimal(merop.dcf[index])"
                                      dense
                                      style="margin:0px;border-bottom:1px solid #D6C4BE;"
                                      readonly
                                      hide-details


                                  />

                                  <v-text-field
                                      :value="decimal(merop.chddarray[index])"
                                      dense
                                      style="margin:0px;border-bottom:1px solid #D6C4BE;"
                                      readonly
                                      hide-details


                                  />



                                </td>

                              </tr>






                              </tbody>
                            </table>
                          </div>


                        </td>

                      </tr>
                      <tr>
                        <td style="padding:15px;border-top:0px;border-right:0px; border-left:0px;" colspan="2">

                          <div class="subtitle-2 text-left " style="margin-left:15px;"> Затраты на реализацию мероприятия</div>

                          <div style="max-width:952px; margin-left:10px; overflow-x: scroll; padding:20px;border-radius: 5px; border: 1px solid #9F8F8B ; ">


                            <table id="toplivotable" border="1" cellpadding="0" cellspacing="0" style="background-color: #FFFFFF" >
                              <thead>
                              <tr>


                                <th class="text-center" style="min-width:95px;max-width:95px"  rowspan="2">
                                  Ед. изм.
                                </th>

                                <th v-for="item in yearsprognoz" :key="item" class="text-center" style="min-width:110px;max-width:110px"
                                    v-show="item>=merop.start_god " >
                                  <span>{{item}}</span>
                                </th>
                              </tr>
                              <tr>



                                <th v-for="item in yearsprognoz" :key="item" style="min-width:110px;max-width:110px; line-height: 0.95rem" v-show="item>=merop.start_god">

      <span>

        {{item==pe.fact_god?'Факт':''}}
        {{(item==pe.fact_god) && (pe.fact_god==(pe.god_ot-1))?' / ':''}}
        {{item==(pe.god_ot-1)?'Базовый год':''}}
        {{ (item>=pe.god_ot && !(item>pe.god_do))?' ПЭ ':''}}
      </span>
                                </th>
                              </tr>
                              </thead>
                              <tbody>


                              <tr >

                                <td class="text-left" style="text-indent: 0px" >
                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;"
                                      readonly
                                      value="руб. (план)"
                                      hide-details
                                  />
                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;border-top:2px solid #29DF12;"
                                      readonly
                                      value="руб. (факт)"
                                      hide-details
                                  />

                                </td>
                                <td v-for="(item,index) in yearsprognoz" :key="item" class="text-left" v-show="item>=merop.start_god" >

                                  <FormulaEdit
                                      :value.sync="merop.zatrati_plan[index]"
                                      :nocalc="true"
                                      :formulavalue="true"

                                      :decimal="2"
                                      style=" border-bottom:1px solid #D6C4BE;"
                                      :color="item>pe.god_do?'#FDFFD8':'#EBFFD5'"

                                  />
                                  <FormulaEdit
                                      :value.sync="merop.zatrati_fact[index]"
                                      :nocalc="true"
                                      :formulavalue="true"
                                      style=" border-bottom:1px solid #D6C4BE;border-top:2px solid #29DF12;"
                                      :decimal="2"
                                      :color="item>pe.god_do?'#FDFFD8':'#EBFFD5'"

                                  />

                                </td>

                              </tr>






                              </tbody>
                            </table>
                          </div>


                        </td>

                      </tr>
                      <tr>
                        <td style="padding:15px;border-top:0px;border-right:0px; border-left:0px;" colspan="2">



                          <FormulaEditTextArea
                              :value.sync="merop.technologii"
                              rows="14"
                              :allowenter="true"



                              label="Принципы определения технологического эффекта"

                              :noresize="true"


                              style=" display: inline-block;   margin-top:20px ;width:960px; background: #ffffff;"

                          />



                        </td>

                      </tr>
                      <tr>
                        <td style="padding:15px;border-top:0px;border-right:0px; border-left:0px;" colspan="2">

                          <v-autocomplete
                              v-model="merop.period_effect"
                              rows="10"
                              :items="['На период окупаемости','На период окупаемости и ещё два года','На период срока амортизации','По значениям в таблицах']"

                              outlined
                              hide-details
                              label="В течение какого периода учитывать экономию ТЭР и эффект изменения показателей?"

                              no-resize


                              style=" display: inline-block;   margin-top:2px ;width:960px; background: #ffffff;"

                          ></v-autocomplete>



                        </td>

                      </tr>


                      <tr>
                        <td style="padding:15px;border-top:0px;border-right:0px; border-left:0px;" colspan="2">

                          <div class="subtitle-2 text-left " style="margin-left:15px;"> Расчёт изменений показателей при реализации программы</div>

                          <div style="max-width:952px; margin-left:10px; overflow-x: scroll; padding:20px;border-radius: 5px; border: 1px solid #9F8F8B ; ">






                            <table id="toplivotable" border="1" cellpadding="0" cellspacing="0" style="background-color: #FFFFFF" >
                              <thead>
                              <tr>


                                <th class="text-right pr-1" style="min-width:140px;max-width:140px"  >
                                  Показатель
                                </th>
                                <td v-for="perem in merop.raschet"  height="90" width="130" style="min-width:130px; text-indent: 0px; padding:0px;" :key="perem">

                                  <FormulaEditTextArea
                                      :value.sync="perem.name"

                                      :allowenter="true"
                                      :rows="5"

                                      :noresize="true"



                                      style="width:100%;  margin:0px; margin-bottom:-20px; margin-left:-2px;"

                                  />
                                </td>

                              </tr>

                              <tr>


                                <th class="text-right pr-1" style="min-width:140px;max-width:140px" >
                                  Переменная
                                </th>
                                <td v-for="perem in merop.raschet"  style="width:110px;" :key="perem" >

                                  <FormulaEditText
                                      :value.sync="perem.var"

                                  ></FormulaEditText>
                                </td>

                              </tr>
                              <tr>



                                <th class="text-right pr-1" style="min-width:140px;max-width:140px; vertical-align: top"  rowspan="2"  >
                                  Формула/значение
                                </th>
                                <td v-for="perem in merop.raschet" style="width:110px;" :key="perem" >
                                  <FormulaEdit
                                      :value="perem.value"
                                      :formula.sync="perem.formula"
                                      :decimal="perem.decimal"
                                      :nocalc="true"
                                      :mark='!isformula(perem.formula)'
                                      color="#e3ffbf"/>
                                </td>

                              </tr>
                              <tr>
                                <td v-for="(perem,index) in merop.raschet"  style="width:110px;" :key="perem">
                                  <v-btn   @click="merop.raschet.splice(index,1);" color="#FFA6B1"  x-small  outlined rounded icon style="margin:2px; border:3px solid #F3D3FF" >
                                    <v-icon x-small>
                                      mdi-close
                                    </v-icon>
                                  </v-btn>
                                  <v-btn   @click="()=>{if(!perem.decimal){perem.decimal=1;pe.trigger++}else{perem.decimal=perem.decimal-1;pe.trigger++};}" color="#aaaaaa"  x-small  outlined rounded icon style="margin:2px; border:3px solid #F3D3FF" >
                                    <v-icon >
                                      mdi-decimal-decrease
                                    </v-icon>
                                  </v-btn>
                                  <v-btn   @click="()=>{if(!perem.decimal){perem.decimal=3;pe.trigger++}else{perem.decimal=perem.decimal+1;pe.trigger++};}" color="#aaaaaa"  x-small  outlined rounded icon style="margin:2px; border:3px solid #F3D3FF" >
                                    <v-icon >
                                      mdi-decimal-increase
                                    </v-icon>
                                  </v-btn>
                                </td>
                              </tr>

                              </thead>

                            </table>
                            <div class="text-left py-2 my-2">
                              <v-btn
                                rounded
                                :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
                                small
                                style="color:rgb(255, 255, 255);  "
                                class="ml-4 "
                                @click="merop.raschet.push({name:'',var:'',value:'0',formula:'0'});" color="success">
                              <v-icon class="mr-1">
                                mdi-plus
                              </v-icon>добавить показатель

                            </v-btn></div>










                          </div>


                        </td>

                      </tr>

                      <tr>
                        <td style="padding:15px;border-top:0px;border-right:0px; border-left:0px;" colspan="2">
                          <div class="subtitle-2 text-left " style="margin-left:15px;">Экономия ТЭР при реализации мероприятия </div>

                          <div style="max-width:952px; margin-left:10px; overflow-x: scroll; padding:20px;border-radius: 5px; border: 1px solid #9F8F8B;border-style: solid;">
                            <div style="margin-bottom:15px; " class="text-left">

                              <v-btn
                                rounded
                                :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
                               small
                                style="color:rgb(255, 255, 255);  "
                                class="ml-4 "
                                @click="addtermer(merop);" color="success">
                              <v-icon class="mr-1">
                                mdi-plus
                              </v-icon>добавить ТЭР

                            </v-btn>
                            </div>

                            <table id="toplivotable" border="1" cellpadding="0" cellspacing="0" style="background: #FFFFFF;" >
                              <thead>
                              <tr>
                                <th class="text-center" style="min-width:190px;max-width:190px"  rowspan="2">
                                  Ед. изм.
                                </th>

                                <th v-for="item in yearsprognoz" :key="item" class="text-center" style="min-width:110px;max-width:110px"
                                    v-show="item>=merop.start_god " >
                                  <span>{{item}}</span>
                                </th>
                              </tr>
                              <tr>



                                <th v-for="item in yearsprognoz" :key="item" style="min-width:120px;max-width:120px; line-height: 0.95rem" v-show="item>=merop.start_god ">

      <span>

        {{item==pe.fact_god?'Факт':''}}
        {{(item==pe.fact_god) && (pe.fact_god==(pe.god_ot-1))?' / ':''}}
        {{item==(pe.god_ot-1)?'Базовый год':''}}
        {{ (item>=pe.god_ot && !(item>pe.god_do))?' ПЭ ':''}}
      </span>
                                </th>
                              </tr>
                              </thead>
                              <tbody>


                              <template v-for="(ektopl,index) in merop.ter" >
                                <tr :key="ektopl"  >
                                  <td class="text-left pl-2" style="text-indent: 0px;background: #FFFFFF; "
                                      :colspan="yearsprognoz.length-(pe.god_ot-pe.fact_god)+1"  >
                                    <v-btn   @click="merop.ter.splice(index,1);" color="#FFA6B1"  small  outlined rounded icon style="margin:2px; border:3px solid #F3D3FF" >
                                      <v-icon>
                                        mdi-close
                                      </v-icon>
                                    </v-btn>
                                    <v-autocomplete

                                        outlined

                                        dense
                                        label="Вид ТЭР"
                                        v-model="ektopl.name"
                                        :items="pe.ter.map(x=>x.name)"
                                        style="margin:10px; display: inline-block; width:350px; background: #e3ffbf; "
                                        hide-details



                                    />

                                  </td>
                                </tr>

                                <tr :key="ektopl">

                                <td class="text-left" style="text-indent: 0px; border-bottom: 3px solid #CDCCD6;  padding-left:10px " >

                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;"
                                      readonly
                                      :value="(pe.ter.map(x=>x.name).indexOf(ektopl.name)>-1?pe.ter.find(x=>(x.name==ektopl.name)).ed:'') +' (план)'"
                                      hide-details
                                  />


                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;"
                                      readonly
                                      :value="'руб./'+  (pe.ter.map(x=>x.name).indexOf(ektopl.name)>-1?pe.ter.find(x=>(x.name==ektopl.name)).ed:'') +' (план)'"
                                      hide-details
                                  />
                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;"
                                      readonly
                                      value="Экономия, руб.(план)"
                                      hide-details
                                  />
                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;"
                                      readonly
                                      value="Экономия, т.у.т.(план)"
                                      hide-details
                                  />
                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;;border-top:2px solid #29DF12;"
                                      readonly
                                      :value="(pe.ter.map(x=>x.name).indexOf(ektopl.name)>-1?pe.ter.find(x=>(x.name==ektopl.name)).ed:'') +' (факт)'"
                                      hide-details
                                  />

                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE"
                                      readonly
                                      :value="'руб./'+  (pe.ter.map(x=>x.name).indexOf(ektopl.name)>-1?pe.ter.find(x=>(x.name==ektopl.name)).ed:'') +' (факт)'"
                                      hide-details
                                  />



                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;"
                                      readonly
                                      value="Экономия, руб.(факт)"
                                      hide-details
                                  />
                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;"
                                      readonly
                                      value="Экономия, т.у.т.(факт)"
                                      hide-details

                                  />


                                </td>
                                <td v-for="(item,index) in yearsprognoz" :key="item" class="text-left"
                                    v-show="item>=merop.start_god "  style="border-bottom: 3px solid #CDCCD6; vertical-align: top;">





                                  <FormulaEdit
                                      :value="ektopl.delta_volume_plan[index]"
                                      :formula.sync="ektopl.delta_volume_plan_formula[index]"
                                      :decimal="2"
                                      :nocalc="true"
                                      color="#e3ffbf"
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;"
                                      @change="autofillplan(true,ektopl.delta_volume_plan,index,yearsprognoz.length-1,ektopl.delta_volume_plan[index]);
                                               autofillplan(true,ektopl.delta_volume_plan_formula,index,yearsprognoz.length-1,ektopl.delta_volume_plan_formula[index]);"/>

                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;"
                                      :value="ektopl.price_plan[index].toLocaleString('ru-ru',{ minimumFractionDigits: 2,maximumFractionDigits: 2 })"
                                      readonly
                                      hide-details
                                  />

                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;"
                                      readonly
                                      :value="ektopl.delta_rub_plan[index].toLocaleString('ru-ru',{ minimumFractionDigits: 2,maximumFractionDigits: 2 })"
                                      hide-details
                                  />

                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;"
                                      :value="ektopl.tut_plan[index].toLocaleString('ru-ru',{ minimumFractionDigits: 2,maximumFractionDigits: 2 })"
                                      hide-details
                                      readonly
                                      v-if="item<=pe.god_do"
                                  />

                                  <FormulaEdit
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;border-top:2px solid #29DF12;"
                                      :value.sync="ektopl.delta_volume_fact[index]"
                                      :nocalc="true"
                                      :decimal="2"
                                      :formulavalue="true"
                                      color="#e3ffbf"

                                      v-if="item<=pe.god_do"
                                  />

                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;"
                                      :value="ektopl.price_fact[index].toLocaleString('ru-ru',{ minimumFractionDigits: 2,maximumFractionDigits: 2 })"
                                      hide-details
                                      readonly
                                      v-if="item<=pe.god_do"
                                  />



                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;"
                                      :value="ektopl.delta_rub_fact[index].toLocaleString('ru-ru',{ minimumFractionDigits: 2,maximumFractionDigits: 2 })"
                                      hide-details
                                      readonly
                                      v-if="item<=pe.god_do"
                                  />
                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;"
                                      :value="ektopl.tut_fact[index].toLocaleString('ru-ru',{ minimumFractionDigits: 2,maximumFractionDigits: 2 })"
                                      hide-details
                                      readonly
                                      v-if="item<=pe.god_do"

                                  />





                                </td>
                                </tr>
                              </template>


                              </tbody>
                            </table>
                          </div>


                        </td>

                      </tr>

                     <tr>
                        <td style="padding:15px;border-top:0px;border-right:0px; border-left:0px;" colspan="2">
                          <div class="subtitle-2 text-left " style="margin-left:15px;">Изменение показателей при реализации мероприятия (снижение указать со знаком минус) </div>

                          <div style="max-width:952px; margin-left:10px; overflow-x: scroll; padding:20px;border-radius: 5px; border: 1px solid #9F8F8B;border-style: solid;">
                            <div style="margin-bottom:15px; " class="text-left"><v-btn
                                rounded

                                small
                                :disabled="!pe.celev.filter(x=>(x.formula_plan.find(myObj => myObj.toLowerCase().indexOf('эффектпэ')>=0)!=null) || (x.formula_fact.find(myObj => myObj.toLowerCase().indexOf('эффектпэ')>=0)!=null)).length>0"
                                style="color:rgb(255, 255, 255);  "
                                class="ml-4 "
                                @click="addcppmer(merop);" color="success">
                              <v-icon class="mr-1">
                                mdi-plus
                              </v-icon>добавить показатель

                            </v-btn>
                            </div>

                            <table id="toplivotable" border="1" cellpadding="0" cellspacing="0" style="background: #FFFFFF" >
                              <thead>
                              <tr>


                                <th class="text-center" style="min-width:130px;max-width:130px"  rowspan="2">
                                  Ед. изм.
                                </th>

                                <th v-for="item in yearsprognoz" :key="item" class="text-center" style="min-width:110px;max-width:110px"
                                    v-show="item>=merop.start_god " >
                                  <span>{{item}}</span>
                                </th>
                              </tr>
                              <tr>



                                <th v-for="item in yearsprognoz" :key="item" style="min-width:110px;max-width:110px; line-height: 0.95rem"
                                    v-show="item>=merop.start_god ">

      <span>

        {{item==pe.fact_god?'Факт':''}}
        {{(item==pe.fact_god) && (pe.fact_god==(pe.god_ot-1))?' / ':''}}
        {{item==(pe.god_ot-1)?'Базовый год':''}}
        {{ (item>=pe.god_ot && !(item>pe.god_do))?' ПЭ ':''}}
      </span>
                                </th>
                              </tr>
                              </thead>
                              <tbody>


                              <template v-for="(pok,index) in merop.cp" >
                                <tr :key="pok"  >
                                  <td class="text-left pl-2" style="text-indent: 0px;background: #FFFFFF; "
                                      :colspan="yearsprognoz.length-(pe.god_ot-pe.fact_god)+1"  >
                                    <v-btn   @click="merop.cp.splice(index,1);" color="#FFA6B1"  small  outlined rounded icon style="margin:2px; margin-top:-25px; margin-left:10px; border:3px solid #F3D3FF" >
                                      <v-icon>
                                        mdi-close
                                      </v-icon>
                                    </v-btn>
                                    <v-autocomplete

                                        filled


                                        label="Вид показателя"
                                        dense
                                        v-model="pok.name"
                                        :items="pe.celev.filter(x=>(x.formula_plan.find(myObj => myObj.toLowerCase().indexOf('эффектпэ')>=0)!=null) || (x.formula_fact.find(myObj => myObj.toLowerCase().indexOf('эффектпэ')>=0)!=null)).map(x=>x.name)"

                                        style="margin:10px; display: inline-block; width:840px;  "
                                        hide-details



                                    />

                                  </td>
                                </tr>
                                <tr :key="pok">

                                <td class="text-left" style="text-indent: 0px; padding-left:5px" >


                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;"
                                      readonly
                                      :value="(pe.celev.map(x=>x.name).indexOf(pok.name)>-1?pe.celev.find(x=>(x.name==pok.name)).ed:'')+ ' (план)'"
                                      hide-details
                                  />


                                  <v-text-field
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;"
                                      readonly
                                      :value="(pe.celev.map(x=>x.name).indexOf(pok.name)>-1?pe.celev.find(x=>(x.name==pok.name)).ed:'')+ ' (факт)'"
                                      hide-details
                                  />
                                </td>
                                <td v-for="(item,index) in yearsprognoz" :key="item" class="text-left" v-show="item>=merop.start_god " >




                                  <FormulaEdit
                                      :value="pok.delta_plan[index]"
                                      :formula.sync="pok.delta_plan_formula[index]"
                                      :decimal="pe.celev.find(x=>(x.name==pok.name)).decimal"
                                      :nocalc="true"
                                      color="#e3ffbf"
                                      v-show="item<=pe.god_do"
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;"
                                      @change="autofillplan(true,pok.delta_plan,index,yearsprognoz.length-1,pok.delta_plan[index]);
                                               autofillplan(true,pok.delta_plan_formula,index,yearsprognoz.length-1,pok.delta_plan_formula[index]);"/>






                                  <FormulaEdit
                                      dense
                                      style="margin:0px; border-bottom:1px solid #D6C4BE;border-top:2px solid #29DF12;"
                                      :value.sync="pok.delta_fact[index]"
                                      :nocalc="true"
                                      :decimal="pe.celev.find(x=>(x.name==pok.name)).decimal"
                                      :formulavalue="true"
                                      color="#e3ffbf"

                                      v-if="item<=pe.god_do"
                                  />





                                </td>

                              </tr>
                              </template>








                              </tbody>
                            </table>
                          </div>


                        </td>

                      </tr>

                    </table>
















                  </td>



                </tr>



                </tbody>
              </table>

            </v-card-text>
            </v-card>
            </v-dialog>





              </div>


            </v-card-text>

          </v-card>





        </v-card-text>
        

      </v-card>
    </v-tab-item>
    <v-tab-item >
      <v-app-bar


          floating
          light
          dense
          style="background:url('/fon-3.png'); width:100%"
          elevation="0"

      >
        <v-card-title>
          <table>
            <tr>
              <td style="width:90vw">
                <v-icon class="mr-0" style="margin-top:-2px">
                  mdi-file-document-check
                </v-icon>
                Приложения к программе энергосбережения

                <span class="white--text">{{tut}}</span>
                </td>

              <td style="width:10vw; min-width:250px"> </td>
            </tr>
          </table>









        </v-card-title>

      </v-app-bar>

      <v-card elevation="2" class="pb-5   mb-0" style="  border: 1px solid  rgb(194, 194, 194);background:url('/fon-5.png');border-radius:0px; height:81vh; width:89vw; min-width:530px; overflow-y:scroll;
">


        <v-card-text>
          <v-alert v-if="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
                   icon="mdi-arrow-top-left"
                   prominent
                   text
                   type="purple lighten-1"
          >


            Для добавления показателей заполните на вкладке "Наименование":<br/>1) год начала программы,<br/>2) год окончания программы, <br/>3) последний завершённый год (панель "Индексы" на вкладке "Наименование").
          </v-alert>


          <v-expansion-panels>


    <v-expansion-panel>
      <v-expansion-panel-header class="text-bold">
        Сметы, дефектные ведомости, калькуляции, прайс-листы, конъюнктурные справки <v-chip small class="mx-2 px-3" style="max-width:35px;">  {{pe.pril.sm.length}}</v-chip>
      </v-expansion-panel-header>
      <v-expansion-panel-content style="border:1px solid rgb(226, 226, 226); border-radius:15px; margin:20px; padding:20px">

        <v-btn @click="newattachfile=true;razdelprilfile='Сметы, дефектовки и т.п.';" small rounded style="margin-top:10px" class="mr-1 success"><v-icon>mdi-file-upload-outline</v-icon>загрузить материалы</v-btn>
        <v-btn @click="razdelpril='Сметы, дефектовки и т.п.';razdelinew='';newattachlabel=true" small rounded style="margin-top:10px"  class=" success mr-1"><v-icon>mdi-label-outline</v-icon> добавить пункт содержания</v-btn>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
        <sup>
          <v-btn
          v-bind="attrs"
          v-on="on"


          @click=" closeallmer();closeallter();tabpe=6; showwordpe=true;"
          href="#smeti"

            text
          x-small
          :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"


          color="success"  style="text-shadow:  #8af025 0px 0px 2px; margin-left:-7px ;  "

        > ПЭ
        <v-icon small  color="success"  style="text-shadow:  #8af025 0px 0px 2px;
        ">
        mdi-open-in-new
        </v-icon>

        </v-btn></sup>
        </template>
        <span>Просмотреть приложения по сметам в программе энергосбережения</span>
        </v-tooltip>


        <div style="border:1px solid rgb(226, 226, 226); border-radius:15px; margin-top:20px; padding:20px">


        <template v-for="(item,index) in pe.pril.sm" >


          <div style="border:1px solid #D1A2D0; border-radius:10px; background:#FAFAFA;margin-left:50px"
               class=" px-2 py-2 my-4 mr-4 "
               v-if="item.type=='label'"
               :key="item">
            <v-icon large class="mr-0  lighten-2" style="margin-top:-3px; ">
              mdi-label-outline
            </v-icon>
            Пункт содержания:
            <span class="title ml-1 ">

           <FormulaEditText
               :value.sync="item.name"


               :width="800"
               color="#FAFAFA"
               style="margin-left:7;display:inline-block"
           ></FormulaEditText></span>


            <v-btn @click="pe.pril.sm.splice(index,1)" icon style="float:right"><v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
              mdi-close
            </v-icon></v-btn>
            <v-btn :disabled="index==0" @click="element=pe.pril.sm[index-1];pe.pril.sm.splice(index-1,1,pe.pril.sm[index]);pe.pril.sm[index]=element;" icon style="float:right">
              <v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
                mdi-chevron-up
              </v-icon></v-btn>
            <v-btn :disabled="index==pe.pril.sm.length-1"
                   @click="element=pe.pril.sm[index+1];pe.pril.sm.splice(index+1,1,pe.pril.sm[index]);pe.pril.sm[index]=element;"
                   icon style="float:right"><v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
              mdi-chevron-down
            </v-icon></v-btn>
            <v-btn style="float:right" @click="razdelprilfile='Сметы, дефектовки и т.п.'; soderzhpunkt=item.name; newattachfile=true; " icon  >
              <v-icon large class="mr-0  lighten-2">mdi-file-upload-outline</v-icon></v-btn>
          </div>

          <span style="margin-left:50px;" :key="item">


            <div  style="border:1px solid #D1A2D0; border-radius:10px;
             width:215px; display: inline-block; background:#FAFAFA; "
                 class=" px-2 py-2 my-4 mr-1 "
                 v-if="item.type=='file'"
                 >
              <div>
                <v-btn @click="pe.pril.sm.splice(index,1)" icon style="float:right"><v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
                  mdi-close
                </v-icon></v-btn>
                <v-btn :disabled="index==pe.pril.sm.length-1"
                       @click="element=pe.pril.sm[index+1];pe.pril.sm.splice(index+1,1,pe.pril.sm[index]);pe.pril.sm[index]=element;"
                       icon style="float:right"><v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
                  mdi-chevron-right
                </v-icon></v-btn>
                <v-btn :disabled="index==0" @click="element=pe.pril.sm[index-1];pe.pril.sm.splice(index-1,1,pe.pril.sm[index]);pe.pril.sm[index]=element;"
                       icon style="float:right">
                  <v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
                    mdi-chevron-left
                  </v-icon></v-btn>изображение



              </div>


              <a style="text-decoration:none"  :href="makefilelink(item)" target="_blank"><img :src="makefilelink(item)" width="200" alt="" /></a>



          </div>
        </span>


          <div v-if="item.type=='text'" style="border:1px solid #D1A2D0; border-radius:10px; margin-left:70px"
               class=" px-2 py-2 my-4 mr-4 "  :key="item">
            <v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
              mdi-text
            </v-icon>
            Блок текста:
            <v-btn @click="pe.pril.sm.splice(index,1)" icon style="float:right"><v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
              mdi-close
            </v-icon></v-btn>
            <v-btn :disabled="index==0" @click="element=pe.pril.sm[index-1];pe.pril.sm.splice(index-1,1,pe.pril.sm[index]);pe.pril.sm[index]=element;"
                   icon style="float:right"><v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
              mdi-chevron-up
            </v-icon></v-btn>
            <v-btn :disabled="index==pe.pril.sm.length-1" @click="element=pe.pril.sm[index+1];pe.pril.sm.splice(index+1,1,pe.pril.sm[index]);pe.pril.sm[index]=element;"
                   icon style="float:right"><v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
              mdi-chevron-down
            </v-icon></v-btn>


            <proeditpril  :value="item.text" style="width:95%" v-on:changer="item.text=$event"  />
          </div>


        </template>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>


<v-expansion-panel>
    <v-expansion-panel-header class="text-bold">
      Отчёты по энергосбережению за последние 5 лет <v-chip small class="mx-2 px-3" style="max-width:35px;">   {{pe.pril.report.length}}</v-chip>
    </v-expansion-panel-header>
    <v-expansion-panel-content style="border:1px solid rgb(226, 226, 226); border-radius:15px; margin:20px; padding:20px">

      <v-btn @click="newattachfile=true;razdelprilfile='Отчёты по ПЭ за 5 лет';" small rounded style="margin-top:10px"  class="mr-1 success">
        <v-icon>mdi-file-upload-outline</v-icon>загрузить материалы</v-btn>

      <v-btn @click="razdelpril='Отчёты по ПЭ за 5 лет';razdelinew='';newattachlabel=true" small rounded style="margin-top:10px"  class="mr-1 success">
        <v-icon>mdi-label-outline</v-icon> добавить пункт содержания</v-btn>

        <v-btn @click="copyprilanotherpe=true;" small rounded style="margin-top:10px"  class="mr-1 success">
          <v-icon small>mdi-content-copy</v-icon>  скопировать из другой программы</v-btn>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
          <sup>
            <v-btn
            v-bind="attrs"
            v-on="on"


            @click=" closeallmer();closeallter();tabpe=6; showwordpe=true;"
            href="#otchetipe"

              text
            x-small
            :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"


            color="success"  style="text-shadow:  #8af025 0px 0px 2px; margin-left:-7px ;  "

          > ПЭ
          <v-icon small  color="success"  style="text-shadow:  #8af025 0px 0px 2px;
          ">
          mdi-open-in-new
          </v-icon>

          </v-btn></sup>
          </template>
          <span>Просмотреть приложения по отчётам в программе энергосбережения</span>
          </v-tooltip>



          <div style="border:1px solid rgb(226, 226, 226); border-radius:15px; margin-top:20px; padding:20px">
            <template v-for="(item,index) in pe.pril.report">


              <div style="border:1px solid #D1A2D0; border-radius:10px; background:#FAFAFA;margin-left:50px"
                   class=" px-2 py-2 my-4 mr-4 "
                   v-if="item.type=='label'"
                   :key="item">
                <v-icon large class="mr-0  lighten-2" style="margin-top:-3px; ">
                  mdi-label-outline
                </v-icon>Пункт содержания:
                <span class="title ml-1 ">

               <FormulaEditText
                   :value.sync="item.name"


                   :width="800"
                   color="#FAFAFA"
                   style="margin-left:7;display:inline-block"
               ></FormulaEditText></span>


                <v-btn @click="pe.pril.report.splice(index,1)" icon style="float:right"><v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
                  mdi-close
                </v-icon></v-btn>
                <v-btn :disabled="index==0" @click="element=pe.pril.report[index-1];pe.pril.report.splice(index-1,1,pe.pril.report[index]);pe.pril.report[index]=element;" icon style="float:right">
                  <v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
                    mdi-chevron-up
                  </v-icon></v-btn>
                <v-btn :disabled="index==pe.pril.report.length-1"
                       @click="element=pe.pril.report[index+1];pe.pril.report.splice(index+1,1,pe.pril.report[index]);pe.pril.report[index]=element;"
                       icon style="float:right"><v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
                  mdi-chevron-down
                </v-icon></v-btn>
                <v-btn style="float:right" @click="razdelprilfile='Отчёты по ПЭ за 5 лет'; soderzhpunkt=item.name; newattachfile=true; " icon  >
                  <v-icon large class="mr-0  lighten-2">mdi-file-upload-outline</v-icon></v-btn>
              </div>

              <span style="margin-left:50px;" :key="item">


                <div  style="border:1px solid #D1A2D0; border-radius:10px;
                 width:215px; display: inline-block; background:#FAFAFA; "
                     class=" px-2 py-2 my-4 mr-1 "
                     v-if="item.type=='file'"
                     >
                <div>
                  <v-btn @click="pe.pril.report.splice(index,1)" icon style="float:right"><v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
                    mdi-close
                  </v-icon></v-btn>
                  <v-btn :disabled="index==pe.pril.report.length-1"
                         @click="element=pe.pril.report[index+1];pe.pril.report.splice(index+1,1,pe.pril.report[index]);pe.pril.report[index]=element;"
                         icon style="float:right"><v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
                    mdi-chevron-right
                  </v-icon></v-btn>
                  <v-btn :disabled="index==0" @click="element=pe.pril.report[index-1];pe.pril.report.splice(index-1,1,pe.pril.report[index]);pe.pril.report[index]=element;"
                         icon style="float:right">
                    <v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
                      mdi-chevron-left
                    </v-icon></v-btn>изображение



                </div>

                <a style="text-decoration:none" :href="makefilelink(item)" target="_blank" ><img  :src="makefilelink(item)" width="200" alt="" /></a>


              </div>
            </span>


              <div v-if="item.type=='text'" style="border:1px solid #D1A2D0; border-radius:10px; margin-left:70px"
                   class=" px-2 py-2 my-4 mr-4 "  :key="item">
                <v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
                  mdi-text
                </v-icon>Блок текста:
                <v-btn @click="pe.pril.report.splice(index,1)" icon style="float:right"><v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
                  mdi-close
                </v-icon></v-btn>
                <v-btn :disabled="index==0" @click="element=pe.pril.report[index-1];pe.pril.report.splice(index-1,1,pe.pril.report[index]);pe.pril.report[index]=element;"
                       icon style="float:right"><v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
                  mdi-chevron-up
                </v-icon></v-btn>
                <v-btn :disabled="index==pe.pril.report.length-1" @click="element=pe.pril.report[index+1];pe.pril.report.splice(index+1,1,pe.pril.report[index]);pe.pril.report[index]=element;"
                       icon style="float:right"><v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
                  mdi-chevron-down
                </v-icon></v-btn>


                <proeditpril  :value="item.text" v-on:changer="item.text=$event"  />
              </div>


            </template>

          </div>
















      </v-expansion-panel-content>
  </v-expansion-panel>


<v-expansion-panel>
  <v-expansion-panel-header class="text-bold">
    Иные приложения (при наличии: П1.30/баланс передачи электроэнергии, пояснительные расчёты в дополнение к пояснительной записке, прочие документы) <v-chip small class="mx-2 px-3" style="max-width:35px;">  {{pe.pril.another.length}}</v-chip>
  </v-expansion-panel-header>
  <v-expansion-panel-content style="border:1px solid rgb(226, 226, 226); border-radius:15px; margin:20px; padding:20px">
    <v-btn @click="newattachfile=true;razdelprilfile='Другие приложения';" small rounded style="margin-top:10px"  class="mr-1 success"><v-icon>mdi-file-upload-outline</v-icon>загрузить материалы</v-btn>
    <v-btn @click="razdelpril='Другие приложения';razdelinew='';newattachlabel=true" small rounded  class="mr-1 success" style="margin-top:10px"><v-icon>mdi-label-outline</v-icon> добавить пункт содержания</v-btn>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
    <sup>
      <v-btn
      v-bind="attrs"
      v-on="on"


      @click=" closeallmer();closeallter();tabpe=6; showwordpe=true;"
      href="#prochieprilozheniya"

        text
      x-small
      :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"


      color="success"  style="text-shadow:  #8af025 0px 0px 2px; margin-left:-7px ;  "

    > ПЭ
    <v-icon small  color="success"  style="text-shadow:  #8af025 0px 0px 2px;
    ">
    mdi-open-in-new
    </v-icon>

    </v-btn></sup>
    </template>
    <span>Просмотреть иные приложения по отчётам в программе энергосбережения</span>
    </v-tooltip>


<div style="border:1px solid rgb(226, 226, 226); border-radius:15px; margin-top:20px; padding:20px">
  <template v-for="(item,index) in pe.pril.another">


    <div style="border:1px solid #D1A2D0; border-radius:10px; background:#FAFAFA;margin-left:50px"
         class=" px-2 py-2 my-4 mr-4 "
         v-if="item.type=='label'"
         :key="item">
      <v-icon large class="mr-0  lighten-2" style="margin-top:-3px; ">
        mdi-label-outline
      </v-icon>Пункт содержания:
      <span class="title ml-1 ">

     <FormulaEditText
         :value.sync="item.name"


         :width="800"
         color="#FAFAFA"
         style="margin-left:7;display:inline-block"
     ></FormulaEditText></span>


      <v-btn @click="pe.pril.another.splice(index,1)" icon style="float:right"><v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
        mdi-close
      </v-icon></v-btn>
      <v-btn :disabled="index==0" @click="element=pe.pril.another[index-1];pe.pril.another.splice(index-1,1,pe.pril.another[index]);pe.pril.another[index]=element;" icon style="float:right">
        <v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
          mdi-chevron-up
        </v-icon></v-btn>
      <v-btn :disabled="index==pe.pril.another.length-1"
             @click="element=pe.pril.another[index+1];pe.pril.another.splice(index+1,1,pe.pril.another[index]);pe.pril.another[index]=element;"
             icon style="float:right"><v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
        mdi-chevron-down
      </v-icon></v-btn>
      <v-btn style="float:right" @click="razdelprilfile='Другие приложения'; soderzhpunkt=item.name; newattachfile=true; " icon  >
        <v-icon large class="mr-0  lighten-2">mdi-file-upload-outline</v-icon></v-btn>
    </div>

    <span style="margin-left:50px;" :key="item">


      <div  style="border:1px solid #D1A2D0; border-radius:10px;
       width:215px; display: inline-block; background:#FAFAFA; "
           class=" px-2 py-2 my-4 mr-1 "
           v-if="item.type=='file'"
           >
      <div>
        <v-btn @click="pe.pril.another.splice(index,1)" icon style="float:right"><v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
          mdi-close
        </v-icon></v-btn>
        <v-btn :disabled="index==pe.pril.another.length-1"
               @click="element=pe.pril.another[index+1];pe.pril.another.splice(index+1,1,pe.pril.another[index]);pe.pril.another[index]=element;"
               icon style="float:right"><v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
          mdi-chevron-right
        </v-icon></v-btn>
        <v-btn :disabled="index==0" @click="element=pe.pril.another[index-1];pe.pril.another.splice(index-1,1,pe.pril.another[index]);pe.pril.another[index]=element;"
               icon style="float:right">
          <v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
            mdi-chevron-left
          </v-icon></v-btn>изображение



      </div>

    <a style="text-decoration:none" :href="makefilelink(item)" target="_blank" >  <img :src="makefilelink(item)" width="200" alt="" /></a>


    </div>

  </span>


    <div v-if="item.type=='text'" style="border:1px solid #D1A2D0; border-radius:10px; margin-left:70px"
         class=" px-2 py-2 my-4 mr-4 "  :key="item">
      <v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
        mdi-text
      </v-icon>Блок текста:
      <v-btn @click="pe.pril.another.splice(index,1)" icon style="float:right"><v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
        mdi-close
      </v-icon></v-btn>

      <v-btn :disabled="index==pe.pril.another.length-1" @click="element=pe.pril.another[index+1];pe.pril.another.splice(index+1,1,pe.pril.another[index]);pe.pril.another[index]=element;"
             icon style="float:right"><v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
        mdi-chevron-up
      </v-icon></v-btn>
      <v-btn :disabled="index==0" @click="element=pe.pril.another[index-1];pe.pril.another.splice(index-1,1,pe.pril.another[index]);pe.pril.another[index]=element;"
             icon style="float:right"><v-icon large class="mr-0  lighten-2" style="margin-top:-6px; ">
        mdi-chevron-down
      </v-icon></v-btn>


      <proeditpril  :value="item.text" v-on:changer="item.text=$event"  />
    </div>


  </template>
</div>


  </v-expansion-panel-content>
</v-expansion-panel>




  </v-expansion-panels>












        </v-card-text>
      </v-card>
    </v-tab-item>
    <v-tab-item >
      <v-app-bar


          floating
          light
          dense
          style="background:url('/fon-3.png'); width:100%"
          elevation="0"

      >
        <v-card-title>
          <table>
            <tr>
              <td style="width:90vw">
                <v-icon class="mr-0" style="margin-top:-2px">
                  mdi-folder-text-outline
                </v-icon>
                Описания и пояснения
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                <sup>
                  <v-btn
                  v-bind="attrs"
                  v-on="on"


                  @click=" closeallmer();closeallter();tabpe=6; showwordpe=true;"
                  href="#poyasn"

                    text
                  x-small
                  :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"


                  color="success"  style="text-shadow:  #8af025 0px 0px 2px; margin-left:-7px ;  "

      > ПЭ
      <v-icon small  color="success"  style="text-shadow:  #8af025 0px 0px 2px;
      ">
       mdi-open-in-new
      </v-icon>

              </v-btn></sup>
            </template>
            <span>Просмотреть пояснительную записку программы энергосбережения</span>
          </v-tooltip>

                <span class="white--text">{{tut}}</span>
                <v-btn small rounded class="success"  @click="textgen();">Заполнить</v-btn>
              </td>

              <td style="width:10vw; min-width:250px">


              </td>
            </tr>
          </table>









        </v-card-title>


      </v-app-bar>

      <v-card elevation="2" class="pb-5   mb-0" style="background:url('/fon-5.png');  border: 1px solid  rgb(194, 194, 194);border-radius:0px; height:81vh; width:89vw; min-width:530px; overflow-y:scroll;
">


        <v-card-text>
          <v-alert v-if="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
                   icon="mdi-arrow-top-left"
                   prominent
                   text
                   type="purple lighten-1"
          >


            Для добавления показателей заполните на вкладке "Наименование":<br/>1) год начала программы,<br/>2) год окончания программы, <br/>3) последний завершённый год (панель "Индексы" на вкладке "Наименование").
          </v-alert>

          <v-expansion-panels multiple class="description-panels">
          <v-expansion-panel><v-expansion-panel-header>Полное наименование программы</v-expansion-panel-header><v-expansion-panel-content>
          <proedit :value="pe.fullname" v-on:changer="pe.fullname=$event"  />
          </v-expansion-panel-content></v-expansion-panel>
<!--          <div
              v-html="pe.fullname"
              id="khd" name="khd"
              @input="$set(pe,'fullname',$event.target.innerHTML)"
              contentEditable="true" style="width:170mm; max-width:170mm;
              color:#000000; font-size: 14pt; text-indent: 15mm;font-family: 'Times New Roman'; padding:5px;
              line-height:1.5rem; text-align:justify; border:2px solid #D7D6CF; min-height:30px ;border-radius:10px;margin:10px;padding:15px"></div>-->



          <v-expansion-panel><v-expansion-panel-header>Основные виды деятельности организации</v-expansion-panel-header><v-expansion-panel-content>
          <proedit :value="pe.vidideyateln" v-on:changer="pe.vidideyateln=$event"  />
          </v-expansion-panel-content></v-expansion-panel>

<!--          <div v-html="pe.vidideyateln"  id="khd" name="khd" @input="$set(pe,'vidideyateln',$event.target.innerHTML)" contentEditable="true" style="width:170mm; max-width:170mm; color:#000000; font-size: 14pt; text-indent: 15mm;font-family: 'Times New Roman'; padding:5px; text-align:justify; line-height:1.5rem; border:2px solid #D7D6CF; min-height:30px ;border-radius:10px;margin:15px; padding:10px "></div>-->





          <v-expansion-panel><v-expansion-panel-header>Краткая характеристика регулируемого вида деятельности организации</v-expansion-panel-header><v-expansion-panel-content>
          <proedit :value="pe.kratk_har_vd" v-on:changer="pe.kratk_har_vd=$event"  />
          </v-expansion-panel-content></v-expansion-panel>




          <v-expansion-panel><v-expansion-panel-header>Сведения о наличии зданий административного и административно-производственного назначения</v-expansion-panel-header><v-expansion-panel-content>
          <proedit :value="pe.admzd" v-on:changer="pe.admzd=$event"  />
          </v-expansion-panel-content></v-expansion-panel>





          <v-expansion-panel><v-expansion-panel-header>Сведения о наличии автотранспорта и спецтехники</v-expansion-panel-header><v-expansion-panel-content>
          <proedit :value="pe.transport" v-on:changer="pe.transport=$event"  />
          </v-expansion-panel-content></v-expansion-panel>


          <v-expansion-panel><v-expansion-panel-header>Сведения о количестве точек приема (поставки) электрической энергии</v-expansion-panel-header><v-expansion-panel-content>
          <proedit :value="pe.tochkiee" v-on:changer="pe.tochkiee=$event"  />
          </v-expansion-panel-content></v-expansion-panel>


          <v-expansion-panel><v-expansion-panel-header>Сведения о количестве точек поставки энергетических ресурсов на хозяйственные нужды</v-expansion-panel-header><v-expansion-panel-content>
          <proedit :value="pe.tochkihoz" v-on:changer="pe.tochkihoz=$event"  />
          </v-expansion-panel-content></v-expansion-panel>


          <v-expansion-panel><v-expansion-panel-header>Сведения о потреблении используемых энергетических ресурсов по видам этих энергетических ресурсов</v-expansion-panel-header><v-expansion-panel-content>
          <proedit :value="pe.resursporteb" v-on:changer="pe.resursporteb=$event"  />
          </v-expansion-panel-content></v-expansion-panel>


          <v-expansion-panel><v-expansion-panel-header>Текущее состояние в области энергосбережения и повышения энергетической эффективности организации</v-expansion-panel-header><v-expansion-panel-content>
          <proedit :value="pe.teksost" v-on:changer="pe.teksost=$event"  />
          </v-expansion-panel-content></v-expansion-panel>


          <v-expansion-panel><v-expansion-panel-header>Информация о достигнутых результатах в области энергосбережения и повышения энергетической эффективности организации за последние 5 лет</v-expansion-panel-header><v-expansion-panel-content>
          <proedit :value="pe.rezultee" v-on:changer="pe.rezultee=$event"  />
          </v-expansion-panel-content></v-expansion-panel>



          <v-expansion-panel><v-expansion-panel-header>Сравнение показателей деятельности организации с компаниями, достигшими наилучших показателей в аналогичной сфере деятельности</v-expansion-panel-header><v-expansion-panel-content>
          <proedit :value="pe.sravnenie" v-on:changer="pe.sravnenie=$event"  />
          </v-expansion-panel-content></v-expansion-panel>





          <v-expansion-panel><v-expansion-panel-header>Экономические показатели программы организации</v-expansion-panel-header><v-expansion-panel-content>
          <proedit :value="pe.ekonompokaz" v-on:changer="pe.ekonompokaz=$event"  />
          </v-expansion-panel-content></v-expansion-panel>



          <v-expansion-panel><v-expansion-panel-header>Изменение уровня потерь энергетических ресурсов и потребления ресурсов по годам программы</v-expansion-panel-header><v-expansion-panel-content>
          <proedit :value="pe.izmpoter" v-on:changer="pe.izmpoter=$event"  />
          </v-expansion-panel-content></v-expansion-panel>


          <v-expansion-panel><v-expansion-panel-header>Изменение расхода энергетических ресурсов на хозяйственные нужды по годам программы</v-expansion-panel-header><v-expansion-panel-content>
          <proedit :value="pe.izmreshoz" v-on:changer="pe.izmreshoz=$event"  />
          </v-expansion-panel-content></v-expansion-panel>



          <v-expansion-panel><v-expansion-panel-header>Изменение расхода моторного топлива автотранспортом и спецтехникой по годам программы</v-expansion-panel-header><v-expansion-panel-content>
          <proedit :value="pe.izmresmotor" v-on:changer="pe.izmresmotor=$event"  />
          </v-expansion-panel-content></v-expansion-panel>



          <v-expansion-panel><v-expansion-panel-header>Фактические значения целевых показателей программы по годам</v-expansion-panel-header><v-expansion-panel-content>
          <proedit :value="pe.factcelevgod" v-on:changer="pe.factcelevgod=$event"  />
          </v-expansion-panel-content></v-expansion-panel>


          <v-expansion-panel><v-expansion-panel-header>Распределение целевых показателей программы по направлениям деятельности организации</v-expansion-panel-header><v-expansion-panel-content>
          <proedit :value="pe.raspredcp" v-on:changer="pe.raspredcp=$event"  />
          </v-expansion-panel-content></v-expansion-panel>


          <v-expansion-panel><v-expansion-panel-header>Сведения об увязке результатов реализации программы с вознаграждением сотрудников организации через КПР</v-expansion-panel-header><v-expansion-panel-content>
          <proedit :value="pe.uviazkazp" v-on:changer="pe.uviazkazp=$event"  />
          </v-expansion-panel-content></v-expansion-panel>


          <v-expansion-panel><v-expansion-panel-header>Перечень мероприятий, технологий и денежных средств для реализации программы</v-expansion-panel-header><v-expansion-panel-content>
          <proedit :value="pe.perechenmertext" v-on:changer="pe.perechenmertext=$event"  />
          </v-expansion-panel-content></v-expansion-panel>


          <v-expansion-panel><v-expansion-panel-header>Механизм мониторинга и контроля за исполнением КПР</v-expansion-panel-header><v-expansion-panel-content>
          <proedit :value="pe.mehanizmmonkpr" v-on:changer="pe.mehanizmmonkpr=$event"  />
          </v-expansion-panel-content></v-expansion-panel>



          <v-expansion-panel><v-expansion-panel-header>Механизм мониторинга и контроля за исполнением целевых показателей программы</v-expansion-panel-header><v-expansion-panel-content>
          <proedit :value="pe.mehanizmmoncp" v-on:changer="pe.mehanizmmoncp=$event"  />
          </v-expansion-panel-content></v-expansion-panel>


          <v-expansion-panel><v-expansion-panel-header>Правовая и иная информация</v-expansion-panel-header><v-expansion-panel-content>
          <proedit :value="pe.pravov" v-on:changer="pe.pravov=$event"  />
          </v-expansion-panel-content></v-expansion-panel>
          </v-expansion-panels>












        </v-card-text>
      </v-card>
    </v-tab-item>
    <v-tab-item >
      <v-app-bar


          floating
          light
          dense
          style="background:url('/fon-3.png'); width:100%"
          elevation="0"

      >
        <v-card-title>
          <table>
            <tr>
              <td style="vertical-align: middle;" >
                <v-icon class="mr-1" style="margin-top:-5px">
                  mdi-book-open-page-variant
                </v-icon>
                <div style="margin-top:20px; display:inline-block;"> Программа энергосбережения</div>

                <span class="white--text">{{cpp}}{{tut}}{{meropriyatiya}}{{pe.trigger}}</span>


                <v-btn

                    :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
                    rounded


                    style="color:rgb(255, 255, 255); margin-top:15px ; text-shadow:  #59ff00 0px 0px 2px;  "
                    class="ml-2 mb-4"
                    href="#passport"
                    text
                    x-small

                    color="success">
                  <v-icon  class="mr-1">
                    mdi-passport
                  </v-icon>Паспорт
                </v-btn>


                <v-btn

                    :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
                    rounded


                    style="color:rgb(255, 255, 255); margin-top:15px ; text-shadow:  #59ff00 0px 0px 2px;   "
                    class="ml-2 mb-4"
                    href="#celevie"

                    text
                    x-small
                    color="success">
                  <v-icon  class="mr-1">
                    mdi-bullseye-arrow
                  </v-icon>Целевые показатели
                </v-btn>


                <v-btn

                    :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
                    rounded


                    style="color:rgb(255, 255, 255); margin-top:15px;  text-shadow:  #59ff00 0px 0px 2px;   "
                    class="ml-2 mb-4"
                    href="#meropriyatia"

                    text
                    x-small
                    color="success">
                  <v-icon  class="mr-1 ">
                    mdi-view-list
                  </v-icon>Мероприятия
                </v-btn>

                <v-btn

                    :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
                    text
                    x-large


                    style="color:rgb(255, 255, 255); margin-bottom:-5px; margin-top:-7px; text-shadow:  #7ed8ff 0px 0px 3px; "
                    class="ml-4"
                    @click="Export2Word('printContainer','11.doc');"
                    color="indigo">
                  <v-icon  class="mr-1">
                    mdi-file-word
                  </v-icon>Скачать ПЭ
                </v-btn>


              </td>


            </tr>
          </table>









        </v-card-title>

      </v-app-bar>

      <v-card elevation="2" class="pb-5   mb-0" style="  border: 1px solid  rgb(194, 194, 194);border-radius:0px; height:81vh; width:89vw; min-width:530px; overflow-y:scroll;
">


        <v-card-text>
          <v-alert v-if="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
                   icon="mdi-arrow-top-left"
                   prominent
                   text
                   type="purple lighten-1"
          >


            Для добавления показателей заполните на вкладке "Наименование":<br/>1) год начала программы,<br/>2) год окончания программы, <br/>3) последний завершённый год (панель "Индексы" на вкладке "Наименование").
          </v-alert>







          <div id="printContainer" v-if="showwordpe"  >

            <div class="WordSection2" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 210mm; width:210mm; border:1px solid #D7D6CF; padding:20mm;">

              <div align="right"><b>УТВЕРЖДАЮ</b></div>
              <div align="right"><b>{{pe.ruk_dolg}}</b></div>
              <div align="right"><b>{{pe.org}}</b></div>
              <div align="right"><b>{{pe.ruk_sokr}}</b></div>
              <div align="right"> </div>
              <div align="right">_________________________________</div>
              <div align="right"> </div>
              <div align="right"><b>{{new Date(pe.date_sogl).toLocaleDateString()}}</b></div>
              <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>

              <p align="center" style="line-height:1.5em;font-family: 'Times New Roman'; color:#000000; font-size:16pt; text-transform: uppercase "><b>ПРОГРАММА ЭНЕРГОСБЕРЕЖЕНИЯ И ПОВЫШЕНИЯ ЭНЕРГЕТИЧЕСКОЙ ЭФФЕКТИВНОСТИ<br/>
                {{ pe.org }} на {{peperiodtext()}}<br/>
                {{  pe.sphere }}{{pe.priznak?':':''}} {{ pe.priznak }} {{pe.invest?'(к инвестпрограмме)':''}}
              </b></p>
              <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>

              <p align="center" style="line-height:1.5em;font-family: 'Times New Roman'; color:#000000; font-size:12pt;"><b>{{(new Date().getFullYear())}}</b></p>

            </div>
            BREAKKK
            <div class="WordSection2" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 210mm; width:210mm; border:1px solid #D7D6CF; padding:20mm;">

              <div align="center"><h1>Содержание</h1></div>
              <br/><br/>
              <div align="left"><i>ВСТАВЬТЕ ВМЕСТО ЭТОГО ТЕКСТА АВТОСОДЕРЖАНИЕ, ПРОВЕРЬТЕ СЕБЯ</i></div>
              <div align="left"><i>---------------------------------------------------------------------------------------------------------</i></div>
              <div align="left"><i>1) Вставьте номера страниц в ворде</i></div>
              <div align="left"><i>2) Отметьте настройку "Особый колонтитул для первой страницы", чтобы не отображался номер страницы на титульном листе</i></div>
              <div align="left"><i>3) Вставьте автосодержание</i></div>
              <div align="left"><i>4) Удалите в автосодержании надпись "Оглавление" сверху</i></div>
              <div align="left"><i>5) Прочитайте программу, удостоверьтесь, что всё нужное заполнено (просмотрите региональные требования), сметы, дефектные ведомости и отчёты по энергосбереению приложены, обязательные организационные мероприятия по годам добавлены, для сферы передачи электроэнергии - приложен баланс электроэнергии</i></div>
              <div align="left"><i>6) Сохраните программу, сохраните копию в формате pdf при необходимости, распечатайте программу и заверьте, проверьте наличие подписей руководителей в пояснительной записке, сшейте программу, заверьте подписи печатями</i></div>
              <div align="left"><i>---------------------------------------------------------------------------------------------------------</i></div>








            </div>
            {{pe.fed?'BREAKKK':''}}
            <div v-if="pe.fed" class="WordSection2" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 210mm; width:210mm; border:1px solid #D7D6CF; padding:20mm;">


              <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>

              <h1 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Основные формы программы энергосбережения согласно федеральному законодательству
              </h1>
              <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>


            </div>
            {{pe.fed?'BREAKKK':''}}


            <div v-if="pe.fed" class="WordSection1" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 297mm; width:297mm; border:1px solid #D7D6CF; padding:20mm;">


              <a name="passport"></a>
              <div align="right"><b>{{pe.ruk_dolg}}</b></div>
              <div align="right"><b>{{pe.ruk_sokr}}</b></div>
              <div align="right"> </div>
              <div align="right">_________________________________</div>
              <div align="right"> </div>
              <div align="right"><b>{{new Date(pe.date_sogl).toLocaleDateString()}}</b></div>

              <h2 align="center" style="margin-bottom: 5px;">Паспорт</h2>

              <p align="center" style="font-family: 'Times New Roman'; color:#000000; font-size:14pt; text-transform: uppercase ">ПРОГРАММА ЭНЕРГОСБЕРЕЖЕНИЯ И ПОВЫШЕНИЯ ЭНЕРГЕТИЧЕСКОЙ ЭФФЕКТИВНОСТИ<br/>
                {{ pe.org }} на {{peperiodtext()}}<br/>
                {{  pe.sphere }}{{pe.priznak?':':''}} {{ pe.priznak }} {{pe.invest?'(к инвестпрограмме)':''}}           </p>



              <table
                  style="width:255mm; border-collapse: collapse; border:1px solid #000000; font-family: 'Times New Roman'; color:#000000; font-size:9pt;"
                  border="1"
                  cellspacing="0" >
                <thead>
                <tr >
                  <td colspan="3" valign="center" >Основание для разработки
                    программы
                  </td>
                  <td colspan="9" align="left" valign="top"  >Федеральный
                    закон от 23.11.2009 N261-ФЗ "Об энергосбережении и о повышении энергетической эффективности и о внесении изменений в
                    отдельные законодательные акты Российской Федерации"
                    <template v-if="pe.regtreb">
                      <br/>
                      {{ pe.regtreb }}
                    </template>
                  </td>
                </tr>
                <tr   >
                  <td colspan="3" valign="center" >Почтовый адрес</td>
                  <td colspan="9" valign="center" >{{ pe.pocht_address }}</td>
                </tr>
                <tr    >
                  <td colspan="3" valign="center" >Ответственный за формирование
                    программы (Ф.И.О., контактный телефон, e-mail)
                  </td>
                  <td colspan="9" valign="center" >
                    <template v-for="pers in pe.otv">
                      <div style="display: block; line-height:10pt" :key="pers">{{pers.otv_fio}}, {{pers.otv_dolg!==''?pers.otv_dolg+', ':''}}{{pers.phone}}, {{pers.email}};</div>

                    </template>

                  </td>
                </tr>
                <tr >
                  <td colspan="3" valign="center" >Даты начала и окончания
                    действия программы
                  </td>
                  <td colspan="9" valign="center"  >01.01.{{pe.god_ot}} - 31.12.{{pe.god_do}}</td>
                </tr>

                <tr >
                  <td rowspan="5" align="center" width="10%" valign="center" >Год
                  </td>
                  <td colspan="2" rowspan="2" align="center" valign="center" >Затраты
                    на реализацию программы, млн. руб. без НДС
                  </td>
                  <td rowspan="5" align="center" valign="center" >Доля затрат в
                    инвестиционной программе, направленная на реализацию мероприятий программы энергосбережения и повышения
                    энергетической эффективности
                  </td>
                  <td colspan="8" align="center" valign="center" >Топливно-энергетические
                    ресурсы (ТЭР)
                  </td>
                </tr>
                <tr >
                  <td colspan="4" rowspan="2" align="center" valign="center" >При
                    осуществлении регулируемого вида деятельности
                  </td>
                  <td colspan="4" rowspan="2" align="center" valign="center" >При
                    осуществлении прочей деятельности, в т.ч. хозяйственные нужды
                  </td>
                </tr>
                <tr >
                  <td rowspan="3" align="center" width="7%" valign="center" >всего
                  </td>
                  <td rowspan="3" align="center" width="9%" valign="center" >в
                    т.ч. капитальные
                  </td>
                </tr>
                <tr >
                  <td colspan="2" align="center" valign="center" >Суммарные
                    затраты ТЭР
                  </td>
                  <td colspan="2" align="center" valign="center" >Экономия ТЭР в
                    результате реализации программы
                  </td>
                  <td colspan="2" align="center" valign="center" >Суммарные
                    затраты ТЭР
                  </td>
                  <td colspan="2" align="center" valign="center" >Экономия ТЭР в
                    результате реализации программы
                  </td>
                </tr>
                <tr >
                  <td align="center" width="6%" valign="center" >т у.т. без учета
                    воды
                  </td>
                  <td align="center" width="7%" valign="center" >млн. руб. без НДС
                    с учетом воды
                  </td>
                  <td align="center" width="6%" valign="center" >т у.т. без учета
                    воды
                  </td>
                  <td align="center" width="8%" valign="center" >млн. руб. без НДС
                    с учетом воды
                  </td>
                  <td align="center" width="6%" valign="center" >т у.т. без учета
                    воды
                  </td>
                  <td align="center" width="8%" valign="center" >млн. руб. без НДС
                    с учетом воды
                  </td>
                  <td align="center" width="7%" valign="center" >т у.т. без учета
                    воды
                  </td>
                  <td align="center" width="8%" valign="center" >млн. руб. без НДС
                    с учетом воды
                  </td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in yearspe" :key="item" :style="(item>=pe.god_ot && !(item>pe.god_do))?'background: #E2FFCC':''">
                  <td width="10%" valign="top" align="center"  >
                    {{ item }} год -

                    {{item==pe.fact_god?'Факт':''}}
                    {{(item==pe.fact_god) && (pe.fact_god==(pe.god_ot-1))?' / ':''}}
                    {{item==(pe.god_ot-1)?'Баз.':''}}
                    {{ (item>=pe.god_ot && !(item>pe.god_do))?'ПЭ':''}}



                  </td>
                  <td width="7%" valign="center" align="center" >{{decimal(pe.zatrati_total[index]/1000000,7)}}</td>
                  <td width="9%" valign="center" align="center" >{{decimal(pe.zatrati_total_capital[index]/1000000,7)}}</td>
                  <td valign="center" align="center" >{{decimal(pe.dolya_total[index]*100,2)}}%</td>
                  <td width="6%" valign="center" align="center" >  {{decimal(pe.zatrati_ter_tut_total[index],2)}}</td>
                  <td width="7%" valign="center" align="center" > {{decimal(pe.zatrati_ter_rub_total[index]/1000,7)}}</td>
                  <td width="6%" valign="center" align="center" >{{decimal(pe.economy_ter_tut_total[index],2)}}</td>
                  <td width="8%" valign="center" align="center" >{{decimal(pe.economy_ter_rub_total[index]/1000,7)}}</td>
                  <td width="6%" valign="center" align="center" >-</td>
                  <td width="8%" valign="center" align="center" >-</td>
                  <td width="7%" valign="center" align="center" >-</td>
                  <td width="8%" valign="center" align="center" >-</td>
                </tr>

                <tr style="font-weight: bold" >
                  <td width="10%" valign="center" align="center" >ВСЕГО - ПЭ</td>
                  <td width="7%" valign="center" align="center" >{{decimal(pe.zatrati_total_itog/1000000,7)}}</td>
                  <td width="9%" valign="center" align="center" >{{decimal(pe.zatrati_total_capital_itog/1000000,7)}}</td>
                  <td valign="center" align="center" >{{decimal(pe.dolya_total_itog*100,2)}}%</td>
                  <td width="6%" valign="center" align="center" >  {{decimal(pe.zatrati_ter_tut_total_itog,2)}}</td>
                  <td width="7%" valign="center" align="center" > {{decimal(pe.zatrati_ter_rub_total_itog/1000,7)}}</td>
                  <td width="6%" valign="center" align="center" >{{decimal(pe.economy_ter_tut_total_itog,2)}}</td>
                  <td width="8%" valign="center" align="center" >{{decimal(pe.economy_ter_rub_total_itog/1000,7)}}</td>
                  <td width="6%" valign="center" align="center" >-</td>
                  <td width="8%" valign="center" align="center" >-</td>
                  <td width="7%" valign="center" align="center" >-</td>
                  <td width="8%" valign="center" align="center" >-</td>
                </tr>
                </tbody>
              </table>
              <br/>
              <p v-if="pe.sogl.length>0" align="left">СОГЛАСОВАНО	 	на обороте документа:</p>
              <table v-if="pe.sogl.length>0">

                <tr v-for="item in pe.sogl" :key="item">
                  <td><b>{{item.sogl_dolg}}</b></td><td> __________________________________ </td><td><b>{{item.sogl_sokr}}</b></td>
                </tr>


              </table>





            </div>

            {{pe.fed?'BREAKKK':''}}
            <div v-if="pe.fed" class="WordSection1" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 297mm; width:297mm; border:1px solid #D7D6CF; padding:20mm;">
            <a name="celevie"></a>
              <h2 align="center">Целевые и прочие показатели программы энергосбережения и повышения энергетической эффективности</h2>
              <br/>

              <table
                  style="width:255mm; border-collapse: collapse; border:1px solid #000000; font-family: 'Times New Roman'; color:#000000; font-size:9pt;"
                  border="1"
                  cellspacing="0" >
                <thead>
                <tr>
                  <td align="center" rowspan="2" width="44" valign="center">
                    N п/п
                  </td>
                  <td align="center" rowspan="2" width="280" style="max-width:280px; min-width:280px;"  valign="center">
                    Целевые и прочие показатели
                  </td>
                  <td  align="center" rowspan="2" width="85" valign="center" >
                    Ед. изм.
                  </td>
                  <td v-if="!pe.hide_industry_benchmarks" align="center" rowspan="2" width="100" valign="center" >
                    Средние показатели по отрасли
                  </td>
                  <td v-if="!pe.hide_industry_benchmarks" align="center" rowspan="2" width="100" valign="center" >
                    Лучшие мировые показатели по отрасли
                  </td>
                  <td v-for="item in yearspe.slice(0,pe.god_ot-pe.fact_god)" :key="item" align="center" rowspan="2" width="80"  valign="center"
                  >
                    {{ item }} год -

                    {{item==pe.fact_god?'Факт':''}}
                    {{(item==pe.fact_god) && (pe.fact_god==(pe.god_ot-1))?' / ':''}}
                    {{item==(pe.god_ot-1)?'Базовый год':''}}
                    {{ (item>=pe.god_ot && !(item>pe.god_do))?'ПЭ':''}}
                  </td>
                  <td align="center" :colspan="pe.god_do-pe.god_ot+1" valign="center" style="border-bottom:1px solid black;border-right:1px solid black;border-top:1px solid black;">
                    Плановые значения целевых показателей по годам
                  </td>
                </tr>
                <tr>
                  <td v-for="(item) in yearspe.slice(pe.god_ot-pe.fact_god,pe.god_do-pe.fact_god+1)" :key="item" align="center" width="80" valign="center"
                      :style="(item>=pe.god_ot && !(item>pe.god_do))?'background: #E2FFCC':''">
                    {{item}} г.
                  </td>


                </tr>

                <tr>
                  <td valign="center" align="center">1</td>
                  <td valign="center" align="center">2</td>
                  <td valign="center" align="center">3</td>
                  <td v-if="!pe.hide_industry_benchmarks" valign="center" align="center">4</td>
                  <td v-if="!pe.hide_industry_benchmarks" valign="center" align="center">5</td>
                  <td v-for="(item,index) in yearspe.slice(0,pe.god_do-pe.fact_god+1)" :key="item" align="center" valign="center"
                      :style="(item>=pe.god_ot && !(item>pe.god_do))?'background: #E2FFCC':''">
                    {{index+(pe.hide_industry_benchmarks ? 4 : 6)}}
                  </td>

                </tr>
                </thead>
                <tbody>
                <tr >
                  <td valign="center" align="center" width="44" style="border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                    1
                  </td>
                  <td  valign="center"  align="left" style="padding-left:3px" :colspan="pe.god_do-pe.fact_god+1+(pe.hide_industry_benchmarks ? 2 : 4)" >
                    <b>Целевые показатели</b>
                  </td>


                </tr>
                <tr v-for="(item,index) in pe.celev.filter(x=>x.kind==='Целевой' && x.showinform)" :key="item">
                  <td valign="center" align="center"  style="border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                    1.{{index+1}}
                  </td>
                  <td valign="center" align="justify" width="280" style="max-width:280px; min-width:280px;padding-left:3px;line-height:0.9rem;" >
                    {{item.name}}
                  </td>
                  <td valign="center" align="center"   >
                    {{item.ed}}
                  </td>
                  <td v-if="!pe.hide_industry_benchmarks" valign="center" align="center"   >
                    {{decimal(item.sred_otrasl,item.decimal)}}
                  </td>
                  <td v-if="!pe.hide_industry_benchmarks" valign="center" align="center"  >
                    {{decimal(item.best_mir,item.decimal)}}
                  </td>
                  <td v-for="(year,indexyear) in yearspe.slice(0,pe.god_do-pe.fact_god+1)" valign="center" align="center" :key="year"
                      :style="(year>=pe.god_ot && !(year>pe.god_do))?'background: #E2FFCC':''">
                    {{decimal(item.value_plan[indexyear],item.decimal)}}
                  </td>
                </tr>
                <tr >
                  <td valign="center" align="center" width="44" style="border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                    2
                  </td>
                  <td  valign="center"  align="left" style="padding-left:3px" :colspan="pe.god_do-pe.fact_god+1+(pe.hide_industry_benchmarks ? 2 : 4)" >
                    <b>Прочие показатели</b>
                  </td>

                </tr>
                <template v-if="pe.show_economy_targets !== false">
                <tr v-for="(topl,indextopl) in pe.ter" :key="topl">
                  <td valign="center" align="center"  style="border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                    2.{{indextopl+1}}
                  </td>
                  <td  style="text-indent: 0px; padding-left:3px"  >
                    <span >Экономия ТЭР: {{ topl.name }}</span>
                  </td>
                  <td valign="center" align="center">
                    {{ topl.ed }}<br/>
                    {{ pe.economy_targets_unit === 'million' ? 'млн.руб.' : 'тыс.руб.' }}
                  </td>
                  <td v-if="!pe.hide_industry_benchmarks" valign="center" align="center">

                  </td>
                  <td v-if="!pe.hide_industry_benchmarks" valign="center" align="center">

                  </td>
                  <td v-for="(item,index) in yearspe.slice(0,pe.god_do-pe.fact_god+1)" :key="item" valign="center" align="center"
                      :style="(item>=pe.god_ot && !(item>pe.god_do))?'background: #E2FFCC':''">

                    <span >{{ decimal((topl.economy_volume_plan[index]),2) }}</span>
                    <br/>
                    <span>{{ decimal(pe.economy_targets_unit === 'million' ? topl.economy_rub_plan[index] / 1000 : topl.economy_rub_plan[index], pe.economy_targets_decimals) }}</span>


                  </td>
                </tr>
                </template>
                <tr v-for="(item,index) in pe.celev.filter(x=>x.kind==='Прочий' && x.showinform)" :key="item">
                  <td valign="center" align="center"  style="border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                    2.{{index+1+(pe.show_economy_targets !== false ? pe.ter.length : 0)}}
                  </td>
                  <td valign="center" align="justify" width="280" style="max-width:280px; min-width:280px;padding-left:3px;line-height:0.9rem;" >
                    {{item.name}}
                  </td>
                  <td valign="center" align="center"   >
                    {{item.ed}}
                  </td>
                  <td v-if="!pe.hide_industry_benchmarks" valign="center" align="center"   >
                    {{decimal(item.sred_otrasl,item.decimal)}}
                  </td>
                  <td v-if="!pe.hide_industry_benchmarks" valign="center" align="center"  >
                    {{decimal(item.best_mir,item.decimal)}}
                  </td>
                  <td v-for="(year,indexyear) in yearspe.slice(0,pe.god_do-pe.fact_god+1)" valign="center" align="center" :key="year"
                      :style="(year>=pe.god_ot && !(year>pe.god_do))?'background: #E2FFCC':''"  >
                    {{decimal(item.value_plan[indexyear],item.decimal)}}
                  </td>
                </tr>

                </tbody></table>
              <br/>
              <br/>
              <br/>
              <br/>
              <table>

                <tr >
                  <td><b>{{pe.ruk_dolg}}</b></td><td> __________________________________ </td><td><b>{{pe.ruk_sokr}}</b></td>
                </tr>


              </table>




            </div>

            {{pe.fed?'BREAKKK':''}}
            <div v-if="pe.fed" class=WordSection5 style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 1190.4pt; width:1190.4pt; border:1px solid #D7D6CF; padding:20mm;">
              <a name="meropriyatia"></a>
              <h2 align="center">Перечень мероприятий, основной целью которых является энергосбережение и (или) повышение энергетической эффективности</h2>
              <br/>

              <table   style=" border-collapse: collapse; border:1px solid #000000; font-family: 'Times New Roman'; color:#000000; font-size:7pt; line-height:0.9rem"
                       border="1"
                       cellspacing="0" >
                <thead>
                <tr>
                  <td align="center" valign="center"  rowspan="3" width="80" ROT90  class="pov90" >
                    N п/п
                  </td>
                  <td align="center" valign="center"  rowspan="3" width="500"  >
                    Наименование мероприятия
                  </td>
                  <td align="center" valign="center"   rowspan="2" :colspan="2+(pe.god_do-pe.god_ot+1)*1"    >
                    Объемы выполнения (план) с разбивкой по годам действия программы
                  </td>
                  <td align="center" valign="center"   :colspan="2+(pe.god_do-pe.god_ot+1)*3"   >
                    Плановые численные значения экономии в обозначенной размеренности с разбивкой по годам действия программы
                  </td>
                  <td align="center" valign="center"  rowspan="2" colspan="3"   >
                    Показатели экономической эффективности
                  </td>
                  <td align="center" valign="center"  rowspan="3" width="80" ROT90  class="pov90" >
                    Срок амортизации, лет
                  </td>
                  <td align="center" valign="center"  rowspan="2"  :colspan="1+(pe.god_do-pe.god_ot+1)*1"  >
                    Затраты (план), млн руб. (без НДС), с разбивкой по годам действия программы
                  </td>
                  <td align="center" valign="center"  rowspan="3" width="100" ROT90  class="pov90" >
                    Статья затрат
                  </td>
                  <td align="center" valign="center"  rowspan="3" width="100" ROT90  class="pov90" >
                    Источник финансирования
                  </td>
                </tr>

                <tr >

                  <td align="center" valign="center"  rowspan="2" width="200"  style="min-width:45mm; width:45mm;" >
                    единицы измерения
                  </td>
                  <td align="center" valign="center"  rowspan="2"  width="80" ROT90  class="pov90" >
                    всего по годам экономия в указанной размерности
                  </td>
                  <td align="center" valign="center"  colspan="3" v-for="item in yearspe.slice(pe.god_ot-pe.fact_god,yearspe.length)" :key="item"   >
                    {{ item }} г.

                  </td>

                </tr>
                <tr  height="100" style="max-height:100px; word-wrap: normal ">
                  <td align="center" valign="center"  width="80" ROT90  class="pov90" >
                    ед. измерения
                  </td>
                  <td align="center" valign="center"  width="80"  ROT90  class="pov90" >
                    всего
                  </td>
                  <td align="center" valign="center"  width="80" v-for="item in yearspe.slice(pe.god_ot-pe.fact_god,yearspe.length)" :key="item" ROT90  class="pov90" >
                    {{ item }} г.
                  </td>


                  <template v-for="item in yearspe.slice(pe.god_ot-pe.fact_god,yearspe.length)">

                    <td align="center" valign="center"  width="80" :name="item" :key="item"  ROT90  class="pov90"  >
                      численное значение экономии в указанной размерности
                    </td>
                    <td align="center" valign="center"   width="80" :key="item"  ROT90  class="pov90" >
                      численное значение экономии, т у. т.
                    </td>
                    <td align="center" valign="center"  width="80"  :key="item"  ROT90  class="pov90" >
                      численное значение экономии, млн руб.
                    </td>
                  </template>

                  <td align="center" valign="center"  width="100" ROT90  class="pov90"  >
                    дисконтированный срок окупаемости, лет
                  </td>
                  <td align="center" valign="center"   width="80" ROT90  class="pov90" >
                    ВНД, %
                  </td>
                  <td align="center" valign="center"  width="80" ROT90  class="pov90" >
                    ЧДД, млн руб.
                  </td>
                  <td align="center" valign="center"  width="80" ROT90  class="pov90" >
                    всего
                  </td>
                  <td align="center" valign="center"  width="80" v-for="item in yearspe.slice(pe.god_ot-pe.fact_god,yearspe.length)" :key="item" >
                    {{ item }} г.
                  </td>

                </tr>

                <tr>
                  <td align="center" valign="center" v-for="item in (13+5*yearspe.slice(pe.god_ot-pe.fact_god,yearspe.length).length)"  :key="item">
                    {{item}}
                  </td>

                </tr>
                </thead>
                <tbody>
                <tr align="center" valign="center" v-for="(merop, index) in pe.mer" :key="merop">
                  <td   >
                    {{index+1}}
                  </td>
                  <td align="center" valign="center" >
                    {{merop.name}}
                  </td>
                  <td align="center" valign="center" >
                    шт.
                  </td>
                  <td align="center" valign="center"  >
                    1
                  </td>
                  <td align="center" valign="center" v-for="item in (yearspe.slice(pe.god_ot-pe.fact_god,yearspe.length))"  :key="item" >
                    {{item==merop.start_god?'1':''}}
                  </td>
                  <td width="32"  >
             <span style="display: block" v-for="item in merop.ter" :key="item">
               {{toplmerinfo(item.name)}}
               <br/>
             </span>
                  </td>

                  <td  >


              <span  v-for="item in merop.ter" :key="item">
                   {{ decimal(item.delta_volume_plan.slice(pe.god_ot-pe.fact_god,Math.min(end_effect_god_index(merop)+1,yearspe.length-(pe.god_ot-pe.fact_god)+2)).reduce(function (a, b) {
                return Number(a) + Number(b);
              }),3) }}<br/>
                </span>





                  </td>

                  <template  v-for="(item,index) in yearspe.slice(pe.god_ot-pe.fact_god,yearspe.length)"  >
                    <td :key="item" >


                <span  v-show="index<=(end_effect_god_index(merop)-(pe.god_ot-pe.fact_god)) && index>=(merop.start_god-pe.fact_god-(pe.god_ot-pe.fact_god))"
                       v-for="item2 in merop.ter" :key="item2">
                    {{decimal(item2.delta_volume_plan[index+(pe.god_ot-pe.fact_god)],3)}}<br/>
                </span>

                    </td>
                    <td :key="item" >
                <span v-show="index<=(end_effect_god_index(merop)-(pe.god_ot-pe.fact_god)) && index>=(merop.start_god-pe.fact_god-(pe.god_ot-pe.fact_god))" v-for="item2 in merop.ter" :key="item2">
                    {{decimal(item2.tut_plan[index+(pe.god_ot-pe.fact_god)],3)}}<br/>
                </span>

                    </td>
                    <td :key="item" >
                <span v-show="index<=(end_effect_god_index(merop)-(pe.god_ot-pe.fact_god)) && index>=(merop.start_god-pe.fact_god-(pe.god_ot-pe.fact_god))" v-for="item2 in merop.ter" :key="item2">
                    {{decimal(item2.delta_rub_plan[index+(pe.god_ot-pe.fact_god)]/1000000,7)}}<br/>
                </span>

                    </td>
                  </template>
                  <td  >
                    {{decimal(merop.disk_srok_okup)}}
                  </td>
                  <td  >
                    {{decimal(merop.vnd)}}%
                  </td>
                  <td  >
                    {{decimal(merop.chdd/1000000,7)}}
                  </td>
                  <td  >
                    {{decimal(merop.amort)}}
                  </td>
                  <td  >
                    {{ decimal(merop.zatrati_plan.slice(pe.god_ot-pe.fact_god,yearspe.length).reduce(function (a, b) {
                    return Number(a) + Number(b);
                  })/1000000,7) }}
                  </td>


                  <td align="center" valign="center"  width="80" v-for="(item,index) in yearspe.slice(pe.god_ot-pe.fact_god,yearspe.length)" :key="item" >
                    {{ decimal(merop.zatrati_plan[index+pe.god_ot-pe.fact_god]/1000000,7) }}
                  </td>
                  <td  >
                    {{merop.statia}}
                  </td>
                  <td  >
                    {{merop.istochnik}}
                  </td>


                </tr>



                <tr align="center"  valign="center" style="font-weight: bold" >
                  <td    colspan="2">
                    ИТОГО
                  </td>
                  <td align="center" valign="center" >
                    шт.
                  </td>
                  <td align="center" valign="center"  >
                    {{ pe.mer.length }}
                  </td>
                  <td align="center" valign="center" v-for="item in (yearspe.slice(pe.god_ot-pe.fact_god,yearspe.length))"  :key="item" >
                    {{ pe.mer.filter(x=>x.start_god==item).length }}
                  </td>
                  <td width="32"  >
             <span style="display: block" >

             </span>
                  </td>

                  <td  >

                  </td>

                  <template  v-for="(item,index) in yearspe.slice(pe.god_ot-pe.fact_god,yearspe.length)"  >
                    <td :key="item" >

                    </td>
                    <td :key="item" >

                      {{ total_mer('total_tut_plan',index+(pe.god_ot-pe.fact_god),3) }}




                    </td>
                    <td :key="item" >
                      {{ decimal(total_mer('total_delta_rub_plan',index+(pe.god_ot-pe.fact_god),-1)/1000000,7) }}

                    </td>
                  </template>
                  <td  >

                  </td>
                  <td  >

                  </td>
                  <td  >

                  </td>
                  <td  >

                  </td>
                  <td  >
                    {{decimal(pe.zatrati_total_itog/1000000,7)}}


                  </td>


                  <td align="center" valign="center"  width="80" v-for="(item,index) in yearspe.slice(pe.god_ot-pe.fact_god,yearspe.length)" :key="item" >
                    {{decimal(pe.zatrati_total[index+(pe.god_ot-pe.fact_god)]/1000000,7)}}
                  </td>
                  <td  >

                  </td>
                  <td  >

                  </td>


                </tr>
                </tbody>
              </table>



              <br/>
              <br/>
              <br/>
              <br/>
              <table>

                <tr >
                  <td><b>{{pe.ruk_dolg}}</b></td><td> __________________________________ </td><td><b>{{pe.ruk_sokr}}</b></td>
                </tr>


              </table>
            </div>
            {{pe.reg?'BREAKKK':''}}
            <div  v-if="pe.reg" class="WordSection2" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 210mm; width:210mm; border:1px solid #D7D6CF; padding:20mm;">


              <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>

              <h1 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Основные формы программы энергосбережения согласно региональному законодательству
              </h1>
              <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>


            </div>
            {{pe.reg?'BREAKKK':''}}
            <div v-if="pe.reg" class="WordSection1" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 297mm; width:297mm; border:1px solid #D7D6CF; padding:20mm;">


              <a name="passport"></a>
              <div align="right"><b>{{pe.ruk_dolg}}</b></div>
              <div align="right"><b>{{pe.ruk_sokr}}</b></div>
              <div align="right"> </div>
              <div align="right">_________________________________</div>
              <div align="right"> </div>
              <div align="right"><b>{{new Date(pe.date_sogl).toLocaleDateString()}}</b></div>

              <h2 align="center" style="margin-bottom: 5px;">Паспорт</h2>

              <p align="center" style="font-family: 'Times New Roman'; color:#000000; font-size:14pt; text-transform: uppercase ">ПРОГРАММА ЭНЕРГОСБЕРЕЖЕНИЯ И ПОВЫШЕНИЯ ЭНЕРГЕТИЧЕСКОЙ ЭФФЕКТИВНОСТИ<br/>
                {{ pe.org }} на {{peperiodtext()}}<br/>
                {{  pe.sphere }}{{pe.priznak?':':''}} {{ pe.priznak }} {{pe.invest?'(к инвестпрограмме)':''}}           </p>



              <table
                  style="width:255mm; border-collapse: collapse; border:1px solid #000000; font-family: 'Times New Roman'; color:#000000; font-size:9pt;"
                  border="1"
                  cellspacing="0" >
                <thead>
                <tr >
                  <td colspan="3" valign="center" >Основание для разработки
                    программы
                  </td>
                  <td colspan="9" align="left" valign="top"  >Федеральный
                    закон от 23.11.2009 N261-ФЗ "Об энергосбережении и о повышении энергетической эффективности и о внесении изменений в
                    отдельные законодательные акты Российской Федерации";
                    <br/>
                    {{pe.regtreb}}
                  </td>
                </tr>
                <tr   >
                  <td colspan="3" valign="center" >Почтовый адрес</td>
                  <td colspan="9" valign="center" >{{ pe.pocht_address }}</td>
                </tr>
                <tr    >
                  <td colspan="3" valign="center" >Ответственный за формирование
                    программы (Ф.И.О., контактный телефон, e-mail)
                  </td>
                  <td colspan="9" valign="center" >
                    <template v-for="pers in pe.otv">
                      <div style="display: block; line-height:10pt" :key="pers">{{pers.otv_fio}}, {{pers.otv_dolg!==''?pers.otv_dolg+', ':''}}{{pers.phone}}, {{pers.email}};</div>

                    </template>

                  </td>
                </tr>
                <tr >
                  <td colspan="3" valign="center" >Даты начала и окончания
                    действия программы
                  </td>
                  <td colspan="9" valign="center"  >01.01.{{pe.god_ot}} - 31.12.{{pe.god_do}}</td>
                </tr>

                <tr >
                  <td rowspan="5" align="center" width="10%" valign="center" >Год
                  </td>
                  <td colspan="2" rowspan="2" align="center" valign="center" >Затраты
                    на реализацию программы, тыс. руб. без НДС
                  </td>
                  <td rowspan="5" align="center" valign="center" >Доля затрат в
                    инвестиционной программе, направленная на реализацию мероприятий программы энергосбережения и повышения
                    энергетической эффективности
                  </td>
                  <td colspan="8" align="center" valign="center" >Топливно-энергетические
                    ресурсы (ТЭР)
                  </td>
                </tr>
                <tr >
                  <td colspan="4" rowspan="2" align="center" valign="center" >При
                    осуществлении регулируемого вида деятельности
                  </td>
                  <td colspan="4" rowspan="2" align="center" valign="center" >При
                    осуществлении прочей деятельности, в т.ч. хозяйственные нужды
                  </td>
                </tr>
                <tr >
                  <td rowspan="3" align="center" width="7%" valign="center" >всего
                  </td>
                  <td rowspan="3" align="center" width="9%" valign="center" >в
                    т.ч. капитальные
                  </td>
                </tr>
                <tr >
                  <td colspan="2" align="center" valign="center" >Суммарные
                    затраты ТЭР
                  </td>
                  <td colspan="2" align="center" valign="center" >Экономия ТЭР в
                    результате реализации программы
                  </td>
                  <td colspan="2" align="center" valign="center" >Суммарные
                    затраты ТЭР
                  </td>
                  <td colspan="2" align="center" valign="center" >Экономия ТЭР в
                    результате реализации программы
                  </td>
                </tr>
                <tr >
                  <td align="center" width="6%" valign="center" >т у.т. без учета
                    воды
                  </td>
                  <td align="center" width="7%" valign="center" >тыс. руб. без НДС
                    с учетом воды
                  </td>
                  <td align="center" width="6%" valign="center" >т у.т. без учета
                    воды
                  </td>
                  <td align="center" width="8%" valign="center" >тыс. руб. без НДС
                    с учетом воды
                  </td>
                  <td align="center" width="6%" valign="center" >т у.т. без учета
                    воды
                  </td>
                  <td align="center" width="8%" valign="center" >тыс. руб. без НДС
                    с учетом воды
                  </td>
                  <td align="center" width="7%" valign="center" >т у.т. без учета
                    воды
                  </td>
                  <td align="center" width="8%" valign="center" >тыс. руб. без НДС
                    с учетом воды
                  </td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in yearspe" :key="item" :style="(item>=pe.god_ot && !(item>pe.god_do))?'background: #E2FFCC':''">
                  <td width="10%" valign="top" align="center"  >
                    {{ item }} год -

                    {{item==pe.fact_god?'Баз.':''}}
                    {{(item==pe.fact_god) && (pe.fact_god==(pe.god_ot-1))?' / ':''}}
                    {{item==(pe.god_ot-1)?'Спр.':''}}
                    {{ (item>=pe.god_ot && !(item>pe.god_do))?'ПЭ':''}}



                  </td>
                  <td width="7%" valign="center" align="center" >{{decimal(pe.zatrati_total[index]/1000,4)}}</td>
                  <td width="9%" valign="center" align="center" >{{decimal(pe.zatrati_total_capital[index]/1000,4)}}</td>
                  <td valign="center" align="center" >{{decimal(pe.dolya_total[index]*100,2)}}%</td>
                  <td width="6%" valign="center" align="center" >  {{decimal(pe.zatrati_ter_tut_total[index],2)}}</td>
                  <td width="7%" valign="center" align="center" > {{decimal(pe.zatrati_ter_rub_total[index],4)}}</td>
                  <td width="6%" valign="center" align="center" >{{decimal(pe.economy_ter_tut_total[index],2)}}</td>
                  <td width="8%" valign="center" align="center" >{{decimal(pe.economy_ter_rub_total[index],4)}}</td>
                  <td width="6%" valign="center" align="center" >-</td>
                  <td width="8%" valign="center" align="center" >-</td>
                  <td width="7%" valign="center" align="center" >-</td>
                  <td width="8%" valign="center" align="center" >-</td>
                </tr>

                <tr style="font-weight: bold" >
                  <td width="10%" valign="center" align="center" >ВСЕГО - ПЭ</td>
                  <td width="7%" valign="center" align="center" >{{decimal(pe.zatrati_total_itog/1000,4)}}</td>
                  <td width="9%" valign="center" align="center" >{{decimal(pe.zatrati_total_capital_itog/1000,4)}}</td>
                  <td valign="center" align="center" >{{decimal(pe.dolya_total_itog*100,2)}}%</td>
                  <td width="6%" valign="center" align="center" >  {{decimal(pe.zatrati_ter_tut_total_itog,2)}}</td>
                  <td width="7%" valign="center" align="center" > {{decimal(pe.zatrati_ter_rub_total_itog,4)}}</td>
                  <td width="6%" valign="center" align="center" >{{decimal(pe.economy_ter_tut_total_itog,2)}}</td>
                  <td width="8%" valign="center" align="center" >{{decimal(pe.economy_ter_rub_total_itog,4)}}</td>
                  <td width="6%" valign="center" align="center" >-</td>
                  <td width="8%" valign="center" align="center" >-</td>
                  <td width="7%" valign="center" align="center" >-</td>
                  <td width="8%" valign="center" align="center" >-</td>
                </tr>
                </tbody>
              </table>
              <br/>
              <p v-if="pe.sogl.length>0" align="left">СОГЛАСОВАНО	 	на обороте документа:</p>
              <table v-if="pe.sogl.length>0">

                <tr v-for="item in pe.sogl" :key="item">
                  <td><b>{{item.sogl_dolg}}</b></td><td> __________________________________ </td><td><b>{{item.sogl_sokr}}</b></td>
                </tr>


              </table>





            </div>

            {{pe.reg?'BREAKKK':''}}
            <div v-if="pe.reg" class="WordSection1" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 297mm; width:297mm; border:1px solid #D7D6CF; padding:20mm;">
            <a name="celevie"></a>
              <h2 align="center">Целевые и прочие показатели программы энергосбережения и повышения энергетической эффективности</h2>
              <br/>

              <table
                  style="width:255mm; border-collapse: collapse; border:1px solid #000000; font-family: 'Times New Roman'; color:#000000; font-size:9pt;"
                  border="1"
                  cellspacing="0" >
                <thead>
                <tr>
                  <td align="center" rowspan="2" width="44" valign="center">
                    N п/п
                  </td>
                  <td align="center" rowspan="2" width="280" style="max-width:280px; min-width:280px;"  valign="center">
                    Целевые и прочие показатели
                  </td>
                  <td  align="center" rowspan="2" width="85" valign="center" >
                    Ед. изм.
                  </td>


                  <td v-for="item in yearspe.slice(0,pe.god_ot-pe.fact_god)" :key="item" align="center" rowspan="2" width="80"  valign="center"
                  >
                    {{ item }} год -

                    {{item==pe.fact_god?'Базовый год':''}}
                    {{(item==pe.fact_god) && (pe.fact_god==(pe.god_ot-1))?' / ':''}}
                    {{item==(pe.god_ot-1)?'Справочно':''}}
                    {{ (item>=pe.god_ot && !(item>pe.god_do))?'ПЭ':''}}
                  </td>
                  <td align="center" :colspan="pe.god_do-pe.god_ot+1" valign="center" style="border-bottom:1px solid black;border-right:1px solid black;border-top:1px solid black;">
                    Плановые значения целевых показателей по годам
                  </td>
                </tr>
                <tr>
                  <td v-for="(item) in yearspe.slice(pe.god_ot-pe.fact_god,pe.god_do-pe.fact_god+1)" :key="item" align="center" width="80" valign="center"
                      :style="(item>=pe.god_ot && !(item>pe.god_do))?'background: #E2FFCC':''">
                    {{item}} г.
                  </td>


                </tr>

                <tr>
                  <td valign="center" align="center">1</td>
                  <td valign="center" align="center">2</td>
                  <td valign="center" align="center">3</td>

                  <td v-for="(item,index) in yearspe.slice(0,pe.god_do-pe.fact_god+1)" :key="item" align="center" valign="center"
                      :style="(item>=pe.god_ot && !(item>pe.god_do))?'background: #E2FFCC':''">
                    {{index+4}}
                  </td>

                </tr>
                </thead>
                <tbody>
                <tr >
                  <td valign="center" align="center" width="44" style="border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                    1
                  </td>
                  <td  valign="center"  align="left" style="padding-left:3px" :colspan="yearspe.length+2" >
                    <b>Целевые показатели</b>
                  </td>


                </tr>
                <tr v-for="(item,index) in pe.celev.filter(x=>x.kind==='Целевой' && x.showinform)" :key="item">
                  <td valign="center" align="center"  style="border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                    1.{{index+1}}
                  </td>
                  <td valign="center" align="justify" width="280" style="max-width:280px; min-width:280px;padding-left:3px;line-height:0.9rem;" >
                    {{item.name}}
                  </td>
                  <td valign="center" align="center"   >
                    {{item.ed}}
                  </td>

                  <td v-for="(year,indexyear) in yearspe" valign="center" align="center" :key="year"
                      :style="(year>=pe.god_ot && !(year>pe.god_do))?'background: #E2FFCC':''">
                    {{decimal(item.value_plan[indexyear],item.decimal)}}
                  </td>
                </tr>
                <tr >
                  <td valign="center" align="center" width="44" style="border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                    2
                  </td>
                  <td  valign="center"  align="left" style="padding-left:3px" :colspan="yearspe.length+2" >
                    <b>Прочие показатели</b>
                  </td>

                </tr>
                <template v-if="pe.show_economy_targets !== false">
                <tr v-for="(topl,indextopl) in pe.ter" :key="topl">
                  <td valign="center" align="center"  style="border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                    2.{{indextopl+1}}
                  </td>
                  <td  style="text-indent: 0px; padding-left:3px"  >
                    <span >Экономия ТЭР: {{ topl.name }}</span>
                  </td>
                  <td valign="center" align="center">
                    {{ topl.ed }}<br/>
                    {{ pe.economy_targets_unit === 'million' ? 'млн.руб.' : 'тыс.руб.' }}
                  </td>

                  <td v-for="(item,index) in yearspe" :key="item" valign="center" align="center"
                      :style="(item>=pe.god_ot && !(item>pe.god_do))?'background: #E2FFCC':''">

                    <span >{{ decimal((topl.economy_volume_plan[index]),2) }}</span>
                    <br/>
                    <span>{{ decimal(pe.economy_targets_unit === 'million' ? topl.economy_rub_plan[index] / 1000 : topl.economy_rub_plan[index], pe.economy_targets_decimals) }}</span>


                  </td>
                </tr>
                </template>
                <tr v-for="(item,index) in pe.celev.filter(x=>x.kind==='Прочий' && x.showinform)" :key="item">
                  <td valign="center" align="center"  style="border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                    2.{{index+1+(pe.show_economy_targets !== false ? pe.ter.length : 0)}}
                  </td>
                  <td valign="center" align="justify" width="280" style="max-width:280px; min-width:280px;padding-left:3px;line-height:0.9rem;" >
                    {{item.name}}
                  </td>
                  <td valign="center" align="center"   >
                    {{item.ed}}
                  </td>

                  <td v-for="(year,indexyear) in yearspe" valign="center" align="center" :key="year"
                      :style="(year>=pe.god_ot && !(year>pe.god_do))?'background: #E2FFCC':''"  >
                    {{decimal(item.value_plan[indexyear],item.decimal)}}
                  </td>
                </tr>

                </tbody></table>
              <br/>
              <br/>
              <br/>
              <br/>
              <table>

                <tr >
                  <td><b>{{pe.ruk_dolg}}</b></td><td> __________________________________ </td><td><b>{{pe.ruk_sokr}}</b></td>
                </tr>


              </table>




            </div>

            {{pe.reg?'BREAKKK':''}}
            <div v-if="pe.reg" class=WordSection5 style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 1190.4pt; width:1190.4pt; border:1px solid #D7D6CF; padding:20mm;">
              <a name="meropriyatia"></a>
              <h2 align="center">Перечень мероприятий, основной целью которых является энергосбережение и (или) повышение энергетической эффективности</h2>
              <br/>

              <table   style=" border-collapse: collapse; border:1px solid #000000; font-family: 'Times New Roman'; color:#000000; font-size:7pt; line-height:0.9rem"
                       border="1"
                       cellspacing="0" >
                <thead>
                <tr>
                  <td align="center" valign="center"  rowspan="3" width="80" ROT90  class="pov90" >
                    N п/п
                  </td>
                  <td align="center" valign="center"  rowspan="3" width="500"  >
                    Наименование мероприятия
                  </td>
                  <td align="center" valign="center"   rowspan="2" :colspan="2+(pe.god_do-pe.god_ot+1)*1"    >
                    Объемы выполнения (план) с разбивкой по годам действия программы
                  </td>
                  <td align="center" valign="center"   :colspan="2+(pe.god_do-pe.god_ot+1)*3"   >
                    Плановые численные значения экономии в обозначенной размеренности с разбивкой по годам действия программы
                  </td>
                  <td align="center" valign="center"  rowspan="2" colspan="3"   >
                    Показатели экономической эффективности
                  </td>

                  <td align="center" valign="center"  rowspan="2"  :colspan="1+(pe.god_do-pe.god_ot+1)*1"  >
                    Затраты (план), тыс. руб. (без НДС), с разбивкой по годам действия программы
                  </td>
                  <td align="center" valign="center"  rowspan="3" width="100" ROT90  class="pov90" >
                    Источник финансирования / Статья затрат
                  </td>

                </tr>

                <tr >

                  <td align="center" valign="center"  rowspan="2" width="200"  style="min-width:45mm; width:45mm;" >
                    единицы измерения
                  </td>
                  <td align="center" valign="center"  rowspan="2"  width="80" ROT90  class="pov90" >
                    всего по годам экономия в указанной размерности
                  </td>
                  <td align="center" valign="center"  colspan="3" v-for="item in yearspe.slice(pe.god_ot-pe.fact_god,yearspe.length)" :key="item"   >
                    {{ item }} г.

                  </td>

                </tr>
                <tr  height="100" style="max-height:100px; word-wrap: normal ">
                  <td align="center" valign="center"  width="80" ROT90  class="pov90" >
                    ед. измерения
                  </td>
                  <td align="center" valign="center"  width="80"  ROT90  class="pov90" >
                    всего
                  </td>
                  <td align="center" valign="center"  width="80" v-for="item in yearspe.slice(pe.god_ot-pe.fact_god,yearspe.length)" :key="item" ROT90  class="pov90" >
                    {{ item }} г.
                  </td>


                  <template v-for="item in yearspe.slice(pe.god_ot-pe.fact_god,yearspe.length)">

                    <td align="center" valign="center"  width="80" :name="item" :key="item"  ROT90  class="pov90"  >
                      численное значение экономии в указанной размерности
                    </td>
                    <td align="center" valign="center"   width="80" :key="item"  ROT90  class="pov90" >
                      численное значение экономии, т у. т.
                    </td>
                    <td align="center" valign="center"  width="80"  :key="item"  ROT90  class="pov90" >
                      численное значение экономии, тыс. руб.
                    </td>
                  </template>

                  <td align="center" valign="center"  width="100" ROT90  class="pov90"  >
                    дисконтированный срок окупаемости, лет
                  </td>
                  <td align="center" valign="center"   width="80" ROT90  class="pov90" >
                    ВНД, %
                  </td>
                  <td align="center" valign="center"  width="80" ROT90  class="pov90" >
                    ЧДД, тыс. руб.
                  </td>
                  <td align="center" valign="center"  width="80" ROT90  class="pov90" >
                    всего
                  </td>
                  <td align="center" valign="center"  width="80" v-for="item in yearspe.slice(pe.god_ot-pe.fact_god,yearspe.length)" :key="item" >
                    {{ item }} г.
                  </td>

                </tr>

                <tr>
                  <td align="center" valign="center" v-for="item in (11+5*yearspe.slice(pe.god_ot-pe.fact_god,yearspe.length).length)"  :key="item">
                    {{item}}
                  </td>

                </tr>
                </thead>
                <tbody>
                <tr align="center" valign="center" v-for="(merop, index) in pe.mer" :key="merop">
                  <td   >
                    {{index+1}}
                  </td>
                  <td align="center" valign="center" >
                    {{merop.name}}
                  </td>
                  <td align="center" valign="center" >
                    шт.
                  </td>
                  <td align="center" valign="center"  >
                    1
                  </td>
                  <td align="center" valign="center" v-for="item in (yearspe.slice(pe.god_ot-pe.fact_god,yearspe.length))"  :key="item" >
                    {{item==merop.start_god?'1':''}}
                  </td>
                  <td width="32"  >
             <span style="display: block" v-for="item in merop.ter" :key="item">
               {{toplmerinfo(item.name)}}
               <br/>
             </span>
                  </td>

                  <td  >


              <span  v-for="item in merop.ter" :key="item">
                   {{ decimal(item.delta_volume_plan.slice(pe.god_ot-pe.fact_god,Math.min(end_effect_god_index(merop)+1,yearspe.length-(pe.god_ot-pe.fact_god)+2)).reduce(function (a, b) {
                return Number(a) + Number(b);
              }),3) }}<br/>
                </span>





                  </td>

                  <template  v-for="(item,index) in yearspe.slice(pe.god_ot-pe.fact_god,yearspe.length)"  >
                    <td :key="item" >


                <span  v-show="index<=(end_effect_god_index(merop)-(pe.god_ot-pe.fact_god)) && index>=(merop.start_god-pe.fact_god-(pe.god_ot-pe.fact_god))"
                       v-for="item2 in merop.ter" :key="item2">
                    {{decimal(item2.delta_volume_plan[index+(pe.god_ot-pe.fact_god)],3)}}<br/>
                </span>

                    </td>
                    <td :key="item" >
                <span v-show="index<=(end_effect_god_index(merop)-(pe.god_ot-pe.fact_god)) && index>=(merop.start_god-pe.fact_god-(pe.god_ot-pe.fact_god))" v-for="item2 in merop.ter" :key="item2">
                    {{decimal(item2.tut_plan[index+(pe.god_ot-pe.fact_god)],3)}}<br/>
                </span>

                    </td>
                    <td :key="item" >
                <span v-show="index<=(end_effect_god_index(merop)-(pe.god_ot-pe.fact_god)) && index>=(merop.start_god-pe.fact_god-(pe.god_ot-pe.fact_god))" v-for="item2 in merop.ter" :key="item2">
                    {{decimal(item2.delta_rub_plan[index+(pe.god_ot-pe.fact_god)]/1000,4)}}<br/>
                </span>

                    </td>
                  </template>
                  <td  >
                    {{decimal(merop.disk_srok_okup)}}
                  </td>
                  <td  >
                    {{decimal(merop.vnd)}}%
                  </td>
                  <td  >
                    {{decimal(merop.chdd/1000,4)}}
                  </td>

                  <td  >
                    {{ decimal(merop.zatrati_plan.slice(pe.god_ot-pe.fact_god,yearspe.length).reduce(function (a, b) {
                    return Number(a) + Number(b);
                  })/1000,4) }}
                  </td>


                  <td align="center" valign="center"  width="80" v-for="(item,index) in yearspe.slice(pe.god_ot-pe.fact_god,yearspe.length)" :key="item" >
                    {{ decimal(merop.zatrati_plan[index+pe.god_ot-pe.fact_god]/1000,4) }}
                  </td>
                  <td  >
                  {{merop.istochnik}} / {{merop.statia}}
                  </td>



                </tr>



                <tr align="center"  valign="center" style="font-weight: bold" >
                  <td    colspan="2">
                    ИТОГО
                  </td>
                  <td align="center" valign="center" >
                    шт.
                  </td>
                  <td align="center" valign="center"  >
                    {{ pe.mer.length }}
                  </td>
                  <td align="center" valign="center" v-for="item in (yearspe.slice(pe.god_ot-pe.fact_god,yearspe.length))"  :key="item" >
                    {{ pe.mer.filter(x=>x.start_god==item).length }}
                  </td>
                  <td width="32"  >
             <span style="display: block" >

             </span>
                  </td>

                  <td  >

                  </td>

                  <template  v-for="(item,index) in yearspe.slice(pe.god_ot-pe.fact_god,yearspe.length)"  >
                    <td :key="item" >

                    </td>
                    <td :key="item" >

                      {{ total_mer('total_tut_plan',index+(pe.god_ot-pe.fact_god),3) }}




                    </td>
                    <td :key="item" >
                      {{ decimal(total_mer('total_delta_rub_plan',index+(pe.god_ot-pe.fact_god),-1)/1000,4) }}

                    </td>
                  </template>
                  <td  >

                  </td>
                  <td  >

                  </td>

                  <td  >

                  </td>
                  <td  >
                    {{decimal(pe.zatrati_total_itog/1000,4)}}


                  </td>


                  <td align="center" valign="center"  width="80" v-for="(item,index) in yearspe.slice(pe.god_ot-pe.fact_god,yearspe.length)" :key="item" >
                    {{decimal(pe.zatrati_total[index+(pe.god_ot-pe.fact_god)]/1000,4)}}
                  </td>
                  <td  >

                  </td>



                </tr>
                </tbody>
              </table>



              <br/>
              <br/>
              <br/>
              <br/>
              <table>

                <tr >
                  <td><b>{{pe.ruk_dolg}}</b></td><td> __________________________________ </td><td><b>{{pe.ruk_sokr}}</b></td>
                </tr>


              </table>
            </div>
            BREAKKK

            <div class="WordSection2" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 210mm; width:210mm; border:1px solid #D7D6CF; padding:20mm;">


              <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>

              <h1 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Пояснительная записка
              </h1>
              <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>


            </div>
            BREAKKK
            <div class="WordSection2" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 210mm; width:210mm; border:1px solid #D7D6CF; padding:20mm;">
<a name="poyasn"></a>
              <h2 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Полное наименование программы
              </h2>

              <div v-html="pe.fullname" style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify "></div>

              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Сведения о должностных лицах
              </h3>
              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Сведения о должностном лице, утвердившем программу
              </h3>
              <p align="left"
                 style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify ">
                Таблица. Сведения о должностном лице, утвердившем программу.
              </p>

              <table
                style="width:170mm; border-collapse: collapse; border:1px solid #000000; font-family: 'Times New Roman'; color:#000000; font-size:12pt;"
                border="1"
                cellspacing="0" >
                <tr>
                  <td align="center" valign="center" width="30">№</td>
                  <td  align="center" valign="center" width="210">Фамилия, имя, отчество</td>
                  <td  align="center" valign="center" width="180">Должность</td>
                  <td  align="center" valign="center" width="120">Подпись</td>
                </tr>
                <tr height="50">
                  <td  align="center" valign="center">1</td>
                  <td  align="center" valign="center">{{ pe.ruk_fio }}</td>
                  <td  align="center" valign="center">{{ pe.ruk_dolg }}</td>
                  <td  align="center" valign="center"></td>
                </tr>
              </table>
              <h3 v-if="pe.sogl.length>0" align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Сведения о должностных лицах, согласовавших программу
              </h3>
              <p align="left" v-if="pe.sogl.length>0"
                 style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify ">
                Таблица. Сведения о должностных лицах, согласовавших программу.
              </p>
              <table
                  v-if="pe.sogl.length>0"
                  style="width:170mm; border-collapse: collapse; border:1px solid #000000; font-family: 'Times New Roman'; color:#000000; font-size:12pt;"
                  border="1"
                  cellspacing="0" >
                <tr>
                  <td align="center" valign="center" width="30">№</td>
                  <td  align="center" valign="center" width="210">Фамилия, имя, отчество</td>
                  <td  align="center" valign="center" width="180">Должность</td>
                  <td  align="center" valign="center" width="120">Подпись</td>
                </tr>
                <tr height="50" v-for="(item,index) in pe.sogl" :key="item">
                  <td  align="center" valign="center">{{ index+1 }}</td>
                  <td  align="center" valign="center">{{ item.sogl_fio }}</td>
                  <td  align="center" valign="center">{{ item.sogl_dolg }}</td>
                  <td  align="center" valign="center"></td>
                </tr>
              </table>
              <h3  v-if="pe.otv.length>0" align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Сведения об ответственных должностных лицах
              </h3>
              <p align="left" v-if="pe.otv.length>0"
                 style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify ">
                Таблица. Сведения об ответственных должностных лицах.
              </p>
              <table
                  v-if="pe.otv.length>0"
                  style="width:170mm; border-collapse: collapse; border:1px solid #000000; font-family: 'Times New Roman'; color:#000000; font-size:12pt;"
                  border="1"
                  cellspacing="0" >
                <tr>
                  <td align="center" valign="center" width="30">№</td>
                  <td  align="center" valign="center" width="180">Фамилия, имя, отчество</td>
                  <td  align="center" valign="center" width="180">Должность</td>
                  <td  align="center" valign="center" width="180">Контакты</td>
                </tr>
                <tr height="50" v-for="(item,index) in pe.otv" :key="item">
                  <td  align="center" valign="center">{{ index+1 }}</td>
                  <td  align="center" valign="center">{{ item.otv_fio }}</td>
                  <td  align="center" valign="center">{{ item.otv_dolg}}</td>
                  <td  align="center" valign="center">{{ item.phone}}<br/> {{ item.email}}</td>
                </tr>
              </table>


              <h2 v-if="pe.sogl.length>0" align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Информация об организации
              </h2>
              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Реквизиты и контактные сведения
              </h3>
              <p align="left"
                 style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify ">
                Таблица. Реквизиты и контактные сведения.
              </p>
              <table
                  style="width:170mm; border-collapse: collapse; border:1px solid #000000; font-family: 'Times New Roman'; color:#000000; font-size:12pt;"
                  border="1"
                  cellspacing="0" >
                <tr>
                  <td align="center" valign="center" width="150">Наименование</td>
                  <td  align="left" style="padding-left:3px" valign="center" width="300">{{ pe.org }}</td>

                </tr>
                <tr>
                  <td align="center" valign="center" width="150">Почтовый адрес</td>
                  <td  align="left" style="padding-left:3px" valign="center" width="300">{{ pe.pocht_address }}</td>

                </tr>
                <tr>
                  <td align="center" valign="center" width="150">ИНН</td>
                  <td  align="left" style="padding-left:3px" valign="center" width="300">{{ pe.inn }}</td>

                </tr>
                <tr>
                  <td align="center" valign="center" width="150">КПП</td>
                  <td  align="left" style="padding-left:3px" valign="center" width="300">{{ pe.kpp }}</td>

                </tr>
                <tr>
                  <td align="center" valign="center" width="150">ОКПО</td>
                  <td  align="left" style="padding-left:3px" valign="center" width="300">{{ pe.okpo }}</td>

                </tr>
                <tr>
                  <td align="center" valign="center" width="150">ОГРН</td>
                  <td  align="left" style="padding-left:3px" valign="center" width="300">{{ pe.ogrn }}</td>

                </tr>
                <tr>
                  <td align="center" valign="center" width="150">Телефон</td>
                  <td  align="left" style="padding-left:3px" valign="center" width="300">{{ pe.phone }}</td>

                </tr>
                <tr>
                  <td align="center" valign="center" width="150">E-mail</td>
                  <td  align="left" style="padding-left:3px" valign="center" width="300">{{ pe.email }}</td>

                </tr>


              </table>




              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Основные виды деятельности организации
              </h3>

              <div v-html="pe.vidideyateln" style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify "></div>




              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Краткая характеристика регулируемого вида деятельности организации
              </h3>
              <div v-html="pe.kratk_har_vd" style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify "></div>






              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Сведения о наличии  зданий административного и административно-производственного назначения
              </h3>
              <div v-html="pe.admzd" style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify "></div>

              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Сведения о наличии автотранспорта и спецтехники
              </h3>
              <div v-html="pe.transport" style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify "></div>

              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Сведения о количестве точек приема (поставки) электрической энергии
              </h3>
              <div v-html="pe.tochkiee" style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify "></div>

              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Сведения о количестве точек поставки энергетических ресурсов на хозяйственные нужды
              </h3>
              <div v-html="pe.tochkihoz" style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify "></div>

              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Сведения о потреблении используемых энергетических ресурсов по видам этих энергетических ресурсов
              </h3>
              <div v-html="pe.resursporteb" style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify "></div>



              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Текущее состояние в области энергосбережения и повышения энергетической эффективности организации
              </h3>
              <div v-html="pe.teksost" style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify "></div>

              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Информация о достигнутых результатах в области энергосбережения и повышения энергетической эффективности организации за последние 5 лет
              </h3>
              <div v-html="pe.rezultee" style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify "></div>


              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Сравнение показателей деятельности организации с компаниями, достигшими наилучших показателей в аналогичной сфере деятельности, из числа российских и зарубежных компаний
              </h3>
              <div v-html="pe.sravnenie" style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify "></div>




              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Экономические показатели программы организации
              </h3>
              <div v-html="pe.ekonompokaz" style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify "></div>




              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Изменение уровня потерь энергетических ресурсов при их передаче или изменение потребления энергетических ресурсов для целей осуществления регулируемого вида деятельности в натуральном и денежном выражении по годам периода действия программы
              </h3>
              <div v-html="pe.izmpoter" style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify "></div>




              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Изменение расхода энергетических ресурсов на хозяйственные нужды в натуральном выражении и денежном выражении по годам периода действия программы
              </h3>
              <div v-html="pe.izmreshoz" style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify "></div>





              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Изменение расхода моторного топлива автотранспортом и спецтехникой в натуральном выражении и денежном выражении, с разбивкой по годам действия программы
              </h3>
              <div v-html="pe.izmresmotor" style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify "></div>


              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Фактические значения целевых показателей программы по годам периода действия программы
              </h3>
              <div v-html="pe.factcelevgod" style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify "></div>



              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Распределение целевых показателей программы по направлениям деятельности организации в разрезе каждого года, их целевые и фактические значения
              </h3>
              <div v-html="pe.raspredcp" style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify "></div>




              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Сведения об увязке результатов реализации программы с вознаграждением сотрудников организации, в том числе через механизм ключевых показателей результативности (далее - КПР) для менеджеров и структурных подразделений по каждому направлению деятельности организации в разрезе каждого года, их целевые и фактические значения
              </h3>
              <div v-html="pe.uviazkazp" style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify "></div>

              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Перечень мероприятий, технологий, денежных средств, необходимых для реализации мероприятий организации в целях достижения целевых показателей программы
              </h3>
              <div v-html="pe.perechenmertext" style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify "></div>




              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Механизм мониторинга и контроля за исполнением КПР
              </h3>
              <div v-html="pe.mehanizmmonkpr" style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify "></div>






              <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Механизм мониторинга и контроля за исполнением целевых показателей программы
              </h3>
              <div v-html="pe.mehanizmmoncp" style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify "></div>





              <h2 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Правовая и иная информация
              </h2>
              <div v-html="pe.pravov" style="text-indent:15mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: justify "></div>

            </div>
            BREAKKK
            <div class="WordSection2" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 210mm; width:210mm; border:1px solid #D7D6CF; padding:20mm;">


              <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>

              <h1 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Технико-экономические расчёты по мероприятиям программы
              </h1>
              <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>


            </div>
            BREAKKK
            <template v-for="(merop,index) in pe.mer">
              <div :key="merop" class="WordSection1" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 297mm; width:297mm; border:1px solid #D7D6CF; padding:20mm;">
                <h2  align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Мероприятие № {{index+1}} на {{merop.start_god}} год: {{merop.name}}
                </h2>
                <br/>
                <p align="left"
                   style="text-indent:0mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: left; font-weight:bold; ">
                  Сводная информация по мероприятию:
                </p>

                <table
                  style="width:255mm;border-collapse:collapse;font-family: Times New Roman; color:#000000; font-size:12pt;line-height:1rem"
                  border="0"

                  cellspacing="0">
                  <tr>
                    <td style="border-bottom: 1px solid #D7D6CF;  " >Объект, адресная характеристика: {{merop.object}}</td>
                  </tr>
                  <tr>
                    <td style="border-bottom: 1px solid #D7D6CF;  ">Год начала мероприятия: {{merop.start_god}}</td>
                  </tr>
                  <tr>
                    <td style="border-bottom: 1px solid #D7D6CF;  ">Срок амортизации (при наличии в случае отнесения к капитальным затратам): {{merop.amort}}</td>
                  </tr>
                  <tr>
                    <td style="border-bottom: 1px solid #D7D6CF;  ">Источник финансирования: {{merop.istochnik}}</td>
                  </tr>
                  <tr>
                    <td style="border-bottom: 1px solid #D7D6CF;  "> Статья затрат: {{merop.statia}}</td>
                  </tr>
                  <tr>
                    <td style="border-bottom: 1px solid #D7D6CF;  "> Обоснование затрат: {{merop.obosnovanie_doc}}</td>
                  </tr>
                  <tr>
                    <td style="border-bottom: 1px solid #D7D6CF;  ">Ставка дисконтирования, %: {{merop.discont}}</td>
                  </tr>
                  <tr>
                    <td style="border-bottom: 1px solid #D7D6CF;  ">Объём затрат, руб.: {{decimal(merop.summa_zatrat)}}</td>
                  </tr>
                  <tr>
                    <td style="border-bottom: 1px solid #D7D6CF;  "> Простой срок окупаемости, лет: {{decimal(merop.srok_okup,3)}}</td>
                  </tr>
                  <tr>
                    <td style="border-bottom: 1px solid #D7D6CF;  ">Дисконтированный срок окупаемости, лет: {{decimal(merop.disk_srok_okup,3)}}</td>
                  </tr>

                  <tr>
                    <td style="border-bottom: 1px solid #D7D6CF;  "> Доля в инвестпрограмме (при наличии), %: {{decimal(merop.dolya_invest,2)}}</td>
                  </tr>
                  <tr>
                    <td style="border-bottom: 1px solid #D7D6CF;  "> Внутренняя норма доходности, %: {{decimal(merop.vnd,3)}}</td>
                  </tr>
                  <tr>
                    <td style="border-bottom: 1px solid #D7D6CF;  "> Чистый дисконтированный доход, руб.: {{decimal(merop.chdd,2)}}</td>
                  </tr>
                  <tr>
                    <td style="border-bottom: 1px solid #D7D6CF;  "> Продолжительность учёта экономии ТЭР и эффекта изменения показателей: {{merop.period_effect}}</td>
                  </tr>

                </table>
                <br/>

                <p align="left" v-if="merop.summa_zatrat>0"
                   style="text-indent:0mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: left; font-weight:bold;  ">
                  Затраты на реализацию мероприятия по годам ПЭ:
                </p>

                <table v-if="merop.summa_zatrat>0 || merop.disk_srok_okup>0"  style="border-collapse:collapse;font-family: Times New Roman; color:#000000; font-size:10pt;line-height:1rem"
                       border="1"

                       cellspacing="0">
                  <thead>
                  <th width="50">№ п/п</th>
                  <th width="50">Год</th>

                  <th width="180">Затраты, руб.</th>


                  </thead>
                  <tbody>
                  <tr v-for="(item,index) in yearspe.slice(pe.god_ot-pe.fact_god,pe.god_do-pe.fact_god+1)" :key="item">
                    <td valign="center" align="center" >{{index+1 }}</td>
                    <td valign="center" align="center" >{{ item }}</td>

                    <td valign="center" align="center" >{{decimal(merop.zatrati_plan[index+(pe.god_ot-pe.fact_god)])}}</td>




                  </tr>
                  </tbody>

                </table>



                <p align="left" v-if="merop.summa_zatrat>0 || merop.disk_srok_okup>0"
                   style="text-indent:0mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: left; font-weight:bold;  ">
                  Финансовые показатели:
                </p>



                <table v-if="merop.summa_zatrat>0 || merop.disk_srok_okup>0"  style="border-collapse:collapse;font-family: Times New Roman; color:#000000; font-size:10pt;line-height:1rem"
                         border="1"

                         cellspacing="0">
                  <thead>
                  <th width="50">№ п/п</th>
                  <th width="50">Год</th>
                  <th width="50">ПЭ</th>
                  <th width="180">Инвестиции, руб.</th>
                  <th width="180">Денежный поток, руб.</th>
                  <th width="180">Доход, руб.</th>
                  <th width="180">Диск. денеж. поток, руб.</th>
                  <th width="180">Чистый диск. доход, руб.</th>

                  </thead>
                  <tbody>
                  <tr v-for="(item,index) in yearsprognoz.slice(merop.start_god-pe.fact_god,merop.start_god-pe.fact_god+Math.ceil(merop.disk_srok_okup))" :key="item">
                    <td valign="center" align="center" >{{index+1 }}</td>
                    <td valign="center" align="center" >{{ item }}</td>
                    <td valign="center" align="center" > {{item==pe.fact_god?'Факт':''}}
                      {{(item==pe.fact_god) && (pe.fact_god==(pe.god_ot-1))?' / ':''}}
                      {{item==(pe.god_ot-1)?'Базовый год':''}}
                      {{ (item>=pe.god_ot && !(item>pe.god_do))?' ПЭ ':''}}</td>
                    <td valign="center" align="center" >{{decimal(merop.zatrati_plan[index+(merop.start_god-pe.fact_god)])}}</td>
                    <td valign="center" align="center" >{{decimal(merop.cf[index+(merop.start_god-pe.fact_god)])}}</td>
                    <td valign="center" align="center" >{{decimal(merop.dohodarray[index+(merop.start_god-pe.fact_god)])}}</td>
                    <td valign="center" align="center" >{{decimal(merop.dcf[index+(merop.start_god-pe.fact_god)])}}</td>
                    <td valign="center" align="center" >{{decimal(merop.chddarray[index+(merop.start_god-pe.fact_god)])}}</td>



                  </tr>
                  </tbody>

                </table>


                <p align="left" v-if="merop.technologii.length>0"
                   style="text-indent:0mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: left; font-weight:bold;  ">
                  Принципы определения технологического эффекта:
                </p>
                <p align="left" v-if="merop.technologii.length>0"
                   style="text-indent:0mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:12pt; text-align: justify;   border: 1px solid #D7D6CF; ">
                  {{ merop.technologii }}
                </p>
                <p align="left" v-if="merop.raschet.length>0"
                   style="text-indent:0mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: left; font-weight:bold;  ">
                  Расчёт изменений показателей при реализации программы:
                </p>

                <table v-if="merop.raschet.length>0"  style="border-collapse:collapse;font-family: Times New Roman; color:#000000; font-size:10pt;line-height:1rem"
                       border="1"

                       cellspacing="0">
                  <thead>
                  <th width="180">Показатель</th>
                  <th width="80">Значение</th>



                  </thead>
                  <tbody>
                  <tr v-for="perem in merop.raschet" :key="perem">
                    <td valign="center" align="center" >{{perem.name }}</td>
                    <td valign="center" align="center" >{{ decimal(perem.value,perem.decimal) }}</td>




                  </tr>
                  </tbody>

                </table>

                <p align="left" v-if="merop.ter.length>0"
                   style="text-indent:0mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: left; font-weight:bold;  ">
                  Экономия ТЭР при реализации мероприятия:
                </p>

                <span v-if="merop.ter.length>0">
                  <template v-for="(topl) in merop.ter">
                    <p :key="topl" align="left"
                       style="text-indent:0mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:12pt; text-align: left; font-weight:bold; font-style:italic;  ">
                  {{ topl.name }}
                </p>
                    <table :key="topl"   style="border-collapse:collapse;font-family: Times New Roman; color:#000000; font-size:10pt;line-height:1rem"
                           border="1"

                           cellspacing="0">
                  <thead>
                  <th width="40">№ п/п</th>
                  <th width="40">Год</th>
                  <th width="40">ПЭ</th>
                  <th width="180">{{(pe.ter.map(x=>x.name).indexOf(topl.name)>-1?pe.ter.find(x=>(x.name==topl.name)).ed:'') +' (план)'}}</th>
                  <th width="180">{{ 'руб./'+  (pe.ter.map(x=>x.name).indexOf(topl.name)>-1?pe.ter.find(x=>(x.name==topl.name)).ed:'') +' (план)' }}</th>
                  <th width="180">Экономия, руб.(план)</th>
                  <th width="180">Экономия, т.у.т.(план)</th>




                  </thead>
                  <tbody>
                  <tr  v-for="(item,index) in yearsprognoz.slice(merop.start_god-pe.fact_god,merop.start_god-pe.fact_god+Math.max(Math.ceil(merop.disk_srok_okup),1))" :key="item">
                    <th width="40">{{ index+1 }}</th>
                  <th width="40">{{ item }}</th>
                  <th width="40"> {{item==pe.fact_god?'Факт':''}}
        {{(item==pe.fact_god) && (pe.fact_god==(pe.god_ot-1))?' / ':''}}
        {{item==(pe.god_ot-1)?'Базовый год':''}}
        {{ (item>=pe.god_ot && !(item>pe.god_do))?' ПЭ ':''}}</th>

                  <th width="180">{{decimal(topl.delta_volume_plan[index+(merop.start_god-pe.fact_god)])}}</th>
                  <th width="180">{{ decimal(topl.price_plan[index+(merop.start_god-pe.fact_god)]) }}</th>
                  <th width="180">{{ decimal(topl.delta_rub_plan[index+(merop.start_god-pe.fact_god)]) }}</th>
                  <th width="180">{{ decimal(topl.tut_plan[index+(merop.start_god-pe.fact_god)]) }}</th>

                  </tr>
                  </tbody>

                </table>


                  </template>

                </span>




                <p align="left" v-if="merop.cp.length>0"
                   style="text-indent:0mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:14pt; text-align: left; font-weight:bold;  ">
                  Изменение показателей при реализации мероприятия:
                </p>

                <span v-if="merop.cp.length>0">
                  <template v-for="(cpp) in merop.cp">
                    <p :key="cpp" align="left"
                       style="text-indent:0mm; line-height:1.5em;font-family: 'Times New Roman'; color:#000000;
                 font-size:12pt; text-align: left; font-weight:bold; font-style:italic;  ">
                  {{ cpp.name }}
                </p>
                    <table :key="cpp"   style="border-collapse:collapse;font-family: Times New Roman; color:#000000; font-size:10pt;line-height:1rem"
                           border="1"

                           cellspacing="0">
                  <thead>
                  <th width="40">№ п/п</th>
                  <th width="40">Год</th>
                  <th width="40">ПЭ</th>
                  <th width="180">{{(pe.celev.map(x=>x.name).indexOf(cpp.name)>-1?pe.celev.find(x=>(x.name==cpp.name)).ed:'')+ ' (план)'}}</th>





                  </thead>
                  <tbody>
                  <tr  v-for="(item,index) in yearsprognoz.slice(merop.start_god-pe.fact_god,merop.start_god-pe.fact_god+Math.max(Math.ceil(merop.disk_srok_okup),1))" :key="item">
                    <th width="40">{{ index+1 }}</th>
                  <th width="40">{{ item }}</th>
                  <th width="40"> {{item==pe.fact_god?'Факт':''}}
        {{(item==pe.fact_god) && (pe.fact_god==(pe.god_ot-1))?' / ':''}}
        {{item==(pe.god_ot-1)?'Базовый год':''}}
        {{ (item>=pe.god_ot && !(item>pe.god_do))?' ПЭ ':''}}</th>

                  <th width="180">{{decimal(cpp.delta_plan[index+(merop.start_god-pe.fact_god)], pe.celev.find(x=>(x.name==cpp.name)).decimal)}}</th>

                  </tr>
                  </tbody>

                </table>


                  </template>

                </span>










              </div>
              BREAKKK
            </template>
            <div class="WordSection2" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 210mm; width:210mm; border:1px solid #D7D6CF; padding:20mm;">


              <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>

              <h1 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Балансы топливно-энергетических ресурсов
              </h1>
              <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>


            </div>
            BREAKKK



            <template v-for="topl in pe.ter">
              <div :key="topl" class="WordSection1" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 297mm; width:297mm; border:1px solid #D7D6CF; padding:20mm;">
              <h2  align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Сведения о потреблении ТЭР: {{topl.name}} ({{topl.ed}})
              </h2>
<table
:style="'width:255mm;border-collapse:collapse;border:1px solid #000000;font-family: Times New Roman; color:#000000; font-size:'+fontsizetopl()+'pt;line-height:1rem'"
                       border="1"

                       cellspacing="0">
                  <thead>
                  <tr>
                    <th align="center" valign="center" rowspan="2" width="250">
                      Показатели / Периоды
                    </th>
                    <th v-for="item in yearspe" :key="item" align="center" valign="center" width="70">
                      <span>{{item}}</span>
                    </th>
                  </tr>
                  <tr>

                    <th v-for="item in yearspe" :key="item" align="center" valign="center">


                      <span>

        {{ (yearspe.indexOf(item)>-1 )&& (item>=
                          pe.god_ot)?'ПЭ':''}}

        {{item==pe.fact_god?'Факт':''}}
        {{(item==pe.fact_god) && (pe.fact_god==(pe.god_ot-1))?' / ':''}}
        {{item==(pe.god_ot-1)?'Базовый год':''}}

      </span>
                    </th>
                  </tr>
                  </thead>
                  <tbody>

                  <tr>
                    <td style="text-indent:3px;background: #E9FFCF" :colspan="yearspe.length+1" align="left" valign="center">
                      <b>Показатели без учёта ПЭ (план)</b>
                    </td>

                  </tr>



                  <tr>
                    <td style="text-indent:3px;" align="left" valign="center">
                      Переводной коэфф. из {{topl.ed}} в т.у.т.
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">



                      {{decimal(topl.pk_plan[index],4)}}

                    </td>
                  </tr>


                  <tr>
                    <td style="text-indent:3px;" align="left" valign="center">
                      Объём ресурса ({{topl.ed}})
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">
                      {{decimal(topl.volume_plan_do_mer[index],3)}}



                    </td>
                  </tr>

                  <tr>
                    <td style="text-indent:3px;">
                      Объём ресурса (т.у.т.)
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">

                      {{decimal(topl.tut_plan_do_mr[index],2)}}


                    </td>
                  </tr>

                  <tr>
                    <td style="text-indent:3px;">
                      Затраты на ресурс (тыс. руб.)
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">


                      {{decimal(topl.rub_plan_do_mer[index],2)}}








                    </td>
                  </tr>

                  <tr>
                    <td style="text-indent:3px;">
                      Индекс роста цены, %
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">
                      {{decimal(topl.index[index],2)}}


                    </td>
                  </tr>

                  <tr>
                    <td style="text-indent:3px;">
                      Цена ресурса (руб./{{topl.ed}})
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">
                      {{decimal(topl.price[index],2)}}


                    </td>
                  </tr>

                  <tr>
                    <td style="text-indent:3px; background: #E9FFCF" :colspan="yearspe.length+1">
                      <b>Показатели с учётом ПЭ (план)</b>
                    </td>

                  </tr>


                  <tr>
                    <td style="text-indent:3px;">
                      Объём ресурса с учётом ПЭ ({{topl.ed}})
                    </td>
                    <td  v-for="(item,index) in yearspe" :key="item" align="center" valign="center">

                     <span v-if="item>=pe.god_ot"> {{decimal(topl.volume_plan_posle_mer[index],3)}}</span>
                     <span v-if="item<pe.god_ot"> -</span>

                    </td>
                  </tr>
                  <tr>
                    <td style="text-indent:3px;">
                      Объём ресурса с учётом ПЭ (т.у.т.)
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">
                      <span v-if="item>=pe.god_ot">{{decimal(topl.tut_plan_posle_mer[index],2)}}</span>
                      <span v-if="item<pe.god_ot"> -</span>


                    </td>
                  </tr>
                  <tr>
                    <td style="text-indent:3px;">
                      Затраты на ресурс с учётом ПЭ (тыс. руб.)
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">

                      <span v-if="item>=pe.god_ot">{{decimal(topl.rub_plan_posle_mer[index],2)}}</span>
                      <span v-if="item<pe.god_ot"> -</span>


                    </td>
                  </tr>

                  <tr>
                    <td style="text-indent:3px;">
                      Плановая экономия ресурса ({{topl.ed}})
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">
                      <span v-if="item>=pe.god_ot">{{decimal(topl.economy_volume_plan[index],2)}}</span>
                      <span v-if="item<pe.god_ot"> -</span>


                    </td>
                  </tr>


                  <tr>
                    <td style="text-indent:3px;">
                      Плановая экономия ресурса (т.у.т.)
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">
                      <span v-if="item>=pe.god_ot">{{decimal(topl.economy_tut_plan[index],2)}}</span>
                      <span v-if="item<pe.god_ot"> -</span>


                    </td>
                  </tr>
                  <tr>
                    <td style="text-indent:3px;">
                      Плановая экономия затрат на ресурс (тыс. руб.)
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">

                      <span v-if="item>=pe.god_ot">{{decimal(topl.economy_rub_plan[index],2)}}</span>
                      <span v-if="item<pe.god_ot"> -</span>


                    </td>
                  </tr>




                  <tr>
                    <td style="text-indent:3px;background: #E9FFCF" :colspan="yearspe.length+1">
                      <b>Фактические показатели отчёта к ПЭ (заполняется после окончания каждого года периода ПЭ)</b>
                    </td>

                  </tr>

                  <tr>
                    <td style="text-indent:3px;">
                      Фактический пер. коэфф. из {{topl.ed}} в т.у.т.
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">

                      <span v-if="item>=pe.god_ot">{{decimal(topl.pk_fact[index],4)}}</span>
                      <span v-if="item<pe.god_ot"> -</span>



                    </td>
                  </tr>

                  <tr>
                    <td style="text-indent:3px;">
                      Фактический объём ресурса ({{topl.ed}})
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">

                      <span v-if="item>=pe.god_ot">{{decimal(topl.volume_fact[index],3)}}</span>
                      <span v-if="item<pe.god_ot"> -</span>



                    </td>
                  </tr>


                  <tr>
                    <td style="text-indent:3px;">
                      Фактический объём ресурса (т.у.т.)
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">

                      <span v-if="item>=pe.god_ot">{{decimal(topl.tut_fact[index],2)}}</span>
                      <span v-if="item<pe.god_ot"> -</span>



                    </td>
                  </tr>
                  <tr>
                    <td style="text-indent:3px;">
                      Фактические затраты на ресурс (тыс. руб.)
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">

                      <span v-if="item>=pe.god_ot">{{decimal(topl.rub_fact[index],2)}}</span>
                      <span v-if="item<pe.god_ot"> -</span>



                    </td>
                  </tr>


                  <tr>
                    <td style="text-indent:3px;">
                      Фактическая цена ресурса (руб./{{topl.ed}})
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">
                      <span v-if="item>=pe.god_ot">{{decimal(topl.price_fact[index],2)}}</span>
                      <span v-if="item<pe.god_ot"> -</span>


                    </td>
                  </tr>







                  <tr>
                    <td style="text-indent:3px;">
                      Фактическая экономия ресурса ({{topl.ed}})
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">
                      <span v-if="item>=pe.god_ot">{{decimal(topl.economy_volume_fact[index],2)}}</span>
                      <span v-if="item<pe.god_ot"> -</span>


                    </td>
                  </tr>


                  <tr>
                    <td style="text-indent:3px;">
                      Фактическая экономия ресурса (т.у.т.)
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">
                      <span v-if="item>=pe.god_ot">{{decimal(topl.economy_tut_fact[index],2)}}</span>
                      <span v-if="item<pe.god_ot"> -</span>


                    </td>
                  </tr>
                  <tr>
                    <td style="text-indent:3px;">
                      Фактическая экономия затрат на ресурс (тыс. руб.)
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">
                      <span v-if="item>=pe.god_ot">{{decimal(topl.economy_rub_fact[index],2)}}</span>
                      <span v-if="item<pe.god_ot"> -</span>



                    </td>
                  </tr>





                  </tbody>
                </table>

              </div>
                BREAKKK
            </template>
            <div class="WordSection2" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 210mm; width:210mm; border:1px solid #D7D6CF; padding:20mm;">


              <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>

              <h1 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Баланс целевых и прочих показателей программы
              </h1>
              <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>


            </div>
            BREAKKK

            <div class="WordSection1" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 297mm; width:297mm; border:1px solid #D7D6CF; padding:20mm;">

              <table
                  :style="'width:255mm;border-collapse:collapse;border:1px solid #000000;font-family: Times New Roman; color:#000000; font-size:'+fontsizecpp()+'pt;line-height:1rem'"
                  border="1"

                  cellspacing="0">
                <thead>
                <tr>
                  <th align="center" valign="center"  width="200" style="min-width:200px;max-width:200px" rowspan="2">
                    Показатели / Периоды
                  </th>

                  <th align="center" valign="center"  width="80" style="min-width:80px;max-width:80px"  rowspan="2">
                    Ед. изм.
                  </th>

                  <th v-if="!pe.hide_industry_benchmarks" align="center" valign="center" width="80" style="min-width:80px;max-width:80px"  rowspan="2">
                    Средние показатели по отрасли
                  </th>
                  <th v-if="!pe.hide_industry_benchmarks" align="center" valign="center" width="80" style="min-width:80px;max-width:80px" rowspan="2">
                    Лучшие мировые показатели по отрасли
                  </th>
                  <th v-for="item in yearspe" :key="item" align="center" valign="center" width="80"  style="min-width:80px;max-width:80px">
                    <span>{{item}}</span>
                  </th>
                </tr>
                <tr>



                  <th v-for="item in yearspe" :key="item" width="80" align="center" valign="center"  style="min-width:80px;max-width:80px; line-height: 1rem">

      <span>

        {{item==pe.fact_god?'Факт':''}}
        {{(item==pe.fact_god) && (pe.fact_god==(pe.god_ot-1))?' / ':''}}
        {{item==(pe.god_ot-1)?'Базовый год':''}}
        {{ (item>=pe.god_ot)?' ПЭ ':''}}
      </span>
                  </th>
                </tr>
                </thead>
                <tbody>

                <tr>
                  <td align="left" valign="center"  style="text-indent:3px;background: #E9FFCF" :colspan="yearspe.length+(pe.hide_industry_benchmarks ? 2 : 4)">
                    <b>Базовые (начальные) значения показателей (без учёта программы энергосбережения)</b>
                  </td>
                </tr>


                <tr v-for="cp in pe.celev" :key="cp">
                  <td align="left" valign="center"  width="200" style="min-width:200px;max-width:200px;text-indent:3px" >
                    <span class="green--text">{{cp.kind}}: </span>
                    <span >{{ cp.name }}</span>
                  </td>
                  <td align="center" valign="center">
                    {{ cp.ed }}
                  </td>
                  <td v-if="!pe.hide_industry_benchmarks" align="center" valign="center" >

                    {{decimal(cp.sred_otrasl,cp.decimal)}}


                  </td>
                  <td v-if="!pe.hide_industry_benchmarks" align="center" valign="center">
                    {{decimal(cp.best_mir,cp.decimal)}}

                  </td>
                  <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">

                    {{decimal(cp.base[index],cp.decimal)}}


                  </td>


                </tr>





                <tr>
                  <td calign="left" valign="center"  style="text-indent:3px; background: #E9FFCF" :colspan="yearspe.length+(pe.hide_industry_benchmarks ? 2 : 4)">
                    <b>Изменение показателей по Программе энергосбережения (план)</b>
                  </td>


                </tr>
                <tr v-for="cp in pe.celev" :key="cp">
                  <td align="left" valign="center"  style="text-indent:3px" >
                    <span class="green--text">{{cp.kind}}: </span>
                    <span >{{ cp.name }}</span>
                  </td>
                  <td align="center" valign="center">
                    {{ cp.ed }}
                  </td>
                  <td v-if="!pe.hide_industry_benchmarks" class="text-left">
                  </td>
                  <td v-if="!pe.hide_industry_benchmarks" class="text-left">
                  </td>
                  <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">
                    {{decimal(cp.effect_plan[index],cp.decimal)}}
                  </td>
                </tr>
                <tr>
                  <td align="left" valign="center"  style="text-indent:3px;background: #E9FFCF" :colspan="yearspe.length+(pe.hide_industry_benchmarks ? 2 : 4)">
                    <b>Изменение показателей по Программе энергосбережения (факт)</b>
                  </td>
                  <tr v-for="cp in pe.celev" :key="cp">
                    <td align="left" valign="center"  style="text-indent:3px" >
                      <span class="green--text">{{cp.kind}}: </span>
                      <span >{{ cp.name }}</span>
                    </td>
                    <td align="center" valign="center">
                      {{ cp.ed }}
                    </td>
                     <td v-if="!pe.hide_industry_benchmarks">
                    </td>
                     <td v-if="!pe.hide_industry_benchmarks">
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">
                      {{decimal(cp.effect_fact[index],cp.decimal)}}
                    </td>



                  </tr>

                  <tr>
                    <td align="left" valign="center"  style="text-indent:3px;background: #E9FFCF" :colspan="yearspe.length+(pe.hide_industry_benchmarks ? 2 : 4)">
                      <b>Результирующие показатели (план)</b>
                    </td>

                  </tr>

                  <tr v-for="cp in pe.celev" :key="cp">
                    <td align="left" valign="center"  style="text-indent:3px"  >
                      <span class="green--text">{{cp.kind}}: </span>
                      <span >{{ cp.name }}</span>
                    </td>
                    <td align="center" valign="center">
                      {{ cp.ed }}
                    </td>
                    <td v-if="!pe.hide_industry_benchmarks" align="center" valign="center">
                      {{ cp.sred_otrasl }}
                    </td>
                    <td v-if="!pe.hide_industry_benchmarks" align="center" valign="center">
                      {{ cp.best_mir }}
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center" >

                      {{decimal(cp.value_plan[index],cp.decimal)}}


                    </td>
                  </tr>
                  <tr v-for="topl in pe.ter" :key="topl">
                    <td  align="left" valign="center"  style="text-indent:3px"  >
                      <span class="green--text">Прочие: </span>
                      <span >Экономия ТЭР: {{ topl.name }}</span>
                    </td>
                    <td align="center" valign="center">
                      {{ topl.ed }}<br/>
                      тыс.руб.
                    </td>
                    <td v-if="!pe.hide_industry_benchmarks">

                    </td>
                    <td v-if="!pe.hide_industry_benchmarks">

                    </td>
                    <td v-for="(item,index) in yearspe" :key="item"  align="center" valign="center" >

                      <span >{{ decimal((topl.economy_volume_plan[index]),2) }}</span>
                      <br/>
                      <span>{{ decimal((topl.economy_rub_plan[index]),2) }}</span>


                    </td>
                  </tr>




                  <tr>
                    <td align="left" valign="center"  style="text-indent:3px;background: #E9FFCF" :colspan="yearspe.length+(pe.hide_industry_benchmarks ? 2 : 4)">
                      <b>Результирующие  показатели (факт)</b>
                    </td>

                  </tr>

                  <tr v-for="cp in pe.celev" :key="cp">
                    <td align="left" valign="center"  style="text-indent:3px"  >
                      <span class="green--text">{{cp.kind}}: </span>
                      <span >{{ cp.name }}</span>
                    </td>
                    <td align="center" valign="center">
                      {{ cp.ed }}
                    </td>
                    <td v-if="!pe.hide_industry_benchmarks" align="center" valign="center">
                      {{ cp.sred_otrasl }}
                    </td>
                    <td v-if="!pe.hide_industry_benchmarks" align="center" valign="center">
                      {{ cp.best_mir }}
                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center">

                      {{decimal(cp.value_fact[index],cp.decimal)}}


                    </td>
                  </tr>

                  <tr v-for="topl in pe.ter" :key="topl">
                    <td  align="left" valign="center"  style="text-indent:3px"   >
                      <span class="green--text">Прочие: </span>
                      <span >Экономия ТЭР: {{ topl.name }}</span>
                    </td>
                    <td align="center" valign="center">
                      {{ topl.ed }}<br/>
                      тыс.руб.
                    </td>
                    <td v-if="!pe.hide_industry_benchmarks">

                    </td>
                    <td v-if="!pe.hide_industry_benchmarks">

                    </td>
                    <td v-for="(item,index) in yearspe" :key="item" align="center" valign="center" >

                      <span >{{decimal(topl.economy_volume_fact[index]) }}</span>
                      <br/>
                      <span>{{ decimal(topl.economy_rub_fact[index],2) }}</span>


                    </td>
                  </tr>






                </tbody>
              </table>

              <p style="text-align: justify">
                <br/>
                Пояснение:<br/>
                В таблице представлены, как первичные показатели, так и производные от них величины. Первичные показатели могут изменяться мероприятиями напрямую (например, величина потерь, расход воды, НУР топлива), они вычисляются на основе базовых (начальных) значений (состояния показателя до ПЭ) и эффекта энергосбережения по программе, суммарный результат отражается в  разделе «результирующие показатели». Производные показатели  вычисляются  на основе результирующих значений других  первичных показателей (например, «процент потерь» вычисляется отношением потерь к отпуску), соответственно в разделах «базовые значения» и «изменение показателей по ПЭ» для производных показателей отражаются нулевые величины, так как эти разделы в вычислении результирующего значения не участвуют.



              </p>
            </div>
            BREAKKK



              <div class="WordSection2" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 210mm; width:210mm; border:1px solid #D7D6CF; padding:20mm;">
<a name="smeti"></a>

                <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>

                <h1 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Сметы, дефектные ведомости, калькуляции, прайс-листы, конъюнктурные справки
                </h1>
                <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>


              </div>
              BREAKKK

            <template v-for="(item) in pe.pril.sm">


              <h2 style="display: inline-block"
                   v-if="item.type=='label'"
                   :key="item">
               {{item.name}}
              </h2>
              <p v-if="item.type=='file'"  :key="item">
                <img  style="display: inline-block"   :src="makefilelink(item)"
                      width="582" height="823" alt="" /></p>
              <p v-if="item.type=='file'"  :key="item">BREAKKK</p>

              <div class="WordSection1" v-if="item.type=='text'"  width="582" style="font-size: 8pt"  :key="item">
                <div v-html="item.text"></div>
                BREAKKK
              </div>


            </template>

            BREAKKK
            <div class="WordSection2" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 210mm; width:210mm; border:1px solid #D7D6CF; padding:20mm;">
<a name="otchetipe"></a>

              <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>

              <h1 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Отчёты по энергосбережению
              </h1>
              <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>


            </div>
            BREAKKK
            <template v-for="(item) in pe.pril.report">


              <h2 style="display: inline-block"
                  v-if="item.type=='label'"
                  :key="item">
                {{item.name}}
              </h2>
              <p v-if="item.type=='file'"  :key="item">
                <img  style="display: inline-block"   :src="makefilelink(item)"
                      width="582" height="823" alt="" /></p>
              <p v-if="item.type=='file'"  :key="item">BREAKKK</p>

              <div class="WordSection1" v-if="item.type=='text'"  width="582" style="font-size: 8pt"  :key="item">
                <div v-html="item.text"></div>
                BREAKKK
              </div>


            </template>

            BREAKKK



            <div v-if="pe.pril.another.length>0" class="WordSection2" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 210mm; width:210mm; border:1px solid #D7D6CF; padding:20mm;">
            <a name="prochieprilozheniya"></a>

              <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>

              <h1 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Прочие приложения
              </h1>
              <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>


            </div>
            BREAKKK

            <template  v-for="(item) in pe.pril.another">


              <h2 style="display: inline-block"
                  v-if="item.type=='label'"
                  :key="item">
                {{item.name}}
              </h2>
              <p v-if="item.type=='file'"  :key="item">
                <img  style="display: inline-block"   :src="makefilelink(item)"
                      width="582" height="823" alt="" /></p>
              <p v-if="item.type=='file'"  :key="item">BREAKKK</p>

              <div class="WordSection1" v-if="item.type=='text'"  width="582" style="font-size: 8pt"  :key="item">
                <div v-html="item.text"></div>
                BREAKKK
              </div>


            </template>














          </div>

        </v-card-text>
      </v-card>
    </v-tab-item>
    <v-tab-item >
      <v-app-bar


          floating
          light
          dense
          style="background:url('/fon-3.png');background: #ffffff; width:100%"
          elevation="0"

      >
        <v-card-title>
          <table>
            <tr>
              <td style="width:90vw">
                <v-icon class="mr-0" style="margin-top:-2px">
                  mdi-poll
                </v-icon>
                Отчёт к программе энергосбережения







                <span class="white--text">{{tut}}</span>
              </td>

              <td style="width:10vw; min-width:250px">

                <table>
                  <tr>
                    <td style="min-width:260px;">
                      Год отчёта:


                  <v-autocomplete rounded
                  @click="showwordreport=false;"
                  @mouseup="showwordreport=false;"
                  style="margin-bottom:-25px; margin-left:10px; max-width:130px; display:inline-block; margin-top:5px; "
                    v-model.number="pe.god_otcheta"
                    outlined
                    :items="new Array(pe.god_do-pe.god_ot+1).fill(null).map((_, i) => i +(pe.god_ot))"



                    :rules="[v => (/^[0-9]*$/.test(v) & v>(pe.god_ot-1)& v<(pe.god_do+1)) || 'Неверный ввод']"


                    dense

                  ></v-autocomplete></td>

                    <td>
                      <v-btn

                        rounded
                        :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
                        small
                        style="box-shadow: #2DA820 1px 1px 2px; text-shadow:  #ffffff 0px 0px 3px;;
                        background-image: radial-gradient( circle 100px at 1.1% 15.3%,  rgba(212,171,255,0.82) 50%, rgba(0,246,153,0.52) 100% );
                        ;border-radius:20px; text-shadow: #001c5c 1px 1px 2px;margin-left: 10px; margin:15px; display:inline-block; "

                      @click="pe.god_otcheta>pe.fact_god?planfact():'';" color="success">
                      <v-icon class="mr-1" color="white">
                      mdi-creation-outline
                    </v-icon>Факт по целевым=План до {{pe.god_otcheta}} года
                    </v-btn>
                  </td>
                    <td>
                    <v-btn

                        rounded
                        :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
                        small
                        style="box-shadow: #2DA820 1px 1px 2px; text-shadow:  #ffffff 0px 0px 3px;;
                        background-image: radial-gradient( circle 100px at 1.1% 15.3%,  rgba(212,171,255,0.82) 50%, rgba(0,246,153,0.52) 100% );
                        ;border-radius:20px; text-shadow: #001c5c 1px 1px 2px;margin-left: 10px; margin:15px; display:inline-block; "

                      @click="showwordreport=false;vvodfactter=true;" color="success">
                      <v-icon class="mr-1" color="white">
                      mdi-fire
                    </v-icon>факт по ТЭР
                    </v-btn>


                  </td>
                    <td><v-btn
                    v-if="!showwordreport"
                        rounded
                        :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
                        small
                        style="box-shadow: #2DA820 1px 1px 2px; text-shadow:  #ffffff 0px 0px 3px;;
                        background-image: radial-gradient( circle 100px at 1.1% 15.3%,  rgba(212,171,255,0.82) 50%, rgba(0,246,153,0.52) 100% );
                        ;border-radius:20px; text-shadow: #001c5c 1px 1px 2px;margin-left: 10px; margin:15px; display:inline-block; "

                      @click="showwordreport=true;" color="success">
                      <v-icon class="mr-1" color="white">
                      mdi-rocket-launch-outline
                      </v-icon>Построить
                    </v-btn>

                    <v-btn
                    v-if="showwordreport"
                        rounded
                        :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
                        small
                        style="box-shadow: #2DA820 1px 1px 2px; text-shadow:  #ffffff 0px 0px 3px;;
                        background-image: radial-gradient( circle 100px at 1.1% 15.3%,  rgba(212,171,255,0.82) 50%, rgba(0,246,153,0.52) 100% );
                        ;border-radius:20px; text-shadow: #001c5c 1px 1px 2px;margin-left: 10px; margin:15px; display:inline-block; "

                      @click="Export2Word('printContainer1','Отчёт.doc');" color="success">
                      <v-icon class="mr-1" color="white">
                      mdi-file-word
                      </v-icon>Скачать отчёт
                    </v-btn>




                  </td>

                  </tr>
                </table>




              </td>
            </tr>
          </table>









        </v-card-title>

      </v-app-bar>

      <v-card elevation="2" class="pb-5   mb-0" style="  border: 1px solid  rgb(194, 194, 194);background:url('/fon-5.png');border-radius:0px; height:81vh; width:89vw; min-width:530px; overflow-y:scroll;
">


        <v-card-text>

          <v-alert v-if="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
                   icon="mdi-arrow-top-left"
                   prominent
                   text
                   type="purple lighten-1"
          >


            Для добавления показателей заполните на вкладке "Наименование":<br/>1) год начала программы,<br/>2) год окончания программы, <br/>3) последний завершённый год (панель "Индексы" на вкладке "Наименование").
          </v-alert>






                <div id="printContainer1" v-if="showwordreport"  >

                  <div class="WordSection2" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 210mm; width:210mm; border:1px solid #D7D6CF; padding:20mm;">

                    <div align="right"><b>УТВЕРЖДАЮ</b></div>
                    <div align="right"><b>{{pe.ruk_dolg}}</b></div>
                    <div align="right"><b>{{pe.org}}</b></div>
                    <div align="right"><b>{{pe.ruk_sokr}}</b></div>
                    <div align="right"> </div>
                    <div align="right">_________________________________</div>
                    <div align="right"> </div>
                    <div align="right"><b>31.01.{{new Date().getFullYear()}}</b></div>
                    <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>

                    <p align="center" style="line-height:1.5em;font-family: 'Times New Roman'; color:#000000; font-size:16pt; text-transform: uppercase "><b>ОТЧЁТ ЗА {{pe.god_otcheta}} ГОД <br/>К ПРОГРАММЕ ЭНЕРГОСБЕРЕЖЕНИЯ И ПОВЫШЕНИЯ ЭНЕРГЕТИЧЕСКОЙ ЭФФЕКТИВНОСТИ<br/>
                      {{ pe.org }} на {{peperiodtext()}}<br/>
                      {{  pe.sphere }}{{pe.priznak?':':''}} {{ pe.priznak }} {{pe.invest?'(к инвестпрограмме)':''}}
                    </b></p>
                    <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>

                    <p align="center" style="line-height:1.5em;font-family: 'Times New Roman'; color:#000000; font-size:12pt;"><b>{{(new Date().getFullYear())}}</b></p>

                  </div>
                  BREAKKK
                  <div class="WordSection2" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 210mm; width:210mm; border:1px solid #D7D6CF; padding:20mm;">

                    <div align="center"><h1>Содержание</h1></div>
                    <br/><br/>
                    <p>
    <span style="mso-field-code: TOC \o &quot;1-3&quot; \h \z \u">11</span>
  </p>
                    <div align="left"><i>ВСТАВЬТЕ ВМЕСТО ЭТОГО ТЕКСТА АВТОСОДЕРЖАНИЕ, ПРОВЕРЬТЕ СЕБЯ</i></div>
                    <div align="left"><i>---------------------------------------------------------------------------------------------------------</i></div>
                    <div align="left"><i>1) Вставьте номера страниц в ворде</i></div>
                    <div align="left"><i>2) Отметьте настройку "Особый колонтитул для первой страницы", чтобы не отображался номер страницы на титульном листе</i></div>
                    <div align="left"><i>3) Вставьте автосодержание</i></div>
                    <div align="left"><i>4) Удалите в автосодержании надпись "Оглавление" сверху</i></div>
                    <div align="left"><i>5) Прочитайте программу, удостоверьтесь, что всё нужное заполнено (просмотрите региональные требования), сметы, дефектные ведомости и отчёты по энергосбереению приложены, обязательные организационные мероприятия по годам добавлены, для сферы передачи электроэнергии - приложен баланс электроэнергии</i></div>
                    <div align="left"><i>6) Сохраните программу, сохраните копию в формате pdf при необходимости, распечатайте программу и заверьте, проверьте наличие подписей руководителей в пояснительной записке, сшейте программу, заверьте подписи печатями</i></div>
                    <div align="left"><i>---------------------------------------------------------------------------------------------------------</i></div>








                  </div>
                  BREAKKK
                  <div class="WordSection2" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 210mm; width:210mm; border:1px solid #D7D6CF; padding:20mm;">



                    <h1 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Пояснительная записка
                    </h1>
                    <br/>

      <p style="text-indent: 42.55pt; line-height: 18pt;text-align:justify">
        <span style="font-size: 12pt;">{{pe.org}} имеет утверждённую программу энергосбережения с наименованием "Программа энергосбережения и повышения энергетической эффективности {{ pe.org }} на {{peperiodtext()}}; {{  pe.sphere }}{{pe.priznak?':':''}}{{ " "+pe.priznak }}{{pe.invest?' (к инвестпрограмме)':''}}".
        <o:p></o:p></span>
    </p>
    <p style="text-indent: 42.55pt; line-height: 18pt;text-align:justify">
        <span style="font-size: 12pt;">Предприятие соблюдает законодательство в сфере энергосбережения и энергоэффективности. Все обязательные организационные мероприятия исполнены в полном объёме, включая меры относительно обеспечения приборного учёта ТЭР, инструктажи и специальные обучения, обеспечение выполнения требуемого % по светодиодному освещению - а также все остальные обязательные мероприятия исполнены в полном объёме и в сроки с соблюдением законодательства.
        <o:p></o:p></span>
    </p>
    <p style="text-indent: 42.55pt; line-height: 18pt;text-align:justify">
        <span style="font-size: 12pt;">Программа в части мероприятий и достигнутой экономии объёмов топливно-энергетических ресурсов исполнена в соответствии с заявленным планом. Указаны величины экономии относительно сверхнормативных значений. Экономии учтённых в тарифе расходов нет.
        <o:p></o:p></span>
    </p>

    <p style="text-indent: 42.55pt; line-height: 18pt;text-align:justify">
        <span style="font-size: 12pt;">Отличия плановых и фактических показателей величин экономии в части приобретения ТЭР в денежном выражении обусловлены тем, что цены на единицу ТЭР по плану и по факту обычно отличаются, что происходит и в данном случае. Следует также учитывать, что разница в совокупных объёмах потребления ТЭР по плану и по факту отличается ввиду изменяющихся сбытовых возможностей в части ведения регулируемой деятельности (производство или передача ресурсов по регулируемым тарифам), что не связано с реализацией программы энергосбережения. Подробная информация о приобретении ТЭР, их структуре, ценах, калорийности по плану и по факту представлена в таблицах ниже.
        <o:p></o:p></span>
    </p>
    <span style="text-indent: 42.55pt; line-height: 18pt;text-align:justify">
        <h3 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem; ">Таблицы. Балансы потребления ТЭР за период программы.
        <o:p></o:p></h3>

        <template v-for="topl in pe.ter">
          <div :key="topl" >
          <h3  align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">{{topl.name}} ({{topl.ed}})
          </h3>
        <table
        :style="'width:160mm;border-collapse:collapse;border:1px solid #000000;font-family: Times New Roman; color:#000000; font-size:7pt;line-height:0.75rem'"
                   border="1"

                   cellspacing="0">
              <thead>
              <tr>
                <th align="center" valign="center" rowspan="2" width="330">
                  Показатели / Периоды
                </th>
                <th v-for="item in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" align="center" valign="center" width="70">
                  <span>{{item}}</span>
                </th>
              </tr>
              <tr>

                <th v-for="item in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" align="center" valign="center">


                  <span>



        {{item==pe.fact_god?'Факт':''}}
        {{(item==pe.fact_god) && (pe.fact_god==(pe.god_ot-1))?' / ':''}}
        {{item==(pe.god_ot-1)?'Справочно':''}}
        {{ (item>=pe.god_ot && !(item>pe.god_do))?'ПЭ':''}}

        </span>
                </th>
              </tr>
              </thead>
              <tbody>

              <tr>
                <td style="text-indent:3px;background: #E9FFCF" :colspan="yearspe.slice(0,1+pe.god_otcheta-pe.fact_god).length+1" align="left" valign="center">
                  <b>Показатели без учёта ПЭ (план)</b>
                </td>

              </tr>



              <tr>
                <td style="text-indent:3px;" align="left" valign="center">
                  Переводной коэфф. из {{topl.ed}} в т.у.т.
                </td>
                <td v-for="(item,index) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" align="center" valign="center">



                  {{decimal(topl.pk_plan[index],4)}}

                </td>
              </tr>


              <tr>
                <td style="text-indent:3px;" align="left" valign="center">
                  Объём ресурса ({{topl.ed}})
                </td>
                <td v-for="(item,index) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" align="center" valign="center">
                  {{decimal(topl.volume_plan_do_mer[index],3)}}



                </td>
              </tr>

              <tr>
                <td style="text-indent:3px;">
                  Объём ресурса (т.у.т.)
                </td>
                <td v-for="(item,index) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" align="center" valign="center">

                  {{decimal(topl.tut_plan_do_mr[index],2)}}


                </td>
              </tr>

              <tr>
                <td style="text-indent:3px;">
                  Затраты на ресурс (тыс. руб.)
                </td>
                <td v-for="(item,index) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" align="center" valign="center">


                  {{decimal(topl.rub_plan_do_mer[index],2)}}








                </td>
              </tr>

              <tr>
                <td style="text-indent:3px;">
                  Индекс роста цены, %
                </td>
                <td v-for="(item,index) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" align="center" valign="center">
                  {{decimal(topl.index[index],2)}}


                </td>
              </tr>

              <tr>
                <td style="text-indent:3px;">
                  Цена ресурса (руб./{{topl.ed}})
                </td>
                <td v-for="(item,index) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" align="center" valign="center">
                  {{decimal(topl.price[index],2)}}


                </td>
              </tr>

              <tr>
                <td style="text-indent:3px; background: #E9FFCF" :colspan="yearspe.slice(0,1+pe.god_otcheta-pe.fact_god).length+1">
                  <b>Показатели с учётом ПЭ (план)</b>
                </td>

              </tr>


              <tr>
                <td style="text-indent:3px;">
                  Объём ресурса с учётом ПЭ ({{topl.ed}})
                </td>
                <td  v-for="(item,index) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" align="center" valign="center">

                 <span v-if="item>=pe.god_ot"> {{decimal(topl.volume_plan_posle_mer[index],3)}}</span>
                 <span v-if="item<pe.god_ot"> -</span>

                </td>
              </tr>
              <tr>
                <td style="text-indent:3px;">
                  Объём ресурса с учётом ПЭ (т.у.т.)
                </td>
                <td v-for="(item,index) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" align="center" valign="center">
                  <span v-if="item>=pe.god_ot">{{decimal(topl.tut_plan_posle_mer[index],2)}}</span>
                  <span v-if="item<pe.god_ot"> -</span>


                </td>
              </tr>
              <tr>
                <td style="text-indent:3px;">
                  Затраты на ресурс с учётом ПЭ (тыс. руб.)
                </td>
                <td v-for="(item,index) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" align="center" valign="center">

                  <span v-if="item>=pe.god_ot">{{decimal(topl.rub_plan_posle_mer[index],2)}}</span>
                  <span v-if="item<pe.god_ot"> -</span>


                </td>
              </tr>

              <tr>
                <td style="text-indent:3px;">
                  Плановая экономия ресурса ({{topl.ed}})
                </td>
                <td v-for="(item,index) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" align="center" valign="center">
                  <span v-if="item>=pe.god_ot">{{decimal(topl.economy_volume_plan[index],2)}}</span>
                  <span v-if="item<pe.god_ot"> -</span>


                </td>
              </tr>


              <tr>
                <td style="text-indent:3px;">
                  Плановая экономия ресурса (т.у.т.)
                </td>
                <td v-for="(item,index) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" align="center" valign="center">
                  <span v-if="item>=pe.god_ot">{{decimal(topl.economy_tut_plan[index],2)}}</span>
                  <span v-if="item<pe.god_ot"> -</span>


                </td>
              </tr>
              <tr>
                <td style="text-indent:3px;">
                  Плановая экономия затрат на ресурс (тыс. руб.)
                </td>
                <td v-for="(item,index) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" align="center" valign="center">

                  <span v-if="item>=pe.god_ot">{{decimal(topl.economy_rub_plan[index],2)}}</span>
                  <span v-if="item<pe.god_ot"> -</span>


                </td>
              </tr>




              <tr>
                <td style="text-indent:3px;background: #E9FFCF" :colspan="yearspe.slice(0,1+pe.god_otcheta-pe.fact_god).length+1">
                  <b>Фактические показатели отчёта к ПЭ (заполняется после окончания каждого года периода ПЭ)</b>
                </td>

              </tr>

              <tr>
                <td style="text-indent:3px;">
                  Фактический пер. коэфф. из {{topl.ed}} в т.у.т.
                </td>
                <td v-for="(item,index) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" align="center" valign="center">

                  <span v-if="item>=pe.god_ot">{{decimal(topl.pk_fact[index],4)}}</span>
                  <span v-if="item<pe.god_ot"> -</span>



                </td>
              </tr>

              <tr>
                <td style="text-indent:3px;">
                  Фактический объём ресурса ({{topl.ed}})
                </td>
                <td v-for="(item,index) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" align="center" valign="center">

                  <span v-if="item>=pe.god_ot">{{decimal(topl.volume_fact[index],3)}}</span>
                  <span v-if="item<pe.god_ot"> -</span>



                </td>
              </tr>


              <tr>
                <td style="text-indent:3px;">
                  Фактический объём ресурса (т.у.т.)
                </td>
                <td v-for="(item,index) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" align="center" valign="center">

                  <span v-if="item>=pe.god_ot">{{decimal(topl.tut_fact[index],2)}}</span>
                  <span v-if="item<pe.god_ot"> -</span>



                </td>
              </tr>
              <tr>
                <td style="text-indent:3px;">
                  Фактические затраты на ресурс (тыс. руб.)
                </td>
                <td v-for="(item,index) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" align="center" valign="center">

                  <span v-if="item>=pe.god_ot">{{decimal(topl.rub_fact[index],2)}}</span>
                  <span v-if="item<pe.god_ot"> -</span>



                </td>
              </tr>


              <tr>
                <td style="text-indent:3px;">
                  Фактическая цена ресурса (руб./{{topl.ed}})
                </td>
                <td v-for="(item,index) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" align="center" valign="center">
                  <span v-if="item>=pe.god_ot">{{decimal(topl.price_fact[index],2)}}</span>
                  <span v-if="item<pe.god_ot"> -</span>


                </td>
              </tr>







              <tr>
                <td style="text-indent:3px;">
                  Фактическая экономия ресурса ({{topl.ed}})
                </td>
                <td v-for="(item,index) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" align="center" valign="center">
                  <span v-if="item>=pe.god_ot">{{decimal(topl.economy_volume_fact[index],2)}}</span>
                  <span v-if="item<pe.god_ot"> -</span>


                </td>
              </tr>


              <tr>
                <td style="text-indent:3px;">
                  Фактическая экономия ресурса (т.у.т.)
                </td>
                <td v-for="(item,index) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" align="center" valign="center">
                  <span v-if="item>=pe.god_ot">{{decimal(topl.economy_tut_fact[index],2)}}</span>
                  <span v-if="item<pe.god_ot"> -</span>


                </td>
              </tr>
              <tr>
                <td style="text-indent:3px;">
                  Фактическая экономия затрат на ресурс (тыс. руб.)
                </td>
                <td v-for="(item,index) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" align="center" valign="center">
                  <span v-if="item>=pe.god_ot">{{decimal(topl.economy_rub_fact[index],2)}}</span>
                  <span v-if="item<pe.god_ot"> -</span>



                </td>
              </tr>





              </tbody>
            </table>

          </div>

        </template>


    </span>

    <p style="text-indent: 42.55pt; line-height: 18pt;text-align:justify">
        <span style="font-size: 12pt;">Учитывая дату сдачи отчета, следует пояснить, что в соответствии с Федеральным законом от 06.12.2011 N 402-ФЗ бухгалтерская отчетность за год сдаётся до 1 апреля, соответственно, регистры учёта до наступления указанной даты могут быть неактуальны, в связи с этим годовые показатели за год, представленные в данном отчете, впоследствии могут подлежать изменению.
        <o:p></o:p></span>
    </p>
    <br/>
      <br/>
        <br/>
    <table>

      <tr >
        <td><b>{{pe.ruk_dolg}}</b></td><td> __________________________________ </td><td><b>{{pe.ruk_sokr}}</b></td>
      </tr>


    </table>


                  </div>
                  {{pe.fed?'BREAKKK':''}}
                  <div v-if="pe.fed" class="WordSection2" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 210mm; width:210mm; border:1px solid #D7D6CF; padding:20mm;">


                    <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>

                    <h1 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Формы отчётов к программе энергосбережения согласно федеральному законодательству
                    </h1>
                    <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>


                  </div>

                  {{pe.fed?'BREAKKK':''}}
                  <div v-if="pe.fed" class="WordSection1" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 297mm; width:297mm; border:1px solid #D7D6CF; padding:20mm;">


                    <a name="passport"></a>
                    <div align="right"><b>{{pe.ruk_dolg}}</b></div>
                    <div align="right"><b>{{pe.ruk_sokr}}</b></div>
                    <div align="right"> </div>
                    <div align="right">_________________________________</div>
                    <div align="right"> </div>
                    <div align="right"><b>31.01.{{new Date().getFullYear()}}</b></div>

                    <h2  align="center" style="margin-bottom: 5px; font-size:14pt;">Cводная форма мониторинга реализации программы энергосбережения<br/>и повышения энергетической эффективности
 <br/>{{pe.org}}<br/>за {{pe.god_otcheta}} год</h2>

                    <table
                        style="width:255mm; border-collapse: collapse; border:1px solid #000000; font-family: 'Times New Roman'; color:#000000; font-size:9pt;"
                        border="1"
                        cellspacing="0" >
                      <thead>
                      <tr >
                        <td colspan="4" valign="center" >Наименование программы
                        </td>
                        <td colspan="9" align="left" valign="top"  >Программа энергосбережения и повышения энергетической эффективности {{ pe.org }} на {{peperiodtext()}}; {{  pe.sphere }}{{pe.priznak?':':''}} {{ pe.priznak }} {{pe.invest?'(к инвестпрограмме)':''}}
                        </td>
                      </tr>
                      <tr   >
                        <td colspan="4" valign="center" >Почтовый адрес</td>
                        <td colspan="9" valign="center" >{{ pe.pocht_address }}</td>
                      </tr>
                      <tr    >
                        <td colspan="4" valign="center" >Ответственный за формирование
                          программы (Ф.И.О., контактный телефон, e-mail)
                        </td>
                        <td colspan="9" valign="center" >
                          <template v-for="pers in pe.otv">
                            <div style="display: block; line-height:10pt" :key="pers">{{pers.otv_fio}}, {{pers.otv_dolg!==''?pers.otv_dolg+', ':''}}{{pers.phone}}, {{pers.email}};</div>

                          </template>

                        </td>
                      </tr>
                      <tr >
                        <td colspan="4" valign="center" >Даты начала и окончания
                          действия программы
                        </td>
                        <td colspan="9" valign="center"  >01.01.{{pe.god_ot}} - 31.12.{{pe.god_do}}</td>
                      </tr>

                      <tr >
                        <td rowspan="5" align="center" width="10%" valign="center" >Период
                        </td>
                        <td rowspan="5" align="center" width="10%" valign="center" >
                        </td>
                        <td colspan="2" rowspan="2" align="center" valign="center" >Затраты
                          на реализацию программы, млн. руб. без НДС
                        </td>
                        <td rowspan="5" align="center" valign="center" >Доля затрат в
                          инвестиционной программе, направленная на реализацию мероприятий программы энергосбережения и повышения
                          энергетической эффективности
                        </td>
                        <td colspan="8" align="center" valign="center" >Топливно-энергетические
                          ресурсы (ТЭР)
                        </td>
                      </tr>
                      <tr >
                        <td colspan="4" rowspan="2" align="center" valign="center" >При
                          осуществлении регулируемого вида деятельности
                        </td>
                        <td colspan="4" rowspan="2" align="center" valign="center" >При
                          осуществлении прочей деятельности, в т.ч. хозяйственные нужды
                        </td>
                      </tr>
                      <tr >
                        <td rowspan="3" align="center" width="7%" valign="center" >всего
                        </td>
                        <td rowspan="3" align="center" width="9%" valign="center" >в
                          т.ч. капитальные
                        </td>
                      </tr>
                      <tr >
                        <td colspan="2" align="center" valign="center" >Суммарные
                          затраты ТЭР
                        </td>
                        <td colspan="2" align="center" valign="center" >Экономия ТЭР в
                          результате реализации программы
                        </td>
                        <td colspan="2" align="center" valign="center" >Суммарные
                          затраты ТЭР
                        </td>
                        <td colspan="2" align="center" valign="center" >Экономия ТЭР в
                          результате реализации программы
                        </td>
                      </tr>
                      <tr >
                        <td align="center" width="6%" valign="center" >т у.т. без учета
                          воды
                        </td>
                        <td align="center" width="7%" valign="center" >млн. руб. без НДС
                          с учетом воды
                        </td>
                        <td align="center" width="6%" valign="center" >т у.т. без учета
                          воды
                        </td>
                        <td align="center" width="8%" valign="center" >млн. руб. без НДС
                          с учетом воды
                        </td>
                        <td align="center" width="6%" valign="center" >т у.т. без учета
                          воды
                        </td>
                        <td align="center" width="8%" valign="center" >млн. руб. без НДС
                          с учетом воды
                        </td>
                        <td align="center" width="7%" valign="center" >т у.т. без учета
                          воды
                        </td>
                        <td align="center" width="8%" valign="center" >млн. руб. без НДС
                          с учетом воды
                        </td>
                      </tr>
                      </thead>
                      <tbody>



                        <tr>
                          <td rowspan="3" width="10%" valign="top" align="center"  >
                            за отчетный год</td>
                          <td  width="10%" valign="top" align="center"  >
                          план</td>
                          <td width="7%" valign="center" align="center" >{{decimal(pe.zatrati_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000000,7)}}</td>
                          <td width="9%" valign="center" align="center" >{{decimal(pe.zatrati_total_capital[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000000,7)}}</td>
                          <td valign="center" align="center" >{{decimal(pe.dolya_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]*100,2)}}%</td>
                          <td width="6%" valign="center" align="center" >  {{decimal(pe.zatrati_ter_tut_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                          <td width="7%" valign="center" align="center" > {{decimal(pe.zatrati_ter_rub_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,7)}}</td>
                          <td width="6%" valign="center" align="center" >{{decimal(pe.economy_ter_tut_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                          <td width="8%" valign="center" align="center" >{{decimal(pe.economy_ter_rub_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,7)}}</td>
                          <td width="6%" valign="center" align="center" >-</td>
                          <td width="8%" valign="center" align="center" >-</td>
                          <td width="7%" valign="center" align="center" >-</td>
                          <td width="8%" valign="center" align="center" >-</td>
                        </tr>
                        <tr>
                          <td  width="10%" valign="top" align="center"  >
                          факт</td>
                          <td width="7%" valign="center" align="center" >{{decimal(pe.zatrati_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000000,7)}}</td>
                          <td width="9%" valign="center" align="center" >{{decimal(pe.zatrati_total_capital_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000000,7)}}</td>
                          <td valign="center" align="center" >{{decimal(pe.dolya_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]*100,2)}}%</td>
                          <td width="6%" valign="center" align="center" >  {{decimal(pe.zatrati_ter_tut_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                          <td width="7%" valign="center" align="center" > {{decimal(pe.zatrati_ter_rub_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,7)}}</td>
                          <td width="6%" valign="center" align="center" >{{decimal(pe.economy_ter_tut_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                          <td width="8%" valign="center" align="center" >{{decimal(pe.economy_ter_rub_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,7)}}</td>
                          <td width="6%" valign="center" align="center" >-</td>
                          <td width="8%" valign="center" align="center" >-</td>
                          <td width="7%" valign="center" align="center" >-</td>
                          <td width="8%" valign="center" align="center" >-</td>
                        </tr>
                        <tr>
                        <td width="10%" valign="top" align="center"  >
                        отклонение</td>
                        <td width="7%" valign="center" align="center" >{{decimal(-pe.zatrati_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000000+pe.zatrati_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000000,7)}}</td>
                        <td width="9%" valign="center" align="center" >{{decimal(-pe.zatrati_total_capital[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000000+pe.zatrati_total_capital_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000000,7)}}</td>
                        <td valign="center" align="center" >0,00%</td>
                        <td width="6%" valign="center" align="center" >  {{decimal(-pe.zatrati_ter_tut_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]+pe.zatrati_ter_tut_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                        <td width="7%" valign="center" align="center" > {{decimal(-pe.zatrati_ter_rub_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000 + pe.zatrati_ter_rub_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,7)}}</td>
                        <td width="6%" valign="center" align="center" >{{decimal(-pe.economy_ter_tut_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)] + pe.economy_ter_tut_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                        <td width="8%" valign="center" align="center" >{{decimal(-pe.economy_ter_rub_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000 + pe.economy_ter_rub_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,7)}}</td>
                        <td width="6%" valign="center" align="center" >-</td>
                        <td width="8%" valign="center" align="center" >-</td>
                        <td width="7%" valign="center" align="center" >-</td>
                        <td width="8%" valign="center" align="center" >-</td>
                      </tr>




                      <tr>
                        <td rowspan="3" width="10%" valign="top" align="center"  >
                          нарастающим итогом</td>
                        <td  width="10%" valign="top" align="center"  >
                        план</td>
                        <td width="7%" valign="center" align="center" >{{decimal(pe.zatrati_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000000,7)}}</td>
                        <td width="9%" valign="center" align="center" >{{decimal(pe.zatrati_total_capital[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000000,7)}}</td>
                        <td valign="center" align="center" >{{decimal(pe.dolya_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]*100,2)}}%</td>
                        <td width="6%" valign="center" align="center" >  {{decimal(pe.zatrati_ter_tut_total_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                        <td width="7%" valign="center" align="center" > {{decimal(pe.zatrati_ter_rub_total_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,7)}}</td>
                        <td width="6%" valign="center" align="center" >{{decimal(pe.economy_ter_tut_total_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                        <td width="8%" valign="center" align="center" >{{decimal(pe.economy_ter_rub_total_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,7)}}</td>
                        <td width="6%" valign="center" align="center" >-</td>
                        <td width="8%" valign="center" align="center" >-</td>
                        <td width="7%" valign="center" align="center" >-</td>
                        <td width="8%" valign="center" align="center" >-</td>
                      </tr>
                      <tr>
                        <td  width="10%" valign="top" align="center"  >
                        факт</td>
                        <td width="7%" valign="center" align="center" >{{decimal(pe.zatrati_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000000,7)}}</td>
                        <td width="9%" valign="center" align="center" >{{decimal(pe.zatrati_total_capital_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000000,7)}}</td>
                        <td valign="center" align="center" >{{decimal(pe.dolya_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]*100,2)}}%</td>
                        <td width="6%" valign="center" align="center" >  {{decimal(pe.zatrati_ter_tut_total_fact_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                        <td width="7%" valign="center" align="center" > {{decimal(pe.zatrati_ter_rub_total_fact_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,7)}}</td>
                        <td width="6%" valign="center" align="center" >{{decimal(pe.economy_ter_tut_total_fact_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                        <td width="8%" valign="center" align="center" >{{decimal(pe.economy_ter_rub_total_fact_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,7)}}</td>
                        <td width="6%" valign="center" align="center" >-</td>
                        <td width="8%" valign="center" align="center" >-</td>
                        <td width="7%" valign="center" align="center" >-</td>
                        <td width="8%" valign="center" align="center" >-</td>
                      </tr>
                      <tr>
                      <td width="10%" valign="top" align="center"  >
                      отклонение</td>
                      <td width="7%" valign="center" align="center" >{{decimal(-pe.zatrati_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000000+pe.zatrati_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000000,7)}}</td>
                      <td width="9%" valign="center" align="center" >{{decimal(-pe.zatrati_total_capital[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000000-pe.zatrati_total_capital_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000000,7)}}</td>
                      <td valign="center" align="center" >0,00%</td>
                      <td width="6%" valign="center" align="center" >  {{decimal(-pe.zatrati_ter_tut_total_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]+pe.zatrati_ter_tut_total_fact_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                      <td width="7%" valign="center" align="center" > {{decimal(-pe.zatrati_ter_rub_total_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000+pe.zatrati_ter_rub_total_fact_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,7)}}</td>
                      <td width="6%" valign="center" align="center" >{{decimal(-pe.economy_ter_tut_total_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]+pe.economy_ter_tut_total_fact_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                      <td width="8%" valign="center" align="center" >{{decimal(-pe.economy_ter_rub_total_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000+pe.economy_ter_rub_total_fact_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,7)}}</td>
                      <td width="6%" valign="center" align="center" >-</td>
                      <td width="8%" valign="center" align="center" >-</td>
                      <td width="7%" valign="center" align="center" >-</td>
                      <td width="8%" valign="center" align="center" >-</td>
                    </tr>






                      </tbody>
                    </table>
                    <div class="">
                      <p style="font-size:7pt; margin: 0px; margin-left:10px; line-height:1;mso-line-height:1; ">Программа в части мероприятий и достигнутой экономии в объёмах ресурсов исполнена в соответствии с планом. Отклонение факта от плана в денежном выражении касательно экономии обусловлено изменением цен на единицу ТЭР.<br/>
                        Указаны величины экономии относительно сверхнормативных значений. Экономии учтённых в тарифе расходов нет.<br/>
                        Учитывая дату сдачи отчета, следует пояснить, что в соответствии с Федеральным законом от 06.12.2011 N 402-ФЗ бухгалтерская отчетность за год сдаётся до 1 апреля, соответственно, регистры учёта до наступления указанной даты могут быть неактуальны, в связи с этим годовые показатели за год, представленные в данном отчете, впоследствии могут подлежать изменению.</p>
                          <br/>
                          <br/>
                    </div>
                    <p v-if="pe.sogl.length>0" align="left">СОГЛАСОВАНО	 	на обороте документа:</p>
                    <table v-if="pe.sogl.length>0">

                      <tr v-for="item in pe.sogl" :key="item">
                        <td><b>{{item.sogl_dolg}}</b></td><td> __________________________________ </td><td><b>{{item.sogl_sokr}}</b></td>
                      </tr>


                    </table>





                  </div>

                  {{pe.fed?'BREAKKK':''}}
                  <div v-if="pe.fed" class="WordSection1" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 297mm; width:297mm; border:1px solid #D7D6CF; padding:20mm;">
                  <a name="celevie"></a>
                    <h2 align="center">Отчет о достижении целевых и прочих показателей программы энергосбережения и повышения энергетической эффективности</h2>
                    <br/>

                    <table
                        style="width:255mm; border-collapse: collapse; border:1px solid #000000; font-family: 'Times New Roman'; color:#000000; font-size:9pt;"
                        border="1"
                        cellspacing="0" >
                      <thead>
                      <tr>
                        <td align="center" rowspan="2" width="44" valign="center">
                          N п/п
                        </td>
                        <td align="center" rowspan="2" width="280" style="max-width:280px; min-width:280px;"  valign="center">
                          Целевые и прочие показатели
                        </td>
                        <td  align="center" rowspan="2" width="85" valign="center" >
                          Ед. изм.
                        </td>
                        <td v-if="!pe.hide_industry_benchmarks" align="center" rowspan="2" width="100" valign="center" >
                          Средние показатели по отрасли
                        </td>
                        <td v-if="!pe.hide_industry_benchmarks" align="center" rowspan="2" width="100" valign="center" >
                          Лучшие мировые показатели по отрасли
                        </td>
                        <td v-for="item in yearspe.slice(0,pe.god_ot-pe.fact_god)" :key="item" align="center" rowspan="2" width="80"  valign="center"
                        >
                          {{ item }} год -

                          {{item==pe.fact_god?'Факт':''}}
                          {{(item==pe.fact_god) && (pe.fact_god==(pe.god_ot-1))?' / ':''}}
                          {{item==(pe.god_ot-1)?'Базовый год':''}}
                          {{ (item>=pe.god_ot && !(item>pe.god_do))?'ПЭ':''}}
                        </td>
                        <td align="center" :colspan="pe.god_otcheta-pe.god_ot+1" valign="center" style="border-bottom:1px solid black;border-right:1px solid black;border-top:1px solid black;">
                          Плановые значения целевых показателей по годам
                        </td>
                        <td align="center" :colspan="pe.god_otcheta-pe.god_ot+1" valign="center" style="border-bottom:1px solid black;border-right:1px solid black;border-top:1px solid black;">
                          Фактические значения целевых и прочих показателей по годам
                        </td>
                        <td align="center" :colspan="pe.god_otcheta-pe.god_ot+1" valign="center" style="border-bottom:1px solid black;border-right:1px solid black;border-top:1px solid black;">
                          Отклонение, ед.
                        </td>
                        <td align="center" :colspan="pe.god_otcheta-pe.god_ot+1" valign="center" style="border-bottom:1px solid black;border-right:1px solid black;border-top:1px solid black;">
                          Отклонение, %
                        </td>
                      </tr>
                      <tr>
                        <td v-for="(item) in yearspe.slice(pe.god_ot-pe.fact_god,pe.god_otcheta-pe.fact_god+1)" :key="item" align="center" width="80" valign="center"
                          >
                          {{item}} г.
                        </td>
                        <td v-for="(item) in yearspe.slice(pe.god_ot-pe.fact_god,pe.god_otcheta-pe.fact_god+1)" :key="item" align="center" width="80" valign="center"
                            >
                          {{item}} г.
                        </td>
                        <td v-for="(item) in yearspe.slice(pe.god_ot-pe.fact_god,pe.god_otcheta-pe.fact_god+1)" :key="item" align="center" width="80" valign="center"
                          >
                          {{item}} г.
                        </td>
                        <td v-for="(item) in yearspe.slice(pe.god_ot-pe.fact_god,pe.god_otcheta-pe.fact_god+1)" :key="item" align="center" width="80" valign="center"
                          >
                          {{item}} г.
                        </td>


                      </tr>

                      <tr>
                        <td v-for="(item,index) in (5+pe.god_ot-pe.fact_god+(pe.god_otcheta-pe.god_ot+1)*4-(pe.hide_industry_benchmarks ? 2 : 0))" :key="item" align="center" valign="center"
                            >
                          {{index+1}}
                        </td>


                      </tr>
                      </thead>
                      <tbody>
                      <tr >
                        <td valign="center" align="center" width="44" style="border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                          1
                        </td>
                        <td  valign="center"  align="left" style="padding-left:3px" :colspan="(5+pe.god_ot-pe.fact_god+(pe.god_otcheta-pe.god_ot+1)*4-1-(pe.hide_industry_benchmarks ? 2 : 0))" >
                          <b>Целевые показатели</b>
                        </td>


                      </tr>
                      <tr v-for="(item,index) in pe.celev.filter(x=>x.kind==='Целевой' && x.showinform)" :key="item">
                        <td valign="center" align="center"  style="border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                          1.{{index+1}}
                        </td>
                        <td valign="center" align="justify" width="280" style="max-width:280px; min-width:280px;padding-left:3px;line-height:0.9rem;" >
                          {{item.name}}
                        </td>
                        <td valign="center" align="center"   >
                          {{item.ed}}
                        </td>
                        <td v-if="!pe.hide_industry_benchmarks" valign="center" align="center"   >
                          {{decimal(item.sred_otrasl,item.decimal)}}
                        </td>
                        <td v-if="!pe.hide_industry_benchmarks" valign="center" align="center"  >
                          {{decimal(item.best_mir,item.decimal)}}
                        </td>



                        <td v-for="(year,indexyear) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" valign="center" align="center" :key="year"
                            >
                        {{decimal(item.value_plan[indexyear],item.decimal)}}
                        </td>
                        <td v-for="(year,indexyear) in yearspe.slice(pe.god_ot-pe.fact_god,1+pe.god_otcheta-pe.fact_god)" valign="center" align="center" :key="year"
                            >
                          {{decimal(item.value_fact[indexyear+pe.god_ot-pe.fact_god],item.decimal)}}
                        </td>
                        <td v-for="(year,indexyear) in yearspe.slice(pe.god_ot-pe.fact_god,1+pe.god_otcheta-pe.fact_god)" valign="center" align="center" :key="year"
                            >
                          {{decimal(item.value_fact[indexyear+pe.god_ot-pe.fact_god]-item.value_plan[indexyear+pe.god_ot-pe.fact_god],item.decimal)}}
                        </td>
                        <td v-for="(year,indexyear) in yearspe.slice(pe.god_ot-pe.fact_god,1+pe.god_otcheta-pe.fact_god)" valign="center" align="center" :key="year"
                            >
                          {{decimal((item.value_fact[indexyear+pe.god_ot-pe.fact_god]-item.value_plan[indexyear+pe.god_ot-pe.fact_god])/item.value_plan[indexyear+pe.god_ot-pe.fact_god]*100,2)}}%
                        </td>
                      </tr>






                      <tr >
                        <td valign="center" align="center" width="44" style="border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                          2
                        </td>
                        <td  valign="center"  align="left" style="padding-left:3px" :colspan="(5+pe.god_ot-pe.fact_god+(pe.god_otcheta-pe.god_ot+1)*4-1-(pe.hide_industry_benchmarks ? 2 : 0))" >
                          <b>Прочие показатели</b>
                        </td>

                      </tr>
                      <tr v-for="(topl,indextopl) in pe.ter" :key="topl">
                        <td valign="center" align="center"  style="border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                          2.{{indextopl+1}}
                        </td>
                        <td  style="text-indent: 0px; padding-left:3px"  >
                          <span >Экономия ТЭР: {{ topl.name }}</span>
                        </td>
                        <td valign="center" align="center">
                          {{ topl.ed }}<br/>
                          тыс.руб.
                        </td>
                        <td v-if="!pe.hide_industry_benchmarks" valign="center" align="center">

                        </td>
                        <td v-if="!pe.hide_industry_benchmarks" valign="center" align="center">

                        </td>
                        <td v-for="(item,index) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" valign="center" align="center"
                          >

                          <span >{{ decimal((topl.economy_volume_plan[index]),2) }}</span>
                          <br/>
                          <span>{{ decimal((topl.economy_rub_plan[index]),2) }}</span>


                        </td>
                        <td v-for="(item,index) in yearspe.slice(pe.god_ot-pe.fact_god,1+pe.god_otcheta-pe.fact_god)" :key="item" valign="center" align="center"
                          >

                          <span >{{ decimal((topl.economy_volume_fact[index+pe.god_ot-pe.fact_god]),2) }}</span>
                          <br/>
                          <span>{{ decimal((topl.economy_rub_fact[index+pe.god_ot-pe.fact_god]),2) }}</span>


                        </td>
                        <td v-for="(item,index) in yearspe.slice(pe.god_ot-pe.fact_god,1+pe.god_otcheta-pe.fact_god)" :key="item" valign="center" align="center"
                          >

                          <span >{{ decimal(topl.economy_volume_fact[index+pe.god_ot-pe.fact_god]-topl.economy_volume_plan[index+pe.god_ot-pe.fact_god],2) }}</span>
                          <br/>
                          <span>{{ decimal(topl.economy_rub_fact[index+pe.god_ot-pe.fact_god]-(topl.economy_rub_plan[index+pe.god_ot-pe.fact_god]),2) }}</span>


                        </td>
                        <td v-for="(item,index) in yearspe.slice(pe.god_ot-pe.fact_god,1+pe.god_otcheta-pe.fact_god)" :key="item" valign="center" align="center"
                          >

                          <span >{{ decimal((topl.economy_volume_fact[index+pe.god_ot-pe.fact_god]-topl.economy_volume_plan[index+pe.god_ot-pe.fact_god])/topl.economy_volume_plan[index+pe.god_ot-pe.fact_god]*100,2) }}%</span>
                          <br/>
                          <span>{{ decimal((topl.economy_rub_fact[index+pe.god_ot-pe.fact_god]-topl.economy_rub_plan[index+pe.god_ot-pe.fact_god])/topl.economy_rub_plan[index+pe.god_ot-pe.fact_god]*100,2) }}%</span>


                        </td>
                      </tr>








                      <tr v-for="(item,index) in pe.celev.filter(x=>x.kind==='Прочий' && x.showinform)" :key="item">
                        <td valign="center" align="center"  style="border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                          2.{{index+1+pe.ter.length}}
                        </td>
                        <td valign="center" align="justify" width="280" style="max-width:280px; min-width:280px;padding-left:3px;line-height:0.9rem;" >
                          {{item.name}}
                        </td>
                        <td valign="center" align="center"   >
                          {{item.ed}}
                        </td>
                        <td v-if="!pe.hide_industry_benchmarks" valign="center" align="center"   >
                          {{decimal(item.sred_otrasl,item.decimal)}}
                        </td>
                        <td v-if="!pe.hide_industry_benchmarks" valign="center" align="center"  >
                          {{decimal(item.best_mir,item.decimal)}}
                        </td>
                        <td v-for="(year,indexyear) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" valign="center" align="center" :key="year"
                              >
                          {{decimal(item.value_plan[indexyear],item.decimal)}}
                        </td>

                        <td v-for="(year,indexyear) in yearspe.slice(pe.god_ot-pe.fact_god,1+pe.god_otcheta-pe.fact_god)" valign="center" align="center" :key="year"
                              >
                          {{decimal(item.value_fact[indexyear+pe.god_ot-pe.fact_god],item.decimal)}}
                        </td>
                        <td v-for="(year,indexyear) in yearspe.slice(pe.god_ot-pe.fact_god,1+pe.god_otcheta-pe.fact_god)" valign="center" align="center" :key="year"
                              >
                          {{decimal(item.value_fact[indexyear+pe.god_ot-pe.fact_god]-item.value_plan[indexyear+pe.god_ot-pe.fact_god],item.decimal)}}
                        </td>
                        <td v-for="(year,indexyear) in yearspe.slice(pe.god_ot-pe.fact_god,1+pe.god_otcheta-pe.fact_god)" valign="center" align="center" :key="year"
                              >
                          {{decimal((item.value_fact[indexyear+pe.god_ot-pe.fact_god]-item.value_plan[indexyear+pe.god_ot-pe.fact_god])/item.value_plan[indexyear+pe.god_ot-pe.fact_god]*100,2)}}%
                        </td>
                      </tr>

                      </tbody></table>
                      <div class="">
                        <p style="font-size:7pt; margin: 0px; margin-left:10px; line-height:1;mso-line-height:1; ">Программа в части мероприятий и достигнутой экономии в объёмах ресурсов исполнена в соответствии с планом. Отклонение факта от плана в денежном выражении касательно экономии обусловлено изменением цен на единицу ТЭР.<br/>
                          Указаны величины экономии относительно сверхнормативных значений. Экономии учтённых в тарифе расходов нет.<br/>
                          Учитывая дату сдачи отчета, следует пояснить, что в соответствии с Федеральным законом от 06.12.2011 N 402-ФЗ бухгалтерская отчетность за год сдаётся до 1 апреля, соответственно, регистры учёта до наступления указанной даты могут быть неактуальны, в связи с этим годовые показатели за год, представленные в данном отчете, впоследствии могут подлежать изменению.</p>
                            <br/>
                            <br/>
                      </div>
                    <table>

                      <tr >
                        <td><b>{{pe.ruk_dolg}}</b></td><td> __________________________________ </td><td><b>{{pe.ruk_sokr}}</b></td>
                      </tr>


                    </table>




                  </div>

                  {{pe.fed?'BREAKKK':''}}
                  <div v-if="pe.fed" class=WordSection5 style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 1190.4pt; width:1190.4pt; border:1px solid #D7D6CF; padding:20mm;">
                    <a name="meropriyatia"></a>
                    <h2 align="center">Отчет о реализации мероприятий, основной целью которых является энергосбережение и (или) повышение энергетической эффективности</h2>
                    <br/>

                    <table   style=" border-collapse: collapse; border:1px solid #000000; font-family: 'Times New Roman'; color:#000000; font-size:7pt; line-height:0.9rem"
                             border="1"
                             cellspacing="0" >
                      <thead>

                      <tr>
                        <td align="center" valign="center"  rowspan="4" width="80" ROT90  class="pov90" >
                          N п/п
                        </td>
                        <td align="center" valign="center"  rowspan="4" width="500"  >
                          Наименование мероприятия
                        </td>
                        <td align="center" valign="center"   colspan="5"    >
                          Объемы выполнения
                        </td>
                        <td align="center" valign="center"   colspan="12"   >
                          Численные значения экономии
                        </td>

                        <td align="center" valign="center"  colspan="4"  >
                          Затраты (план), млн руб. (без НДС)
                        </td>

                      </tr>

                      <tr>

                        <td align="center" valign="center"  rowspan="3" width="30"  style="min-width:15mm; width:15mm;" ROT90 class="pov90">
                          Размерность
                        </td>
                        <td align="center" valign="center"  colspan="2" width="60"  style="min-width:30mm; width:20mm;" >
                          план
                        </td>
                        <td align="center" valign="center" colspan="2" width="60"  style="min-width:30mm; width:20mm;" >
                          факт
                        </td>
                        <td align="center" valign="center"  colspan="6" width="200"  style="min-width:45mm; width:45mm;" >
                          план
                        </td>
                        <td align="center" valign="center"  colspan="6" width="200"  style="min-width:45mm; width:45mm;" >
                          факт
                        </td>
                        <td align="center" valign="center"  colspan="2" width="200"  style="min-width:45mm; width:45mm;" >
                          план
                        </td>
                        <td align="center" valign="center"  colspan="2" width="200"  style="min-width:45mm; width:45mm;" >
                          факт
                        </td>
                      </tr>



                      <tr>
                        <td align="center" valign="center" rowspan="2"   width="60" ROT90  class="pov90" >
                          Всего накопительным итогом за годы реализации программы
                        </td>
                        <td align="center" valign="center" rowspan="2"    width="30" ROT90  class="pov90" >
                          В отчетном году
                        </td>
                        <td align="center" valign="center"   rowspan="2"  width="60" ROT90  class="pov90" >
                          Всего накопительным итогом за годы реализации программы
                        </td>
                        <td align="center" valign="center"  rowspan="2"   width="30" ROT90  class="pov90" >
                          В отчетном году
                        </td>
                        <td align="center" valign="center"  colspan="3"  width="80"    >
                          Всего накопительным итогом за годы реализации программы
                        </td>
                        <td align="center" valign="center"  colspan="3"  width="80"   >
                          В отчетном году
                        </td>
                        <td align="center" valign="center"  colspan="3"  width="80"   >
                          Всего накопительным итогом за годы реализации программы
                        </td>
                        <td align="center" valign="center"  colspan="3"  width="80"    >
                          В отчетном году
                        </td>
                        <td align="center" valign="center"   rowspan="2"  width="80"   >
                          Всего накопительным итогом за годы реализации программы
                        </td>
                        <td align="center" valign="center"  rowspan="2"   width="80"    >
                          В отчетном году
                        </td>
                        <td align="center" valign="center"  rowspan="2"  width="80"   >
                          Всего накопительным итогом за годы реализации программы
                        </td>
                        <td align="center" valign="center"  rowspan="2"   width="80"    >
                          В отчетном году
                        </td>
                      </tr>



                      <tr>




                          <td align="center" valign="center" height="110"  width="120" :name="item" :key="item"  ROT90  class="pov90"  >
                            численное значение экономии в указанной размерности
                          </td>
                          <td align="center" valign="center" height="110"   width="100" :key="item"  ROT90  class="pov90" >
                            численное значение экономии, т у. т.
                          </td>
                          <td align="center" valign="center"  height="110" width="100"  :key="item"  ROT90  class="pov90" >
                            численное значение экономии, млн руб.
                          </td>
                          <td align="center" valign="center" height="110"  width="100" :name="item" :key="item"  ROT90  class="pov90"  >
                            численное значение экономии в указанной размерности
                          </td>
                          <td align="center" valign="center" height="110"  width="100" :key="item"  ROT90  class="pov90" >
                            численное значение экономии, т у. т.
                          </td>
                          <td align="center" valign="center"  height="110" width="100"  :key="item"  ROT90  class="pov90" >
                            численное значение экономии, млн руб.
                          </td>
                          <td align="center" valign="center"  height="110" width="80" :name="item" :key="item"  ROT90  class="pov90"  >
                            численное значение экономии в указанной размерности
                          </td>
                          <td align="center" valign="center" height="110"   width="100" :key="item"  ROT90  class="pov90" >
                            численное значение экономии, т у. т.
                          </td>
                          <td align="center" valign="center"  height="110" width="100"  :key="item"  ROT90  class="pov90" >
                            численное значение экономии, млн руб.
                          </td>
                          <td align="center" valign="center" height="110"  width="100" :name="item" :key="item"  ROT90  class="pov90"  >
                            численное значение экономии в указанной размерности
                          </td>
                          <td align="center" valign="center" height="110"   width="100" :key="item"  ROT90  class="pov90" >
                            численное значение экономии, т у. т.
                          </td>
                          <td align="center" valign="center" height="110"  width="100"  :key="item"  ROT90  class="pov90" >
                            численное значение экономии, млн руб.
                          </td>



                      </tr>

                      <tr>
                        <td align="center" valign="center" v-for="item in (23)"  :key="item">
                          {{item}}
                        </td>

                      </tr>
                      </thead>
                      <tbody>
                      <tr align="center" valign="center" v-for="(merop, index) in pe.mer.filter(mer=>(mer.start_god<pe.god_otcheta+1))" :key="merop">
                        <td   >
                          {{index+1}}
                        </td>
                        <td align="center" valign="center" >
                          {{merop.start_god}} год: {{merop.name}}
                        </td>
                        <td align="center" valign="center" >
                          шт.
                        </td>
                        <td align="center" valign="center"  >
                          1
                        </td>
                        <td align="center" valign="center"   :key="item" >
                          {{pe.god_otcheta==merop.start_god?'1':''}}
                        </td>
                        <td align="center" valign="center"  >
                          1
                        </td>
                        <td align="center" valign="center"   :key="item" >
                          {{pe.god_otcheta==merop.start_god?'1':''}}
                        </td>





                        <td width="100"  >
                   <span style="display: block" v-for="item in merop.ter" :key="item">
                     {{toplmerinfo(item.name)}} - {{ decimal(item.delta_volume_plan.slice(pe.god_ot-pe.fact_god,Math.min(end_effect_god_index(merop)+1,pe.god_otcheta-pe.fact_god+1)).reduce(function (a, b) {
                  return Number(a) + Number(b);
                }),3) }}
                     <br/>
                   </span>
                        </td>

                        <td  >
                          <span style="display: block" v-for="item in merop.ter" :key="item">
                          {{ decimal(item.tut_plan.slice(pe.god_ot-pe.fact_god,Math.min(end_effect_god_index(merop)+1,pe.god_otcheta-pe.fact_god+1)).reduce(function (a, b) {
                         return Number(a) + Number(b);
                       }),3) }}
                            <br/>
                          </span>


                        </td>

                        <td  >
                          <span style="display: block" v-for="item in merop.ter" :key="item">
                          {{ decimal(item.delta_rub_plan.slice(pe.god_ot-pe.fact_god,Math.min(end_effect_god_index(merop)+1,pe.god_otcheta-pe.fact_god+1)).reduce(function (a, b){
                         return Number(a) + Number(b);
                       })/1000000,7) }}
                            <br/>
                          </span>


                        </td>






                        <td width="100"  >



                        <span  v-show="(pe.god_otcheta-pe.fact_god)<=(end_effect_god_index(merop)) && (pe.god_otcheta-pe.fact_god)>=(merop.start_god-pe.fact_god)"
                               v-for="item2 in merop.ter" :key="item2">
                            {{decimal(item2.delta_volume_plan[pe.god_otcheta-pe.fact_god],3)}}<br/>
                        </span>

                        </td>

                        <td  >
                          <span v-show="(pe.god_otcheta-pe.fact_god)<=(end_effect_god_index(merop)) && (pe.god_otcheta-pe.fact_god)>=(merop.start_god-pe.fact_god)"
                             v-for="item2 in merop.ter" :key="item2">
                              {{decimal(item2.tut_plan[pe.god_otcheta-pe.fact_god],3)}}<br/>
                          </span>


                        </td>

                        <td  >
                          <span v-show="(pe.god_otcheta-pe.fact_god)<=(end_effect_god_index(merop)) && (pe.god_otcheta-pe.fact_god)>=(merop.start_god-pe.fact_god)"
                             v-for="item2 in merop.ter" :key="item2">
                              {{decimal(item2.delta_rub_plan[pe.god_otcheta-pe.fact_god]/1000000,7)}}<br/>
                          </span>


                        </td>

















                        <td width="100"  >
                        <span style="display: block" v-for="item in merop.ter" :key="item">
                         {{ decimal(item.delta_volume_fact.slice(pe.god_ot-pe.fact_god,Math.min(end_effect_god_index(merop)+1,pe.god_otcheta-pe.fact_god+1)).reduce(function (a, b) {
                        return Number(a) + Number(b);
                        }),3) }}
                        <br/>
                        </span>
                        </td>

                        <td  >
                          <span style="display: block" v-for="item in merop.ter" :key="item">
                          {{ decimal(item.tut_fact.slice(pe.god_ot-pe.fact_god,Math.min(end_effect_god_index(merop)+1,pe.god_otcheta-pe.fact_god+1)).reduce(function (a, b) {
                         return Number(a) + Number(b);
                        }),3) }}
                            <br/>
                          </span>


                        </td>

                        <td  >
                          <span style="display: block" v-for="item in merop.ter" :key="item">
                          {{ decimal(item.delta_rub_fact.slice(pe.god_ot-pe.fact_god,Math.min(end_effect_god_index(merop)+1,pe.god_otcheta-pe.fact_god+1)).reduce(function (a, b){
                         return Number(a) + Number(b);
                        })/1000000,7) }}
                            <br/>
                          </span>


                        </td>






                        <td width="100"  >



                        <span  v-show="(pe.god_otcheta-pe.fact_god)<=(end_effect_god_index(merop)) && (pe.god_otcheta-pe.fact_god)>=(merop.start_god-pe.fact_god)"
                               v-for="item2 in merop.ter" :key="item2">
                            {{decimal(item2.delta_volume_fact[pe.god_otcheta-pe.fact_god],3)}}<br/>
                        </span>

                        </td>

                        <td  >
                          <span v-show="(pe.god_otcheta-pe.fact_god)<=(end_effect_god_index(merop)) && (pe.god_otcheta-pe.fact_god)>=(merop.start_god-pe.fact_god)"
                             v-for="item2 in merop.ter" :key="item2">
                              {{decimal(item2.tut_fact[pe.god_otcheta-pe.fact_god],3)}}<br/>
                          </span>


                        </td>

                        <td  >
                          <span v-show="(pe.god_otcheta-pe.fact_god)<=(end_effect_god_index(merop)) && (pe.god_otcheta-pe.fact_god)>=(merop.start_god-pe.fact_god)"
                             v-for="item2 in merop.ter" :key="item2">
                              {{decimal(item2.delta_rub_fact[pe.god_otcheta-pe.fact_god]/1000000,7)}}<br/>
                          </span>


                        </td>


                        <td  >
                          {{ decimal(merop.zatrati_plan.slice(pe.god_ot-pe.fact_god,pe.god_otcheta-pe.fact_god+1).reduce(function (a, b) {
                          return Number(a) + Number(b);
                        })/1000000,7) }}
                        </td>


                        <td align="center" valign="center"  width="80" >
                          {{ decimal(merop.zatrati_plan[pe.god_otcheta-pe.fact_god]/1000000,7) }}
                        </td>


                        <td  >
                          {{ decimal(merop.zatrati_fact.slice(pe.god_ot-pe.fact_god,pe.god_otcheta-pe.fact_god+1).reduce(function (a, b) {
                          return Number(a) + Number(b);
                        })/1000000,7) }}
                        </td>


                        <td align="center" valign="center"  width="80" >
                          {{ decimal(merop.zatrati_fact[pe.god_otcheta-pe.fact_god]/1000000,7) }}
                        </td>



                      </tr>





                      </tbody>
                    </table>

                    <div class="">
                      <p style="font-size:7pt; margin: 0px; margin-left:10px; line-height:1;mso-line-height:1; ">Программа в части мероприятий и достигнутой экономии в объёмах ресурсов исполнена в соответствии с планом. Отклонение факта от плана в денежном выражении касательно экономии обусловлено изменением цен на единицу ТЭР.<br/>
                        Указаны величины экономии относительно сверхнормативных значений. Экономии учтённых в тарифе расходов нет.<br/>
                        Учитывая дату сдачи отчета, следует пояснить, что в соответствии с Федеральным законом от 06.12.2011 N 402-ФЗ бухгалтерская отчетность за год сдаётся до 1 апреля, соответственно, регистры учёта до наступления указанной даты могут быть неактуальны, в связи с этим годовые показатели за год, представленные в данном отчете, впоследствии могут подлежать изменению.</p>
                          <br/>
                          <br/>
                    </div>

                    <table>

                      <tr >
                        <td><b>{{pe.ruk_dolg}}</b></td><td> __________________________________ </td><td><b>{{pe.ruk_sokr}}</b></td>
                      </tr>


                    </table>
                  </div>
                  {{pe.reg?'BREAKKK':''}}
                  <div v-if="pe.reg" class="WordSection2" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 210mm; width:210mm; border:1px solid #D7D6CF; padding:20mm;">


                    <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>

                    <h1 align="center" style="font-family: 'Times New Roman'; color:#000000; line-height: 2rem;  ">Формы отчётов к программе энергосбережения согласно региональному законодательству
                    </h1>
                    <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>


                  </div>


                  {{pe.reg?'BREAKKK':''}}
                  <div v-if="pe.reg" class="WordSection1" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 297mm; width:297mm; border:1px solid #D7D6CF; padding:20mm;">


                    <a name="passport"></a>
                    <div align="right"><b>{{pe.ruk_dolg}}</b></div>
                    <div align="right"><b>{{pe.ruk_sokr}}</b></div>
                    <div align="right"> </div>
                    <div align="right">_________________________________</div>
                    <div align="right"> </div>
                    <div align="right"><b>31.01.{{new Date().getFullYear()}}</b></div>

                    <h2  align="center" style="margin-bottom: 5px; font-size:14pt;">Cводная форма мониторинга реализации программы энергосбережения<br/>и повышения энергетической эффективности
 <br/>{{pe.org}}<br/>за {{pe.god_otcheta}} год</h2>
                    <table
                        style="width:255mm; border-collapse: collapse; border:1px solid #000000; font-family: 'Times New Roman'; color:#000000; font-size:9pt;"
                        border="1"
                        cellspacing="0" >
                      <thead>
                      <tr >
                        <td colspan="4" valign="center" >Наименование программы
                        </td>
                        <td colspan="9" align="left" valign="top"  >Программа энергосбережения и повышения энергетической эффективности {{ pe.org }} на {{peperiodtext()}}; {{  pe.sphere }}{{pe.priznak?':':''}} {{ pe.priznak }} {{pe.invest?'(к инвестпрограмме)':''}}
                        </td>
                      </tr>
                      <tr   >
                        <td colspan="4" valign="center" >Почтовый адрес</td>
                        <td colspan="9" valign="center" >{{ pe.pocht_address }}</td>
                      </tr>
                      <tr    >
                        <td colspan="4" valign="center" >Ответственный за формирование
                          программы (Ф.И.О., контактный телефон, e-mail)
                        </td>
                        <td colspan="9" valign="center" >
                          <template v-for="pers in pe.otv">
                            <div style="display: block; line-height:10pt" :key="pers">{{pers.otv_fio}}, {{pers.otv_dolg!==''?pers.otv_dolg+', ':''}}{{pers.phone}}, {{pers.email}};</div>

                          </template>

                        </td>
                      </tr>
                      <tr >
                        <td colspan="4" valign="center" >Даты начала и окончания
                          действия программы
                        </td>
                        <td colspan="9" valign="center"  >01.01.{{pe.god_ot}} - 31.12.{{pe.god_do}}</td>
                      </tr>

                      <tr >
                        <td rowspan="5" align="center" width="10%" valign="center" >Период
                        </td>
                        <td rowspan="5" align="center" width="10%" valign="center" >
                        </td>
                        <td colspan="2" rowspan="2" align="center" valign="center" >Затраты
                          на реализацию программы, тыс. руб. без НДС
                        </td>
                        <td rowspan="5" align="center" valign="center" >Доля затрат в
                          инвестиционной программе, направленная на реализацию мероприятий программы энергосбережения и повышения
                          энергетической эффективности
                        </td>
                        <td colspan="8" align="center" valign="center" >Топливно-энергетические
                          ресурсы (ТЭР)
                        </td>
                      </tr>
                      <tr >
                        <td colspan="4" rowspan="2" align="center" valign="center" >При
                          осуществлении регулируемого вида деятельности
                        </td>
                        <td colspan="4" rowspan="2" align="center" valign="center" >При
                          осуществлении прочей деятельности, в т.ч. хозяйственные нужды
                        </td>
                      </tr>
                      <tr >
                        <td rowspan="3" align="center" width="7%" valign="center" >всего
                        </td>
                        <td rowspan="3" align="center" width="9%" valign="center" >в
                          т.ч. капитальные
                        </td>
                      </tr>
                      <tr >
                        <td colspan="2" align="center" valign="center" >Суммарные
                          затраты ТЭР
                        </td>
                        <td colspan="2" align="center" valign="center" >Экономия ТЭР в
                          результате реализации программы
                        </td>
                        <td colspan="2" align="center" valign="center" >Суммарные
                          затраты ТЭР
                        </td>
                        <td colspan="2" align="center" valign="center" >Экономия ТЭР в
                          результате реализации программы
                        </td>
                      </tr>
                      <tr >
                        <td align="center" width="6%" valign="center" >т у.т. без учета
                          воды
                        </td>
                        <td align="center" width="7%" valign="center" >тыс. руб. без НДС
                          с учетом воды
                        </td>
                        <td align="center" width="6%" valign="center" >т у.т. без учета
                          воды
                        </td>
                        <td align="center" width="8%" valign="center" >тыс. руб. без НДС
                          с учетом воды
                        </td>
                        <td align="center" width="6%" valign="center" >т у.т. без учета
                          воды
                        </td>
                        <td align="center" width="8%" valign="center" >тыс. руб. без НДС
                          с учетом воды
                        </td>
                        <td align="center" width="7%" valign="center" >т у.т. без учета
                          воды
                        </td>
                        <td align="center" width="8%" valign="center" >тыс. руб. без НДС
                          с учетом воды
                        </td>
                      </tr>
                      </thead>
                      <tbody>



                        <tr>
                          <td rowspan="3" width="10%" valign="top" align="center"  >
                            за отчетный год</td>
                          <td  width="10%" valign="top" align="center"  >
                          план</td>
                          <td width="7%" valign="center" align="center" >{{decimal(pe.zatrati_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,4)}}</td>
                          <td width="9%" valign="center" align="center" >{{decimal(pe.zatrati_total_capital[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,4)}}</td>
                          <td valign="center" align="center" >{{decimal(pe.dolya_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]*100,2)}}%</td>
                          <td width="6%" valign="center" align="center" >  {{decimal(pe.zatrati_ter_tut_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                          <td width="7%" valign="center" align="center" > {{decimal(pe.zatrati_ter_rub_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],4)}}</td>
                          <td width="6%" valign="center" align="center" >{{decimal(pe.economy_ter_tut_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                          <td width="8%" valign="center" align="center" >{{decimal(pe.economy_ter_rub_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],4)}}</td>
                          <td width="6%" valign="center" align="center" >-</td>
                          <td width="8%" valign="center" align="center" >-</td>
                          <td width="7%" valign="center" align="center" >-</td>
                          <td width="8%" valign="center" align="center" >-</td>
                        </tr>
                        <tr>
                          <td  width="10%" valign="top" align="center"  >
                          факт</td>
                          <td width="7%" valign="center" align="center" >{{decimal(pe.zatrati_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,4)}}</td>
                          <td width="9%" valign="center" align="center" >{{decimal(pe.zatrati_total_capital_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,4)}}</td>
                          <td valign="center" align="center" >{{decimal(pe.dolya_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]*100,2)}}%</td>
                          <td width="6%" valign="center" align="center" >  {{decimal(pe.zatrati_ter_tut_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                          <td width="7%" valign="center" align="center" > {{decimal(pe.zatrati_ter_rub_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],4)}}</td>
                          <td width="6%" valign="center" align="center" >{{decimal(pe.economy_ter_tut_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                          <td width="8%" valign="center" align="center" >{{decimal(pe.economy_ter_rub_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],4)}}</td>
                          <td width="6%" valign="center" align="center" >-</td>
                          <td width="8%" valign="center" align="center" >-</td>
                          <td width="7%" valign="center" align="center" >-</td>
                          <td width="8%" valign="center" align="center" >-</td>
                        </tr>
                        <tr>
                        <td width="10%" valign="top" align="center"  >
                        отклонение</td>
                        <td width="7%" valign="center" align="center" >{{decimal(-pe.zatrati_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000+pe.zatrati_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,4)}}</td>
                        <td width="9%" valign="center" align="center" >{{decimal(-pe.zatrati_total_capital[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000+pe.zatrati_total_capital_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,4)}}</td>
                        <td valign="center" align="center" >0,00%</td>
                        <td width="6%" valign="center" align="center" >  {{decimal(-pe.zatrati_ter_tut_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]+pe.zatrati_ter_tut_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                        <td width="7%" valign="center" align="center" > {{decimal(-pe.zatrati_ter_rub_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)] + pe.zatrati_ter_rub_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],4)}}</td>
                        <td width="6%" valign="center" align="center" >{{decimal(-pe.economy_ter_tut_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)] + pe.economy_ter_tut_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                        <td width="8%" valign="center" align="center" >{{decimal(-pe.economy_ter_rub_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)] + pe.economy_ter_rub_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],4)}}</td>
                        <td width="6%" valign="center" align="center" >-</td>
                        <td width="8%" valign="center" align="center" >-</td>
                        <td width="7%" valign="center" align="center" >-</td>
                        <td width="8%" valign="center" align="center" >-</td>
                      </tr>




                      <tr>
                        <td rowspan="3" width="10%" valign="top" align="center"  >
                          нарастающим итогом</td>
                        <td  width="10%" valign="top" align="center"  >
                        план</td>
                        <td width="7%" valign="center" align="center" >{{decimal(pe.zatrati_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,4)}}</td>
                        <td width="9%" valign="center" align="center" >{{decimal(pe.zatrati_total_capital[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,4)}}</td>
                        <td valign="center" align="center" >{{decimal(pe.dolya_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]*100,2)}}%</td>
                        <td width="6%" valign="center" align="center" >  {{decimal(pe.zatrati_ter_tut_total_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                        <td width="7%" valign="center" align="center" > {{decimal(pe.zatrati_ter_rub_total_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],4)}}</td>
                        <td width="6%" valign="center" align="center" >{{decimal(pe.economy_ter_tut_total_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                        <td width="8%" valign="center" align="center" >{{decimal(pe.economy_ter_rub_total_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],4)}}</td>
                        <td width="6%" valign="center" align="center" >-</td>
                        <td width="8%" valign="center" align="center" >-</td>
                        <td width="7%" valign="center" align="center" >-</td>
                        <td width="8%" valign="center" align="center" >-</td>
                      </tr>
                      <tr>
                        <td  width="10%" valign="top" align="center"  >
                        факт</td>
                        <td width="7%" valign="center" align="center" >{{decimal(pe.zatrati_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,4)}}</td>
                        <td width="9%" valign="center" align="center" >{{decimal(pe.zatrati_total_capital_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,4)}}</td>
                        <td valign="center" align="center" >{{decimal(pe.dolya_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]*100,2)}}%</td>
                        <td width="6%" valign="center" align="center" >  {{decimal(pe.zatrati_ter_tut_total_fact_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                        <td width="7%" valign="center" align="center" > {{decimal(pe.zatrati_ter_rub_total_fact_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],4)}}</td>
                        <td width="6%" valign="center" align="center" >{{decimal(pe.economy_ter_tut_total_fact_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                        <td width="8%" valign="center" align="center" >{{decimal(pe.economy_ter_rub_total_fact_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],4)}}</td>
                        <td width="6%" valign="center" align="center" >-</td>
                        <td width="8%" valign="center" align="center" >-</td>
                        <td width="7%" valign="center" align="center" >-</td>
                        <td width="8%" valign="center" align="center" >-</td>
                      </tr>
                      <tr>
                      <td width="10%" valign="top" align="center"  >
                      отклонение</td>
                      <td width="7%" valign="center" align="center" >{{decimal(-pe.zatrati_total[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000+pe.zatrati_total_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,4)}}</td>
                      <td width="9%" valign="center" align="center" >{{decimal(-pe.zatrati_total_capital[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000-pe.zatrati_total_capital_fact[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]/1000,4)}}</td>
                      <td valign="center" align="center" >0,00%</td>
                      <td width="6%" valign="center" align="center" >  {{decimal(-pe.zatrati_ter_tut_total_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]+pe.zatrati_ter_tut_total_fact_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                      <td width="7%" valign="center" align="center" > {{decimal(-pe.zatrati_ter_rub_total_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]+pe.zatrati_ter_rub_total_fact_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],4)}}</td>
                      <td width="6%" valign="center" align="center" >{{decimal(-pe.economy_ter_tut_total_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]+pe.economy_ter_tut_total_fact_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],2)}}</td>
                      <td width="8%" valign="center" align="center" >{{decimal(-pe.economy_ter_rub_total_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)]+pe.economy_ter_rub_total_fact_naritog[pe.god_otcheta-pe.god_ot+(pe.god_ot-pe.fact_god)],4)}}</td>
                      <td width="6%" valign="center" align="center" >-</td>
                      <td width="8%" valign="center" align="center" >-</td>
                      <td width="7%" valign="center" align="center" >-</td>
                      <td width="8%" valign="center" align="center" >-</td>
                    </tr>






                      </tbody>
                    </table>
                    <div class="">
                      <p style="font-size:7pt; margin: 0px; margin-left:10px; line-height:1;mso-line-height:1; ">Программа в части мероприятий и достигнутой экономии в объёмах ресурсов исполнена в соответствии с планом. Отклонение факта от плана в денежном выражении касательно экономии обусловлено изменением цен на единицу ТЭР.<br/>
                        Указаны величины экономии относительно сверхнормативных значений. Экономии учтённых в тарифе расходов нет.<br/>
                        Учитывая дату сдачи отчета, следует пояснить, что в соответствии с Федеральным законом от 06.12.2011 N 402-ФЗ бухгалтерская отчетность за год сдаётся до 1 апреля, соответственно, регистры учёта до наступления указанной даты могут быть неактуальны, в связи с этим годовые показатели за год, представленные в данном отчете, впоследствии могут подлежать изменению.</p>
                          <br/>
                          <br/>
                    </div>
                    <p v-if="pe.sogl.length>0" align="left">СОГЛАСОВАНО	 	на обороте документа:</p>
                    <table v-if="pe.sogl.length>0">

                      <tr v-for="item in pe.sogl" :key="item">
                        <td><b>{{item.sogl_dolg}}</b></td><td> __________________________________ </td><td><b>{{item.sogl_sokr}}</b></td>
                      </tr>


                    </table>





                  </div>

                  {{pe.reg?'BREAKKK':''}}
                  <div v-if="pe.reg" class="WordSection1" style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 297mm; width:297mm; border:1px solid #D7D6CF; padding:20mm;">
                  <a name="celevie"></a>
                    <h2 align="center">Отчет о достижении целевых и прочих показателей программы энергосбережения и повышения энергетической эффективности</h2>
                    <br/>

                    <table
                        style="width:255mm; border-collapse: collapse; border:1px solid #000000; font-family: 'Times New Roman'; color:#000000; font-size:9pt;"
                        border="1"
                        cellspacing="0" >
                      <thead>
                      <tr>
                        <td align="center" rowspan="2" width="44" valign="center">
                          N п/п
                        </td>
                        <td align="center" rowspan="2" width="280" style="max-width:280px; min-width:280px;"  valign="center">
                          Целевые и прочие показатели
                        </td>
                        <td  align="center" rowspan="2" width="85" valign="center" >
                          Ед. изм.
                        </td>

                        <td v-for="item in yearspe.slice(0,pe.god_ot-pe.fact_god)" :key="item" align="center" rowspan="2" width="80"  valign="center"
                        >

                          {{ item }} год -

                          {{item==pe.fact_god?'Базовый год':''}}
                          {{(item==pe.fact_god) && (pe.fact_god==(pe.god_ot-1))?' / ':''}}
                          {{item==(pe.god_ot-1)?'Справочно':''}}
                          {{ (item>=pe.god_ot && !(item>pe.god_do))?'ПЭ':''}}
                        </td>
                        <td align="center" :colspan="pe.god_otcheta-pe.god_ot+1" valign="center" style="border-bottom:1px solid black;border-right:1px solid black;border-top:1px solid black;">
                          Плановые значения целевых показателей по годам
                        </td>
                        <td align="center" :colspan="pe.god_otcheta-pe.god_ot+1" valign="center" style="border-bottom:1px solid black;border-right:1px solid black;border-top:1px solid black;">
                          Фактические значения целевых и прочих показателей по годам
                        </td>
                        <td align="center" :colspan="pe.god_otcheta-pe.god_ot+1" valign="center" style="border-bottom:1px solid black;border-right:1px solid black;border-top:1px solid black;">
                          Отклонение, ед.
                        </td>
                        <td align="center" :colspan="pe.god_otcheta-pe.god_ot+1" valign="center" style="border-bottom:1px solid black;border-right:1px solid black;border-top:1px solid black;">
                          Отклонение, %
                        </td>
                      </tr>
                      <tr>
                        <td v-for="(item) in yearspe.slice(pe.god_ot-pe.fact_god,pe.god_otcheta-pe.fact_god+1)" :key="item" align="center" width="80" valign="center"
                          >
                          {{item}} г.
                        </td>
                        <td v-for="(item) in yearspe.slice(pe.god_ot-pe.fact_god,pe.god_otcheta-pe.fact_god+1)" :key="item" align="center" width="80" valign="center"
                            >
                          {{item}} г.
                        </td>
                        <td v-for="(item) in yearspe.slice(pe.god_ot-pe.fact_god,pe.god_otcheta-pe.fact_god+1)" :key="item" align="center" width="80" valign="center"
                          >
                          {{item}} г.
                        </td>
                        <td v-for="(item) in yearspe.slice(pe.god_ot-pe.fact_god,pe.god_otcheta-pe.fact_god+1)" :key="item" align="center" width="80" valign="center"
                          >
                          {{item}} г.
                        </td>


                      </tr>

                      <tr>


                        <td v-for="(item,index) in (3+pe.god_ot-pe.fact_god+(pe.god_otcheta-pe.god_ot+1)*4)" :key="item" align="center" valign="center"
                            >
                          {{index+1}}
                        </td>


                      </tr>
                      </thead>
                      <tbody>
                      <tr >
                        <td valign="center" align="center" width="44" style="border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                          1
                        </td>
                        <td  valign="center"  align="left" style="padding-left:3px" :colspan="(3+pe.god_ot-pe.fact_god+(pe.god_otcheta-pe.god_ot+1)*4-1)" >
                          <b>Целевые показатели</b>
                        </td>


                      </tr>
                      <tr v-for="(item,index) in pe.celev.filter(x=>x.kind==='Целевой' && x.showinform)" :key="item">
                        <td valign="center" align="center"  style="border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                          1.{{index+1}}
                        </td>
                        <td valign="center" align="justify" width="280" style="max-width:280px; min-width:280px;padding-left:3px;line-height:0.9rem;" >
                          {{item.name}}
                        </td>
                        <td valign="center" align="center"   >
                          {{item.ed}}
                        </td>




                        <td v-for="(year,indexyear) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" valign="center" align="center" :key="year"
                            >
                        {{decimal(item.value_plan[indexyear],item.decimal)}}
                        </td>
                        <td v-for="(year,indexyear) in yearspe.slice(pe.god_ot-pe.fact_god,1+pe.god_otcheta-pe.fact_god)" valign="center" align="center" :key="year"
                            >
                          {{decimal(item.value_fact[indexyear+pe.god_ot-pe.fact_god],item.decimal)}}
                        </td>
                        <td v-for="(year,indexyear) in yearspe.slice(pe.god_ot-pe.fact_god,1+pe.god_otcheta-pe.fact_god)" valign="center" align="center" :key="year"
                            >
                          {{decimal(item.value_fact[indexyear+pe.god_ot-pe.fact_god]-item.value_plan[indexyear+pe.god_ot-pe.fact_god],item.decimal)}}
                        </td>
                        <td v-for="(year,indexyear) in yearspe.slice(pe.god_ot-pe.fact_god,1+pe.god_otcheta-pe.fact_god)" valign="center" align="center" :key="year"
                            >
                          {{decimal((item.value_fact[indexyear+pe.god_ot-pe.fact_god]-item.value_plan[indexyear+pe.god_ot-pe.fact_god])/item.value_plan[indexyear+pe.god_ot-pe.fact_god]*100,2)}}%
                        </td>
                      </tr>






                      <tr >
                        <td valign="center" align="center" width="44" style="border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                          2
                        </td>
                        <td  valign="center"  align="left" style="padding-left:3px" :colspan="(3+pe.god_ot-pe.fact_god+(pe.god_otcheta-pe.god_ot+1)*4-1)" >
                          <b>Прочие показатели</b>
                        </td>

                      </tr>
                      <tr v-for="(topl,indextopl) in pe.ter" :key="topl">
                        <td valign="center" align="center"  style="border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                          2.{{indextopl+1}}
                        </td>
                        <td  style="text-indent: 0px; padding-left:3px"  >
                          <span >Экономия ТЭР: {{ topl.name }}</span>
                        </td>
                        <td valign="center" align="center">
                          {{ topl.ed }}<br/>
                          тыс.руб.
                        </td>

                        <td v-for="(item,index) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" :key="item" valign="center" align="center"
                          >

                          <span >{{ decimal((topl.economy_volume_plan[index]),2) }}</span>
                          <br/>
                          <span>{{ decimal((topl.economy_rub_plan[index]),2) }}</span>


                        </td>
                        <td v-for="(item,index) in yearspe.slice(pe.god_ot-pe.fact_god,1+pe.god_otcheta-pe.fact_god)" :key="item" valign="center" align="center"
                          >

                          <span >{{ decimal((topl.economy_volume_fact[index+pe.god_ot-pe.fact_god]),2) }}</span>
                          <br/>
                          <span>{{ decimal((topl.economy_rub_fact[index+pe.god_ot-pe.fact_god]),2) }}</span>


                        </td>
                        <td v-for="(item,index) in yearspe.slice(pe.god_ot-pe.fact_god,1+pe.god_otcheta-pe.fact_god)" :key="item" valign="center" align="center"
                          >

                          <span >{{ decimal(topl.economy_volume_fact[index+pe.god_ot-pe.fact_god]-topl.economy_volume_plan[index+pe.god_ot-pe.fact_god],2) }}</span>
                          <br/>
                          <span>{{ decimal(topl.economy_rub_fact[index+pe.god_ot-pe.fact_god]-(topl.economy_rub_plan[index+pe.god_ot-pe.fact_god]),2) }}</span>


                        </td>
                        <td v-for="(item,index) in yearspe.slice(pe.god_ot-pe.fact_god,1+pe.god_otcheta-pe.fact_god)" :key="item" valign="center" align="center"
                          >

                          <span >{{ decimal((topl.economy_volume_fact[index+pe.god_ot-pe.fact_god]-topl.economy_volume_plan[index+pe.god_ot-pe.fact_god])/topl.economy_volume_plan[index+pe.god_ot-pe.fact_god]*100,2) }}%</span>
                          <br/>
                          <span>{{ decimal((topl.economy_rub_fact[index+pe.god_ot-pe.fact_god]-topl.economy_rub_plan[index+pe.god_ot-pe.fact_god])/topl.economy_rub_plan[index+pe.god_ot-pe.fact_god]*100,2) }}%</span>


                        </td>
                      </tr>








                      <tr v-for="(item,index) in pe.celev.filter(x=>x.kind==='Прочий' && x.showinform)" :key="item">
                        <td valign="center" align="center"  style="border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                          2.{{index+1+pe.ter.length}}
                        </td>
                        <td valign="center" align="justify" width="280" style="max-width:280px; min-width:280px;padding-left:3px;line-height:0.9rem;" >
                          {{item.name}}
                        </td>
                        <td valign="center" align="center"   >
                          {{item.ed}}
                        </td>

                        <td v-for="(year,indexyear) in yearspe.slice(0,1+pe.god_otcheta-pe.fact_god)" valign="center" align="center" :key="year"
                              >
                          {{decimal(item.value_plan[indexyear],item.decimal)}}
                        </td>

                        <td v-for="(year,indexyear) in yearspe.slice(pe.god_ot-pe.fact_god,1+pe.god_otcheta-pe.fact_god)" valign="center" align="center" :key="year"
                              >
                          {{decimal(item.value_fact[indexyear+pe.god_ot-pe.fact_god],item.decimal)}}
                        </td>
                        <td v-for="(year,indexyear) in yearspe.slice(pe.god_ot-pe.fact_god,1+pe.god_otcheta-pe.fact_god)" valign="center" align="center" :key="year"
                              >
                          {{decimal(item.value_fact[indexyear+pe.god_ot-pe.fact_god]-item.value_plan[indexyear+pe.god_ot-pe.fact_god],item.decimal)}}
                        </td>
                        <td v-for="(year,indexyear) in yearspe.slice(pe.god_ot-pe.fact_god,1+pe.god_otcheta-pe.fact_god)" valign="center" align="center" :key="year"
                              >
                          {{decimal((item.value_fact[indexyear+pe.god_ot-pe.fact_god]-item.value_plan[indexyear+pe.god_ot-pe.fact_god])/item.value_plan[indexyear+pe.god_ot-pe.fact_god]*100,2)}}%
                        </td>
                      </tr>

                      </tbody></table>
                      <div class="">
                        <p style="font-size:7pt; margin: 0px; margin-left:10px; line-height:1;mso-line-height:1; ">Программа в части мероприятий и достигнутой экономии в объёмах ресурсов исполнена в соответствии с планом. Отклонение факта от плана в денежном выражении касательно экономии обусловлено изменением цен на единицу ТЭР.<br/>
                          Указаны величины экономии относительно сверхнормативных значений. Экономии учтённых в тарифе расходов нет.<br/>
                          Учитывая дату сдачи отчета, следует пояснить, что в соответствии с Федеральным законом от 06.12.2011 N 402-ФЗ бухгалтерская отчетность за год сдаётся до 1 апреля, соответственно, регистры учёта до наступления указанной даты могут быть неактуальны, в связи с этим годовые показатели за год, представленные в данном отчете, впоследствии могут подлежать изменению.</p>
                            <br/>
                            <br/>
                      </div>
                    <table>

                      <tr >
                        <td><b>{{pe.ruk_dolg}}</b></td><td> __________________________________ </td><td><b>{{pe.ruk_sokr}}</b></td>
                      </tr>


                    </table>




                  </div>

                  {{pe.reg?'BREAKKK':''}}
                  <div v-if="pe.reg" class=WordSection5 style="font-family: 'Times New Roman'; color:#000000; font-size:12pt; line-height:1.2em; max-width: 1190.4pt; width:1190.4pt; border:1px solid #D7D6CF; padding:20mm;">
                    <a name="meropriyatia"></a>
                    <h2 align="center">Отчет о реализации мероприятий, основной целью которых является энергосбережение и (или) повышение энергетической эффективности</h2>
                    <br/>

                    <table   style=" border-collapse: collapse; border:1px solid #000000; font-family: 'Times New Roman'; color:#000000; font-size:7pt; line-height:0.9rem"
                             border="1"
                             cellspacing="0" >
                      <thead>

                      <tr>
                        <td align="center" valign="center"  rowspan="4" width="80" ROT90  class="pov90" >
                          N п/п
                        </td>
                        <td align="center" valign="center"  rowspan="4" width="500"  >
                          Наименование мероприятия
                        </td>
                        <td align="center" valign="center"   colspan="5"    >
                          Объемы выполнения
                        </td>
                        <td align="center" valign="center"   colspan="12"   >
                          Численные значения экономии
                        </td>

                        <td align="center" valign="center"  colspan="4"  >
                          Затраты (план), тыс. руб. (без НДС)
                        </td>

                      </tr>

                      <tr>

                        <td align="center" valign="center"  rowspan="3" width="30"  style="min-width:15mm; width:15mm;" ROT90 class="pov90">
                          Размерность
                        </td>
                        <td align="center" valign="center"  colspan="2" width="60"  style="min-width:30mm; width:20mm;" >
                          план
                        </td>
                        <td align="center" valign="center" colspan="2" width="60"  style="min-width:30mm; width:20mm;" >
                          факт
                        </td>
                        <td align="center" valign="center"  colspan="6" width="200"  style="min-width:45mm; width:45mm;" >
                          план
                        </td>
                        <td align="center" valign="center"  colspan="6" width="200"  style="min-width:45mm; width:45mm;" >
                          факт
                        </td>
                        <td align="center" valign="center"  colspan="2" width="200"  style="min-width:45mm; width:45mm;" >
                          план
                        </td>
                        <td align="center" valign="center"  colspan="2" width="200"  style="min-width:45mm; width:45mm;" >
                          факт
                        </td>
                      </tr>



                      <tr>
                        <td align="center" valign="center" rowspan="2"   width="60" ROT90  class="pov90" >
                          Всего накопительным итогом за годы реализации программы
                        </td>
                        <td align="center" valign="center" rowspan="2"    width="30" ROT90  class="pov90" >
                          В отчетном году
                        </td>
                        <td align="center" valign="center"   rowspan="2"  width="60" ROT90  class="pov90" >
                          Всего накопительным итогом за годы реализации программы
                        </td>
                        <td align="center" valign="center"  rowspan="2"   width="30" ROT90  class="pov90" >
                          В отчетном году
                        </td>
                        <td align="center" valign="center"  colspan="3"  width="80"    >
                          Всего накопительным итогом за годы реализации программы
                        </td>
                        <td align="center" valign="center"  colspan="3"  width="80"   >
                          В отчетном году
                        </td>
                        <td align="center" valign="center"  colspan="3"  width="80"   >
                          Всего накопительным итогом за годы реализации программы
                        </td>
                        <td align="center" valign="center"  colspan="3"  width="80"    >
                          В отчетном году
                        </td>
                        <td align="center" valign="center"   rowspan="2"  width="80"   >
                          Всего накопительным итогом за годы реализации программы
                        </td>
                        <td align="center" valign="center"  rowspan="2"   width="80"    >
                          В отчетном году
                        </td>
                        <td align="center" valign="center"  rowspan="2"  width="80"   >
                          Всего накопительным итогом за годы реализации программы
                        </td>
                        <td align="center" valign="center"  rowspan="2"   width="80"    >
                          В отчетном году
                        </td>
                      </tr>



                      <tr>




                          <td align="center" valign="center" height="110"  width="120" :name="item" :key="item"  ROT90  class="pov90"  >
                            численное значение экономии в указанной размерности
                          </td>
                          <td align="center" valign="center" height="110"   width="100" :key="item"  ROT90  class="pov90" >
                            численное значение экономии, т у. т.
                          </td>
                          <td align="center" valign="center"  height="110" width="100"  :key="item"  ROT90  class="pov90" >
                            численное значение экономии, тыс. руб.
                          </td>
                          <td align="center" valign="center" height="110"  width="100" :name="item" :key="item"  ROT90  class="pov90"  >
                            численное значение экономии в указанной размерности
                          </td>
                          <td align="center" valign="center" height="110"  width="100" :key="item"  ROT90  class="pov90" >
                            численное значение экономии, т у. т.
                          </td>
                          <td align="center" valign="center"  height="110" width="100"  :key="item"  ROT90  class="pov90" >
                            численное значение экономии, тыс. руб.
                          </td>
                          <td align="center" valign="center"  height="110" width="80" :name="item" :key="item"  ROT90  class="pov90"  >
                            численное значение экономии в указанной размерности
                          </td>
                          <td align="center" valign="center" height="110"   width="100" :key="item"  ROT90  class="pov90" >
                            численное значение экономии, т у. т.
                          </td>
                          <td align="center" valign="center"  height="110" width="100"  :key="item"  ROT90  class="pov90" >
                            численное значение экономии, тыс. руб.
                          </td>
                          <td align="center" valign="center" height="110"  width="100" :name="item" :key="item"  ROT90  class="pov90"  >
                            численное значение экономии в указанной размерности
                          </td>
                          <td align="center" valign="center" height="110"   width="100" :key="item"  ROT90  class="pov90" >
                            численное значение экономии, т у. т.
                          </td>
                          <td align="center" valign="center" height="110"  width="100"  :key="item"  ROT90  class="pov90" >
                            численное значение экономии, тыс. руб.
                          </td>



                      </tr>

                      <tr>
                        <td align="center" valign="center" v-for="item in (23)"  :key="item">
                          {{item}}
                        </td>

                      </tr>
                      </thead>
                      <tbody>
                      <tr align="center" valign="center" v-for="(merop, index) in pe.mer.filter(mer=>(mer.start_god<pe.god_otcheta+1))" :key="merop">
                        <td   >
                          {{index+1}}
                        </td>
                        <td align="center" valign="center" >
                          {{merop.start_god}} год: {{merop.name}}
                        </td>
                        <td align="center" valign="center" >
                          шт.
                        </td>
                        <td align="center" valign="center"  >
                          1
                        </td>
                        <td align="center" valign="center"   :key="item" >
                          {{pe.god_otcheta==merop.start_god?'1':''}}
                        </td>
                        <td align="center" valign="center"  >
                          1
                        </td>
                        <td align="center" valign="center"   :key="item" >
                          {{pe.god_otcheta==merop.start_god?'1':''}}
                        </td>





                        <td width="100"  >
                   <span style="display: block" v-for="item in merop.ter" :key="item">
                     {{toplmerinfo(item.name)}} - {{ decimal(item.delta_volume_plan.slice(pe.god_ot-pe.fact_god,Math.min(end_effect_god_index(merop)+1,pe.god_otcheta-pe.fact_god+1)).reduce(function (a, b) {
                  return Number(a) + Number(b);
                }),3) }}
                     <br/>
                   </span>
                        </td>

                        <td  >
                          <span style="display: block" v-for="item in merop.ter" :key="item">
                          {{ decimal(item.tut_plan.slice(pe.god_ot-pe.fact_god,Math.min(end_effect_god_index(merop)+1,pe.god_otcheta-pe.fact_god+1)).reduce(function (a, b) {
                         return Number(a) + Number(b);
                       }),3) }}
                            <br/>
                          </span>


                        </td>

                        <td  >
                          <span style="display: block" v-for="item in merop.ter" :key="item">
                          {{ decimal(item.delta_rub_plan.slice(pe.god_ot-pe.fact_god,Math.min(end_effect_god_index(merop)+1,pe.god_otcheta-pe.fact_god+1)).reduce(function (a, b){
                         return Number(a) + Number(b);
                       })/1000,4) }}
                            <br/>
                          </span>


                        </td>






                        <td width="100"  >



                        <span  v-show="(pe.god_otcheta-pe.fact_god)<=(end_effect_god_index(merop)) && (pe.god_otcheta-pe.fact_god)>=(merop.start_god-pe.fact_god)"
                               v-for="item2 in merop.ter" :key="item2">
                            {{decimal(item2.delta_volume_plan[pe.god_otcheta-pe.fact_god],3)}}<br/>
                        </span>

                        </td>

                        <td  >
                          <span v-show="(pe.god_otcheta-pe.fact_god)<=(end_effect_god_index(merop)) && (pe.god_otcheta-pe.fact_god)>=(merop.start_god-pe.fact_god)"
                             v-for="item2 in merop.ter" :key="item2">
                              {{decimal(item2.tut_plan[pe.god_otcheta-pe.fact_god],3)}}<br/>
                          </span>


                        </td>

                        <td  >
                          <span v-show="(pe.god_otcheta-pe.fact_god)<=(end_effect_god_index(merop)) && (pe.god_otcheta-pe.fact_god)>=(merop.start_god-pe.fact_god)"
                             v-for="item2 in merop.ter" :key="item2">
                              {{decimal(item2.delta_rub_plan[pe.god_otcheta-pe.fact_god]/1000,4)}}<br/>
                          </span>


                        </td>

















                        <td width="100"  >
                        <span style="display: block" v-for="item in merop.ter" :key="item">
                         {{ decimal(item.delta_volume_fact.slice(pe.god_ot-pe.fact_god,Math.min(end_effect_god_index(merop)+1,pe.god_otcheta-pe.fact_god+1)).reduce(function (a, b) {
                        return Number(a) + Number(b);
                        }),3) }}
                        <br/>
                        </span>
                        </td>

                        <td  >
                          <span style="display: block" v-for="item in merop.ter" :key="item">
                          {{ decimal(item.tut_fact.slice(pe.god_ot-pe.fact_god,Math.min(end_effect_god_index(merop)+1,pe.god_otcheta-pe.fact_god+1)).reduce(function (a, b) {
                         return Number(a) + Number(b);
                        }),3) }}
                            <br/>
                          </span>


                        </td>

                        <td  >
                          <span style="display: block" v-for="item in merop.ter" :key="item">
                          {{ decimal(item.delta_rub_fact.slice(pe.god_ot-pe.fact_god,Math.min(end_effect_god_index(merop)+1,pe.god_otcheta-pe.fact_god+1)).reduce(function (a, b){
                         return Number(a) + Number(b);
                       })/1000,4) }}
                            <br/>
                          </span>


                        </td>






                        <td width="100"  >



                        <span  v-show="(pe.god_otcheta-pe.fact_god)<=(end_effect_god_index(merop)) && (pe.god_otcheta-pe.fact_god)>=(merop.start_god-pe.fact_god)"
                               v-for="item2 in merop.ter" :key="item2">
                            {{decimal(item2.delta_volume_fact[pe.god_otcheta-pe.fact_god],3)}}<br/>
                        </span>

                        </td>

                        <td  >
                          <span v-show="(pe.god_otcheta-pe.fact_god)<=(end_effect_god_index(merop)) && (pe.god_otcheta-pe.fact_god)>=(merop.start_god-pe.fact_god)"
                             v-for="item2 in merop.ter" :key="item2">
                              {{decimal(item2.tut_fact[pe.god_otcheta-pe.fact_god],3)}}<br/>
                          </span>


                        </td>

                        <td  >
                          <span v-show="(pe.god_otcheta-pe.fact_god)<=(end_effect_god_index(merop)) && (pe.god_otcheta-pe.fact_god)>=(merop.start_god-pe.fact_god)"
                             v-for="item2 in merop.ter" :key="item2">
                              {{decimal(item2.delta_rub_fact[pe.god_otcheta-pe.fact_god]/1000,4)}}<br/>
                          </span>


                        </td>


                        <td  >
                          {{ decimal(merop.zatrati_plan.slice(pe.god_ot-pe.fact_god,pe.god_otcheta-pe.fact_god+1).reduce(function (a, b) {
                          return Number(a) + Number(b);
                        })/1000,4) }}
                        </td>


                        <td align="center" valign="center"  width="80" >
                          {{ decimal(merop.zatrati_plan[pe.god_otcheta-pe.fact_god]/1000,4) }}
                        </td>


                        <td  >
                          {{ decimal(merop.zatrati_fact.slice(pe.god_ot-pe.fact_god,pe.god_otcheta-pe.fact_god+1).reduce(function (a, b) {
                          return Number(a) + Number(b);
                        })/1000,4) }}
                        </td>


                        <td align="center" valign="center"  width="80" >
                          {{ decimal(merop.zatrati_fact[pe.god_otcheta-pe.fact_god]/1000,4) }}
                        </td>



                      </tr>





                      </tbody>
                    </table>

                    <div class="">
                      <p style="font-size:7pt; margin: 0px; margin-left:10px; line-height:1;mso-line-height:1; ">Программа в части мероприятий и достигнутой экономии в объёмах ресурсов исполнена в соответствии с планом. Отклонение факта от плана в денежном выражении касательно экономии обусловлено изменением цен на единицу ТЭР.<br/>
                        Указаны величины экономии относительно сверхнормативных значений. Экономии учтённых в тарифе расходов нет.<br/>
                        Учитывая дату сдачи отчета, следует пояснить, что в соответствии с Федеральным законом от 06.12.2011 N 402-ФЗ бухгалтерская отчетность за год сдаётся до 1 апреля, соответственно, регистры учёта до наступления указанной даты могут быть неактуальны, в связи с этим годовые показатели за год, представленные в данном отчете, впоследствии могут подлежать изменению.</p>
                          <br/>
                          <br/>
                    </div>

                    <table>

                      <tr >
                        <td><b>{{pe.ruk_dolg}}</b></td><td> __________________________________ </td><td><b>{{pe.ruk_sokr}}</b></td>
                      </tr>


                    </table>
                  </div>
                  BREAKKK






                </div>










        </v-card-text>
      </v-card>
    </v-tab-item>
    <v-tab-item >
      <v-app-bar


          floating
          light
          dense
          style="background:url('/fon-3.png'); width:100%"
          elevation="0"

      >
        <v-card-title>
          <table>
            <tr>
              <td style="width:90vw">
                <v-icon class="mr-0" style="margin-top:-2px">
                  mdi-cog
                </v-icon>
                Настройки

                <span class="white--text">{{tut}}</span>
              </td>

              <td style="width:10vw; min-width:250px">



              </td>
            </tr>
          </table>











        </v-card-title>

      </v-app-bar>

      <v-card elevation="2" class="pb-5   mb-0" style=" background:url('/fon-5.png'); border: 1px solid  rgb(194, 194, 194);border-radius:0px; height:81vh; width:89vw; min-width:530px; overflow-y:scroll;
">


        <v-card-text>
          <v-alert v-if="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
                   icon="mdi-arrow-top-left"
                   prominent
                   text
                   type="purple lighten-1"
          >


            Для добавления показателей заполните на вкладке "Наименование":<br/>1) год начала программы,<br/>2) год окончания программы, <br/>3) последний завершённый год (панель "Индексы" на вкладке "Наименование").
          </v-alert>

          <br/>
          <div class="body-0 px-4 py-4  mb-4 mt-4 text-justify" style="  color:#333; border:1px solid rgb(207, 212, 207); width:95%; margin:0px auto;  border-radius:15px;padding-bottom:10px ">
          1) Заполнить эту программу копией программы с кодом -

          <FormulaEditText

              v-model="kodcopyfrom"
              :value.sync="kodcopyfrom"
              label="Код"
              color="#ffffff"
              :width="150"
              style=" display: inline-block"


          ></FormulaEditText>
          <v-btn class="success"  @click="fillfromcode(kodcopyfrom);"
                  style="margin-top:0px; display: inline-block; margin-left:10px">ЗАПОЛНИТЬ</v-btn>

                </div>
                  <br/>
                  <div class="body-0 px-4 py-4 mb-4 mt-4 text-justify" style="  color:#333; border:1px solid rgb(207, 212, 207); width:95%; margin:0px auto;  border-radius:15px;padding-bottom:10px ">
                  2) Режим определения номера периода дисконтирования по каждому мероприятию программы (при расчёте дисконтированного дохода, ЧДД, дисконтированного срока окупаемости) -
                  <v-radio-group success  v-model="pe.diskmode">
     <v-radio
      success
       label="Начиная с первого года программы энергосбережения"
       value="startpe"
      @click="$set(pe.mer[0],'discont',Number(pe.mer[0].discont)+1);$set(pe.mer[0],'discont',Number(pe.mer[0].discont)-1);"
     ></v-radio>
     <v-radio

       label="Начиная с первого года мероприятия"
       value="startmer"
        @click="$set(pe.mer[0],'discont',Number(pe.mer[0].discont)+1);$set(pe.mer[0],'discont',Number(pe.mer[0].discont)-1);"
       success
     ></v-radio>
   </v-radio-group>


</div>

<br/>
<div class="body-0 px-4 py-4  mb-4 mt-4 text-justify" style="  color:#333; border:1px solid rgb(207, 212, 207); width:95%; margin:0px auto;  border-radius:15px;padding-bottom:10px ">
3) Параметры форм <br/>
<br/>
<v-checkbox
v-model="pe.fed"
color="success"
style="margin-top:-12px;"
label="Федеральные формы (Приказ Минэнерго России от 30.06.2014 № 398)"
@click="$set(pe,'fed',pe.fed)"
></v-checkbox>
<v-checkbox
v-model="pe.reg"
color="success"
style="margin-top:-12px;"
@click="$set(pe,'reg',pe.reg)"
label="Региональные формы (По образцу форм в Самарской области)"
></v-checkbox>

<v-checkbox
  v-model="pe.hide_industry_benchmarks"
  color="success"
  style="margin-top:-12px;"
  label="Не отображать средние и лучшие мировые показатели по отрасли"
  hint="Столбцы не будут выведены в таблице ПЭ и в печатной форме программы"
  persistent-hint
></v-checkbox>

Реквизиты НПА с региональными требованиями:
<br/><br/>
<FormulaEditTextArea

    v-model="pe.regtreb"
    :value.sync="pe.regtreb"

    color="#ffffff"
    :width="500"
    rows="10"
    style=" display: inline-block"


></FormulaEditTextArea>

<v-checkbox
  v-model="pe.show_economy_targets"
  color="success"
  label="Выводить экономию в целевых показателях"
></v-checkbox>

<v-radio-group v-model="pe.economy_targets_unit" row>
  <v-radio label="млн рублей" value="million"></v-radio>
  <v-radio label="тыс. рублей" value="thousand"></v-radio>
</v-radio-group>

<v-select
  v-model="pe.economy_targets_decimals"
  :items="[0, 1, 2, 3, 4, 5, 6, 7, 8]"
  label="Знаков после запятой в сумме экономии"
  style="max-width: 360px"
></v-select>

      </div>


          <br/><br/>










        </v-card-text>
      </v-card>
    </v-tab-item>



  </v-tabs>
</v-card>

</v-dialog>

      <p class="body-0 pr-4 pl-4 mb-4 mt-4 text-justify" style="line-height:1.2rem; color:#333 ">

        {{kod}}







 </p>

<v-overlay :value="overlayer" style="z-index:500;">

<v-progress-circular
indeterminate
size="64"
></v-progress-circular><br/>
<span class="display-1"> Пожалуйста, подождите</span>
</v-overlay>

<v-dialog
      v-model="newprog"
      transition="dialog-bottom-transition"
      max-width="800" :fullscreen="showwidth()<500"
    >


      <v-card>
        <v-card-title class="text-h5 grey lighten-2 " style="word-break: keep-all;">
          Создание программы энергосбережения
        </v-card-title>

        <v-card-text ref="form" class="body-1 black--text">
          <br/>
          Введите любое рабочее название

          <br/>
          <br/>

          <v-text-field outlined
                      ref="titlerab"
                      v-model="titlerab"
                      :rules="[rules.required]"
                      label="Рабочее наименование"

                    ></v-text-field>


           Заполните поля e-mail. Вводите реальный адрес. Дальнейший доступ к программе производится по коду или по ссылке из письма, направляемого по электронной почте.

          <br/>
          <br/>


          <v-text-field outlined
            v-model="emailrab"
            ref="emailrab"
            :rules="[rules.required, rules.email]"
            label="Введите email"
          ></v-text-field>



          <v-text-field outlined
            v-model="emailrab2"
            ref="emailrab2"
            :rules="[() => emailrab2==emailrab || 'Не совпадает']"
            label="Введите email повторно"
          ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>

          <v-spacer></v-spacer>
          <v-btn large   class=" white--text mr-2 ml-2  mt-2 mb-2  " color="rgba(203, 65, 6, 0.8)"  @click="newprog = false" style=" ;border:2px solid rgba(198, 0, 0, 0.32)"><span class="pl-2 pr-2 ">Закрыть</span></v-btn>

          <v-btn large    class=" white--text mr-2 ml-2  mt-2 mb-2 " color="rgba(0, 157, 16, 0.8)"   @click="submitnewprog" style=" ;border:2px solid rgba(12, 69, 14, 0.32)"><span class="pl-2 pr-2 ">Создать</span></v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>

  <v-dialog
      v-model="newattachlabel"
      transition="dialog-bottom-transition"
      max-width="800" :fullscreen="showwidth()<500"
  >


    <v-card>
      <v-card-title class="text-h5 grey lighten-2 " style="word-break: keep-all;">
        Добавление пунктов содержания для вставки приложений
      </v-card-title>

      <v-card-text ref="form" class="body-1 black--text">
        <br/>
        Выберите раздел приложений

        <br/>
        <br/>

        <v-combobox
            outlined
            v-model="razdelpril"

            label="Раздел"
            :items="['Сметы, дефектовки и т.п.','Отчёты по ПЭ за 5 лет', 'Другие приложения']"

        ></v-combobox>


        Введите название одного или нескольких разделов (каждое название с новой строки)

        <br/>
        <br/>


        <FormulaEditTextArea outlined
                       :value.sync="razdelinew"
                       rows="7"
                             :allowenter="true"

                      label="Введите добавляемые пункты содержания"
                             :noresize="true"
        ></FormulaEditTextArea>














      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>

        <v-spacer></v-spacer>
        <v-btn large   class=" white--text mr-2 ml-2  mt-2 mb-2  " color="rgba(203, 65, 6, 0.8)"
               @click="newattachlabel = false" style=" ;border:2px solid rgba(198, 0, 0, 0.32)"><span class="pl-2 pr-2 ">Закрыть</span></v-btn>

        <v-btn large
               class=" white--text mr-2 ml-2  mt-2 mb-2 "
               color="rgba(0, 157, 16, 0.8)"
               :disabled="((razdelinew==='') || (razdelpril===''))"
               @click="addrazdelipril()" style=" ;border:2px solid rgba(12, 69, 14, 0.32)"><span class="pl-2 pr-2 ">Добавить</span></v-btn>


      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
      v-model="newattachfile"
      transition="dialog-bottom-transition"
      max-width="290mm" :fullscreen="showwidth()<500"
  >


    <v-card>
      <v-card-title class="text-h5 grey lighten-2 " style="word-break: keep-all;">
        Добавление приложений
      </v-card-title>

      <v-card-text ref="form" class="body-1 black--text">
        <br/>
        Выберите раздел приложений

        <br/>


        <v-autocomplete
            outlined
            v-model="razdelprilfile"
            dense
            hide-details
            :items="['Сметы, дефектовки и т.п.','Отчёты по ПЭ за 5 лет', 'Другие приложения']"

        ></v-autocomplete>
        <br/>
        Выберите пункт содержания

        <br/>


        <v-autocomplete
            outlined
            v-model="soderzhpunkt"
            dense
            hide-details
            :items="itemsforfiles()"

        ></v-autocomplete>
        <v-btn x-small @click="razdelpril=razdelprilfile;razdelinew='';newattachlabel=true"  rounded style="margin-top:10px; float:right"><v-icon x-small>mdi-label-outline</v-icon> добавить пункт содержания</v-btn>

        <br/><br/>

        <v-radio-group
            v-model="typepril"
            row
            dense

            label="Тип приложения"

            style="margin-top: -30px"
        >
          <v-radio
              label="Файл"
              value="file"
              color="success"
          ></v-radio>
          <v-radio
              label="Текстовое приложение"
              value="text"
              color="success"
          ></v-radio>
        </v-radio-group>


        <span v-if="typepril==='text' && soderzhpunkt!=='' && razdelprilfile!==''">Вставьте добавляемый текст</span>


        <v-checkbox
            label="Сделать пункты содержания из имён добавляемых файлов"
            color="success"
            dense
            style="margin-top:-15px;margin-bottom:-5px"
            v-if="typepril==='file'  && razdelprilfile!==''"
            v-model="soderzhfilenames"
        ></v-checkbox>

        <div class="red--text" v-if=" razdelprilfile==''">Раздел не выбран</div>
        <div class="red--text" v-if="typepril==='text'  && soderzhpunkt==''">Пункт содержания не выбран</div>
        <span v-if="typepril==='file'  && razdelprilfile!==''">Перетащите файлы (pdf или jpeg/jpg) мышкой или нажмите "Выбрать файлы"</span>
        <v-btn v-if="typepril==='file'  && razdelprilfile!==''" @click="clicker_file('loader')" rounded small style="margin-left:15px ;border: 1px solid rgb(215, 215, 215)">
          <v-icon color="rgb(171, 171, 171) ">mdi-folder-search</v-icon>
          Выбрать файлы
        </v-btn>

        <v-file-input v-show="false" @change="loadfiles('loader');" id="loader" small-chips multiple>

        </v-file-input>

        <div v-if="typepril==='file'   && razdelprilfile!==''"
            style="border: 2px dotted #D1A2D0; max-height:190px;  height:190px; border-radius:10px; overflow-y: scroll  "
             @drop.prevent="addFileMessage" @dragover.prevent="snackbarOK = true">


          <img v-for="item in loaded"
               :src="'https://storage.yandexcloud.net/261rf/'+kod+'/'+item"
               :key="item"
               width="105"

               style="border:1px solid grey; border-radius: 10px; margin:5px; "

          />

        </div>


        <proeditpril
            style="border: 2px dotted #D1A2D0; height:100px;  border-radius:10px"
            v-if="typepril==='text'  && soderzhpunkt!=='' && razdelprilfile!==''" :value="newtextpril" v-on:changer="newtextpril=$event"  />






      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>

        <v-spacer></v-spacer>
        <v-btn large   class=" white--text mr-2 ml-2  mt-2 mb-2  " color="rgba(203, 65, 6, 0.8)"
               @click="newattachfile = false" style=" ;border:2px solid rgba(198, 0, 0, 0.32)"><span class="pl-2 pr-2 ">Закрыть</span></v-btn>

        <v-btn large
               class=" white--text mr-2 ml-2  mt-2 mb-2 "
               color="rgba(0, 157, 16, 0.8)"
               :disabled="((typepril=='text') && ((soderzhpunkt==='')|| (razdelprilfile==='')|| (newtextpril==='')))
                       || ((typepril=='file') && ((soderzhpunkt==='' && soderzhfilenames===false) || (razdelprilfile==='')))"
               @click="addtextorfile()" style=" ;border:2px solid rgba(12, 69, 14, 0.32)"><span class="pl-2 pr-2 ">Добавить</span></v-btn>


      </v-card-actions>
    </v-card>
  </v-dialog>











  <v-dialog
      v-model="meropmaster"
      transition="dialog-bottom-transition"
      max-width="1340"
       :fullscreen="showwidth()<500"
  >




    <v-card>
      <v-card-title class="text-h5 grey lighten-2 " style="word-break: keep-all;">
        Мастер создания мероприятий <v-spacer/>


      </v-card-title>



      <v-card-text ref="form" class="body-1 black--text py-7;" style=" max-height:72vh; overflow-y:scroll; border:1px solid #D0D0D0; ;margin:10px; max-width:99% " >





        <table  id="toplivotable" border="1" cellpadding="0" cellspacing="0"   style="margin-top:15px" >


     <thead>
       <th width="130"></th>
       <th width="160">Год
         <v-btn x-small
         @click="sortmaster();"
         color="#00691a"    outlined rounded icon style="margin:2px; border:0px solid #F3D3FF" >
           <v-icon>
            mdi-sort-clock-ascending-outline
           </v-icon>
         </v-btn>

       </th>
       <th style="min-width:400px" colspan="2">Шаблон мероприятия / Шаблон сметы</th>
       <th  width="450">Название мероприятия</th>
       <th width="350">Объект</th>
       <th  width="170">Сумма, руб.</th>


     </thead>


          <tbody>

<template v-for="(mer,index) in pe.mastermermassiv"  >





          <tr  :key="index" >

            <td rowspan="2" style="max-width:60px; width:60px;text-indent: 0px; background: rgb(255, 255, 255);">

              <v-btn x-small   @click="pe.mastermermassiv.splice(index,1);" color="#FFA6B1"    outlined rounded icon style="margin:2px; border:1px solid #F3D3FF" >
                <v-icon>
                  mdi-close
                </v-icon>
              </v-btn>

              <v-btn x-small  v-if="index>0" @click="element=pe.mastermermassiv[index-1];pe.mastermermassiv.splice(index-1,1,pe.mastermermassiv[index]);pe.mastermermassiv[index]=element;"
                       outlined rounded icon style="margin:2px; border:1px solid #F3D3FF; color:#CA77FF" >
                <v-icon>
                  mdi-arrow-up-thin
                </v-icon>
              </v-btn>
              <v-btn x-small  v-if="index<pe.mastermermassiv.length-1" @click="element=pe.mastermermassiv[index+1];pe.mastermermassiv.splice(index+1,1,pe.mastermermassiv[index]);pe.mastermermassiv[index]=element;"
                       outlined rounded icon style="margin:2px; border:1px solid #F3D3FF;color:#CA77FF" >
                <v-icon>
                  mdi-arrow-down-thin
                </v-icon>
              </v-btn>
              <br/>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
              <v-btn
              v-bind="attrs"
               v-on="on"
               x-small   @click=";pe.mastermermassiv.splice(index+1,0,JSON.parse(JSON.stringify(pe.mastermermassiv[index])));"
                    icon style="margin:2px; color:#18b04b" >
                <v-icon small>
                mdi-numeric-1-box-multiple-outline
                </v-icon>
              </v-btn>
            </template>
            <span>Скопировать один раз</span>
          </v-tooltip>



              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
              <v-btn
              v-bind="attrs"
               v-on="on"

              x-small   @click=";pe.mastermermassiv.splice(index+1,0,JSON.parse(JSON.stringify(pe.mastermermassiv[index])));pe.mastermermassiv.splice(index+1,0,JSON.parse(JSON.stringify(pe.mastermermassiv[index])));"
                      icon style="margin:2px;color:#18b04b" >
                <v-icon small>
                mdi-numeric-2-box-multiple-outline
                </v-icon>
              </v-btn>
            </template>
            <span>Скопировать два раза</span>
          </v-tooltip>



              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
              <v-btn
              v-bind="attrs"
               v-on="on"

              x-small   @click=";pe.mastermermassiv.splice(index+1,0,JSON.parse(JSON.stringify(pe.mastermermassiv[index])));pe.mastermermassiv.splice(index+1,0,JSON.parse(JSON.stringify(pe.mastermermassiv[index])));pe.mastermermassiv.splice(index+1,0,JSON.parse(JSON.stringify(pe.mastermermassiv[index])));"
                        icon style="margin:2px;color:#18b04b" >
                <v-icon small>
                mdi-numeric-3-box-multiple-outline
                </v-icon>
                  </v-btn>
                </template>
                <span>Скопировать три раза</span>
              </v-tooltip>


                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
              <v-btn
              v-bind="attrs"
               v-on="on"

              x-small   @click="new Array(pe.god_do-pe.god_ot+1).fill(null).map((_, i) => pe.god_do-i).forEach((item) => {if (item!==mer.god){pe.mastermermassiv.splice(index+1,0,JSON.parse(JSON.stringify(pe.mastermermassiv[index])));pe.mastermermassiv[index+1].god=item;}});"
                         icon style="margin:2px;color:#18b04b" >
                <v-icon small>
                mdi-text-box-multiple-outline
                </v-icon>
              </v-btn>
            </template>
            <span>Скопировать, чтобы такое мероприятие было по каждому году программы</span>
          </v-tooltip>



            </td>
            <td style="text-indent:-10px; padding:5px;">

              <v-autocomplete
                  v-model="mer.god"
                  dense
                  :items="new Array(pe.god_do-pe.god_ot+1).fill(null).map((_, i) => i +pe.god_ot)"
                  outlined
                  hide-details


                  style="background: #ffffff; "




              ></v-autocomplete>

            </td>

            <td style="text-indent: -5px; padding:5px; background:rgb(255, 252, 252)" colspan="2">


              <table cellspacing="7" style="border: 0px solid ;width:100%">

                <tr>
                  <td style="border: 0px solid ;"><v-autocomplete
                      v-model="mer.tempmer"

                      :items="mers.map(x=>x.name)"

                      label="шаблон мероприятия"

                      @change="mer.name= JSON.parse(mers.find(x=>x.name===mer.tempmer).mer).name;mer.obj=JSON.parse(mers.find(x=>x.name===mer.tempmer).mer).object; $set(pe.mastermermassiv[index],'datavar',makemassivdata(mer));"

                      dense

                      hide-details
                      rounded

                              style="box-shadow: #7fad7a 1px 1px 2px;
                                background-image: radial-gradient(  circle 210px at 1.1% 65.3%,  rgba(212,171,255,0.12) 60%, rgba(0,246,153,0.12) 100% );
                                ;border-radius:5px; color:black;  margin: 6px; padding:5px; padding-top:18px; padding-bottom:10px  "





                  ></v-autocomplete></td>

                </tr>
                <tr>
                  <td style="border: 0px solid ;">


                    <v-autocomplete
                        v-model="mer.tempsmeta"

                        label="шаблон сметы"
                        :items="smeti.map(x=>x.name)"

                        @change="mer.sum=smeti.find(x=>x.name===mer.tempsmeta).summa"
                        dense

                        hide-details
                        rounded

                                style="box-shadow: #7fad7a 1px 1px 2px;
                                  background-image: radial-gradient(  circle 290px at 1.1% 65.3%,  rgba(212,171,255,0.12) 60%, rgba(0,246,153,0.12) 100% );
                                  ;border-radius:5px; color:black;  margin: 6px; padding:5px; padding-top:18px; padding-bottom:10px  "


                    ></v-autocomplete>

                  </td>

                </tr>

              </table>

</td>

  <td style="text-indent: -5px; padding:15px;  ">
              <FormulaEditTextArea
                  :value.sync="mer.name"
                  rows="7"
                  :allowenter="false"





                  :noresize="true"


                  style=" display: inline-block; width:100%;height:100%; "

              />



            </td>
            <td style="text-indent: -5px; padding:15px;  ">

              <FormulaEditTextArea
                  :value.sync="mer.obj"
                  rows="7"
                  :allowenter="false"


                  :noresize="true"


                  style=" display: inline-block; width:100%;height:100%; "

              />


            </td>

            <td style="text-indent: -5px; padding:5px;   ">

              <FormulaEdit

                :value.sync="mer.sum"

                :nocalc="true"
                :formulavalue="true"

                :decimal="2"
                style="border:1px solid rgb(157, 157, 157); border-radius:5px;padding:5px"



              ></FormulaEdit>

              <v-checkbox
              v-model="mer.share"
              color="success"

              label="в доле"
              style="margin:0px"


              >
              </v-checkbox>

            </td>









          </tr>
          <tr :key="index"  style=" border-bottom:5px solid rgb(208, 182, 206);  ">
            <td colspan="6" style="padding:5px">

              <table  style=" margin:5px  ">
                <tr >
                  <td  :key="perem" v-for="(perem) in pe.mastermermassiv[index].datavar" style="font-size:8pt; line-height:0.8rem;width:250px; background:#ffffff">
                    {{perem.name}}

                  </td>


                </tr>
                <tr >
                  <td :key="perem" v-for="(perem) in pe.mastermermassiv[index].datavar" >
                    <FormulaEdit

                        :value="perem.value"
                        :formula.sync="perem.formula"
                        :decimal="2"
                        :nocalc="false"

                        color="#e3ffbf"/>
                  </td>

                </tr>
              </table>

            </td>
          </tr>

          </template>



          </tbody>
        </table>




      </v-card-text>

      <v-card-actions>
        <v-btn
            rounded
            :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
            small
            style="color:rgb(255, 255, 255); margin:20px; margin-top:-20px "
            class="ml-4 "
            @click="addmermaster()" color="success">
          <v-icon class="mr-1">
            mdi-plus
          </v-icon>Добавить
        </v-btn>
        <v-btn
            rounded
            :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
            small
            style="color:rgb(255, 255, 255); margin:20px; margin-top:-20px "
            class="ml-4 "
            @click="addobiazmer()" color="success">
          <v-icon class="mr-1">
            mdi-plus
          </v-icon>Добавить обязательные мероприятия
        </v-btn>
        <v-btn
            rounded
            :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
            small
            style="color:rgb(255, 255, 255); margin:20px; margin-top:-20px "
            class="ml-4 "
            @click="pe.mastermermassiv=[];" color="success">
          <v-icon class="mr-1">
            mdi-delete-sweep-outline
          </v-icon>Очистить
        </v-btn>
        <v-spacer></v-spacer>


          <v-btn large   class=" white--text mr-2 ml-2  mt-2 mb-2  " color="rgba(0, 157, 16, 0.8)"
          @click="master_mer_add_to_pe();meropmaster = false" style=" ;border:2px solid rgba(12, 69, 14, 0.32)">
          Вставить в программу</v-btn>


        <v-btn large
               class=" white--text mr-2 ml-2  mt-2 mb-2  "
               color="rgba(203, 65, 6, 0.8)"
               @click="meropmaster = false"
               style=" ;border:2px solid rgba(198, 0, 0, 0.32)">
          <span class="pl-2 pr-2 ">Закрыть</span></v-btn>





      </v-card-actions>
    </v-card>





  </v-dialog>












  <v-dialog
      v-model="celevmaster"
      transition="dialog-bottom-transition"
      max-width="1340"
       :fullscreen="showwidth()<500"
  >




    <v-card>
      <v-card-title class="text-h5 grey lighten-2 " style="word-break: keep-all;">
        Шаблоны моделей показателей<v-spacer/>


      </v-card-title>



      <v-card-text ref="form" class="body-1 black--text py-7;" style=" max-height:72vh; overflow-y:scroll; border:1px solid #D0D0D0; ;margin:10px; max-width:99%; padding-top:20px" >







              <v-autocomplete
                  v-model="modelcelevtopaste"

                  :items="cps.map(x=>x.name)"
                  label="Модели показателей"
                  dense

                  hide-details
                  rounded

                          style="box-shadow: #7fad7a 1px 1px 2px;
                            background-image: radial-gradient( circle 100px at 1.1% 15.3%,  rgba(212,171,255,0.12) 60%, rgba(0,246,153,0.12) 100% );
                            ;border-radius:5px; color:black;  margin: 6px; padding:5px; padding-top:18px; padding-bottom:10px  "



              ></v-autocomplete>






      </v-card-text>

      <v-card-actions>



        <v-spacer></v-spacer>


          <v-btn large   class=" white--text mr-2 ml-2  mt-2 mb-2  " color="rgba(0, 157, 16, 0.8)"
          @click="master_celev_add_to_pe();celevmaster = false" style=" ;border:2px solid rgba(12, 69, 14, 0.32)">
          Вставить модель в программу</v-btn>


        <v-btn large
               class=" white--text mr-2 ml-2  mt-2 mb-2  "
               color="rgba(203, 65, 6, 0.8)"
               @click="celevmaster = false"
               style=" ;border:2px solid rgba(198, 0, 0, 0.32)">
          <span class="pl-2 pr-2 ">Закрыть</span></v-btn>





      </v-card-actions>
    </v-card>





  </v-dialog>









  <v-dialog
      v-model="mertempmaster"
      transition="dialog-bottom-transition"
      max-width="1340"
       :fullscreen="showwidth()<500"
  >




    <v-card>
      <v-card-title class="text-h5 grey lighten-2 " style="word-break: keep-all;">
        Шаблоны мероприятий<v-spacer/>


      </v-card-title>



      <v-card-text ref="form" class="body-1 black--text py-7;" style=" max-height:72vh; overflow-y:scroll; border:1px solid #D0D0D0; ;margin:10px; max-width:99%; padding-top:20px" >







              <v-autocomplete
                  v-model="modelmertopaste"

                  :items="mers.map(x=>x.name)"
                  label="шаблоны мероприятий"
                  dense

                  hide-details
                  rounded

                          style="box-shadow: #7fad7a 1px 1px 2px;
                            background-image: radial-gradient( circle 100px at 1.1% 15.3%,  rgba(212,171,255,0.12) 60%, rgba(0,246,153,0.12) 100% );
                            ;border-radius:5px; color:black;  margin: 6px; padding:5px; padding-top:18px; padding-bottom:10px  "



              ></v-autocomplete>






      </v-card-text>

      <v-card-actions>



        <v-spacer></v-spacer>


          <v-btn large   class=" white--text mr-2 ml-2  mt-2 mb-2  " color="rgba(0, 157, 16, 0.8)"
          @click="master_merop_fill_from_template(selectedmerop);mertempmaster = false;" style=" ;border:2px solid rgba(12, 69, 14, 0.32)">
          Вставить модель в программу</v-btn>


        <v-btn large
               class=" white--text mr-2 ml-2  mt-2 mb-2  "
               color="rgba(203, 65, 6, 0.8)"
               @click="mertempmaster = false"
               style=" ;border:2px solid rgba(198, 0, 0, 0.32)">
          <span class="pl-2 pr-2 ">Закрыть</span></v-btn>





      </v-card-actions>
    </v-card>





  </v-dialog>

  <v-dialog
      v-model="copyprilanotherpe"
      transition="dialog-bottom-transition"
      max-width="1340"
       :fullscreen="showwidth()<500"
  >




    <v-card>
      <v-card-title class="text-h5 grey lighten-2 " style="word-break: keep-all;">
        Скопировать отчёты из другой программы<v-spacer/>


      </v-card-title>



      <v-card-text ref="form" class="body-1 black--text py-7;" style=" max-height:72vh; overflow-y:scroll; border:1px solid #D0D0D0; ;margin:10px; max-width:99%; padding-top:20px" >

        Код Программы:





        <FormulaEditText

            v-model="kodcopyfrom"
            :value.sync="kodcopyfrom"
            label="Код"
            color="#ffffff"
            :width="150"
            style=" display: inline-block"


        ></FormulaEditText>






      </v-card-text>

      <v-card-actions>



        <v-spacer></v-spacer>


          <v-btn large   class=" white--text mr-2 ml-2  mt-2 mb-2  " color="rgba(0, 157, 16, 0.8)"
          @click="copyreportfromanotherprog();copyprilanotherpe = false;" style=" ;border:2px solid rgba(12, 69, 14, 0.32)">
          Вставить отчёты</v-btn>


        <v-btn large
               class=" white--text mr-2 ml-2  mt-2 mb-2  "
               color="rgba(203, 65, 6, 0.8)"
               @click="copyprilanotherpe = false"
               style=" ;border:2px solid rgba(198, 0, 0, 0.32)">
          <span class="pl-2 pr-2 ">Закрыть</span></v-btn>





      </v-card-actions>
    </v-card>





  </v-dialog>






  <v-dialog
      v-model="copcpmaster"
      transition="dialog-bottom-transition"
      max-width="1340"
       :fullscreen="showwidth()<500"
  >




    <v-card>
      <v-card-title class="text-h5 grey lighten-2 " style="word-break: keep-all;">
        Скопировать модель показателей из другой программы<v-spacer/>


      </v-card-title>



      <v-card-text ref="form" class="body-1 black--text py-7;" style=" max-height:72vh; overflow-y:scroll; border:1px solid #D0D0D0; ;margin:10px; max-width:99%; padding-top:20px" >

        Код Программы:





        <FormulaEditText

            v-model="kodcopyfrom"
            :value.sync="kodcopyfrom"
            label="Код"
            color="#ffffff"
            :width="150"
            style=" display: inline-block"


        ></FormulaEditText>






      </v-card-text>

      <v-card-actions>



        <v-spacer></v-spacer>


          <v-btn large   class=" white--text mr-2 ml-2  mt-2 mb-2  " color="rgba(0, 157, 16, 0.8)"
          @click="copycpfromanotherprog();copcpmaster = false;" style=" ;border:2px solid rgba(12, 69, 14, 0.32)">
          Вставить модель</v-btn>


        <v-btn large
               class=" white--text mr-2 ml-2  mt-2 mb-2  "
               color="rgba(203, 65, 6, 0.8)"
               @click="copcpmaster = false"
               style=" ;border:2px solid rgba(198, 0, 0, 0.32)">
          <span class="pl-2 pr-2 ">Закрыть</span></v-btn>





      </v-card-actions>
    </v-card>





  </v-dialog>














  <v-dialog
      v-model="copmermaster"
      transition="dialog-bottom-transition"
      max-width="1340"
       :fullscreen="showwidth()<500"
  >




    <v-card>
      <v-card-title class="text-h5 grey lighten-2 " style="word-break: keep-all;">
        Скопировать мероприятие из другой программы<v-spacer/>


      </v-card-title>



      <v-card-text ref="form" class="body-1 black--text py-7;" style=" max-height:72vh; overflow-y:scroll; border:1px solid #D0D0D0; ;margin:10px; max-width:99%; padding-top:20px" >

        Код Программы:





        <FormulaEditText

            v-model="kodcopyfrom"
            :value.sync="kodcopyfrom"
            label="Код"
            color="#ffffff"
            :width="150"
            style=" display: inline-block"


        ></FormulaEditText>



        <v-btn
            rounded
            :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
            small
            style="color:rgb(255, 255, 255); margin-top:20px; margin-bottom:20px; "
            class="ml-4 "
            @click="showimportmerop(kodcopyfrom)" color="success">
          <v-icon class="mr-1">
            mdi-show
          </v-icon>Показать мероприятия
        </v-btn>

        <v-autocomplete
            v-model="modelmertopaste"
            v-if="merimport.length>0"

            :items="merimport"
            item-text="name"
            :return-object="true"




            label="Выберите мероприятие"
            dense

            hide-details
            rounded

                    style="box-shadow: #7fad7a 1px 1px 2px;
                      background-image: radial-gradient( circle 100px at 1.1% 15.3%,  rgba(212,171,255,0.12) 60%, rgba(0,246,153,0.12) 100% );
                      ;border-radius:5px; color:black;  margin: 6px; padding:5px; padding-top:18px; padding-bottom:10px  "



        ></v-autocomplete>








      </v-card-text>

      <v-card-actions>



        <v-spacer></v-spacer>


          <v-btn large   class=" white--text mr-2 ml-2  mt-2 mb-2  " color="rgba(0, 157, 16, 0.8)"
          @click="$set(pe.mer,merindextoimport,modelmertopaste);copmermaster = false;" style=" ;border:2px solid rgba(12, 69, 14, 0.32)">
          Вставить</v-btn>


        <v-btn large
               class=" white--text mr-2 ml-2  mt-2 mb-2  "
               color="rgba(203, 65, 6, 0.8)"
               @click="copmermaster = false"
               style=" ;border:2px solid rgba(198, 0, 0, 0.32)">
          <span class="pl-2 pr-2 ">Закрыть</span></v-btn>





      </v-card-actions>
    </v-card>





  </v-dialog>




















  <v-dialog
      v-model="cpp_settings"
      transition="dialog-bottom-transition"
      max-width="1340"
       :fullscreen="showwidth()<500"
  >




    <v-card>
      <v-card-title class="text-h5 grey lighten-2 " style="word-break: keep-all;">
        Настройки показателей <v-spacer/>


      </v-card-title>



      <v-card-text ref="form" class="body-1 black--text py-7;" style=" max-height:72vh; overflow-y:scroll; border:1px solid #D0D0D0; ;margin:10px; max-width:99% " >





        <table  id="toplivotable" border="1" cellpadding="0" cellspacing="0"   style="margin-top:15px" >

          <tbody>

          <tr v-for="(cp,index) in pe.celev" :key="index">
            <td style="max-width:60px; width:60px;text-indent: 10px; border-right:0px;">

              <v-btn   @click="pe.celev.splice(index,1);" color="#FFA6B1"  large  outlined rounded icon style="margin:2px; border:3px solid #F3D3FF" >
                <v-icon>
                  mdi-close
                </v-icon>
              </v-btn>
            </td>
            <td style="max-width:50px; width:50px;text-indent: 0px;border-right:0px;border-left:0px;">
              <v-btn v-if="index>0" @click="element=pe.celev[index-1];pe.celev.splice(index-1,1,pe.celev[index]);pe.celev[index]=element;"
                     large  outlined rounded icon style="margin:2px; border:3px solid #F3D3FF; color:#CA77FF" >
                <v-icon>
                  mdi-arrow-up-thin
                </v-icon>
              </v-btn>
              <v-btn v-if="index<pe.celev.length-1" @click="element=pe.celev[index+1];pe.celev.splice(index+1,1,pe.celev[index]);pe.celev[index]=element;"
                     large  outlined rounded icon style="margin:2px; border:3px solid #F3D3FF;color:#CA77FF" >
                <v-icon>
                  mdi-arrow-down-thin
                </v-icon>
              </v-btn>
            </td>
            <td style="max-width:50px; width:50px;text-indent: 0px;border-right:0px;border-left:0px; ">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn  @click="cp.showinform=!cp.showinform" color="#6EC764" hint="dd"
                         v-bind="attrs"
                          v-on="on"
                          large  outlined rounded icon style="margin:2px; border:3px solid #F3D3FF">
                    <v-icon>
                      {{cp.showinform?'mdi-table-eye':'mdi-table-eye-off'}}
                    </v-icon>
                  </v-btn>
                </template>
                <span>Отображать в печатной <u>(основной)</u> форме Целевых показателей</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn  @click="cp.mark=!cp.mark" color="#6EC764" hint="dd"
                         v-bind="attrs"
                          v-on="on"
                          large  outlined rounded icon style="margin:2px; border:3px solid #F3D3FF">
                    <v-icon>
                      {{cp.mark?'mdi-play-box-edit-outline':'mdi-checkbox-blank-outline'}}
                    </v-icon>
                  </v-btn>
                </template>
                <span>Отображать в ячейке пометку для заполнения</span>
              </v-tooltip>
            </td>

            <td style="max-width:50px; width:50px;text-indent: 0px;border-left:0px;border-right:0px;">

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs"
                        v-on="on">
              <v-icon    outlined fab  style="margin:2px; border:3px solid #F3D3FF;color:#D567D5;border-radius:25px; padding:7px">
                      {{(!(cp.formula_plan.find(myObj => myObj.toLowerCase().indexOf('эффектпэ')>=0)==null) || !(cp.formula_fact.find(myObj => myObj.toLowerCase().indexOf('эффектпэ')>=0)==null))?
                  'mdi-playlist-check':'mdi-comment-alert'}}
                    </v-icon>
                    </span>
              </template>
              <span>{{(!(cp.formula_plan.find(myObj => myObj.toLowerCase().indexOf('эффектпэ')>=0)==null) || !(cp.formula_fact.find(myObj => myObj.toLowerCase().indexOf('эффектпэ')>=0)==null))?
                  'Показатель можно напрямую изменять в мероприятиях ПЭ (в формуле учтён эффект ПЭ)':'Показатель нельзя напрямую изменять в мероприятиях ПЭ (в формуле не учтён эффект ПЭ)'}}</span>
            </v-tooltip>

            </td>
            <td style="text-indent: 0px;padding: 10px; vertical-align: top;border-left:0px;  ">

              <table style="border:2px solid #f1d1ff; margin:5px;background-image: radial-gradient( circle 329px at 3.1% 9.3%,  rgb(238,255,233) 28.1%, rgba(230,197,255,0.15) 100.7% );;border-radius:20px" cellpadding="0" cellspacing="0" >
                <tr>
                  <td rowspan="2" style=" width:315px;border:0px   ">


                    <FormulaEditTextArea
                        :value.sync="cp.name"
                        rows="7"
                        :allowenter="false"



                        label="Наименование"

                        :noresize="true"


                        style=" display: inline-block; margin:7px;  margin-top:10px ;width:300px; "

                    />

                </td>
                <td style="padding:15px;border-top:0px;border-right:0px">



                  <FormulaEditText
                      :value.sync="cp.ed"
                      label="Ед.изм."
                      color="#ffffff"
                      :width="150"
                      style=" display: inline-block"
                  ></FormulaEditText>


                  <v-select
                      v-model="cp.decimal"
                      :items="[0,1,2,3,4,5]"
                      dense
                      outlined
                      hide-details
                      label="Числ. знаков"
                      style="width:137px    ; display: inline-block"
                  ></v-select>
                  <v-select
                      v-model="cp.kind"
                      :items="['Целевой','Прочий']"

                      dense
                      outlined
                      hide-details
                      label="Вид"
                      style="width:140px    ; display: inline-block"



                  ></v-select>


                  <FormulaEditText
                      :value.sync="cp.varname"
                      label="Имя переменной"
                      color="#ffffff"
                      :width="150"
                      style=" display: inline-block; margin-top:-10px;  "
                  ></FormulaEditText>
                </td>
                </tr>
                <tr>
                  <td style="padding:15px; border-top:0px;border-right:0px; border-bottom:0px">


                    <v-text-field
                        v-model="cp.formula_plan[0]"
                        dense
                        outlined
                        hide-details

                        v-bind="attrs"
                        v-on="{  ...on1 }"
                        label="Формула - план"
                        @click="(cp.formula_plan[0]===''?cp.formula_plan[0]='0':cp.formula_plan[0]=cp.formula_plan[0]);autofillplan(true,cp.formula_plan,0,yearsprognoz.length-1,cp.formula_plan[0]==''?0:cp.formula_plan[0]);
                  autofillplan(true,cp.value_plan,0,yearsprognoz.length-1,cp.value_plan[0]==''?0:cp.value_plan[0])"
                        @change="(cp.formula_plan[0]===''?cp.formula_plan[0]='0':cp.formula_plan[0]=cp.formula_plan[0]);autofillplan(true,cp.formula_plan,0,yearsprognoz.length-1,cp.formula_plan[0]==''?0:cp.formula_plan[0]);
                  autofillplan(true,cp.value_plan,0,yearsprognoz.length-1,cp.value_plan[0]==''?0:cp.value_plan[0])"
                        style=" display: inline-block; width:300px    "

                    ></v-text-field>
                    <v-menu

                        bottom
                        rounded="b-xl"
                        offset-y
                        v-bind="attrs2"
                        v-on="{  ...menu2 }"
                        open-on-hover

                        transition="scale-transition"
                        close-on-content-click
                        :close-delay="200"
                    >
                      <template v-slot:activator="{ on: on1, attrs }">
                        <v-icon color="#A3FF8F" small
                                v-bind="attrs"
                                v-on="{  ...on1 }"
                                style="margin-left:-8px; margin-top:-40px; background-image: radial-gradient( circle farthest-corner at 10% 20%,  rgb(29,150,23) 0%, rgb(1,185,114) 90% ); border-radius:30px;">
                          mdi-record
                        </v-icon>
                      </template>




                      <v-list color="#CFFFA2"  >
                        <v-list-item link
                                     v-for="(item, index) in varlist"
                                     :key="index"
                                     @click="$set(cp.formula_plan,0,editformula(cp.formula_plan[0],item));
                                     autofillplan(true,cp.formula_plan,0,yearsprognoz.length-1,cp.formula_plan[0]);
                                     autofillplan(true,cp.value_plan,0,yearsprognoz.length-1,cp.value_plan[0]==''?0:cp.value_plan[0]);"
                        >
                          <v-list-item-title >{{ item }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>





                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        @click="$set(cp.formula_fact,0,cp.formula_plan[0]);
                        autofillplan(true,cp.formula_fact,0,yearsprognoz.length-1,cp.formula_fact[0]);
                        autofillplan(true,cp.value_fact,0,yearsprognoz.length-1,cp.value_fact[0])"
                        icon
                        style="margin-left:-10px;margin-right:-10px"
                        v-bind="attrs"
                        v-on="on"
                    >
                    <v-icon color="green">
                      mdi-chevron-double-right
                    </v-icon>
                  </v-btn>
                      </template>
                      <span>Скопировать формулу из плана в факт</span>
                    </v-tooltip>



                      <v-text-field
                          v-model="cp.formula_fact[0]"
                          dense
                          outlined
                          hide-details

                          label="Формула - факт"
                          @click="(cp.formula_fact[0]===''?cp.formula_fact[0]='0':cp.formula_fact[0]=cp.formula_fact[0]);autofillplan(true,cp.formula_fact,0,yearsprognoz.length-1,cp.formula_fact[0]==''?0:cp.formula_fact[0]);
                  autofillplan(true,cp.value_fact,0,yearsprognoz.length-1,cp.value_fact[0])"

                          @change="(cp.formula_fact[0]===''?cp.formula_fact[0]='0':cp.formula_fact[0]=cp.formula_fact[0]);autofillplan(true,cp.formula_fact,0,yearsprognoz.length-1,cp.formula_fact[0]==''?0:cp.formula_fact[0]);
                  autofillplan(true,cp.value_fact,0,yearsprognoz.length-1,cp.value_fact[0])"

                          style=" display: inline-block; width:300px   ;"

                      ></v-text-field>
                    <v-menu

                        bottom
                        rounded="b-xl"
                        offset-y
                        v-bind="attrs2"
                        v-on="{  ...menu2 }"
                        open-on-hover

                        transition="scale-transition"
                        close-on-content-click
                        :close-delay="200"
                    >
                      <template v-slot:activator="{ on: on1, attrs }">
                        <v-icon color="#A3FF8F" small
                                v-bind="attrs"
                                v-on="{  ...on1 }"
                                style="margin-left:-8px; margin-top:-40px; background-image: radial-gradient( circle farthest-corner at 10% 20%,  rgb(29,150,23) 0%, rgb(1,185,114) 90% ); border-radius:30px;">
                          mdi-record
                        </v-icon>
                      </template>




                      <v-list color="#CFFFA2"  >
                        <v-list-item link
                                     v-for="(item, index) in varlist"
                                     :key="index"
                                     @click="$set(cp.formula_fact,0,editformula(cp.formula_fact[0],item));autofillplan(true,cp.formula_fact,0,yearsprognoz.length-1,cp.formula_fact[0]);
                  autofillplan(true,cp.value_fact,0,yearsprognoz.length-1,cp.value_fact[0])"
                        >
                          <v-list-item-title >{{ item }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    </td></tr>
              </table>
















            </td>



          </tr>



          </tbody>
        </table>




      </v-card-text>

      <v-card-actions>
        <v-btn
            rounded
            :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
            small
            style="color:rgb(255, 255, 255); margin:20px; margin-top:-20px "
            class="ml-4 "
            @click="addcpp()" color="success">
          <v-icon class="mr-1">
            mdi-plus
          </v-icon>Добавить
        </v-btn>
        <v-btn
            rounded
            :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
            small
            style="box-shadow: #2DA820 1px 1px 2px; text-shadow:  #ffffff 0px 0px 3px;;
            background-image: radial-gradient( circle 100px at 1.1% 15.3%,  rgba(212,171,255,0.82) 50%, rgba(0,246,153,0.52) 100% );
            ;border-radius:20px; text-shadow: #001c5c 1px 1px 2px;margin:20px; margin-top:-20px  "

          @click="getCP();celevmaster=true;" color="success">
          <v-icon small class="mr-1"   style="color:rgb(255, 255, 255); text-shadow:  #000000 0px 0px 2px;
           ">
             mdi-star
          </v-icon>заполнить по шаблону
        </v-btn>

        <v-btn
            rounded
            :disabled="(pe.god_ot==='' || pe.god_do==='' || pe.fact_god==='')"
            small
            style="box-shadow: #2DA820 1px 1px 2px; text-shadow:  #ffffff 0px 0px 3px;;
            background-image: radial-gradient( circle 100px at 1.1% 15.3%,  rgba(212,171,255,0.82) 50%, rgba(0,246,153,0.52) 100% );
            ;border-radius:20px; text-shadow: #001c5c 1px 1px 2px;margin:20px; margin-top:-20px  "

          @click="copcpmaster=true;" color="success">
          <v-icon small class="mr-1"   style="color:rgb(255, 255, 255); text-shadow:  #000000 0px 0px 2px;
           ">
             mdi-content-copy
          </v-icon>Скопировать из другой программы
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn large
               class=" white--text mr-2 ml-2  mt-2 mb-2  "
               color="rgba(203, 65, 6, 0.8)"
               @click="cpp_settings = false"
               style=" ;border:2px solid rgba(198, 0, 0, 0.32)">
          <span class="pl-2 pr-2 ">Закрыть</span></v-btn>





      </v-card-actions>
    </v-card>





  </v-dialog>

  <v-dialog
      v-model="newCPP"
      transition="dialog-bottom-transition"
      max-width="835px" min-width="835px" :fullscreen="showwidth()<500"
  >


    <v-card>
      <v-card-title class="text-h5 grey lighten-2 " style="word-break: keep-all;">
       Добавление показателя <v-spacer/>


      </v-card-title>

      <v-card-text ref="form" class="body-1 black--text py-7 ">





        <table  border="0" cellpadding="0" cellspacing="0">
          <tbody>

          <tr >
            <td class="text-center pt-5 px-2 pr-6" style="min-width:230px" colspan="3">
              <v-text-field
                  v-model="cpname"
                  label="Наименование показателя"
                  dense

              ></v-text-field>
            </td>
            <td class="text-center pt-5 px-2" style="min-width:230px">
              <v-text-field
                  v-model="cped"
                  label="Единица измерения"
                  dense
                  style="width:200px;"
              ></v-text-field>
            </td>

          <tr >
            <td class="text-center pt-5 px-2" style="min-width:230px">
              <v-text-field
                  v-model="cpvar"
                  label="Название переменной"
                  dense
                  style="width:200px;"
              ></v-text-field>
            </td>
            <td class="text-center pt-5 px-2" style="min-width:230px" colspan="2">
              <v-select
                  v-model="cpdecimal"
                  :items="[0,1,2,3,4,5]"
                  label="Число знаков округления"
                  dense
                  style="width:200px;"
              ></v-select>
            </td>

            <td class="text-center pt-1 pr-2 pr-6" style="width:190px">
              <v-select
                  v-model="cppkind"
                  :items="['Целевой','Прочий']"
                  label="Вид показателя"
              ></v-select>
            </td>

          </tr>
            <tr >
              <td class="text-center pt-5 px-2 pr-6" style="min-width:230px" colspan="4">
                <v-text-field
                    v-model="cpformula_plan"
                    label="Формула по годам программы (плановый период)"
                    dense

                ></v-text-field>
              </td>

              </tr >
            <tr >
              <td class="text-center pt-5 px-2 pr-6" style="min-width:230px" colspan="4">
                <v-text-field
                    v-model="cpformula_fact"
                    label="Формула по годам программы (факт по плановому периоду - для Отчётов по ПЭ)"
                    dense

                ></v-text-field>
              </td>

            </tr >


            <tr >

                    <td class="text-center pt-5 px-2 pr-3" style="min-width:230px" colspan="2">
                      <v-checkbox
                          v-model="cpmerpe"
                          color="success"
                          style="margin-top:-12px;"
                          label="Изменяется мероприятиями ПЭ"
                      ></v-checkbox>
                    </td>

                    <td class="text-center pt-5 px-2 pr-6" style="min-width:230px"  colspan="2">
                      <v-checkbox
                          v-model="cpformvisible"
                          color="success"
                          style="margin-top:-12px;"
                          label="Выводить в форме целевых показателей"
                      ></v-checkbox>
                    </td>







            </tr >

          </tbody>
        </table>



      </v-card-text>

      <v-card-actions>

        <v-spacer></v-spacer>
        <v-btn large   class=" white--text mr-2 ml-2  mt-2 mb-2  " color="rgba(203, 65, 6, 0.8)"  @click="newCPP = false" style=" ;border:2px solid rgba(198, 0, 0, 0.32)"><span class="pl-2 pr-2 ">Закрыть</span></v-btn>

        <v-btn  large    class=" white--text mr-2 ml-2  mt-2 mb-2 " color="rgba(0, 157, 16, 0.8)"
               @click="addcpp();newCPP=false;" style=" ;border:2px solid rgba(12, 69, 14, 0.32)"><span class="pl-2 pr-2 ">Добавить</span></v-btn>



      </v-card-actions>
    </v-card>





  </v-dialog>


    <v-dialog
          v-model="newTER"
          transition="dialog-bottom-transition"
          max-width="80vw" min-width="500px" :fullscreen="showwidth()<500"
        >


          <v-card>
            <v-card-title class="text-h5 grey lighten-2 " style="word-break: keep-all;">
              Отметьте щелчком  потребляемые ТЭР для регулируемого вида деятельности <v-spacer/>
              <v-btn    class=" white--text mr-2 ml-2  mt-2 mb-2  " color="rgba(203, 65, 6, 0.8)"  @click="newTER = false" style=" ;border:2px solid rgba(198, 0, 0, 0.32)"><span class="pl-2 pr-2 ">Закрыть</span></v-btn>

            </v-card-title>

            <v-card-text ref="form" class="body-1 black--text ">
              <br/>
              <span class="ml-2">
                Добавленные позиции подсвечиваются зелёным. Удаление производится в разделе "Расходы ТЭР".
              </span>

              <br/>
              <br/>

              <v-btn :disabled="pe.ter.filter(word => (word.name.indexOf(item.name)>-1)).length>0" @click="addter(item);"  width="180px" :style="pe.ter.filter(word => (word.name.indexOf(item.name)>-1)).length>0?'background:rgb(212, 230, 255); box-shadow: 0px 0px 4px 4px rgba(5, 254, 0, 0.98);':'background:rgb(223, 247, 255); box-shadow: 0px 0px 5px rgba(1, 170, 232, 0.84)'"
                class="mx-2 my-2  black--text"  v-for="item in TOPL.filter(word => (word.name.indexOf('Вода') > -1))" :key="item">
                  <div  style="max-width:195px; padding:5px; white-space: normal;word-break: keep-all; overflow-wrap: anywhere;  ">
                    {{item.name}}

                  </div>
              </v-btn>




              <br/>

            <v-btn :disabled="pe.ter.filter(word => (word.name.indexOf(item.name)>-1)).length>0" @click="addter(item);"  width="180px"
            :style="pe.ter.filter(word => (word.name.indexOf(item.name)>-1)).length>0?'background:rgba(241, 223, 255, 0.61);box-shadow: 0px 0px 4px 4px rgba(5, 254, 0, 0.98);':'background:rgba(241, 223, 255, 0.4);box-shadow: 0px 0px 5px rgba(188, 101, 255, 0.9)'"
            class="mx-2 my-2  black--text"  v-for="item in TOPL.filter(word => (word.name.indexOf('Электроэнергия') > -1))" :key="item">
                <div  style="max-width:195px; padding:5px; white-space: normal;word-break: keep-all; overflow-wrap: anywhere;">
                  {{item.name}}

                </div>
            </v-btn>


            <br/>





            <v-btn :disabled="pe.ter.filter(word => (word.name.indexOf(item.name)>-1)).length>0" @click="addter(item);"  width="180px"
            :style="pe.ter.filter(word => (word.name.indexOf(item.name)>-1)).length>0?'background:rgba(126, 174, 255, 0.61);;box-shadow: 0px 0px 4px 4px rgba(5, 254, 0, 0.98);':'background:rgba(184, 223, 255, 0.44);box-shadow: 0px 0px 5px rgba(66, 170, 255, 0.94)'"
            class="mx-2 my-2 black--text"  v-for="item in TOPL.filter(word => (word.name.indexOf('Газ') > -1))" :key="item">
                <div  style="max-width:195px; padding:5px; white-space: normal;word-break: keep-all; overflow-wrap: anywhere;">
                  {{item.name}}

                </div>
            </v-btn>

            <br/>

            <v-btn :disabled="pe.ter.filter(word => (word.name.indexOf(item.name)>-1)).length>0" @click="addter(item);"  width="180px"

            :style="pe.ter.filter(word => (word.name.indexOf(item.name)>-1)).length>0?'background:rgba(200, 126, 0, 0.25);box-shadow: 0px 0px 4px 4px rgba(5, 254, 0, 0.98);':'background:rgba(200, 126, 0, 0.25);box-shadow: 0px 0px 5px rgba(158, 81, 0, 0.84)'"
            class="mx-2 my-2  black--text"  v-for="item in TOPL.filter(word => (word.name.indexOf('Мазут') > -1))" :key="item">
                <div  style="max-width:195px; padding:5px; white-space: normal;word-break: keep-all; overflow-wrap: anywhere;">
                  {{item.name}}

                </div>
            </v-btn>

            <br/>

            <v-btn :disabled="pe.ter.filter(word => (word.name.indexOf(item.name)>-1)).length>0" @click="addter(item);"  width="180px"
            :style="pe.ter.filter(word => (word.name.indexOf(item.name)>-1)).length>0?'background:rgba(255, 187, 187, 0.27);box-shadow: 0px 0px 4px 4px rgba(5, 254, 0, 0.98);':'background:rgba(255, 187, 187, 0.27);box-shadow: 0px 0px 5px rgba(175, 8, 133, 0.84)'"
            class="mx-2 my-2   black--text"   v-for="item in TOPL.filter(word => (word.name.indexOf('Вода') ==-1 && word.name.indexOf('Газ') ==-1 && word.name.indexOf('Мазут') ==-1 && word.name.indexOf('Уголь') ==-1 && word.name.indexOf('Дизель') ==-1 && word.name.indexOf('Электроэнергия') ==-1))" :key="item">
                <div  style="max-width:195px; padding:5px; white-space: normal;word-break: keep-all; overflow-wrap: anywhere;">
                  {{item.name}}

                </div>
            </v-btn>
            <br/>

            <v-btn :disabled="pe.ter.filter(word => (word.name.indexOf(item.name)>-1)).length>0" @click="addter(item);"  width="180px"
            :style="pe.ter.filter(word => (word.name.indexOf(item.name)>-1)).length>0?'rgba(203, 203, 203, 0.17);;box-shadow: 0px 0px 4px 4px rgba(5, 254, 0, 0.98);':'background:rgba(203, 203, 203, 0.17);box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.84)'"
              class="mx-2 my-2  black--text"   v-for="item in TOPL.filter(word => (word.name.indexOf('Дизель') > -1))" :key="item">
                <div  style="max-width:195px; padding:5px; white-space: normal;word-break: keep-all; overflow-wrap: anywhere;">
                  {{item.name}}

                </div>
            </v-btn>
            <br/>

            <v-btn :disabled="pe.ter.filter(word => (word.name.indexOf(item.name)>-1)).length>0" @click="addter(item);"  width="180px"
            :style="pe.ter.filter(word => (word.name.indexOf(item.name)>-1)).length>0?'background:rgba(108, 86, 53, 0.26);box-shadow: 0px 0px 4px 4px rgba(5, 254, 0, 0.98);':'background:rgba(108, 86, 53, 0.26);box-shadow: 0px 0px 5px rgba(34, 32, 2, 0.84)'"
              class="mx-2 my-2  black--text"  v-for="item in TOPL.filter(word => (word.name.indexOf('Уголь') > -1))" :key="item">
                <div  style="max-width:195px; font-size:8pt; padding:5px; white-space: normal;word-break: keep-all; overflow-wrap: anywhere;">
                  {{item.name}}

                </div>
            </v-btn>


            <br/>







            </v-card-text>




          </v-card>
        </v-dialog>

        <v-dialog
              v-model="setform"
              transition="dialog-bottom-transition"
              max-width="80vw" min-width="500px" :fullscreen="showwidth()<500"
            >


              <v-card>
                <v-card-title class="text-h5 grey lighten-2 " style="word-break: keep-all;">
                Сметы, мероприятия и целевые показатели (системные настройки) <input v-model="secretcode"/><v-spacer/>
                  <v-btn    class=" white--text mr-2 ml-2  mt-2 mb-2  " color="rgba(203, 65, 6, 0.8)"  @click="setform = false" style=" ;border:2px solid rgba(198, 0, 0, 0.32)"><span class="pl-2 pr-2 ">Закрыть</span></v-btn>

                </v-card-title>

                <v-card-text ref="form" class="body-1 black--text ">
                  <br/>
                  <span v-if="secretcode=='117'">

                    <v-tabs vertical  outlined v-model="tabsyst" color="success"   class="mb-5 mr-5 black--text" style="justify-content:left;" slider-color="rgb(180, 182, 181)" slider-size="7" active-class="grey lighten-4" >

                        <v-tab style="justify-content:left;" >
                        <v-icon class="mr-1">
                        mdi-table-star
                        </v-icon>
                        Показатели
                      </v-tab>
                      <v-tab style="justify-content:left;" >
                        <v-icon class="mr-1">
                        mdi-clipboard-list-outline
                        </v-icon>
                        Мероприятия
                      </v-tab>
                      <v-tab style="justify-content:left;" >
                        <v-icon class="mr-1">
                        mdi-file-document-check
                        </v-icon>
                        Приложения к ПЭ
                      </v-tab>

                      <v-tab-item style="padding:25px">
                        Целевые

                          <FormulaEditText

                          :value.sync="nazvcp"
                          label="Название модели ЦП"
                          color="#ffffff"

                          style="margin-left:7px" />
                          <br/>
                          <v-btn    class=" white--text mr-2 ml-2  mt-2 mb-2  " color="rgba(3, 158, 33, 0.8)"  @click="createcp();" style=" ;border:2px solid rgba(0, 119, 26, 0.32)"><span class="pl-2 pr-2 ">Добавить</span></v-btn>
                      </v-tab-item>

                      <v-tab-item style="padding:25px">
                        Мероприятия
                      <br/>

                        <v-autocomplete

                        v-model="merselect"
                        :items="pe.mer.map(x=>x.name)"
                        />


                        <FormulaEditText

                        :value.sync="nazvmer"
                        label="Название мероприятия"
                        color="#ffffff"

                        style="margin-left:7px" />
                        <br/>
                        <v-btn    class=" white--text mr-2 ml-2  mt-2 mb-2  " color="rgba(3, 158, 33, 0.8)"  @click="createmer();" style=" ;border:2px solid rgba(0, 119, 26, 0.32)"><span class="pl-2 pr-2 ">Добавить</span></v-btn>
                      </v-tab-item>


                      <v-tab-item style="padding:25px">
                        Сметы и ДВ
                        <br/>
                        <br/>
                        <FormulaEditText

                        :value.sync="nazvsmeta"
                        label="Название сметы"
                        color="#ffffff"

                        style="margin-left:7px" />
                        <br/>
                        СУММА, руб.:
                        <FormulaEdit
                        :value.sync="summasmeta"

                        :nocalc="true"
                        :formulavalue="true"
                        :decimal="2"




                        />
                        <br/>
                        СМЕТА:
                        <Proeditpril   :value="smeta" v-on:changer="smeta=$event" />
                        <br/>
                        ДВ:
                        <Proeditpril   :value="dv" v-on:changer="dv=$event"/>
                        <br/>
                        <v-btn    class=" white--text mr-2 ml-2  mt-2 mb-2  " color="rgba(3, 158, 33, 0.8)"  @click="createsmeta();" style=" ;border:2px solid rgba(0, 119, 26, 0.32)"><span class="pl-2 pr-2 ">Добавить</span></v-btn>







                      </v-tab-item>


                    </v-tabs>


                  </span>

                  <br/>
                  <br/>



                <br/>







                </v-card-text>




              </v-card>
            </v-dialog>







            <v-dialog
                  v-model="vvodfactter"
                  transition="dialog-bottom-transition"
                  max-width="1500" :fullscreen="showwidth()<500"
                >


                  <v-card>
                    <v-card-title class="text-h5 grey lighten-2 " style="word-break: keep-all;">
                      Заполнение фактических расходов ТЭР
                    </v-card-title>

                    <v-card-text ref="form" class="body-1 black--text">


                      <v-card v-for="(toplivo) in pe.ter" :key="toplivo" elevation="5" class="mx-1 my-3"
                              style="border-radius:10px;  min-height:40px; "
                      >




                        <v-card-text   style=" overflow-x:scroll">


<p class="title" style="margin-bottom:5px; margin-top:-15px;">
  <v-icon large style="
   text-shadow: #29e212 1px 1px 1px;margin-right: 15px; margin:5px; display:inline-block; color:rgba(196, 131, 222, 0.95) ">mdi-fire-circle</v-icon>{{toplivo.name}}</p>


                          <table id="toplivotable" border="1" cellpadding="0" cellspacing="0">
                            <thead>
                           <tr>
                             <th class="text-center" style="min-width:380px">
                               Показатели / Периоды
                             </th>
                             <th v-for="item in yearspe.slice(pe.god_ot-pe.fact_god,1+pe.god_otcheta-pe.fact_god)" :key="item" class="text-center" style="min-width:106px">
                            <span>{{item}}</span>
                             </th>
                           </tr>

                          </thead>
                              <tbody>






                                <tr>
                                  <td class="text-left">
                                    Фактический пер. коэфф. из {{toplivo.ed}} в т.у.т.
                                  </td>
                                  <td v-for="(item,index) in yearspe.slice(pe.god_ot-pe.fact_god,1+pe.god_otcheta-pe.fact_god)" :key="item" class="text-left">





                                    <FormulaEdit

                                        :value.sync="toplivo.pk_fact[index+pe.god_ot-pe.fact_god]"

                                        :nocalc="true"
                                        :formulavalue="true"

                                        :decimal="4"


                                        :color="(!((item>=pe.god_ot) && (item<=pe.god_do)))?'rgba(245, 230, 255, 0.43);':'rgba(210, 255, 153, 0.63)'"
                                        v-if="item>=pe.god_ot"

                                    ></FormulaEdit>



                                 </td>
                                </tr>

                                <tr>
                                  <td class="text-left">
                                    Фактический объём ресурса ({{toplivo.ed}})
                                  </td>
                                  <td v-for="(item,index) in yearspe.slice(pe.god_ot-pe.fact_god,1+pe.god_otcheta-pe.fact_god)" :key="item" class="text-left">




                                    <FormulaEdit

                                        :value.sync="toplivo.volume_fact[index+pe.god_ot-pe.fact_god]"

                                        :nocalc="true"
                                        :formulavalue="true"

                                        :decimal="3"


                                        :color="(!((item>=pe.god_ot) && (item<=pe.god_do)))?'rgba(245, 230, 255, 0.43);':'rgba(210, 255, 153, 0.63)'"
                                        v-if="item>=pe.god_ot"

                                    ></FormulaEdit>

                                 </td>
                                </tr>



                                <tr>
                                  <td class="text-left">
                                    Фактические затраты на ресурс (тыс. руб.)
                                  </td>
                                  <td v-for="(item,index) in yearspe.slice(pe.god_ot-pe.fact_god,1+pe.god_otcheta-pe.fact_god)" :key="item" class="text-left">





                                    <FormulaEdit

                                        :value.sync="toplivo.rub_fact[index+pe.god_ot-pe.fact_god]"

                                        :nocalc="true"
                                        :formulavalue="true"

                                        :decimal="3"


                                        :color="(!((item>=pe.god_ot) && (item<=pe.god_do)))?'rgba(245, 230, 255, 0.43);':'rgba(210, 255, 153, 0.63)'"
                                        v-if="item>=pe.god_ot"

                                    ></FormulaEdit>

                                 </td>
                                </tr>








                              </tbody>
                            </table>

                      </v-card-text>
                      </v-card>



                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>

                      <v-spacer></v-spacer>
                      <v-btn large   class=" white--text mr-2 ml-2  mt-2 mb-2  " color="rgba(203, 65, 6, 0.8)"  @click="vvodfactter = false" style=" ;border:2px solid rgba(198, 0, 0, 0.32)"><span class="pl-2 pr-2 ">Закрыть</span></v-btn>




                    </v-card-actions>
                  </v-card>
                </v-dialog>










    <v-dialog
          v-model="innfill"
          transition="dialog-bottom-transition"
          max-width="800" :fullscreen="showwidth()<500"
        >


          <v-card>
            <v-card-title class="text-h5 grey lighten-2 " style="word-break: keep-all;">
              Заполнение данных об организации по сведениям из ЕГРЮЛ
            </v-card-title>

            <v-card-text ref="form" class="body-1 black--text">
              <table>

                <tr>
                  <td>
                           <v-combobox
                      v-model="inn"
                      :items="firms"
                      label="Введите ИНН или часть названия"
                      style="width:320px; margin-top:15px; "
                      item-text="ORG"
                      item-value="INN"
                      outlined
                      @keydown.enter="validateInn(inn)"
                      @change="validateInn(inn)"
                      :return-object="false"

                      dense
                    ></v-combobox>
              {{err.message}}
                         </td>

                         </tr>
                         <tr>
                  <td >

                      <v-btn small rounded  class="mt-0 white--text" color="#009d10"  @click="validateInn(inn,err)" ><v-icon >mdi-magnify</v-icon>Поиск в ГИС</v-btn>
                  </td>
                </tr>
                <tr>
                  <td class="pt-2">

                  <v-chip v-if="egrulprogress" label class="mb-2 ml-1 "><v-progress-circular indeterminate :size="20" :width="2" color="white" class="mr-1" ></v-progress-circular>ЕГРЮЛ</v-chip>

                </td>
                </tr>
              </table>

              <p v-if="'l' in egruldata" style="color:#464646; font-weight:bold;" class="body-3   text-center   ml-5 mt-5">Сведения из ЕГРЮЛ, включая выписку<a style="text-decoration:none;text-shadow:none;  " target="_blank" href="https://egrul.nalog.ru"><v-icon small>mdi-open-in-new</v-icon></a></p>

              <table v-if="'l' in egruldata" cellspacing="7" style=" margin:0px auto;margin-top:-10px;" :width="showwidth()>500?'100%':'90%'" >


                  <tbody>
                    <tr >


                      <td  style="box-shadow: 2px 2px 5px rgba(142, 139, 139, 0.45); border-radius:10px;">
                        <table class="text-caption"  width="100%" style="page-break-inside:avoid;border:1px solid rgb(219, 219, 219); border-radius:10px;line-height:0.8rem ; margin:  0px;">

                          <tr >
                            <td class="pl-3 pr-2 pb-2 pt-2" style="border-bottom:1px  dotted rgb(203, 201, 201);  background:rgb(235, 233, 233); border-radius:10px;"> <b>   {{egruldata['rows'][0].n}}</b></td>

                          </tr>
                          <tr v-if="egruldata['rows'][0].g" >
                            <td class="pl-2 pr-2 pt-1 pb-1 " style="padding:2px;border-bottom:1px  dotted rgb(203, 201, 201);"> {{egruldata['rows'][0].g}}</td>

                          </tr>
                          <tr >
                            <td class="pl-2  pr-2 pt-1 pb-1 "   style= " border-bottom:1px  dotted rgb(203, 201, 201);"><b> ИНН:</b> {{egruldata['rows'][0].i}} <span v-if="egruldata['rows'][0].p"><b>КПП: </b>{{egruldata['rows'][0].p}}</span> </td>

                          </tr>


                          <tr>
                            <td class="pl-2 pt-1 pb-1 " style="border-bottom:1px  dotted rgb(203, 201, 201);"><b> ОГРН:</b> {{egruldata['rows'][0].o}}, <b>дата регистрации - </b> {{egruldata['rows'][0].r}}</td>

                          </tr>
                          <tr v-if="egruldata['rows'][0].a">
                            <td class="pl-2 pt-1 pb-1" style=" border-bottom:1px  dotted rgb(203, 201, 201);;"><b> Адрес:</b> {{egruldata['rows'][0].a}}</td>

                          </tr>

                          <tr >
                            <td class="pl-2 pt-2 pb-2  ;" style="">
                              <b style="color:#009d10">Выписка из ЕГРЮЛ - </b><a target="_blank" :href="egruldata['l']">скачать  </a>  </td>

                          </tr>




                        </table>
                      </td>



                    </tr>
                  </tbody>

              </table>



            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>

              <v-spacer></v-spacer>
              <v-btn large   class=" white--text mr-2 ml-2  mt-2 mb-2  " color="rgba(203, 65, 6, 0.8)"  @click="innfill = false" style=" ;border:2px solid rgba(198, 0, 0, 0.32)"><span class="pl-2 pr-2 ">Закрыть</span></v-btn>

              <v-btn :disabled="!('l' in egruldata) " large    class=" white--text mr-2 ml-2  mt-2 mb-2 " color="rgba(0, 157, 16, 0.8)"
               @click="fillfromegrul();innfill=false;" style=" ;border:2px solid rgba(12, 69, 14, 0.32)"><span class="pl-2 pr-2 ">Заполнить</span></v-btn>


            </v-card-actions>
          </v-card>
        </v-dialog>


    <v-dialog
        transition="dialog-bottom-transition"
        max-width="600"
        v-model="dialogok"

      >

          <v-card>
            <v-toolbar
              color="success"
              dark
            >Успешно</v-toolbar>
            <v-card-text>
              <div class="body-1 pa-2 black--text">{{oktext}}</div>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn large   class=" white--text mr-2 ml-2  mt-0 mb-2  " color="rgba(0, 157, 16, 0.8)"   @click="dialogok = false" style=" ;border:2px solid rgba(12, 69, 14, 0.32)"><span class="pl-2 pr-2 ">Закрыть</span></v-btn>



            </v-card-actions>
          </v-card>

      </v-dialog>




    <v-snackbar  v-model="snackbarOK" :timeout="10000">
        {{oktext}}
        <v-btn color="success" @click="snackbarOK = false">
            закрыть
        </v-btn>
    </v-snackbar>

    <v-snackbar v-model="snackbarErr" :timeout="10000">
      {{errtext}}

        <v-btn color="error" @click="snackbarErr = false">
            закрыть
        </v-btn>
    </v-snackbar>



</div>



</template>



<script>
  // Enable pusher logging - don't include this in production
  //Pusher.logToConsole = true;




  const axios = require('axios').default



  //import draggable from "vuedraggable"
  Vue.filter('datarus', val => {
    if (!val)
    {
      return ""
    }
    const [year, month, day] = val.split('-')
      return `${day}.${month}.${year} г.`;
  });


  import Vue from 'vue';





  import VueCookies from 'vue-cookies';
  import VueExcelEditor from 'vue-excel-editor';
  import PrimeVue from 'primevue/config';
  import InputNumber from 'primevue/inputnumber';
  import FormulaEdit from "@/components/FormulaEdit";
  import FormulaEditText from "@/components/FormulaEditText";
  import Proedit from "@/components/Proedit";
  import Proeditpril from "@/components/Proeditpril";
  import FormulaEditTextArea from "@/components/FormulaEditTextarea";













  Vue.use(VueCookies);
  Vue.use(VueExcelEditor);
  Vue.use(PrimeVue);
  Vue.component('InputNumber', InputNumber);
  Vue.component('FormulaEdit', FormulaEdit);
  Vue.component('FormulaEditText', FormulaEditText);
  Vue.component('Proedit', Proedit);
  Vue.component('Proeditpril', Proeditpril);
  Vue.component('FormulaEditTextArea', FormulaEditTextArea);






  //import html2canvas from 'html2canvas';



  export default {

  components: {
    FormulaEditTextArea,


  },




  data: () => ({
    merimport:[],
    merindextoimport:'',
    shortmodecpp:true,
    copcpmaster:false,
    copmermaster:false,
    showwordpe:false,
    showwordreport:false,
    copyprilanotherpe:false,
    selectedmerop:'',
    modelmertopaste:'',
    mertempmaster:false,
    modelcelevtopaste:'',
    celevmaster:false,

    meropmaster:false,
    smeti:[],
    mers:[],
    cps:[],
    nazvsmeta:'',

    smeta:'',
    dv:'',
    summasmeta:'',
    nazvcp:'',
    merselect:'',
    nazvmer:'',
    tabsyst:'',
    secretcode:'',
    setform:false,
    kodcopyfrom:'',
    regtreb:'',
    soderzhfilenames:false,
    loaded:'',
    stru:[],
    mercopy:'',

    newtextpril:'',
    typepril:'file',
    razdelprilfile:'',
    soderzhpunkt:'',
    newattachfile:false,
    razdelpril:'',
    razdelinew:'',
    newattachlabel:false,
    khdel: {},
    table_nomer:0,
    content: ['1asfsfasfas asd asd sa ' ],
    zoom: 1,
    page_format_mm: [210, 297],
    page_margins: "20mm 20mm",
    display: "grid", // ["grid", "vertical", "horizontal"]
    mounted: false, // will be true after this component is mounted
    undo_count: -1, // contains the number of times user can undo (= current position in content_history)
    content_history: [],

    cpp_settings:false,
    element:{},

    cpname:'',
    cped:'',
    cpvar:'',
    cpdecimal:'',
    cpfact:'',
    cpbace:'',
    cpformula_plan:'',
    cpformula_fact:'',
    cpmerpe:true,
    cppkind:'Целевой',
    cppsred_otrasl:'',
    cppbest_mir:'',
    cpformvisible:true,

    newCPP:false,

    testval:'18',
    testformula:'8',
    testvis:true,

    lastsavetime:'',

    decarray:[],
    polling: null,
    peLockPolling: null,
    peLockToken: '',
    peLockTimestamp: null,
    peReadOnly: true,
    peLockRequestPending: false,

    trigger:0,
    autofillcpp:true,
    vvodfactter:false,

    descriptionFields: [
      { key: 'fullname', title: 'Полное наименование программы' },
      { key: 'vidideyateln', title: 'Основные виды деятельности организации' },
      { key: 'kratk_har_vd', title: 'Краткая характеристика регулируемого вида деятельности организации' },
      { key: 'admzd', title: 'Сведения о наличии зданий административного и административно-производственного назначения' },
      { key: 'transport', title: 'Сведения о наличии автотранспорта и спецтехники' },
      { key: 'tochkiee', title: 'Сведения о количестве точек приема (поставки) электрической энергии' },
      { key: 'tochkihoz', title: 'Сведения о количестве точек поставки энергетических ресурсов на хозяйственные нужды' },
      { key: 'resursporteb', title: 'Сведения о потреблении используемых энергетических ресурсов по видам этих энергетических ресурсов' },
      { key: 'teksost', title: 'Текущее состояние в области энергосбережения и повышения энергетической эффективности организации' },
      { key: 'rezultee', title: 'Информация о достигнутых результатах в области энергосбережения и повышения энергетической эффективности организации за последние 5 лет' },
      { key: 'sravnenie', title: 'Сравнение показателей деятельности организации с компаниями, достигшими наилучших показателей в аналогичной сфере деятельности' },
      { key: 'ekonompokaz', title: 'Экономические показатели программы организации' },
      { key: 'izmpoter', title: 'Изменение уровня потерь энергетических ресурсов при их передаче или изменение потребления энергетических ресурсов по годам программы' },
      { key: 'izmreshoz', title: 'Изменение расхода энергетических ресурсов на хозяйственные нужды по годам программы' },
      { key: 'izmresmotor', title: 'Изменение расхода моторного топлива автотранспортом и спецтехникой по годам программы' },
      { key: 'factcelevgod', title: 'Фактические значения целевых показателей программы по годам периода действия программы' },
      { key: 'raspredcp', title: 'Распределение целевых показателей программы по направлениям деятельности организации' },
      { key: 'uviazkazp', title: 'Сведения об увязке результатов реализации программы с вознаграждением сотрудников организации' },
      { key: 'perechenmertext', title: 'Перечень мероприятий, технологий и денежных средств, необходимых для реализации программы' },
      { key: 'mehanizmmonkpr', title: 'Механизм мониторинга и контроля за исполнением КПР' },
      { key: 'mehanizmmoncp', title: 'Механизм мониторинга и контроля за исполнением целевых показателей программы' },
      { key: 'pravov', title: 'Правовая и иная информация' }
    ],

    pe: {
      mastermermassiv:[],
      regtreb:'',
      show_economy_targets: true,
      economy_targets_unit: 'thousand',
      economy_targets_decimals: 2,
      fed:true,
      hide_industry_benchmarks: false,
      reg:true,
      org: '',
      pocht_address: '',
      ruk_dolg: '',
      ruk_fio: '',
      ruk_sokr: '',
      years: [],

      date_sogl: '',
      god_ot: '',
      god_otcheta:'',
      god_do: '',
      sphere: '',
      priznak: '',
      invest: false,
      edittopl:true,
      fullname:'',
      vidideyateln:'',
      kratk_har_vd:'',
      kratk_har_vd2:'',
      zatrati_total:[],
      zatrati_itog:'',
      zatrati_total_fact:[],
      zatrati_itog_fact:'',



      sogl:
        [
          {
            sogl_dolg: '',
            sogl_fio: '',
            sogl_sokr: ''
          }],
      otv:
        [
          {
            otv_dolg: '',
            otv_fio: '',
            otv_sokr: '',
          },
          {
            otv_dolg: '',
            otv_fio: '',
            otv_sokr: '',
          }],

      inflation: '4',
      discont: '4',
      fact_god: '',

      ter: [],
      celev: new Array(),
      mer: new Array(),
      ter_element: {
        name: '',
        ed: '',
        autoplan: true,
        pk_plan: [],
        pk_fact: [],
        tut_plan_do_mr: [],
        tut_plan_posle_mer: [],
        tut_fact: [],
        rub_plan_do_mer: [],
        rub_plan_posle_mer: [],
        rub_fact: [],
        price: [],
        index: [],
        volume_plan_do_mer: [],
        volume_plan_posle_mer: [],
        volume_fact: [],
        economy_volume_plan: [],
        economy_tut_plan: [],
        economy_rub_plan: [],
        economy_volume_fact: [],
        economy_tut_fact: [],
        economy_rub_fact: [],

      },
      cp_element:{
        name:'',
        ed:'',
        varname:'',
        kind:'Целевой',
        decimal:'',
        value_plan:[],
        value_fact:[],
        formula_plan:[],
        formula_fact:[],
        visformulaselector_plan:[],
        visformulaselector_fact:[],
        base:[],
        effect_plan:[],
        effect_fact:[]
      },
      mer_element:{
        name:'',
        object:'',
        discont:'',
        istochnik:'',
        statia:'',
        amort:'',
        summa_zatrat:'',
        dolya_invest:'',
        obosnovanie_doc:'',
        technologii:'',
        sohr_effecta:'',
        cp:[{name:'', delta_plan:[],delta_plan_formula:[],delta_fact:[],delta_fact_formula:[]}],
        ter:[{name:'', delta_volume_plan:[],delta_volume_fact:[], delta_rub_plan:[],delta_rub_fact:[]}],
        zatrati:[],
        srok_okup:'0',
        disk_srok_okup:'0',
        chdd:'',
        vnd:'',
        raschet:[{per:'',nazv:'',znach:'',formula:''}]

      }

    },





    innfill: false,

    VD: [],
    TOPL: [],


    headers2: [{
      text: 'Сведения о согласующих сотрудниках организации (при наличии)',
      value: 'sogl_fio',
      class: 'thead',
      width: '310'
    }],
    headers3: [{
      text: 'Сведения об ответственных (обязательно)',
      value: 'otv_fio',
      class: 'thead',
      width: '310'
    }],


    menusogl: false,
    dialogpe: false,
    newTER: false,




    snackbarOK: false,
    dialogok: false,
    oktext: '',
    errtext: '',
    snackbarErr: false,





    formnewrogHasErrors: false,

    radelpril:'',
    titlerab: 'Программа на ... годы по участку ... теплоснабжения',
    emailrab: '',
    emailrab2: '',

    rules: {
      required: value => !!value || 'Не заполнено',
      counter: value => value.length <= 20 || 'Max 20 characters',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Проверьте e-mail.'
      },


    },


    RI: [],
    rizero: false,
    ri_caption: { 'TS': 'Теплоснабжение', 'HVS': 'Водоснабжение', 'VO': 'Водоотведение', 'GVS': 'ГВС' },
    RIprogress: false,
    firms: [],
    prikazieedata: [],
    full: '',
    short: '',
    mo: '',
    prikaziprogress: false,
    printvisible: false,
    girbozero: false,
    ermspprogress: false,
    egrulprogress: false,
    rosstatprogress: false,
    fnsprogress: false,
    err: { message: '' },
    egruldata: [],
    mspdata: [],
    fnsdata: [],
    rosstatdata: [],
    prikazidata: [],
    inn: "",
    tab1: null,
    te: true,
    trte: false,
    tn: false,
    gvs: false,
    vs: true,
    vo: true,
    trvs: false,
    trvo: false,
    ee: true,
    osno: true,
    usno: false,
    nebudg: true,
    budg: false,
    nemp: true,
    mp: false,
    nep4: false,
    p4: true,
    do15: false,
    ot15: true,
    tereg: true,
    tenereg: false,
    helpdialog: false,
    vd: ['te', 'tn', 'gvs', 'vs', 'vo', 'trte', 'trvs', 'trvo', 'ee', 'osno', 'usno', 'nebudg', 'budg', 'nemp', 'mp', 'nep4', 'p4', 'do15', 'ot15', 'tereg', 'tenereg'],
    vdtext: ['Теплоснабжение', 'Теплоноситель', 'ГВС', 'Водоснабжение', 'Водоотведение', 'Транспортировка тепловой энергии', 'Транспортировка воды', 'Транспортировка стоков', 'Передача электроэнергии', 'osno', 'usno', 'nebudg', 'budg', 'nemp', 'mp', 'nep4', 'p4', 'do15', 'ot15', 'tereg', 'tenereg'],
    nalog: [],

    months: ['Отчёты и документы с изменяющимися датами сдачи', 'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
    monthshort: ['', 'янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
    calendar: [],
    sendingprocessdown: false,
    download: false,
    flagnow: false,
    recordobj: '',
    overlayer: false,

    flag_stop_redact: 0,

    ch1: [{ message: '' }],



    emailadd: false,
    sending: false,
    word: '',
    about: false,
    balance_upload: 0,
    commentaddindex: '',
    commentaddmsg: '',
    commentadd: false,

    showallperechen: true,
    tomsize_font: '16',
    expanded: [],

    tab: null,
    sel_reestr: "",
    per_direction: 2,
    centerlabel: true,
    sel_delo: {},
    sel_podacha: {},
    kind_titul: 'T',
    scale: 5,
    search: "",
    search1: "",
    move_doc: false,
    move_flag: false,
    dialog_edit_text: "",
    doc: [],
    list_dela: [],
    podacha1: {},
    files: [],
    output: null,
    org_height: 120,
    newprog: false,
    dialog_titul: false,

    dialog_perechen: false,
    notice_print: false,
    label_print: false,
    label_count: 2,
    label_fontsize: 16,
    label_width: 200,
    label_height: 55,
    label_tom: " ",
    settings_pod: false,

    titul_text: "",
    pd: {},

    id: '0',
    show_ov_1: false,
    docs_over: [],
    show_ov_2: false,
    show_ov_3: false,
    eias_over: [],
    files_over: [],
    reestr_over: [],
    kods: [],
    file_links: [],
    index: null,
    drawer: null,
    dis: false,
    show: false,
    stroka_vivod: "",
    orgs: false,
    notes: false,
    jobs: false,
    navigation: {
      shown: true,
      width: 500,
      borderSize: 3
    },




  }),




  computed: {



    varlist()
    {
      return ['Очистить','БазЗнач+ЭффектПЭ','+ БазЗнач', '+ ЭффектПЭ'].concat(this.pe.celev.map((x) => '+ '+ x.varname))
    },



    yearsprognoz() {
      let massiv = new Array();
      if (!((this.pe.god_ot) === '' || (this.pe.god_do) === '' || (this.pe.fact_god) === '')) {

        for (var _i = (Number(this.pe.fact_god)); _i < (Number(this.pe.fact_god)) + 100; _i++) {
          massiv.push(_i);
        }

        this.log(massiv)

      }
      return massiv;
    },

    yearspe() {
      let massiv = new Array();
      if (!((this.pe.god_ot) === '' || (this.pe.god_do) === '' || (this.pe.fact_god) === '')) {

        for (var _i = (Number(this.pe.fact_god)); _i < (Number(this.pe.god_do)) + 1; _i++) {
          massiv.push(_i);
        }

        this.log(massiv)

      }
      return massiv;
    },


    tut() {






      this.pe.ter.forEach((item) => {



        //----------



          for (var i = 0; i < this.yearsprognoz.length; i++) {


            if (i <this.yearspe.length)

            {

            ///ТУТ

              try {
                Vue.set(item.tut_plan_do_mr,i,item.pk_plan[i]*item.volume_plan_do_mer[i])
              }
              catch
              {
                this.log(item.tut_plan_do_mr);
                this.log(this.trigger);
              }

              ///ТУТ

                try {
                  Vue.set(item.tut_fact,i,item.pk_fact[i]*item.volume_fact[i])
                }
                catch
                {
                  this.log(item.tut_fact);
                  this.log(this.trigger);
                }

              //ЦЕНА
              if (i==0) {
                try {
                  Vue.set(item.price,i,item.rub_plan_do_mer[i]/item.volume_plan_do_mer[i]*1000)
                }
                catch
                {
                  this.log(item.rub_plan_do_mer);
                  this.log(this.trigger);
                  }

              }
              else {
                try {
                  Vue.set(item.price,i,item.price[i-1]*(1+(item.index[i]+0)/100))
                }
                catch
                {
                  this.log(item.rub_plan_do_mer);
                  this.log(this.trigger);
                  }

              }

              //Цена факт

                if (i>=(Number(this.pe.god_ot)-Number(this.pe.fact_god))) {
                  try {

                    if (item.volume_fact[i]>0)
                    {
                      Vue.set(item.price_fact, i, item.rub_fact[i] / item.volume_fact[i] * 1000)
                    }
                    else
                    {
                      Vue.set(item.price_fact, i, 0)
                    }
                  }
                  catch
                  {
                    this.log(item.price_fact);
                    this.log(this.trigger);
                    }

                }


              //ЗАТРАТЫ НА ТОПЛИВО С факт+1 года

                if (i>0) {
                  try {
                    Vue.set(item.rub_plan_do_mer,i,item.price[i]*item.volume_plan_do_mer[i]/1000)
                  }
                  catch
                  {
                    this.log(item.rub_plan_do_mer);
                    this.log(this.trigger);
                    }

                }


          }
          else {

            //ЦЕНА
            if (i==0) {
              try {
                Vue.set(item.price,i,item.rub_plan_do_mer[i]/item.volume_plan_do_mer[i]*1000)
              }
              catch
              {
                this.log(item.rub_plan_do_mer);
                this.log(this.trigger);
                }

            }
            else {
              try {
                Vue.set(item.price,i,item.price[i-1]*(1+(item.index[i]+0)/100))
              }
              catch
              {
                this.log(item.rub_plan_do_mer);
                this.log(this.trigger);
                }

            }

          }
          }
          this.log(item.tut_plan_do_mr);
          this.log(this.trigger);






        //----------







      });









      return 1;

    },


    cpp() {




      this.pe.celev.forEach((item,index) => {



        //----------



        for (var i = 0; i < this.yearsprognoz.length; i++) {


          if (i <this.yearspe.length)

          {

          //Значение

            //if (i>=(Number(this.pe.god_ot)-Number(this.pe.fact_god))) {
              try {
                //Vue.set(item.price_fact,i,item.rub_fact[i]/item.volume_fact[i]*1000)
                this.calc_cpp_formula_plan(item,i,index)
                this.calc_cpp_formula_fact(item,i,index)
              }
              catch
              {
                this.log(item.price_fact);
                this.log(this.trigger);
              }

           // }



          }

        }
        this.log(item.value_plan);
        this.log(this.value_fact);






        //----------







      });












      return 1;

    },

    meropriyatiya() {

      //Обнуляем эффект ТЭР
      this.pe.ter.forEach(x => {

        x.economy_volume_plan = new Array(this.yearsprognoz.length).fill(0);
        x.economy_tut_plan = new Array(this.yearsprognoz.length).fill(0);
        x.economy_rub_plan = new Array(this.yearsprognoz.length).fill(0);
        x.economy_volume_fact = new Array(this.yearsprognoz.length).fill(0);
        x.economy_tut_fact = new Array(this.yearsprognoz.length).fill(0);
        x.economy_rub_fact = new Array(this.yearsprognoz.length).fill(0);
      })

      //Обнуляем эффект ЦП

      this.pe.celev.forEach(x => {

        x.effect_plan = new Array(this.yearsprognoz.length).fill('0');
        x.effect_fact = new Array(this.yearsprognoz.length).fill('0');
      })

      //Цикл по мероприятиям
      this.pe.mer.forEach((item, merindex) => {


        //Затраты
        try {

          item.summa_zatrat = item.zatrati_plan.slice(item.start_god - this.pe.fact_god).reduce(function (a, b) {
            return Number(a) + Number(b);
          });

        } catch {
          item.summa_zatrat = 'Ошибка!'
        }

        //Доля в ИП
        if (this.pe.summa_po_invest > 0) {
          try {
            item.dolya_invest = item.summa_zatrat / this.pe.summa_po_invest * 100;
          } catch {
            item.dolya_invest = 'Ошибка!'
          }


        } else {
          item.dolya_invest = 0
        }
        //Переменные
        try {

          item.raschet.forEach((raschetitem, indexrasch) => {
            raschetitem.value = this.calc_merop_formula_var(merindex, raschetitem, indexrasch, item.start_god - this.pe.fact_god)
          })


        } catch {
          //
        }
        //Целевые - формулы
        try {
          item.cp.forEach((cpitem, indexcp) => {
            cpitem.delta_plan.forEach((el, period) => {

              cpitem.delta_plan[period] = this.calc_merop_formula_cpp(merindex, cpitem, indexcp, period)

            })


          })
        } catch {
          //
          window.console.log('ошибка calc_merop_formula_cpp')
        }

        //ТЭР - формулы
        try {
          item.ter.forEach((teritem, indexter) => {
            teritem.delta_volume_plan.forEach((el, period) => {

              teritem.delta_volume_plan[period] = this.calc_merop_formula_ter(merindex, teritem, indexter, period)
            })


          })
        } catch {
          //
          window.console.log('ошибка calc_merop_formula_ter')
        }

        //Цикл по годам до +100
        for (var i = item.start_god - this.pe.fact_god; i < this.yearsprognoz.length; i++) {

          //Цикл по ТЭРАМ

          item.ter.forEach((topl) => {


            //Цена план
            try {

              topl.price_plan[i] = (this.pe.ter.map(x => x.name).indexOf(topl.name) > -1) ? this.pe.ter.find(x => (x.name == topl.name)).price[i] : 0;


            } catch {
              topl.price_plan[i] = 'Ошибка!'
            }

            //Цена факт
            try {

              topl.price_fact[i] = (this.pe.ter.map(x => x.name).indexOf(topl.name) > -1) ? Number(this.pe.ter.find(x => (x.name == topl.name)).price_fact[i]) : 0;


            } catch {

              topl.price_fact[i] = 'Ошибка!'

            }

            //ТУТ план
            try {
              topl.tut_plan[i] = ((this.pe.ter.map(x => x.name).indexOf(topl.name) > -1) ? this.pe.ter.find(x => (x.name == topl.name)).pk_plan[i] : 0) * topl.delta_volume_plan[i];


            } catch {


              topl.tut_plan[i] = 'Ошибка!'

            }

            //ТУТ факт
            try {
              topl.tut_fact[i] = ((this.pe.ter.map(x => x.name).indexOf(topl.name) > -1) ? this.pe.ter.find(x => (x.name == topl.name)).pk_fact[i] : 0) * topl.delta_volume_fact[i];


            } catch {

              topl.tut_fact[i] = 'Ошибка!'

            }
            //Экономия план
            try {

              topl.delta_rub_plan[i] = ((this.pe.ter.map(x => x.name).indexOf(topl.name) > -1) ? this.pe.ter.find(x => (x.name == topl.name)).price[i] : 0) * topl.delta_volume_plan[i];


            } catch {

              topl.delta_rub_plan[i] = 'Ошибка!'

            }

            //Экономия факт
            try {
              topl.delta_rub_fact[i] = ((this.pe.ter.map(x => x.name).indexOf(topl.name) > -1) ? this.pe.ter.find(x => (x.name == topl.name)).price_fact[i] : 0) * topl.delta_volume_fact[i];

            } catch {

              topl.delta_rub_fact[i] = 'Ошибка!'

            }


          })



        }

        // cf, dcf, чдд-массив доход-массив
        try {

          if (item.ter.length > 0) {

            let economies = item.ter.map(x => x.delta_rub_plan)
            if (economies.length > 0) {
              for (let i = (item.start_god - this.pe.fact_god); i < economies[0].length; i++) {
                item.cf[i] = 0
                let summa = 0
                for (let j = 0; j < economies.length; j++) {
                  summa = summa + economies[j][i] + 0

                }
                item.cf[i] = summa;
                let diskperiod=0;
                if (this.pe.diskmode==='startpe')
                {
                  diskperiod=0
                }
                else {
                  diskperiod=item.start_god-this.pe.god_ot
                }

                item.dcf[i] = summa / ((1 + (item.discont / 100)) ** (i - (this.pe.god_ot - this.pe.fact_god)-diskperiod + 1));
                if (i >= (item.start_god - this.pe.fact_god)) {
                  let per = i - (item.start_god - this.pe.fact_god) + 1
                  if (per == 1) {

                    item.chddarray[i] = item.dcf[i] - item.zatrati_plan[i];
                    item.dohodarray[i] = item.cf[i] - item.zatrati_plan[i];
                  } else {
                    item.chddarray[i] = item.dcf[i] - item.zatrati_plan[i] + item.chddarray[i - 1];
                    item.dohodarray[i] = item.cf[i] - item.zatrati_plan[i] + item.dohodarray[i - 1];
                  }


                }


              }

            }
          } else {
            item.chddarray = (new Array(this.yearsprognoz.length)).fill('0');
            item.dohodarray = (new Array(this.yearsprognoz.length)).fill('0')
            item.cf = (new Array(this.yearsprognoz.length)).fill('0')
            item.dcf = (new Array(this.yearsprognoz.length)).fill('0')
          }

        } catch {

          // item.cf[i]='Ошибка!'

        }


        // ЧДД, ВНД, срок окуп дисконт
        try {
          let j = this.yearsprognoz.length - 1;
          let per = j - (item.start_god - this.pe.fact_god) + 1
          let granicairr = 0

          if (item.chddarray[j] < 0) {
            item.chdd = 0
            item.disk_srok_okup = 0
            item.vnd = 0
          } else {
            while ((item.chddarray[j] >= 0) && (j > (item.start_god - this.pe.fact_god))) {
              j = j - 1

            }
            if (item.chddarray[j] > 0) {
              item.chdd = item.chddarray[j]
              per = j - (item.start_god - this.pe.fact_god) + 1
              item.disk_srok_okup = per - 1 + (1 - item.chdd / item.dcf[j])
              granicairr = j
              if (item.zatrati_plan[j] > 0) {
                item.vnd = ((item.cf[j] - item.zatrati_plan[j]) / item.zatrati_plan[j]) * 100
              } else {
                item.vnd = 0
              }
              // this.IRRCalc(item.cf.slice(item.start_god-this.pe.fact_god,granicairr+1),item.zatrati_plan.slice(item.start_god-this.pe.fact_god,granicairr+1))
            } else {
              item.chdd = item.chddarray[j + 1]
              per = j - (item.start_god - this.pe.fact_god) + 1
              if (item.chddarray[j] == 0) {
                item.vnd = item.discont
              } else {
                granicairr = j + 1
                item.vnd = this.IRRCalc(item.cf.slice(item.start_god - this.pe.fact_god, granicairr + 1), item.zatrati_plan.slice(item.start_god - this.pe.fact_god, granicairr + 1))
              }
              if (item.dcf[j + 1] > 0) {
                item.disk_srok_okup = per + (1 - item.chdd / item.dcf[j + 1])
              } else {
                item.disk_srok_okup = 0
                item.vnd = 0
              }
            }

          }


        } catch {
          item.chdd = 'ошибка!'
        }

        // срок окуп прост
        try {
          let j = this.yearsprognoz.length - 1;
          let per = j - (item.start_god - this.pe.fact_god) + 1

          if (item.dohodarray[j] < 0) {

            item.srok_okup = 0
          } else {
            while ((item.dohodarray[j] >= 0) && (j > (item.start_god - this.pe.fact_god))) {
              j = j - 1

            }
            if (item.dohodarray[j] > 0) {

              per = j - (item.start_god - this.pe.fact_god) + 1
              item.srok_okup = per - 1 + (1 - item.dohodarray[j] / item.cf[j])
            } else {

              per = j - (item.start_god - this.pe.fact_god) + 1
              if (item.cf[j + 1] > 0) {
                item.srok_okup = per + (1 - item.dohodarray[j + 1] / item.cf[j + 1])
              } else {
                item.srok_okup = 0
              }
            }

          }


        } catch {
          // item.chdd='ошибка!'
        }


        //Эффект ТЭР и ЦП
        try {
          //Год начала эффекта
          let start_effect_god = Number(item.start_god) - Number(this.pe.fact_god)
          let end_effect_god = start_effect_god
          let delta = 0
          if (Math.ceil(item.disk_srok_okup) == 0) {
            delta = 1
          }

          //Год конец эффекта
          switch (item.period_effect) {
            case 'На период окупаемости':
              end_effect_god = delta + Math.ceil(item.disk_srok_okup) + start_effect_god - 1;
              break;
            case 'На период окупаемости и ещё два года':
              end_effect_god = Math.ceil(item.disk_srok_okup) + start_effect_god - 1 + 2;
              break;
            case 'На период срока амортизации':
              end_effect_god = Math.ceil(item.amort) + start_effect_god - 1;
              break;
              //По значениям в таблицах
            default:
              end_effect_god = this.yearsprognoz.length - 1;
              break;
          }


          ///Эффект ТЭР
          item.ter.forEach(meropter => {
            this.pe.ter.forEach(osnter => {
              if (meropter.name == osnter.name) {
                for (let m = start_effect_god; m <= end_effect_god; m++) {

                  osnter.economy_volume_plan[m] = Number(osnter.economy_volume_plan[m]) + Number(meropter.delta_volume_plan[m]);
                  osnter.economy_tut_plan[m] = Number(osnter.economy_tut_plan[m]) + Number(meropter.tut_plan[m]);
                  osnter.economy_rub_plan[m] = Number(osnter.economy_rub_plan[m]) + Number(meropter.delta_rub_plan[m]) / 1000;


                }
                for (let m = start_effect_god; m <= end_effect_god; m++) {


                  osnter.economy_volume_fact[m] = Number(osnter.economy_volume_fact[m]) + Number(meropter.delta_volume_fact[m]);
                  osnter.economy_tut_fact[m] = Number(osnter.economy_tut_fact[m]) + Number(meropter.tut_fact[m]);
                  osnter.economy_rub_fact[m] = Number(osnter.economy_rub_fact[m]) + Number(meropter.delta_rub_fact[m]) / 1000;

                }

              }

            })
          })

          //ЭФФЕКТ ЦП
          item.cp.forEach(meropcpp => {
            this.pe.celev.forEach(osncpp => {
              if (meropcpp.name == osncpp.name) {
                for (let m = start_effect_god; m <= end_effect_god; m++) {

                  osncpp.effect_plan[m] = Number(osncpp.effect_plan[m]) + Number(meropcpp.delta_plan[m]);


                }
                for (let m = start_effect_god; m <= end_effect_god; m++) {


                  osncpp.effect_fact[m] = Number(osncpp.effect_fact[m]) + Number(meropcpp.delta_fact[m]);

                }

              }

            })
          })




        } catch {
          //
        }


      })

      //Сводим ТЭР после мер

      this.pe.ter.forEach(teri => {
        for (let w = 0; w <= this.yearsprognoz.length - 1; w++) {
          teri.volume_plan_posle_mer[w] = Number(teri.volume_plan_do_mer[w]) - Number(teri.economy_volume_plan[w])
          teri.tut_plan_posle_mer[w] = Number(teri.tut_plan_do_mr[w]) - Number(teri.economy_tut_plan[w])
          teri.rub_plan_posle_mer[w] = Number(teri.rub_plan_do_mer[w]) - Number(teri.economy_rub_plan[w])

        }

      })


      //ЗАТРАТЫ ВСЕГО + ДОЛЯ
      Vue.set(this.pe, 'zatrati_total', (new Array(this.yearsprognoz.length)).fill('0'));
      Vue.set(this.pe, 'dolya_total', (new Array(this.yearsprognoz.length)).fill('0'));
      Vue.set(this.pe, 'zatrati_total_fact', (new Array(this.yearsprognoz.length)).fill('0'));

      let zatrlist = this.pe.mer.map(x => x.zatrati_plan)
      let zatrlist_fact = this.pe.mer.map(x => x.zatrati_fact)

      if (zatrlist.length > 0) {
        for (let k = 0; k <= zatrlist.length - 1; k++) {


          for (let j = 0; j <= this.yearsprognoz.length - 1; j++) {
            Vue.set(this.pe.zatrati_total, j, Number(this.pe.zatrati_total[j]) + Number(zatrlist[k][j]))
            Vue.set(this.pe.zatrati_total_fact, j, Number(this.pe.zatrati_total_fact[j]) + Number(zatrlist_fact[k][j]))
            if (Number(this.pe.summa_po_invest) > 0) {
              Vue.set(this.pe.dolya_total, j, Number(this.pe.dolya_total[j]) + Number(zatrlist[k][j]) / Number(this.pe.summa_po_invest))
            }

          }
        }

      }

      //ЗАТРАТЫ ВСЕГО ИТОГ
      Vue.set(this.pe, 'zatrati_total_itog', 0);
      Vue.set(this.pe, 'dolya_total_itog', 0);

      let itog_zatr = this.pe.zatrati_total.slice(this.pe.god_ot - this.pe.fact_god, this.pe.god_do - this.pe.fact_god + 1).reduce(function (a, b) {
        return Number(a) + Number(b);
      })
      let dolya_zatr = this.pe.dolya_total.slice(this.pe.god_ot - this.pe.fact_god, this.pe.god_do - this.pe.fact_god + 1).reduce(function (a, b) {
        return Number(a) + Number(b);
      })

      Vue.set(this.pe, 'zatrati_total_itog', itog_zatr);
      Vue.set(this.pe, 'dolya_total_itog', dolya_zatr);


      //ЗАТРАТЫ ВСЕГО КАПИТАЛЬНЫЕ
      Vue.set(this.pe, 'zatrati_total_capital', (new Array(this.yearsprognoz.length)).fill('0'));
      Vue.set(this.pe, 'zatrati_total_capital_fact', (new Array(this.yearsprognoz.length)).fill('0'));

      zatrlist = this.pe.mer.filter(x => Number(x.amort) > 0).map(x => x.zatrati_plan)
      zatrlist_fact = this.pe.mer.filter(x => Number(x.amort) > 0).map(x => x.zatrati_fact)


      if (zatrlist.length > 0) {
        for (let k = 0; k <= zatrlist.length - 1; k++) {


          for (let j = 0; j <= this.yearsprognoz.length - 1; j++) {
            Vue.set(this.pe.zatrati_total_capital, j, Number(this.pe.zatrati_total_capital[j]) + Number(zatrlist[k][j]))
            Vue.set(this.pe.zatrati_total_capital_fact, j, Number(this.pe.zatrati_total_capital_fact[j]) + Number(zatrlist_fact[k][j]))
          }
        }

      }

      //ЗАТРАТЫ ВСЕГО ИТОГ КАПИТАЛЬНЫЕ
      Vue.set(this.pe, 'zatrati_total_capital_itog', 0);

      itog_zatr = this.pe.zatrati_total_capital.slice(this.pe.god_ot - this.pe.fact_god, this.pe.god_do - this.pe.fact_god + 1).reduce(function (a, b) {
        return Number(a) + Number(b);
      })

      Vue.set(this.pe, 'zatrati_total_capital_itog', itog_zatr);


      //ЗАТРАТЫ ТЭР - ТУТ, РУБЛ, ЭКОНОМИЯ ТУТ, РУБЛ
      Vue.set(this.pe, 'zatrati_ter_tut_total', (new Array(this.yearsprognoz.length)).fill('0'));
      Vue.set(this.pe, 'zatrati_ter_rub_total', (new Array(this.yearsprognoz.length)).fill('0'));
      Vue.set(this.pe, 'economy_ter_tut_total', (new Array(this.yearsprognoz.length)).fill('0'));
      Vue.set(this.pe, 'economy_ter_rub_total', (new Array(this.yearsprognoz.length)).fill('0'));

      Vue.set(this.pe, 'zatrati_ter_tut_total_fact', (new Array(this.yearsprognoz.length)).fill('0'));
      Vue.set(this.pe, 'zatrati_ter_rub_total_fact', (new Array(this.yearsprognoz.length)).fill('0'));
      Vue.set(this.pe, 'economy_ter_tut_total_fact', (new Array(this.yearsprognoz.length)).fill('0'));
      Vue.set(this.pe, 'economy_ter_rub_total_fact', (new Array(this.yearsprognoz.length)).fill('0'));



      Vue.set(this.pe, 'zatrati_ter_tut_total_naritog', (new Array(this.yearsprognoz.length)).fill('0'));
      Vue.set(this.pe, 'zatrati_ter_rub_total_naritog', (new Array(this.yearsprognoz.length)).fill('0'));
      Vue.set(this.pe, 'economy_ter_tut_total_naritog', (new Array(this.yearsprognoz.length)).fill('0'));
      Vue.set(this.pe, 'economy_ter_rub_total_naritog', (new Array(this.yearsprognoz.length)).fill('0'));

      Vue.set(this.pe, 'zatrati_ter_tut_total_fact_naritog', (new Array(this.yearsprognoz.length)).fill('0'));
      Vue.set(this.pe, 'zatrati_ter_rub_total_fact_naritog', (new Array(this.yearsprognoz.length)).fill('0'));
      Vue.set(this.pe, 'economy_ter_tut_total_fact_naritog', (new Array(this.yearsprognoz.length)).fill('0'));
      Vue.set(this.pe, 'economy_ter_rub_total_fact_naritog', (new Array(this.yearsprognoz.length)).fill('0'));



      let zatrtut = this.pe.ter.map(x => x.tut_plan_posle_mer)
      let zatrrub = this.pe.ter.map(x => x.rub_plan_posle_mer)
      let econtut = this.pe.ter.map(x => x.economy_tut_plan)
      let econrub = this.pe.ter.map(x => x.economy_rub_plan)

      let zatrtut_fact = this.pe.ter.map(x => x.tut_fact)
      let zatrrub_ter_fact = this.pe.ter.map(x => x.rub_fact)
      let econtut_fact = this.pe.ter.map(x => x.economy_tut_fact)
      let econrub_fact = this.pe.ter.map(x => x.economy_rub_fact)




      if (zatrtut.length > 0) {
        for (let k = 0; k <= zatrtut.length - 1; k++) {


          for (let j = 0; j <= this.yearsprognoz.length - 1; j++) {


            Vue.set(this.pe.zatrati_ter_tut_total, j, Number(this.pe.zatrati_ter_tut_total[j]) + Number(zatrtut[k][j]))
            Vue.set(this.pe.zatrati_ter_rub_total, j, Number(this.pe.zatrati_ter_rub_total[j]) + Number(zatrrub[k][j]))
            Vue.set(this.pe.economy_ter_tut_total, j, Number(this.pe.economy_ter_tut_total[j]) + Number(econtut[k][j]))
            Vue.set(this.pe.economy_ter_rub_total, j, Number(this.pe.economy_ter_rub_total[j]) + Number(econrub[k][j]))

            Vue.set(this.pe.zatrati_ter_tut_total_fact, j, Number(this.pe.zatrati_ter_tut_total_fact[j]) + Number(zatrtut_fact[k][j]))
            Vue.set(this.pe.zatrati_ter_rub_total_fact, j, Number(this.pe.zatrati_ter_rub_total_fact[j]) + Number(zatrrub_ter_fact[k][j]))
            Vue.set(this.pe.economy_ter_tut_total_fact, j, Number(this.pe.economy_ter_tut_total_fact[j]) + Number(econtut_fact[k][j]))
            Vue.set(this.pe.economy_ter_rub_total_fact, j, Number(this.pe.economy_ter_rub_total_fact[j]) + Number(econrub_fact[k][j]))


          }
        }

      }

      //нарастающий итоги
      for (let j = 0; j <= this.yearsprognoz.length - 1; j++) {

                        try {
                        Vue.set(this.pe.zatrati_ter_tut_total_naritog, j, this.pe.zatrati_ter_tut_total.slice(this.pe.god_ot - this.pe.fact_god, j+1).reduce(function (a, b) {
                         return Number(a) + Number(b);
                       }))
                     }
                     catch {
                       //

                     }

                     try {
                     Vue.set(this.pe.zatrati_ter_rub_total_naritog, j, this.pe.zatrati_ter_rub_total.slice(this.pe.god_ot - this.pe.fact_god, j+1).reduce(function (a, b) {
                      return Number(a) + Number(b);
                    }))
                  }
                  catch {
                    //

                  }

                  try {
                  Vue.set(this.pe.economy_ter_tut_total_naritog, j, this.pe.economy_ter_tut_total.slice(this.pe.god_ot - this.pe.fact_god,j+1).reduce(function (a, b) {
                   return Number(a) + Number(b);
                 }))
                }
                catch {
                 //

                }

                try {
                Vue.set(this.pe.economy_ter_rub_total_naritog, j, this.pe.economy_ter_rub_total.slice(this.pe.god_ot - this.pe.fact_god, j+1).reduce(function (a, b) {
                 return Number(a) + Number(b);
                }))
                }
                catch {
                //

                }

                try {
                Vue.set(this.pe.zatrati_ter_tut_total_fact_naritog, j, this.pe.zatrati_ter_tut_total_fact.slice(this.pe.god_ot - this.pe.fact_god, j+1).reduce(function (a, b) {
                 return Number(a) + Number(b);
                }))
                }
                catch {
                //

                }

                try {
                Vue.set(this.pe.zatrati_ter_rub_total_fact_naritog, j, this.pe.zatrati_ter_rub_total_fact.slice(this.pe.god_ot - this.pe.fact_god, j+1).reduce(function (a, b) {
                 return Number(a) + Number(b);
                }))
                }
                catch {
                //

                }

                try {
                Vue.set(this.pe.economy_ter_tut_total_fact_naritog, j, this.pe.economy_ter_tut_total_fact.slice(this.pe.god_ot - this.pe.fact_god, j+1).reduce(function (a, b) {
                 return Number(a) + Number(b);
                }))
                }
                catch {
                //

                }

                try {
                Vue.set(this.pe.economy_ter_rub_total_fact_naritog, j, this.pe.economy_ter_rub_total_fact.slice(this.pe.god_ot - this.pe.fact_god, j+1).reduce(function (a, b) {
                 return Number(a) + Number(b);
                }))
                }
                catch {
                //

                }



      }


      //ЗАТРАТЫ ВСЕГО ИТОГ
      Vue.set(this.pe, 'zatrati_ter_tut_total_itog', 0);
      Vue.set(this.pe, 'zatrati_ter_rub_total_itog', 0);
      Vue.set(this.pe, 'economy_ter_tut_total_itog', 0);
      Vue.set(this.pe, 'economy_ter_rub_total_itog', 0);

      let itog_zatr_tut=0
      try {
         itog_zatr_tut = this.pe.zatrati_ter_tut_total.slice(this.pe.god_ot - this.pe.fact_god, this.pe.god_do - this.pe.fact_god + 1).reduce(function (a, b) {
          return Number(a) + Number(b);
        })

      }
      catch {
        //


      }

      let itog_zatr_rub = this.pe.zatrati_ter_rub_total.slice(this.pe.god_ot - this.pe.fact_god, this.pe.god_do - this.pe.fact_god + 1).reduce(function (a, b) {
        return Number(a) + Number(b);
      })
      let itog_ec_tut =0
      try {
         itog_ec_tut = this.pe.economy_ter_tut_total.slice(this.pe.god_ot - this.pe.fact_god, this.pe.god_do - this.pe.fact_god + 1).reduce(function (a, b) {
          return Number(a) + Number(b);
        })

      }
      catch
      {
        //
      }

      let itog_ec_rub = this.pe.economy_ter_rub_total.slice(this.pe.god_ot - this.pe.fact_god, this.pe.god_do - this.pe.fact_god + 1).reduce(function (a, b) {
        return Number(a) + Number(b);
      })


      Vue.set(this.pe, 'zatrati_ter_tut_total_itog', itog_zatr_tut);
      Vue.set(this.pe, 'zatrati_ter_rub_total_itog', itog_zatr_rub);
      Vue.set(this.pe, 'economy_ter_tut_total_itog', itog_ec_tut);
      Vue.set(this.pe, 'economy_ter_rub_total_itog', itog_ec_rub);


      //итоги по каждому мероприятию

      this.pe.mer.forEach(merop => {
        let indexstart = Number(merop.start_god) - Number(this.pe.fact_god);
        let index_end = this.end_effect_god_index(merop)

        merop.ter.forEach(ter => {
          Vue.set(ter, 'total_tut_plan', (new Array(this.yearsprognoz.length)).fill('0'));
          Vue.set(ter, 'total_delta_rub_plan', (new Array(this.yearsprognoz.length)).fill('0'));
          Vue.set(ter, 'total_delta_volume_plan', (new Array(this.yearsprognoz.length)).fill('0'));
          Vue.set(ter, 'total_tut_fact', (new Array(this.yearsprognoz.length)).fill('0'));
          Vue.set(ter, 'total_delta_rub_fact', (new Array(this.yearsprognoz.length)).fill('0'));
          Vue.set(ter, 'total_delta_volume_fact', (new Array(this.yearsprognoz.length)).fill('0'));
          for (let i = indexstart; i <= index_end; i++) {


            Vue.set(ter.total_tut_plan, i, Number(ter.total_tut_plan[i]) + Number(ter.tut_plan[i]));
            Vue.set(ter.total_delta_rub_plan, i, Number(ter.total_delta_rub_plan[i]) + Number(ter.delta_rub_plan[i]));
            Vue.set(ter.total_delta_volume_plan, i, Number(ter.total_delta_volume_plan[i]) + Number(ter.delta_volume_plan[i]));
            Vue.set(ter.total_tut_fact, i, Number(ter.total_tut_fact[i]) + Number(ter.tut_fact[i]));
            Vue.set(ter.total_delta_rub_fact, i, Number(ter.total_delta_rub_fact[i]) + Number(ter.delta_rub_fact[i]));
            Vue.set(ter.total_delta_volume_fact, i, Number(ter.total_delta_volume_fact[i]) + Number(ter.delta_volume_fact[i]));
          }

        })
      })

      return 1;

    },




    kod() {
      return this.$route.params.kod;
    },

    formnewprog() {
      return {
        titlerab: this.titlerab,
        emailrab: this.emailrab,
        emailrab2: this.emailrab2,

      }
    },



    direction() {
      return this.navigation.shown === false ? "Open" : "Closed";
    },







  },

  methods: {
    ensurePELockToken() {
      const storageKey = 'pe-lock-token-' + this.kod;
      let token = window.sessionStorage.getItem(storageKey);
      if (!token) {
        token = (window.crypto && window.crypto.randomUUID)
          ? window.crypto.randomUUID()
          : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2) + '-' + Math.random().toString(36).slice(2);
        window.sessionStorage.setItem(storageKey, token);
      }
      this.peLockToken = token;
    },

    requestPELock(action) {
      if (!this.peLockToken || this.peLockRequestPending) {
        return Promise.resolve(null);
      }
      this.peLockRequestPending = true;
      return axios.post(
        'https://261.рф/PELock',
        JSON.stringify({
          enter: '123',
          kod: this.kod,
          token: this.peLockToken,
          action: action,
        })
      ).then((response) => response.data)
        .finally(() => {
          this.peLockRequestPending = false;
        });
    },

    acquirePELock() {
      return this.requestPELock('acquire').then((lock) => {
        if (!lock) return null;
        this.peLockTimestamp = lock.lock_timestamp || null;
        this.peReadOnly = !(lock.active && lock.owned);
        return lock;
      });
    },

    applyLoadedPE(data) {
      this.pe = data;
      if (!('hide_industry_benchmarks' in this.pe)) this.$set(this.pe, 'hide_industry_benchmarks', false);
      if (!('show_economy_targets' in this.pe)) this.$set(this.pe, 'show_economy_targets', true);
      if (!('economy_targets_unit' in this.pe)) this.$set(this.pe, 'economy_targets_unit', 'thousand');
      if (!('economy_targets_decimals' in this.pe)) this.$set(this.pe, 'economy_targets_decimals', this.pe.economy_targets_unit === 'million' ? 5 : 2);
      if (!('pril' in this.pe)) this.$set(this.pe, 'pril', {sm: [], report: [], another: []});
      if (!('god_otcheta' in this.pe)) this.$set(this.pe, 'god_otcheta', Math.max(this.pe.god_ot, new Date().getFullYear() - 1));
      if (!('mastermermassiv' in this.pe)) this.$set(this.pe, 'mastermermassiv', []);
      if (!('smetnomer' in this.pe)) this.$set(this.pe, 'smetnomer', 1);
      if (!('reg' in this.pe)) this.$set(this.pe, 'reg', true);
      if (!('fed' in this.pe)) this.$set(this.pe, 'fed', true);
      if (!('diskmode' in this.pe)) this.$set(this.pe, 'diskmode', 'startpe');
      if (Array.isArray(this.pe.ter)) this.pe.ter.forEach((item) => { item.edit = false; });
      if (Array.isArray(this.pe.mer)) this.pe.mer.forEach((item) => { item.edit = false; });
    },

    loadPEFromServer() {
      return axios.post(
        'https://261.рф/GetPE',
        JSON.stringify({kod: this.kod, enter: '123'})
      ).then((response) => {
        if (response.data === 'ERROR') throw new Error('PE_LOAD_ERROR');
        this.applyLoadedPE(response.data);
        return response.data;
      });
    },

    startPELockPolling() {
      if (this.peLockPolling) clearInterval(this.peLockPolling);
      this.peLockPolling = setInterval(() => {
        const previousTimestamp = this.peLockTimestamp;
        const action = this.peReadOnly ? 'status' : 'heartbeat';
        this.requestPELock(action).then((lock) => {
          if (!lock) return;
          const changed = previousTimestamp !== null && lock.lock_timestamp !== previousTimestamp;
          this.peLockTimestamp = lock.lock_timestamp || null;

          if (lock.active && lock.owned) {
            const wasReadOnly = this.peReadOnly;
            this.peReadOnly = false;
            if (wasReadOnly) {
              this.loadPEFromServer().then(() => this.saver());
            }
            return;
          }

          this.peReadOnly = true;
          if (this.polling) {
            clearInterval(this.polling);
            this.polling = null;
          }

          if (lock.active) {
            if (changed) this.loadPEFromServer();
            return;
          }

          this.acquirePELock().then((acquired) => {
            if (acquired && acquired.active && acquired.owned) {
              this.loadPEFromServer().then(() => this.saver());
            }
          });
        }).catch((error) => {
          window.console.log(error);
        });
      }, 20000);
    },

    releasePELock() {
      if (!this.peLockToken) return;
      const body = JSON.stringify({
        enter: '123',
        kod: this.kod,
        token: this.peLockToken,
        action: 'release',
      });
      if (navigator.sendBeacon) {
        navigator.sendBeacon('https://261.рф/PELock', new Blob([body], {type: 'application/json'}));
      } else {
        axios.post('https://261.рф/PELock', body);
      }
    },

    makemassivdata(mer)
    {


window.console.log(JSON.parse(this.mers.find(x=>x.name===mer.tempmer).mer))

    return JSON.parse(this.mers.find(x=>x.name===mer.tempmer).mer).raschet.filter(x=>!this.isformula(x.formula));

    },
    copysogl()
    {

      let txt=''
      this.pe.sogl.forEach((item) => {
        txt=txt+item.sogl_fio+'   '+item.sogl_dolg+';'

      });


      navigator.clipboard.writeText(txt).then(
  () => {
    this.oktext="скопировано успешно"
    this.snackbarOK = true;
  },
  () => {
    this.errtext="скопировать не удалось"
    this.snackbarErr = true;
  },
  );

    },
    pastesogl()
    {

      let self=this
      let add=''
      let line=''

      navigator.clipboard
  .readText()
  .then((clipText) =>
    {
    add=clipText.split(";"),
    add.forEach((item) => {
      if (item.length>0)
      {
       line=item.split('   ')

        self.pe.sogl.push(
          {
            sogl_fio:line[0],
            sogl_dolg:line[1],
            sogl_sokr:self.sokr_fio_make(line[0]),

          }
        )
      }





    });


  });
    },







    copyotv()
    {

      let txt=''
      this.pe.otv.forEach((item) => {
        txt=txt+item.otv_fio+'   '+item.otv_dolg+'   '+item.phone+'   '+item.email+';'

      });


      navigator.clipboard.writeText(txt).then(
  () => {
    this.oktext="скопировано успешно"
    this.snackbarOK = true;
  },
  () => {
    this.errtext="скопировать не удалось"
    this.snackbarErr = true;
  },
);

    },
    pasteotv()
    {

      let self=this
      let add=''
      let line=''

      navigator.clipboard
  .readText()
  .then((clipText) =>
    {
    add=clipText.split(";"),
    add.forEach((item) => {
      if (item.length>0)
      {
       line=item.split('   ')

        self.pe.otv.push(
          {
            otv_fio:line[0],
            otv_dolg:line[1],
            phone:line[2],
            otv_sokr:self.sokr_fio_make(line[0]),
            email:line[3]
          }
        )
      }





    });


  });
    },

    isformula(item)
    {
      let rezult=false
      new Array('+','-','*','/','^').forEach((znak) => {
        if (item.indexOf(znak)>-1)
        {
          rezult=true
        }

        if (item.match(/[а-яёА-ЯЁ]/gi))
          {
              rezult=true
          }

      });
      return rezult

    },


    isbase(cpp,mark=false)
    {
     let  rezult=true
     if (mark) {

       if ((cpp.formula_plan.find(myObj => myObj.toLowerCase().indexOf('баззнач')>=0)==null))
       {
         rezult=false

       }


     }
     else {
       if (this.shortmodecpp )
       {

           if ((cpp.formula_plan.find(myObj => myObj.toLowerCase().indexOf('баззнач')>=0)==null))
           {
             rezult=false

           }



       }

     }

      return rezult
    },
    iseffect(cpp, mode='plan', mark=false)
    {
      let  rezult=true

      if (mark)
      {

          if (mode==='plan')
          {
            if ((cpp.formula_plan.find(myObj => myObj.toLowerCase().indexOf('эффектпэ')>=0)==null))
            {
              rezult=false

            }


          }
          else {

            if ((cpp.formula_fact.find(myObj => myObj.toLowerCase().indexOf('эффектпэ')>=0)==null))
            {
              rezult=false

            }

          }





      }
      else {
        if (this.shortmodecpp )
        {
          if (mode==='plan')
          {
            if ((cpp.formula_plan.find(myObj => myObj.toLowerCase().indexOf('эффектпэ')>=0)==null))
            {
              rezult=false

            }


          }
          else {

            if ((cpp.formula_fact.find(myObj => myObj.toLowerCase().indexOf('эффектпэ')>=0)==null))
            {
              rezult=false

            }

          }



        }

      }

       return rezult

    },


      showimportmerop(cod)
      {

        var self=this

        axios.post(
            'https://261.рф/checkkod',
            JSON.stringify({
              enter: "123",
              kod:  cod

            })
        )
            .then(function(response) {

              if (
                  self.Isnoproblem(response.data)) {

                axios.post(
                    'https://261.рф/GetPE',
                    JSON.stringify({
                      kod: cod,
                      enter: "123",
                    })
                )
                    .then(function(response) {
                      if (
                          response.data != "ERROR") {








                          self.merimport = response.data.mer;
                        self.overlayer = false;
                        self.saver();

                      } else {
                        window.alert("Ошибка!");
                      }
                    })
                    .catch(function(error) {
                      window.console.log(error);
                    });









                window.console.log(response.data[0]);


                if (response.data[0]['CHECK'] !== "1") {

                  self.overlayer = false;
                  self.errtext = "Ошибка! Код не найден.";
                  self.snackbarErr = true;




                }
                else {

                  self.overlayer = false;
                  self.dialogpe = true;


                }

              }
              else {
                self.overlayer = false;
                self.errtext = "Ошибка! Попробуйте повторить позднее.";
                self.snackbarErr = true;
              }

            })

            .catch(function(error) {
              self.overlayer = false;
              window.console.log(error);
            })

      },





    copycpfromanotherprog()
    {
      var self=this

      axios.post(
          'https://261.рф/checkkod',
          JSON.stringify({
            enter: "123",
            kod:  self.kodcopyfrom

          })
      )
          .then(function(response) {

            if (
                self.Isnoproblem(response.data)) {

              axios.post(
                  'https://261.рф/GetPE',
                  JSON.stringify({
                    kod: self.kodcopyfrom,
                    enter: "123",
                  })
              )
                  .then(function(response) {
                    if (
                        response.data != "ERROR") {








                        self.pe.celev = response.data.celev;
                      self.overlayer = false;
                      self.saver();

                    } else {
                      window.alert("Ошибка!");
                    }
                  })
                  .catch(function(error) {
                    window.console.log(error);
                  });









              window.console.log(response.data[0]);


              if (response.data[0]['CHECK'] !== "1") {

                self.overlayer = false;
                self.errtext = "Ошибка! Код не найден.";
                self.snackbarErr = true;




              }
              else {

                self.overlayer = false;
                self.dialogpe = true;


              }

            }
            else {
              self.overlayer = false;
              self.errtext = "Ошибка! Попробуйте повторить позднее.";
              self.snackbarErr = true;
            }

          })

          .catch(function(error) {
            self.overlayer = false;
            window.console.log(error);
          })

    },


    copyreportfromanotherprog()
    {
      var self=this

      axios.post(
          'https://261.рф/checkkod',
          JSON.stringify({
            enter: "123",
            kod:  self.kodcopyfrom

          })
      )
          .then(function(response) {

            if (
                self.Isnoproblem(response.data)) {

              axios.post(
                  'https://261.рф/GetPE',
                  JSON.stringify({
                    kod: self.kodcopyfrom,
                    enter: "123",
                  })
              )
                  .then(function(response) {
                    if (
                        response.data != "ERROR") {


                          let ar=['report']
                          ar.forEach(y=>{
                          response.data.pril[y].forEach(x=>{
                              if (x.type=='file')
                              {
                                if (!('copyfrom' in x))
                                  {
                                    x.copyfrom=self.kodcopyfrom
                                  }
                              }

                            })
                          })





                        Vue.set(self.pe.pril,'report' , self.pe.pril.report.concat(response.data.pril.report));
                      self.overlayer = false;
                      self.saver();

                    } else {
                      window.alert("Ошибка!");
                    }
                  })
                  .catch(function(error) {
                    window.console.log(error);
                  });









              window.console.log(response.data[0]);


              if (response.data[0]['CHECK'] !== "1") {

                self.overlayer = false;
                self.errtext = "Ошибка! Код не найден.";
                self.snackbarErr = true;




              }
              else {

                self.overlayer = false;
                self.dialogpe = true;


              }

            }
            else {
              self.overlayer = false;
              self.errtext = "Ошибка! Попробуйте повторить позднее.";
              self.snackbarErr = true;
            }

          })

          .catch(function(error) {
            self.overlayer = false;
            window.console.log(error);
          })

    },

    addobiazmer()
    {

      new Array(this.pe.god_do-this.pe.god_ot+1).fill(null).map((_, i) => i +this.pe.god_ot).forEach((item) => {

        this.pe.mastermermassiv.push({god:item, name:'Обязательные мероприятия (организационные, согласно пр. 3а Требований)',obj:'РСО',sum:'0',tempmer:'Обязательные мероприятия (организационные, согласно пр. 3а Требований)',tempsmeta:'' })
        this.pe.mastermermassiv[this.pe.mastermermassiv.length-1].datavar=this.makemassivdata(this.pe.mastermermassiv[this.pe.mastermermassiv.length-1]);
        this.pe.trigger=this.pe.trigger++;



      });


    },

    master_merop_fill_from_template(merop)
    {
      if (this.modelmertopaste)
      {
        let model=JSON.parse(this.mers.find(x=>x.name===this.modelmertopaste).mer);

        model.start_god=this.pe.mer[merop].start_god;


      Vue.set(this.pe.mer,merop,model);

      }

    },

    master_celev_add_to_pe()
    {
      if (this.modelcelevtopaste)
      {
        let model=JSON.parse(this.cps.find(x=>x.name===this.modelcelevtopaste).model);


        this.pe.celev=model

      }

    },

    master_mer_add_to_pe()
    {
        this.pe.mastermermassiv.forEach((item) => {
          let nomersmeti=''
          let nomerdv=''


            if (item.tempsmeta)
            {
              let smeta=this.smeti.find(x=>x.name===item.tempsmeta).smeta
              let dv=this.smeti.find(x=>x.name===item.tempsmeta).dv

               nomersmeti='ЛС-ПЭ-'+String(this.pe.smetnomer).padStart(3,0)

               nomerdv='ДЕФЕКТНАЯ ВЕДОМОСТЬ <br/> к смете '+nomersmeti
              dv=dv.replace('$$$DEFFECT$$$',nomerdv)
              dv=dv.replace('$$$ORG$$$',this.pe.org)
              dv=dv.replace('$$$STROIKA$$$',item.name+' <br/> '+item.obj)
              dv=dv.replace('$$$OBJECT$$$',item.obj)
              dv=dv.replace('$$$OBJECT$$$',item.obj)


              smeta=smeta.replace('$$$ORG$$$',this.pe.org+": <br/>  "+item.name+' <br/>  '+item.obj)
              smeta=smeta.replace('$$$STROIKA$$$',item.name+' <br/>  '+item.obj)
              smeta=smeta.replace('$$$OBJECT$$$',item.obj)
              smeta=smeta.replace('$$$NUMBER$$$',nomersmeti)
              smeta=smeta.replace('$$$OSNOVANIE$$$','Дефектная ведомость к смете '+nomersmeti)


              this.pe.pril.sm.push({type:'label',name:nomersmeti,or:''})
              this.pe.pril.sm.push({type:'text',text:smeta,or:'',name:''});

              this.pe.pril.sm.push({type:'label',name:'Дефектная ведомость к смете '+nomersmeti,or:''})
              this.pe.pril.sm.push({type:'text',text:dv,or:'',name:''});




              this.pe.smetnomer=this.pe.smetnomer+1

            }

          if (item.tempmer)
          {
            let merop=JSON.parse(this.mers.find(x=>x.name===item.tempmer).mer)
            merop.start_god=item.god
            merop.zatrati_plan[merop.start_god-this.pe.fact_god]=item.sum
            merop.name=item.name
            item.datavar.forEach((item) => {
              merop.raschet.find(x=>x.name===item.name).formula=item.formula


            });


            merop.object=item.obj
            if (item.tempsmeta)
            {
              merop.obosnovanie_doc=nomersmeti

            }
            this.cleandonachala(merop)
            merop.edit=false
            if (item.share)
            {
              merop.technologii='На энергосбережение отнесено '+item.sum+' рублей затрат от сметной стоимости в связи с тем, что мероприятие не является окупаемым за счёт экономии ТЭР и реализуется в большей мере с целью повышения надёжности системы теплоснабжения. '+merop.technologii
            }
            this.pe.mer.push(merop)
          }
          else {

              this.addmer();
              this.pe.mer[this.pe.mer.length-1].name=item.name
              this.pe.mer[this.pe.mer.length-1].object=item.obj
              this.pe.mer[this.pe.mer.length-1].start_god=item.god
              this.pe.mer[this.pe.mer.length-1].zatrati_plan[item.god-this.pe.fact_god]=item.sum

              if (item.tempsmeta)
              {
                this.pe.mer[this.pe.mer.length-1].obosnovanie_doc=nomersmeti

              }


          }

        });


    },
    sortmaster()
    {

      this.pe.mastermermassiv=  this.pe.mastermermassiv.sort((a, b) => (a.god < b.god ? -1 : 1));
  },
  sortmer()
  {

    this.pe.mer=  this.pe.mer.sort((a, b) => (a.start_god < b.start_god ? -1 : 1));
},

    makefilelink(item)
    {
      let link=''
      if ('copyfrom' in item)
      {
        link='https://storage.yandexcloud.net/261rf/'+item.copyfrom+'/'+item.link
      }
      else
      {
        link='https://storage.yandexcloud.net/261rf/'+this.kod+'/'+item.link
      }

      return link

    },
    makefromrecord(code)
    {

      let ar=['sm','report','another']
      ar.forEach(y=>{
        this.pe.pril[y].forEach(x=>{
          if (x.type=='file')
          {
            if (!('copyfrom' in x))
              {
                x.copyfrom=code
              }
          }

        })
      })
      Vue.set(this.pe,'pril',this.pe.pril)


    },

    fillfromcode(source)


    {
      var self=this

      axios.post(
          'https://261.рф/checkkod',
          JSON.stringify({
            enter: "123",
            kod: source

          })
      )
          .then(function(response) {

            if (
                self.Isnoproblem(response.data)) {

              axios.post(
                  'https://261.рф/GetPE',
                  JSON.stringify({
                    kod: source,
                    enter: "123",
                  })
              )
                  .then(function(response) {
                    if (
                        response.data != "ERROR") {
                      self.pe = response.data;
                      if (!('hide_industry_benchmarks' in self.pe)) self.$set(self.pe, 'hide_industry_benchmarks', false);
                      if (!('show_economy_targets' in self.pe)) self.$set(self.pe, 'show_economy_targets', true);
                      if (!('economy_targets_unit' in self.pe)) self.$set(self.pe, 'economy_targets_unit', 'thousand');
                      if (!('economy_targets_decimals' in self.pe)) self.$set(self.pe, 'economy_targets_decimals', self.pe.economy_targets_unit === 'million' ? 5 : 2);
                      if (!('pril' in self.pe))
                      {
                        self.pe.pril={sm:[],report:[],another:[]}
                      }
                      if (!('god_otcheta' in self.pe))
                      {
                        self.pe.god_otcheta=Math.max(self.pe.god_ot,new Date().getFullYear()-1);
                      }
                      if (!('reg' in self.pe))
                      {
                        self.pe.reg=true
                      }
                      if (!('fed' in self.pe))
                      {
                        self.pe.fed=true
                      }
                      self.makefromrecord(source);
                      self.overlayer = false;
                      self.saver();

                    } else {
                      window.alert("Ошибка!");
                    }
                  })
                  .catch(function(error) {
                    window.console.log(error);
                  });









              window.console.log(response.data[0]);


              if (response.data[0]['CHECK'] !== "1") {

                self.overlayer = false;
                self.errtext = "Ошибка! Код не найден.";
                self.snackbarErr = true;




              }
              else {

                self.overlayer = false;
                self.dialogpe = true;


              }

            }
            else {
              self.overlayer = false;
              self.errtext = "Ошибка! Попробуйте повторить позднее.";
              self.snackbarErr = true;
            }

          })

          .catch(function(error) {
            self.overlayer = false;
            window.console.log(error);
          })

    },

    loadfiles(id) {
      this.files = [];
      let droppedFiles = document.getElementById(id).files;
      if (!droppedFiles) return;



      // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
      ([...droppedFiles]).forEach(f => {
            this.files.push(f);
            this.balance_upload += 1

          },

      );

      this.uploadMessageAtt();


    },
    clicker_file(id) {
      document.getElementById(id).click();
    },
    addFileMessage(e) {

      this.files = [];
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
      ([...droppedFiles]).forEach(f => {
            this.files.push(f);

          },

      );
      this.uploadMessageAtt();
    },

    uploadMessageAtt() {

      //-----
      let formData = new FormData();
      let self = this;
      formData.append('folder', self.kod);
      formData.append('enter', "123");
      this.files.forEach((f) => {
        formData.append('docs[]', f);
      });

      axios.post('https://261.рф/loaddelo',
          formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
      ).then(function(data) {

        let load=data.data.split("----")
        load.pop()
        window.console.log(load)
        self.stru=[]
        load.forEach(x=>{
          let elem = x.split('****')[1]
          elem=elem.split(';')
          elem.pop()
          self.stru.push({file:x.split('****')[0],pages:elem})
        })
        window.console.log(self.stru)
        self.loaded=self.stru.map(x=>x.pages).flat();

        window.console.log( self.loaded);



        self.snackbarOK = true;

      })
          .catch(function() {
            window.console.log('FAILURE!!');
          });



    },



    addtextorfile()
    {
      let razd='sm'
      if (this.razdelprilfile=='Сметы, дефектовки и т.п.')
      {razd='sm'}
      else {
        if (this.razdelprilfile == 'Отчёты по ПЭ за 5 лет') {

          {
            razd = 'report'
          }
        } else {
          razd = 'another'
        }
      }
      let indsoderzh=this.pe.pril[razd].map(x=>x.name).indexOf(this.soderzhpunkt)

      if (this.typepril=='text')
      {


        this.pe.pril[razd].splice(indsoderzh+1,0,{type:'text',text:this.newtextpril,or:'',name:''});

      }
      else
      {

        if (this.soderzhfilenames)
        {

          if (indsoderzh==-1)
          {
            indsoderzh=0
          }
          this.stru.forEach(x=>{

            this.pe.pril[razd].splice(indsoderzh,0,{type:'label',name:x.file.split('.')[0],text:'',or:''});
            indsoderzh=indsoderzh+1;

            x.pages.forEach(w=>{
              this.pe.pril[razd].splice(indsoderzh,0,{type:'file',text:'',or:'',name:'',link:w});
              indsoderzh=indsoderzh+1;
            })


          })



        }
        else
        {
          this.loaded.forEach(y=>{
            this.pe.pril[razd].splice(indsoderzh+1,0,{type:'file',text:'',or:'',name:'',link:y});
            indsoderzh=indsoderzh+1;
          })

        }
        this.loaded=[]
        this.stru=[]

      }

      this.newattachfile = false

    },
    itemsformerssmeta()
    {

      return this.pe.pril.sm.filter(x=>x.type=='label').map(x=>x.name)


    },

    itemsforfiles()
    {
      let razd='sm'
      if (this.razdelprilfile=='Сметы, дефектовки и т.п.')
      {razd='sm'}
      else {
        if (this.razdelprilfile == 'Отчёты по ПЭ за 5 лет') {

          {
            razd = 'report'
          }
        } else {
          razd = 'another'
        }
      }

        return this.pe.pril[razd].filter(x=>x.type=='label').map(x=>x.name)


    },

    addrazdelipril()
    {



      let razd='sm'
      if (this.razdelpril=='Сметы, дефектовки и т.п.')
      {razd='sm'}
      else
      {
        if (this.razdelpril=='Отчёты по ПЭ за 5 лет'){

          {razd='report'}
        }
        else
        {
          razd='another'
        }
      }
      let newrazd=this.razdelinew.split('\n')
      newrazd.forEach(x=>{
        this.pe.pril[razd].push({type:'label',name:x,or:''})
      })

      this.newattachlabel=false
    },

    textgen()
    {
      Vue.set(this.pe,'fullname', "Программа энергосбережения и повышения энергетической эффективности "
          + this.pe.org
          +" на "
          + this.peperiodtext()
          +". "+this.pe.sphere
          +(this.pe.priznak?': ': '')
          +this.pe.priznak
          +(this.pe.invest?' (к инвестпрограмме).':'.'));

      Vue.set(this.pe,'vidideyateln', "Основной вид деятельности - "
          + this.pe.osn_vd
          +", осуществляется регулируемая деятельность – "
          + this.pe.sphere+'.');

          Vue.set(this.pe,'pravov',`<p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">В соответствии со статьёй 25 Федерального закона от 23.11.2009 N 261-ФЗ, <b>требования к форме программ</b> в области энергосбережения и повышения энергетической эффективности организаций, осуществляющих регулируемые виды деятельности, и отчетности о ходе их реализации устанавливаются уполномоченным <b>федеральным</b> органом исполнительной власти. Форма программы – это состав и структура таблиц, описание наполнения пояснительной записки.&nbsp;&nbsp;&nbsp; Данные требования утверждены Приказом Министерства энергетики РФ от 30 июня 2014 г. N 398, который является основным руководящим документом, использованным при подготовке данной программы. <o:p></o:p></span></p> <p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">Состав целевых показателей, методика их расчёта,&nbsp; состав обязательных мероприятий, а также иные руководства, <b>не вступающие в противоречие</b>&nbsp; с содержанием федерального законодательства, использованы при проектировании данной программы в соответствии с требованиями, утверждаемыми региональным органом исполнительной власти.<o:p></o:p></span></p> <p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Предприятие оставляет за собой право не раскрывать сведения о видах деятельности, ведение которых не регулируется государством в рамках тарифного регулирования. Нормативно-правовыми актами, дающими предприятию право не раскрывать данную информацию, являются:<o:p></o:p></span></p> <p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">1)&nbsp;&nbsp;&nbsp; Федеральный закон «О коммерческой тайне» от 29.07.2004 N 98-ФЗ;<o:p></o:p></span></p> <p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">2)&nbsp;&nbsp;&nbsp; Закон РФ от 21.07.1993 N 5485-1 «О государственной тайне».<o:p></o:p></span></p> <p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">На основании данных правовых норм сведения по нерегулируемым видам деятельности в рамках данной программы могут быть не раскрыты. <o:p></o:p></span></p> <p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Программы энергосбережения не являются публичными документами в полном объёме. Раскрытию информации подлежат только те сведения, закрытый перечень которых приводится в отраслевых нормативно-правовых актах относительно раскрытия информации (в сфере теплоснабжения, водоснабжения и др.) и информационного обеспечения мероприятий по энергосбережению и повышению энергетической эффективности (согласно 261-ФЗ от 23.11.2009).<o:p></o:p></span></p> <p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Все материалы программы, включая титульный лист, составляют пояснительную записку. Материалы в различных разделах не дублируются. Материалы публичных и общедоступных источников (портал раскрытия информации ФАС России, материалы реестров ИФНС) могут быть приняты во внимание дополнительно, ссылки приводятся по тексту, информация из этих источников в полной мере не копируется в программу во избежание избыточности.<o:p></o:p></span></p> <p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Передача Регулятором программы энергосбережения третьим лицам (сторонним юридическим лицам) возможна только после получения письменного разрешения регулируемой организации.<o:p></o:p></span></p> <p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">Данная программа энергосбережения подразумевает включение и выполнение обязательных организационных мероприятий, согласно приказам уполномоченного регионального органа исполнительной власти в полном объёме. Дополнительно перечень данных мероприятий в рамках программы во избежание избыточности в письменной форме не дублируется. Предприятие планирует и гарантирует своевременное выполнение данных мероприятий в сроки, установленные действующим законодательством РФ.<o:p></o:p></span></p> <p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">Перечень нормативно-технических документов, использованных при составлении программы:<o:p></o:p></span></p> <p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">1) Федеральный закон «Об энергосбережении и о повышении энергетической эффективности и о внесении изменений в отдельные законодательные акты Российской Федерации» от 23.11.2009 N 261-ФЗ;<o:p></o:p></span></p> <p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">2) Действующие НПА регионального органа исполнительной власти об установлении требований к программам энергосбережения;<o:p></o:p></span></p> <p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">3)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Приказ Министерства энергетики РФ от 30 декабря 2008 года № 323 «Об утверждении порядка определения нормативов удельного расхода топлива при производстве электрической и тепловой энергии» в редакции Приказов Минэнерго России от 10 августа 2012 года № 377, от 23 июля 2015 года № 494, от 30 ноября 2015 года № 904; <o:p></o:p></span></p> <p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">4) Информационное письмо Департамента государственной энергетической политики и энергоэффективности Минэнерго России от 21 сентября 2009 года «О повышении качества подготовки расчетов и обоснований нормативов удельного расхода топлива на отпущенную тепловую энергию от отопительных (производственно-отопительных) котельных»;<o:p></o:p></span></p> <p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">5) Информационно-методическое письмо ЗАО «РОСКОММУНЭНЕРГО» от 12 марта 2012 года «О расчетах и обосновании проектов нормативов удельного расхода топлива на отпущенную тепловую энергию от отопительных (производственно-отопительных) котельных» <o:p></o:p></span></p> <p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">6)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Приказ Министерства энергетики РФ от 30 декабря 2008 года № 325 «Об утверждении порядка определения нормативов технологических потерь при передаче тепловой энергии, теплоносителя» в редакции Приказа Минэнерго России от 10 августа 2012 года № 377;<o:p></o:p></span></p> <p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">7) Информационное письмо Департамента государственной энергетической политики и энергоэффективности Минэнерго России от 28 декабря 2009 года «О повышении качества подготовки расчетов и обоснования нормативов технологических потерь при передаче тепловой энергии»;<o:p></o:p></span></p> <p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">8) СП 131.13330.2020 «СНиП 23-01-99 Строительная климатология»;<o:p></o:p></span></p> <p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">9) МДК 4-05.2004. Методика определения потребности в топливе, электрической энергии и воде при производстве и передаче тепловой энергии и теплоносителей в системах коммунального теплоснабжения. Утверждена заместителем председателя Госстроя России 12.08.03 г.;<o:p></o:p></span></p> <p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">10) Приказ Минэнерго РФ от 24 марта 2003 г. N 115 «Об утверждении Правил технической эксплуатации тепловых энергоустановок»;<o:p></o:p></span></p> <p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">11) Совокупность приказов Министерства строительства и жилищно-коммунального хозяйства РФ относительно определения нормативов потерь воды.<o:p></o:p></span></p>`);

        Vue.set(this.pe, 'pravov', `<p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">Предприятие оставляет за собой право не раскрывать сведения о видах деятельности, ведение которых не регулируется государством в рамках тарифного регулирования. Нормативно-правовыми актами, дающими предприятию право не раскрывать данную информацию, являются:</span></p>
<p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">1) Федеральный закон «О коммерческой тайне» от 29.07.2004 N 98-ФЗ;</span></p>
<p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">2) Закон РФ от 21.07.1993 N 5485-1 «О государственной тайне».</span></p>
<p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">На основании данных правовых норм сведения по нерегулируемым видам деятельности в рамках данной программы могут быть не раскрыты.</span></p>
<p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">Программы энергосбережения не являются публичными документами в полном объёме. Раскрытию информации подлежат только те сведения, закрытый перечень которых приводится в отраслевых нормативно-правовых актах относительно раскрытия информации (в сфере теплоснабжения, водоснабжения и др.) и информационного обеспечения мероприятий по энергосбережению и повышению энергетической эффективности (согласно 261-ФЗ от 23.11.2009).</span></p>
<p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">Все материалы программы, включая титульный лист, составляют пояснительную записку. Материалы в различных разделах не дублируются. Материалы публичных и общедоступных источников (портал раскрытия информации ФАС России, материалы реестров ИФНС) могут быть приняты во внимание дополнительно, ссылки приводятся по тексту, информация из этих источников в полной мере не копируется в программу во избежание избыточности.</span></p>
<p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">Передача Регулятором программы энергосбережения третьим лицам (сторонним юридическим лицам) возможна только после получения письменного разрешения регулируемой организации.</span></p>
<p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">Данная программа энергосбережения включает выполнение обязательных мероприятий согласно приказам уполномоченного регионального органа исполнительной власти <b>в полном объёме.</b> Дополнительно перечень данных мероприятий в рамках программы во избежание избыточности в письменной форме может не дублироваться в полной формулировке (используются сокращения). Предприятие планирует и гарантирует своевременное выполнение данных мероприятий в сроки, установленные действующим законодательством РФ.</span></p>
<p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">Перечень нормативно-технических документов, использованных при составлении программы:</span></p>
<p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">1) Федеральный закон «Об энергосбережении и о повышении энергетической эффективности и о внесении изменений в отдельные законодательные акты Российской Федерации» от 23.11.2009 N 261-ФЗ;</span></p>
<p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">2) Действующие НПА регионального органа исполнительной власти об установлении требований к программам энергосбережения;</span></p>
<p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">3) Приказ Министерства энергетики РФ от 30 декабря 2008 года № 323 «Об утверждении порядка определения нормативов удельного расхода топлива при производстве электрической и тепловой энергии» в редакции Приказов Минэнерго России от 10 августа 2012 года № 377, от 23 июля 2015 года № 494, от 30 ноября 2015 года № 904;</span></p>
<p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">4) Информационное письмо Департамента государственной энергетической политики и энергоэффективности Минэнерго России от 21 сентября 2009 года «О повышении качества подготовки расчетов и обоснований нормативов удельного расхода топлива на отпущенную тепловую энергию от отопительных (производственно-отопительных) котельных»;</span></p>
<p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">5) Информационно-методическое письмо ЗАО «РОСКОММУНЭНЕРГО» от 12 марта 2012 года «О расчетах и обосновании проектов нормативов удельного расхода топлива на отпущенную тепловую энергию от отопительных (производственно-отопительных) котельных»;</span></p>
<p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">6) Приказ Министерства энергетики РФ от 30 декабря 2008 года № 325 «Об утверждении порядка определения нормативов технологических потерь при передаче тепловой энергии, теплоносителя» в редакции Приказа Минэнерго России от 10 августа 2012 года № 377;</span></p>
<p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">7) Информационное письмо Департамента государственной энергетической политики и энергоэффективности Минэнерго России от 28 декабря 2009 года «О повышении качества подготовки расчетов и обоснования нормативов технологических потерь при передаче тепловой энергии»;</span></p>
<p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">8) СП 131.13330.2020 «СНиП 23-01-99 Строительная климатология»;</span></p>
<p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">9) МДК 4-05.2004. Методика определения потребности в топливе, электрической энергии и воде при производстве и передаче тепловой энергии и теплоносителей в системах коммунального теплоснабжения. Утверждена заместителем председателя Госстроя России 12.08.03 г.;</span></p>
<p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">10) Приказ Минэнерго РФ от 24 марта 2003 г. N 115 «Об утверждении Правил технической эксплуатации тепловых энергоустановок»;</span></p>
<p style="text-indent: 35.4pt; line-height: 18pt;"><span style="font-size: 14pt;">11) Совокупность приказов Министерства строительства и жилищно-коммунального хозяйства РФ относительно определения нормативов потерь воды.</span></p>`)

        this.pe.mehanizmmoncp=`<p style="text-indent: 35.4pt; line-height: 18pt;"><span style="letter-spacing: 0.1px; text-indent: 56.7333px;">Механизмы мониторинга и контроля за исполнением целевых показателей программы носят ежеквартальный характер: данные фактических квартальных калькуляций по регулируемому виду деятельности сопоставляются с целевыми показателями программы энергосбережения в части объёмов ресурсов и затрат в денежном выражении. Ежегодный отчёт о фактическом исполнении программы энергосбережении направляется Регулятору в установленные нормативно-правовыми актами сроки.</span><br></p>`


        this.pe.mehanizmmonkpr=`<p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Механизмы мониторинга и контроля за исполнением КПР носят ежеквартальный характер: данные фактических квартальных калькуляций по регулируемому виду деятельности сопоставляются с целевыми показателями программы энергосбережения в части объёмов ресурсов и затрат в денежном выражении. Ежегодный отчёт о фактическом исполнении программы энергосбережении направляется Регулятору в установленные нормативно-правовыми актами сроки.<o:p></o:p></span></p>`

        this.pe.perechenmertext=`<p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Сведения представлены в разделе «Технико-экономические расчёты по мероприятиям программы».<o:p></o:p></span></p>`

        this.pe.uviazkazp=`<p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Данные сведения учитываются в работе при начислении премий согласно трудовым договорам и должностным инструкциям, которые, в свою очередь, не являются публичными документами, содержат персональные данные, являются предметом коммерческой тайны.<o:p></o:p></span></p>`

        this.pe.raspredcp=`<p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Сведения представлены в разделе «Целевые и прочие показатели программы энергосбережения и повышения энергетической эффективности», «Баланс целевых и прочих показателей программы».<o:p></o:p></span></p>`

        this.pe.factcelevgod=`<p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Сведения представлены в разделе «Целевые и прочие показатели программы энергосбережения и повышения энергетической эффективности», «Баланс целевых и прочих показателей программы».<o:p></o:p></span></p>`

        this.pe.izmresmotor=`<p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Автотранспорт и спецтехника является объектом подряда (используется на договорной основе в составе услуг сторонних организаций).<o:p></o:p></span></p>`

        this.pe.izmreshoz=`<p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Информация об изменении расхода энергетических ресурсов на хозяйственные нужды в натуральном и денежном выражении по годам периода действия программы может быть приведена в документах: «Целевые и прочие показатели программы энергосбережения» (в натуральном/удельном и относительном (долевом) выражении); &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; «Перечень мероприятий, основной целью которых является энергосбережение и (или) повышение энергетической эффективности» (в натуральном и денежном выражении); «Технико-экономические расчёты по мероприятиям программы», в натуральном, денежном выражении, включая детализированные расчёты и обоснование.<o:p></o:p></span></p><p style="text-indent: 42.55pt; line-height: 18pt;"> </p><p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Отсутствие информации по данным показателям означает тот факт, что расходование энергоресурсов на нерегулируемые виды деятельности может не освещаться в программе энергосбережения по причинам, изложенным в разделе «Правовая и иная информация».<o:p></o:p></span></p>`

        this.pe.izmpoter=`<p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Сведения представлены в разделах «Основные формы программы энергосбережения», «Технико-экономические расчёты по мероприятиям программы», «Балансы топливно-энергетических ресурсов», «Баланс целевых и прочих показателей программы».<o:p></o:p></span></p>`

        this.pe.ekonompokaz=`<p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Сведения, в том числе, и затраты организации на программу в натуральном выражении, затраты организации на программу в процентном выражении от инвестиционной программы, источники финансирования программы как на весь период действия, так и по годам – представлены в разделе «Технико-экономические расчёты по мероприятиям программы».<o:p></o:p></span></p>`

        this.pe.sravnenie=`<p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Поиск в ГИС «Энергоэффективность» произведён, предприятий-аналогов не найдено.<o:p></o:p></span></p>`

        this.pe.rezultee=`Сведения представлены в разделе «Отчёты по энергосбережению».`

        this.pe.teksost=`<p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Предприятие соблюдает правила технической эксплуатации объектов инфраструктуры. Все регламентные мероприятия, в том числе, ремонтные, проводятся своевременно. <o:p></o:p></span></p><p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Данные фактических квартальных калькуляций по регулируемому виду деятельности сопоставляются с целевыми показателями программы энергосбережения в части объёмов ресурсов и затрат в денежном выражении: таким образом отслеживаются наиболее эффективные мероприятия. Ежегодный отчёт о фактическом исполнении программы энергосбережении направляется Регулятору в установленные нормативно-правовыми актами сроки.<o:p></o:p></span></p><p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Ежегодно и в срок Регулятору направляются заявления об установлении технологических нормативов (при необходимости).<o:p></o:p></span></p><p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Рабочие и специалисты получают инструктаж об энергосбережении в работе в соответствии с должностными инструкциями.<o:p></o:p></span></p><p style="text-indent: 42.55pt; line-height: 18pt;"> </p><p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Ежегодно, в том числе и на текущий момент, предприятие имеет утверждённую и согласованную программу энергосбережения и повышения энергоэффективности.<o:p></o:p></span></p>`

        this.pe.resursporteb=`<p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Сведения представлены в разделе «Балансы топливно-энергетических ресурсов».<o:p></o:p></span></p>`

        this.pe.tochkihoz=`<p style="text-indent: 42.55pt;">Таблица. Сведения о количестве точек поставки<o:p></o:p></p> <div align="center"> <table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="524" style="width:393.1pt;border-collapse:collapse;mso-yfti-tbllook:1184; mso-padding-alt:0cm 5.4pt 0cm 5.4pt"> <tbody><tr style="mso-yfti-irow:0;mso-yfti-firstrow:yes;height:1.0pt"> <td width="208" nowrap="" style="width: 155.7pt; border: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><b>Ресурс<o:p></o:p></b></p> </td> <td width="151" style="width: 4cm; border-top: 1pt solid windowtext; border-right: 1pt solid windowtext; border-bottom: 1pt solid windowtext; border-image: initial; border-left: none; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><b>Количество точек поставки<o:p></o:p></b></p> </td> <td width="165" style="width: 124pt; border-top: 1pt solid windowtext; border-right: 1pt solid windowtext; border-bottom: 1pt solid windowtext; border-image: initial; border-left: none; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><b>В том числе, оснащено прибором учёта<o:p></o:p></b></p> </td> </tr> <tr style="mso-yfti-irow:1;height:1.0pt"> <td width="208" nowrap="" style="width: 155.7pt; border-right: 1pt solid windowtext; border-bottom: 1pt solid windowtext; border-left: 1pt solid windowtext; border-image: initial; border-top: none; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center">электроэнергия<o:p></o:p></p> </td> <td width="151" nowrap="" style="width: 4cm; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center">0<o:p></o:p></p> </td> <td width="165" nowrap="" style="width: 124pt; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center">0<o:p></o:p></p> </td> </tr> <tr style="mso-yfti-irow:2;height:1.0pt"> <td width="208" nowrap="" style="width: 155.7pt; border-right: 1pt solid windowtext; border-bottom: 1pt solid windowtext; border-left: 1pt solid windowtext; border-image: initial; border-top: none; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center">тепловая энергия<o:p></o:p></p> </td> <td width="151" nowrap="" style="width: 4cm; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center">0<o:p></o:p></p> </td> <td width="165" nowrap="" style="width: 124pt; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center">0<o:p></o:p></p> </td> </tr> <tr style="mso-yfti-irow:3;height:1.0pt"> <td width="208" nowrap="" style="width: 155.7pt; border-right: 1pt solid windowtext; border-bottom: 1pt solid windowtext; border-left: 1pt solid windowtext; border-image: initial; border-top: none; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center">газ<o:p></o:p></p> </td> <td width="151" nowrap="" style="width: 4cm; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center">0<o:p></o:p></p> </td> <td width="165" nowrap="" style="width: 124pt; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center">0<o:p></o:p></p> </td> </tr> <tr style="mso-yfti-irow:4;height:1.0pt"> <td width="208" nowrap="" style="width: 155.7pt; border-right: 1pt solid windowtext; border-bottom: 1pt solid windowtext; border-left: 1pt solid windowtext; border-image: initial; border-top: none; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center">холодное водоснабжение<o:p></o:p></p> </td> <td width="151" nowrap="" style="width: 4cm; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center">0<o:p></o:p></p> </td> <td width="165" nowrap="" style="width: 124pt; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center">0<o:p></o:p></p> </td> </tr> <tr style="mso-yfti-irow:5;mso-yfti-lastrow:yes;height:1.0pt"> <td width="208" nowrap="" style="width: 155.7pt; border-right: 1pt solid windowtext; border-bottom: 1pt solid windowtext; border-left: 1pt solid windowtext; border-image: initial; border-top: none; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center">горячее водоснабжение<o:p></o:p></p> </td> <td width="151" nowrap="" style="width: 4cm; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center">0<o:p></o:p></p> </td> <td width="165" nowrap="" style="width: 124pt; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center">0<o:p></o:p></p> </td> </tr> </tbody></table> </div>`

        this.pe.tochkiee=`<p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Точек оснащено приборами учёта- 0 шт.<o:p></o:p></span></p> <p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Точек оснащено автоматизированной информационной измерительной системой 0 шт.<o:p></o:p></span></p> <p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Точек не оснащено либо оснащено с нарушением требований нормативной технической документации 0 шт.<o:p></o:p></span></p>`

        this.pe.transport=`<p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Автотранспорт и спецтехника является объектом подряда (используется на договорной основе в составе услуг сторонних организаций).<o:p></o:p></span></p>`

        this.pe.admzd=`<p style="text-indent: 42.55pt; line-height: 18pt;"><span style="font-size: 14pt;">Таблица. Сведения о наличии зданий административного и административно-производственного назначения<o:p></o:p></span></p> <div align="center"> <table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="89%" style="width:89.78%;border-collapse:collapse;mso-yfti-tbllook:1184;mso-padding-alt: 0cm 5.4pt 0cm 5.4pt"> <thead> <tr style="mso-yfti-irow:0;mso-yfti-firstrow:yes;height:1.0pt"> <td width="50%" style="width: 50.78%; border: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><b>Месторасположение (наименование)<o:p></o:p></b></p> </td> <td width="14%" style="width: 14.34%; border-top: 1pt solid windowtext; border-right: 1pt solid windowtext; border-bottom: 1pt solid windowtext; border-image: initial; border-left: none; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><b>Общая площадь, м2</b><b><o:p></o:p></b></p> </td> <td width="12%" style="width: 12.92%; border-top: 1pt solid windowtext; border-right: 1pt solid windowtext; border-bottom: 1pt solid windowtext; border-image: initial; border-left: none; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><b>Объём всего, м3</b><b><o:p></o:p></b></p> </td> <td width="21%" style="width: 21.96%; border-top: 1pt solid windowtext; border-right: 1pt solid windowtext; border-bottom: 1pt solid windowtext; border-image: initial; border-left: none; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><b>Отапливаемый объём, м3</b><b><o:p></o:p></b></p> </td> </tr> </thead> <tbody><tr style="mso-yfti-irow:1;height:1.0pt"> <td width="50%" nowrap="" valign="bottom" style="width: 50.78%; border-right: 1pt solid windowtext; border-bottom: 1pt solid windowtext; border-left: 1pt solid windowtext; border-image: initial; border-top: none; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal"><o:p>&nbsp;</o:p></p> </td> <td width="14%" nowrap="" valign="bottom" style="width:14.34%;border-top:none; border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt; mso-border-bottom-alt:solid windowtext .5pt;mso-border-right-alt:solid windowtext .5pt; padding:0cm 5.4pt 0cm 5.4pt;height:1.0pt"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> <td width="12%" style="width: 12.92%; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> <td width="21%" style="width: 21.96%; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> </tr> <tr style="mso-yfti-irow:2;height:1.0pt"> <td width="50%" nowrap="" valign="bottom" style="width: 50.78%; border-right: 1pt solid windowtext; border-bottom: 1pt solid windowtext; border-left: 1pt solid windowtext; border-image: initial; border-top: none; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal"><o:p>&nbsp;</o:p></p> </td> <td width="14%" nowrap="" valign="bottom" style="width: 14.34%; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> <td width="12%" style="width: 12.92%; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> <td width="21%" style="width: 21.96%; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> </tr> <tr style="mso-yfti-irow:3;height:1.0pt"> <td width="50%" nowrap="" valign="bottom" style="width: 50.78%; border-right: 1pt solid windowtext; border-bottom: 1pt solid windowtext; border-left: 1pt solid windowtext; border-image: initial; border-top: none; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal"><o:p>&nbsp;</o:p></p> </td> <td width="14%" nowrap="" valign="bottom" style="width: 14.34%; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> <td width="12%" style="width: 12.92%; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> <td width="21%" style="width: 21.96%; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> </tr> <tr style="mso-yfti-irow:4;height:1.0pt"> <td width="50%" nowrap="" valign="bottom" style="width: 50.78%; border-right: 1pt solid windowtext; border-bottom: 1pt solid windowtext; border-left: 1pt solid windowtext; border-image: initial; border-top: none; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal"><o:p>&nbsp;</o:p></p> </td> <td width="14%" nowrap="" valign="bottom" style="width: 14.34%; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> <td width="12%" style="width: 12.92%; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> <td width="21%" style="width: 21.96%; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> </tr> <tr style="mso-yfti-irow:5;height:1.0pt"> <td width="50%" nowrap="" valign="bottom" style="width:50.78%;border:solid windowtext 1.0pt; border-top:none;mso-border-left-alt:solid windowtext .5pt;mso-border-bottom-alt: solid windowtext .5pt;mso-border-right-alt:solid windowtext .5pt;padding: 0cm 5.4pt 0cm 5.4pt;height:1.0pt"> <p class="MsoNormal"><o:p>&nbsp;</o:p></p> </td> <td width="14%" nowrap="" valign="bottom" style="width:14.34%;border-top:none; border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt; mso-border-bottom-alt:solid windowtext .5pt;mso-border-right-alt:solid windowtext .5pt; padding:0cm 5.4pt 0cm 5.4pt;height:1.0pt"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> <td width="12%" style="width: 12.92%; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> <td width="21%" style="width: 21.96%; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> </tr> <tr style="mso-yfti-irow:6;height:1.0pt"> <td width="50%" nowrap="" valign="bottom" style="width:50.78%;border:solid windowtext 1.0pt; border-top:none;mso-border-left-alt:solid windowtext .5pt;mso-border-bottom-alt: solid windowtext .5pt;mso-border-right-alt:solid windowtext .5pt;padding: 0cm 5.4pt 0cm 5.4pt;height:1.0pt"> <p class="MsoNormal"><o:p>&nbsp;</o:p></p> </td> <td width="14%" nowrap="" valign="bottom" style="width:14.34%;border-top:none; border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt; mso-border-bottom-alt:solid windowtext .5pt;mso-border-right-alt:solid windowtext .5pt; padding:0cm 5.4pt 0cm 5.4pt;height:1.0pt"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> <td width="12%" style="width: 12.92%; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> <td width="21%" style="width: 21.96%; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> </tr> <tr style="mso-yfti-irow:7;height:1.0pt"> <td width="50%" nowrap="" valign="bottom" style="width:50.78%;border:solid windowtext 1.0pt; border-top:none;mso-border-left-alt:solid windowtext .5pt;mso-border-bottom-alt: solid windowtext .5pt;mso-border-right-alt:solid windowtext .5pt;padding: 0cm 5.4pt 0cm 5.4pt;height:1.0pt"> <p class="MsoNormal"><o:p>&nbsp;</o:p></p> </td> <td width="14%" nowrap="" valign="bottom" style="width:14.34%;border-top:none; border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt; mso-border-bottom-alt:solid windowtext .5pt;mso-border-right-alt:solid windowtext .5pt; padding:0cm 5.4pt 0cm 5.4pt;height:1.0pt"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> <td width="12%" style="width: 12.92%; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> <td width="21%" style="width: 21.96%; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> </tr> <tr style="mso-yfti-irow:8;height:1.0pt"> <td width="50%" valign="bottom" style="width:50.78%;border:solid windowtext 1.0pt; border-top:none;mso-border-left-alt:solid windowtext .5pt;mso-border-bottom-alt: solid windowtext .5pt;mso-border-right-alt:solid windowtext .5pt;padding: 0cm 5.4pt 0cm 5.4pt;height:1.0pt"> <p class="MsoNormal"><o:p>&nbsp;</o:p></p> </td> <td width="14%" nowrap="" valign="bottom" style="width:14.34%;border-top:none; border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt; mso-border-bottom-alt:solid windowtext .5pt;mso-border-right-alt:solid windowtext .5pt; padding:0cm 5.4pt 0cm 5.4pt;height:1.0pt"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> <td width="12%" style="width: 12.92%; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> <td width="21%" style="width: 21.96%; border-top: none; border-left: none; border-bottom: 1pt solid windowtext; border-right: 1pt solid windowtext; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 0cm 5.4pt; height: 1pt;"> <p class="MsoNormal" align="center" style="text-align:center"><o:p>&nbsp;</o:p></p> </td> </tr> <tr style="mso-yfti-irow:9;mso-yfti-lastrow:yes;height:1.0pt"> <td width="50%" nowrap="" valign="bottom" style="width:50.78%;border:solid windowtext 1.0pt; border-top:none;mso-border-left-alt:solid windowtext .5pt;mso-border-bottom-alt: solid windowtext .5pt;mso-border-right-alt:solid windowtext .5pt;background: #D9D9D9;padding:0cm 5.4pt 0cm 5.4pt;height:1.0pt"> <p class="MsoNormal"><b>&nbsp;</b></p> </td> <td width="14%" nowrap="" valign="bottom" style="width:14.34%;border-top:none; border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt; mso-border-bottom-alt:solid windowtext .5pt;mso-border-right-alt:solid windowtext .5pt; background:#D9D9D9;padding:0cm 5.4pt 0cm 5.4pt;height:1.0pt"> <p class="MsoNormal" align="center" style="text-align:center"><b>&nbsp;</b></p> </td> <td width="12%" nowrap="" valign="bottom" style="width:12.92%;border-top:none; border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt; mso-border-bottom-alt:solid windowtext .5pt;mso-border-right-alt:solid windowtext .5pt; background:#D9D9D9;padding:0cm 5.4pt 0cm 5.4pt;height:1.0pt"> <p class="MsoNormal" align="center" style="text-align:center"><b>&nbsp;</b></p> </td> <td width="21%" nowrap="" valign="bottom" style="width:21.96%;border-top:none; border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt; mso-border-bottom-alt:solid windowtext .5pt;mso-border-right-alt:solid windowtext .5pt; background:#D9D9D9;padding:0cm 5.4pt 0cm 5.4pt;height:1.0pt"> <p class="MsoNormal" align="center" style="text-align:center"><b>&nbsp;</b></p> </td> </tr> </tbody></table> </div>`

        this.pe.admzd = this.pe.admzd.replace('<p class="MsoNormal"><o:p>&nbsp;</o:p></p>', '<p class="MsoNormal">Нет таких зданий</p>')

        this.pe.kratk_har_vd=``
    },

    fontsizetopl()
    {
      let rez=7
      let yearcount=this.pe.god_do-this.pe.god_ot
      if (yearcount<=5)
      {
        rez=12
      }
      else
      {
        if (yearcount<8)
        {
          rez=9
        }
        else {
          rez=7
        }
      }
      return rez;
    },
    fontsizecpp()
    {
      let rez=7
      let yearcount=this.pe.god_do-this.pe.god_ot
      if (yearcount<=5)
      {
        rez=9
      }
      else
      {
        if (yearcount<8)
        {
          rez=8
        }
        else {
          rez=7
        }
      }
      return rez;
    },


    tablenum(num)
    {
      let rez=''
      if (num)
      {
        this.table_nomer=num;
        rez='';
        }
      else
      {
        this.table_nomer=this.table_nomer+1
        rez=this.table_nomer
      }
      return rez
    },


    peperiodtext()
    {
      let rez=''
      if (this.pe.god_do!=this.pe.god_ot)
      {
        rez=this.pe.god_ot+' - '+this.pe.god_do+ ' годы'
      }
      else
      {
        rez=this.pe.god_ot+' год'
      }
      return rez
    },

    total_mer(field,index,dec=2)
    {
      let rez=0;
      try {

        this.pe.mer.forEach(merop=>{
          merop.ter.forEach(topl=>{
            rez=rez+Number(topl[field][index])
          })
        })
        if (dec>0)
        {rez=this.decimal(rez,dec)}



      }
      catch
  {
        //
      }
      return rez

    },

    end_effect_god_index(merop)
    {
      //Год начала эффекта
      let start_effect_god=Number(merop.start_god)-Number(this.pe.fact_god)
      let end_effect_god=start_effect_god
      let delta=0
      if (Math.ceil(merop.disk_srok_okup)==0)
      {delta=1}

      //Год конец эффекта
      switch ( merop.period_effect ) {
        case 'На период окупаемости':
          end_effect_god=delta+Math.ceil(merop.disk_srok_okup)+start_effect_god-1;
          break;
        case 'На период окупаемости и ещё два года':
          end_effect_god=Math.ceil(merop.disk_srok_okup)+start_effect_god-1+2;
          break;
        case 'На период срока амортизации':
          end_effect_god=Math.ceil(merop.amort)+start_effect_god-1;
          break;
          //По значениям в таблицах
        default:
          end_effect_god=this.yearsprognoz.length-1;
          break;
      }

      return end_effect_god
    },


    Export2Word(element, filename = ''){
      var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' " +
          "xmlns='http://www.w3.org/TR/REC-html40'>" +
          "<head><meta charset='utf-8'><title>Export HTML To Doc</title>" +
          "<style>@page WordSection2\n" +
          "\t{size:595.3pt 841.9pt;\n" +
          "\tmargin:2.0cm 2.0cm 2.0cm 2.0cm;\n" +
          "\tmso-header-margin:5pt;\n" +
          "\tmso-footer-margin:5pt;\n" +
          "\tmso-paper-source:0;}\n" +
          "div.WordSection2\n" +
          "\t{page:WordSection2;}\n" +
          "@page WordSection1\n" +
          "\t{size:841.9pt 595.3pt;\n" +
          "\tmso-page-orientation:landscape;\n" +
          "\ttmargin:2.0cm 2.0cm 2.0cm 2.0cm;\n" +
          "\tmso-header-margin:5pt;\n" +
          "\tmso-footer-margin:5pt;\n" +
          "\tmso-paper-source:0;}\n" +
          "div.WordSection1\n" +
          "\t{page:WordSection1;}" +
          "@page WordSection5\n" +
          "\t{size:1190.4pt 842.0pt;\n" +
          "\tmso-page-orientation:landscape;\n" +
          "\tmargin:2.0cm 2.0cm 2.0cm 2.0cm;\n" +
          "\tmso-header-margin:36.0pt;\n" +
          "\tmso-footer-margin:36.0pt;\n" +
          "\tmso-paper-source:0;}\n" +
          "div.WordSection5\n" +
          "\t{page:WordSection5;}</style>"+
          ' <meta charset="UTF-8">  <meta name="viewport" content="width=device-width, initial-scale=1.0"><meta name="Word.Document" content="Word.Document"><meta name="Word.TOC" content="1"><meta name="Word.PageNumbers" content="1"></head><body>';



      var postHtml =    '</body></html>';
      var html = preHtml+document.getElementById(element).innerHTML+postHtml;
      html=html.replace(/BREAKKK/g,"<span style='font-size:12.0pt;font-family:\"Times New Roman\",serif;mso-fareast-font-family:\n" +
          "\"Times New Roman\";mso-ansi-language:RU;mso-fareast-language:RU;mso-bidi-language:\n" +
          "AR-SA'><br clear=all style='page-break-before:always;mso-break-type:section-break'>\n" +
          "</span>")
      html=html.replace(/ROT90/gui,"style='mso-rotate:90'");
      var blob = new Blob(['\ufeff', html], {
        type: 'application/msword'
      });



      // Specify link url
      var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);

      // Specify file name
      filename = filename?filename+'.doc':'document.doc';

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if(navigator.msSaveOrOpenBlob ){
        navigator.msSaveOrOpenBlob(blob, filename);
      }else{
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },

    printing()
    {

      // get the printContainer element
      const printContainer = document.getElementById('printContainer');

// get the outerHTML of the element
      const html = printContainer.outerHTML;

// create a download link
      const link = document.createElement('a');
      link.setAttribute('href', 'data:text/doc;charset=utf-8,' + encodeURIComponent(html));
      link.setAttribute('download', 'printContainer.doc');
      link.style.display = 'none';

// add the link to the DOM and trigger the download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    showallmer()
    {
      this.pe.mer.forEach(x=>{
        x.edit=true
      })
    },
    closeallmer(){
      this.pe.mer.forEach(x=>{
        x.edit=false
      })
    },

    showallter()
    {
      this.pe.ter.forEach(x=>{
        x.edit=true
      })
    },
    closeallter(){
      this.pe.ter.forEach(x=>{
        x.edit=false
      })
    },

    IRRCalc(CArray,zatrarray) {

      let min = 0.000;
      let  max = 1000.0;
      let guest = (min + max) / 2;
      let NPV = 0;
      let step=0

      do {
        step++
        guest = (min + max) / 2;
        NPV = 0;
        for (var j=0; j<CArray.length; j++) {
          NPV += (CArray[j]/Math.pow((1+guest),(j+1)))-zatrarray[j];
        }
        if (NPV > 0) {
          min = guest;
        }
        else {
          max = guest;
        }
        window.console.log(NPV+'///'+guest * 100)
      } while(Math.abs(NPV) > 0.0001 && step<50);
      return guest * 100;
    },
    decimal(item,decimal=2)
    {
      let rez=''
      try {
        rez=Number(item).toLocaleString('ru-ru',{ minimumFractionDigits: Number(decimal),maximumFractionDigits: Number(decimal) })
        if (isNaN(+item) || !Number.isFinite(+item))
        {
          rez='--'
        }


      }
      catch {
        rez="ошибка!"
      }
      return rez
    },

    cleandonachala(merop)
    {

      for (let i = 0; i < merop.start_god-this.pe.fact_god; i++) {
        merop.zatrati_plan[i]='0'
        merop.zatrati_fact[i]='0'
        merop.cf[i]='0'
        merop.dcf[i]='0'
        merop.chddarray[i]='0'
        merop.ter.forEach((item)=>{
          item.delta_volume_plan[i]='0'
          item.delta_volume_fact[i]='0'
          item.tut_plan[i]='0'
          item.delta_rub_plan[i]='0'
          item.tut_fact[i]='0'
          item.delta_rub_fact[i]='0'
          item.delta_volume_plan_formula[i]='0'
          item.delta_volume_fact_formula[i]='0'
        })
        merop.cp.forEach((item)=>{
          item.delta_plan[i]='0'
          item.delta_fact[i]='0'
          item.delta_plan_formula[i]='0'
          item.delta_fact_formula[i]='0'
        })
      }
    },


    addtermer(item)
    {
      item.ter.push({
        name:'',
        delta_volume_plan:(new Array(this.yearsprognoz.length)).fill('0'),
        delta_volume_fact:(new Array(this.yearsprognoz.length)).fill('0'),
        delta_volume_plan_formula:(new Array(this.yearsprognoz.length)).fill('0'),
        delta_volume_fact_formula:(new Array(this.yearsprognoz.length)).fill('0'),
        delta_rub_plan:(new Array(this.yearsprognoz.length)).fill('0'),
        delta_rub_fact:(new Array(this.yearsprognoz.length)).fill('0'),
        price_plan:(new Array(this.yearsprognoz.length)).fill('0'),
        price_fact:(new Array(this.yearsprognoz.length)).fill('0'),
        tut_plan:(new Array(this.yearsprognoz.length)).fill('0'),
        tut_fact:(new Array(this.yearsprognoz.length)).fill('0'),

        total_delta_volume_plan:(new Array(this.yearsprognoz.length)).fill('0'),
        total_delta_volume_fact:(new Array(this.yearsprognoz.length)).fill('0'),
        total_delta_rub_plan:(new Array(this.yearsprognoz.length)).fill('0'),
        total_delta_rub_fact:(new Array(this.yearsprognoz.length)).fill('0'),
        total_tut_plan:(new Array(this.yearsprognoz.length)).fill('0'),
        total_tut_fact:(new Array(this.yearsprognoz.length)).fill('0')

    })

  },


  setgodotcheta()
  {
    if ((this.pe.god_otcheta=='') || !('god_otcheta' in self.pe))
    {
          Vue.set(this.pe,'god_otcheta',Math.max(this.pe.god_ot,new Date().getFullYear()-1));
    }


  },

  planfact()
  {

    this.showwordreport=false;

    this.pe.celev.forEach((item,i) => {



      Vue.set(this.pe.celev[i].formula_fact,0,this.pe.celev[i].formula_plan[0]);
      this.autofillplan(true,this.pe.celev[i].formula_fact,0,this.pe.god_otcheta-this.pe.fact_god,this.pe.celev[i].formula_fact[0]);
      this.autofillplan(true,this.pe.celev[i].value_fact,0,this.pe.god_otcheta-this.pe.fact_god,this.pe.celev[i].value_fact[0]);

    });

    this.pe.mer.forEach((item,i) => {

      for (var j = this.pe.god_ot-this.pe.fact_god; j <= this.pe.god_otcheta-this.pe.fact_god; j++) {

        Vue.set(this.pe.mer[i].zatrati_fact,j,this.pe.mer[i].zatrati_plan[j]);
        this.pe.mer[i].cp.forEach((item, k) => {

          Vue.set(this.pe.mer[i].cp[k].delta_fact,j,this.pe.mer[i].cp[k].delta_plan[j]);


        });

        this.pe.mer[i].ter.forEach((item, m) => {

          Vue.set(this.pe.mer[i].ter[m].delta_volume_fact,j,this.pe.mer[i].ter[m].delta_volume_plan[j]);


        });

      }

    });





    this.oktext="Выполнение показателей заполнено до " + this.pe.god_otcheta+" года. \r\n Внесите факт по ТЭР.";
    this.snackbarOK = true;

  },

  addmermaster()
  {

    this.pe.mastermermassiv.push({god:this.pe.god_ot, name:'',obj:'',sum:'',tempmer:'',tempsmeta:'' })
    this.pe.trigger=this.pe.trigger++;
  },
    addcppmer(item)
    {
      item.cp.push({
        name:this.pe.celev[0].name,
        delta_plan:(new Array(this.yearsprognoz.length)).fill('0'),
        delta_fact:(new Array(this.yearsprognoz.length)).fill('0'),
        delta_plan_formula:(new Array(this.yearsprognoz.length)).fill('0'),
        delta_fact_formula:(new Array(this.yearsprognoz.length)).fill('0'),

      })
    },
    addmer()
    {
      //let yearcount = this.pe.god_do - this.pe.god_ot + 1 + this.pe.god_ot - this.pe.fact_god;

      this.pe.mer.push({
            name:'Наименование мероприятия',
            object:'',
            discont:this.pe.discont,
            istochnik:'',
            statia:'',
            amort:'',
            period_effect:'На период окупаемости',
            start_god: this.pe.god_ot,
            summa_zatrat:'',
            edit:false,
            dolya_invest:'',
            obosnovanie_doc:'',
            cf:(new Array(this.yearsprognoz.length)).fill('0'),
            dcf:(new Array(this.yearsprognoz.length)).fill('0'),
            chddarray:(new Array(this.yearsprognoz.length)).fill('0'),
            dohodarray:(new Array(this.yearsprognoz.length)).fill('0'),
            technologii:'',
            sohr_effecta:'',
            cp:[],
            ter:[],
            zatrati_plan: (new Array(this.yearsprognoz.length)).fill('0'),
            zatrati_fact: (new Array(this.yearsprognoz.length)).fill('0'),
            srok_okup:'',
            disk_srok_okup:'',
            chdd:'',
            vnd:'',
            raschet:[]


          })
    },

    editformula(item,znach)
    {
      this.log(item)


      switch ( znach ) {
        case 'БазЗнач+ЭффектПЭ':
          item='=БазЗнач[ТекГод]+ЭффектПЭ[ТекГод]';
          break;
        case '+ БазЗнач':
          item= item+'+БазЗнач[ТекГод]';
          break;
        case '+ ЭффектПЭ':
          item= item+'+ЭффектПЭ[ТекГод]';
          break;
        case 'Очистить':
          item= '0';
          break;
        default:
          item= item+znach+'[ТекГод]';
          break;
      }
      return item
    },

    removeleadingzero(expression)

    {
      let rez=''
      let i=0
      let buffer=''

      this.log(expression)
      while (i<expression.length)
      {


        if (i>expression.length-2)
        {

          rez=rez+(buffer+expression.substr(i,1)).replace(/^0+(?!$)/,'')

          buffer=''

        }
        else
        {

          if (['+','-','*','/','(',')','^'].indexOf(expression.substr(i,1))<0)
          {

            buffer=buffer+expression.substr(i,1)

          }
          else
          {
            rez=rez+buffer.replace(/^0+(?!$)/,'')+expression.substr(i,1)

            buffer=''
          }


        }



        i=i+1
      }
      this.log(rez+'//ЛЗ')
      return rez
      },



    calcindexes(item)
    {

      let znach=item
      let chislo=0
      let matches=znach.match(/(?<=\[)(.*?)(?=\])/g)

      if (znach.match(/(?<=\[)(.*?)(?=\])/g))
      {
        chislo=znach.match(/(?<=\[)(.*?)(?=\])/g).length
        for (let j = 0; j <= chislo-1; j++)
        {
          znach=znach.replace(matches[j], eval(matches[j]))
        }
      }

      return znach;

    },

    calc_cpp_formula_plan(element,i,index)
    {
      this.log(element.name+':::::')
      let rezultat=0
      let formula = element.formula_plan[i];




      //заменяем знак запятой
      formula=formula.replace(/,/g,".");
      //заменяем знак равенства
      formula=formula.replace(/^=/g,"");
      //заменяем знак $
      formula=formula.replace(/\$/g,"");
      //заменяем %
      formula=formula.replace(/%/g,"*0.01");
      //заменяем пробелы
      formula=formula.replace(/\s/g,"");
      //заменяем ^
      formula=formula.replace(/\^/g,"**");
      //заменяем ТекГод
      formula=formula.replace(/ТекГод/gi,i);
      //считаем индексы
      formula=this.calcindexes(formula);
      //удаляем лидирующие нули
      formula=this.removeleadingzero(formula);

      //считаем ЭффектПЭПлан
      if (formula.match(/(?<=ЭффектПЭ\[)(.*?)(?=\])/gi))
      {

        let matches=formula.match(/ЭффектПЭ(.*?)\]/gi)
        let matches2=formula.match(/(?<=ЭффектПЭ\[)(.*?)(?=\])/gi)
        let repl=''
        let searcher=''
        for (let j = 0; j <= matches2.length-1; j++)
        {
          repl=String(element.effect_plan[Number(matches2[j])]);
          searcher=String(matches[j]);
          formula=formula.replace(searcher,repl );
          this.log(formula);
        }

      }
     /* //считаем ЭффектПЭФакт
      if (formula.match(/(?<=ЭффектПЭФакт\[)(.*?)(?=\])/gi))
      {

        let matches=formula.match(/ЭффектПЭФакт(.*?)\]/gi)
        let matches2=formula.match(/(?<=ЭффектПЭФакт\[)(.*?)(?=\])/gi)
        let repl=''
        let searcher=''
        for (let j = 0; j <= matches2.length-1; j++)
        {
          repl=String(element.effect_fact[Number(matches2[j])]);
          searcher=String(matches[j]);
          formula=formula.replace(searcher,repl );
          this.log(formula);
        }

      }*/
      //считаем БазЗнач
      if (formula.match(/(?<=БазЗнач\[)(.*?)(?=\])/gi))
      {

        let matches=formula.match(/БазЗнач(.*?)\]/gi)
        let matches2=formula.match(/(?<=БазЗнач\[)(.*?)(?=\])/gi)
        let repl=''
        let searcher=''
        for (let j = 0; j <= matches2.length-1; j++)
        {
          repl=String(element.base[Number(matches2[j])]);
          searcher=String(matches[j]);
          formula=formula.replace(searcher,repl );
          this.log(formula);
        }

      }
      this.log(formula);

      //Названия переменных
      let matches=formula.match(/[А-Яа-яёЁ]{1,}(?=\[)/gi);
      //Их Индексы
      let matches2=formula.match(/(?<=\[)(.*?)(?=\])/gi);

      this.log(matches)
      this.log(matches2)


      //[А-Яа-яёЁ](.*?)\] искалка для названия переменной
      //[А-Яа-яёЁ]{1,}(?=\[) все переменные - названия

      if (formula.match(/[А-Яа-яёЁ]{1,}(?=\[)/gi))
      {
        for (let j = 0; j <= matches.length-1; j++) {

          for (let k = 0; k <= this.pe.celev.length-1; k++)
          {
            if (this.pe.celev[k].varname.toLowerCase()==matches[j].toLowerCase())
            {
              let repl=''
              let searcher=''

              repl=this.calc_cpp_formula_plan(this.pe.celev[k], matches2[j],k);
              searcher=String(matches[j])+'['+String(matches2[j])+']';

              this.log(searcher+'*****')
              this.log(repl+'*****')
              formula=formula.replace(searcher, repl);
              this.log(formula);
            }

          }

        }
      }
      this.log(formula+'-----------перед eval');
      try {
        rezultat=eval(formula);
      }
      catch {
        rezultat='ошибка!';
      }

      this.log(rezultat+'/// РЕЗУЛЬТАТ'+this.pe.celev[index].name+'//'+i)
      Vue.set(this.pe.celev[index].value_plan,i, String(rezultat));
      return String(rezultat)

    },




    calc_merop_formula_var(merop_index,element,index_element,god_start_index)
    {
      this.log(element.name+':::::')
      let rezultat=0
      let formula = element.formula;




      //заменяем знак запятой
      formula=formula.replace(/,/g,".");
      //заменяем знак равенства
      formula=formula.replace(/^=/g,"");
      //заменяем знак $
      formula=formula.replace(/\$/g,"");
      //заменяем %
      formula=formula.replace(/%/g,"*0.01");
      //заменяем пробелы
      formula=formula.replace(/\s/g,"");
      //заменяем ^
      formula=formula.replace(/\^/g,"**");
      //удаляем лидирующие нули
      formula=this.removeleadingzero(formula);


      this.log(formula);

      //Названия переменных
      let matches=formula.match(/[А-Яа-яёЁ]{1,}/gi);


      this.log(matches)



      //[А-Яа-яёЁ](.*?)\] искалка для названия переменной
      //[А-Яа-яёЁ]{1,}(?=\[) все переменные - названия


      //По целевым
      if (formula.match(/[А-Яа-яёЁ]{1,}/gi))
      {
        for (let j = 0; j <= matches.length-1; j++) {

          for (let k = 0; k <= this.pe.celev.length-1; k++)
          {
            if (this.pe.celev[k].varname.toLowerCase()==matches[j].toLowerCase())
            {
              let repl=''
              let searcher=''

              repl=this.pe.celev[k].base[god_start_index];
              searcher=String(matches[j]);

              this.log(searcher+'*****')
              this.log(repl+'*****'+god_start_index)
              formula=formula.replace(searcher, repl);
              this.log(formula);
            }

          }

        }
      }

      //По переменным
      if (formula.match(/[А-Яа-яёЁ]{1,}/gi))
      {
        for (let j = 0; j <= matches.length-1; j++) {

          for (let k = 0; k <= this.pe.mer[merop_index].raschet.length-1; k++)
          {
            if (this.pe.mer[merop_index].raschet[k].var.toLowerCase()==matches[j].toLowerCase())
            {
              let repl=''
              let searcher=''

              repl=this.calc_merop_formula_var(merop_index,this.pe.mer[merop_index].raschet[k],k,god_start_index);
              searcher=String(matches[j]);

              this.log(searcher+'*****')
              this.log(repl+'*****'+god_start_index)
              formula=formula.replace(searcher, repl);
              this.log(formula);
            }

          }

        }
      }

      //ПервПК

      matches=formula.match(/ПервПК/gi);

      if (formula.match(/ПервПК/gi)) {
        for (let j = 0; j <= matches.length - 1; j++) {
          let repl = '1'
          let searcher = ''
          for (let k = 0; k <= this.pe.ter.length - 1; k++) {
            if ((this.pe.ter[k].name.toLowerCase().indexOf('вод') == -1) && (this.pe.ter[k].name.toLowerCase().indexOf('электр') == -1) && (this.pe.ter[k].name.toLowerCase().indexOf('тепло') == -1)) {
              repl = this.pe.ter[k].pk_plan[god_start_index]
              k = this.pe.ter.length - 1
            }

          }


          searcher = String(matches[j]);

          this.log(searcher + '*****')
          this.log(repl + '*****' + god_start_index)
          formula = formula.replace(searcher, repl);
          this.log(formula);


        }

      }




      this.log(formula+'-----------перед eval');
      try {
        rezultat=eval(formula);
      }
      catch {
        rezultat='ошибка!';
      }

      this.log(rezultat+'/// РЕЗУЛЬТАТ'+element.name+'//')
      Vue.set(this.pe.mer[merop_index].raschet[index_element],'value', String(rezultat));
      return String(rezultat)

    },

    calc_merop_formula_cpp(merop_index,element,index_element,period)
    {
      this.log(element.name+':::::')
      let rezultat=0
      let formula = element.delta_plan_formula[period];




      //заменяем знак запятой
      formula=formula.replace(/,/g,".");
      //заменяем знак равенства
      formula=formula.replace(/^=/g,"");
      //заменяем знак $
      formula=formula.replace(/\$/g,"");
      //заменяем %
      formula=formula.replace(/%/g,"*0.01");
      //заменяем пробелы
      formula=formula.replace(/\s/g,"");
      //заменяем ^
      formula=formula.replace(/\^/g,"**");
      //удаляем лидирующие нули
      formula=this.removeleadingzero(formula);


      this.log(formula+'перед matches');

      //Названия переменных
      let matches=formula.match(/[А-Яа-яёЁ]{1,}/gi);


      this.log(matches)



      //[А-Яа-яёЁ](.*?)\] искалка для названия переменной
      //[А-Яа-яёЁ]{1,}(?=\[) все переменные - названия




      //По переменным
      if (formula.match(/[А-Яа-яёЁ]{1,}/gi))
      {
        for (let j = 0; j <= matches.length-1; j++) {

          for (let k = 0; k <= this.pe.mer[merop_index].raschet.length-1; k++)
          {
            if (this.pe.mer[merop_index].raschet[k].var.toLowerCase()==matches[j].toLowerCase())
            {
              let repl=''
              let searcher=''

              repl=this.pe.mer[merop_index].raschet[k].value;
              searcher=String(matches[j]);

              this.log(searcher+'****-!-*')
              this.log(repl+'****-!-*')
              formula=formula.replace(searcher, repl);
              this.log(formula);
            }

          }

        }
      }
      this.log(formula+'-----------перед eval');
      try {
        rezultat=eval(formula);
      }
      catch {
        rezultat='ошибка!';
      }

      this.log(rezultat+'/// РЕЗУЛЬТАТ'+element.name+'//')
      Vue.set(this.pe.mer[merop_index].cp[index_element].delta_plan,period, String(rezultat));
      return String(rezultat)

    },


    calc_merop_formula_ter(merop_index,element,index_element,period)
    {
      this.log(element.name+':::::')
      let rezultat=0
      let formula = element.delta_volume_plan_formula[period];




      //заменяем знак запятой
      formula=formula.replace(/,/g,".");
      //заменяем знак равенства
      formula=formula.replace(/^=/g,"");
      //заменяем знак $
      formula=formula.replace(/\$/g,"");
      //заменяем %
      formula=formula.replace(/%/g,"*0.01");
      //заменяем пробелы
      formula=formula.replace(/\s/g,"");
      //заменяем ^
      formula=formula.replace(/\^/g,"**");
      //удаляем лидирующие нули
      formula=this.removeleadingzero(formula);


      this.log(formula);

      //Названия переменных
      let matches=formula.match(/[А-Яа-яёЁ]{1,}/gi);


      this.log(matches)



      //[А-Яа-яёЁ](.*?)\] искалка для названия переменной
      //[А-Яа-яёЁ]{1,}(?=\[) все переменные - названия




      //По переменным
      if (formula.match(/[А-Яа-яёЁ]{1,}/gi))
      {
        for (let j = 0; j <= matches.length-1; j++) {

          for (let k = 0; k <= this.pe.mer[merop_index].raschet.length-1; k++)
          {
            if (this.pe.mer[merop_index].raschet[k].var.toLowerCase()==matches[j].toLowerCase())
            {
              let repl=''
              let searcher=''

              repl=this.pe.mer[merop_index].raschet[k].value;
              searcher=String(matches[j]);

              this.log(searcher+'*****')
              this.log(repl+'*****')
              formula=formula.replace(searcher, repl);
              this.log(formula);
            }

          }

        }
      }
      this.log(formula+'-----------перед eval');
      try {
        rezultat=eval(formula);
      }
      catch {
        rezultat='ошибка!';
      }

      this.log(rezultat+'/// РЕЗУЛЬТАТ'+element.name+'//')
      Vue.set(this.pe.mer[merop_index].ter[index_element].delta_volume_plan,period, String(rezultat));
      return String(rezultat)

    },

    calc_cpp_formula_fact(element,i,index)
    {
      this.log(element.name+':::::')
      let rezultat=0
      let formula = element.formula_fact[i];




      //заменяем знак запятой
      formula=formula.replace(/,/g,".");
      //заменяем знак равенства
      formula=formula.replace(/^=/g,"");
      //заменяем %
      //заменяем знак $
      formula=formula.replace(/\$/g,"");
      formula=formula.replace(/%/g,"*0.01");
      //убираем лидирующие нули
      formula=this.removeleadingzero(formula);
      //заменяем пробелы
      formula=formula.replace(/\s/g,"");
      //заменяем ^
      formula=formula.replace(/\^/g,"**");
      //заменяем ТекГод
      formula=formula.replace(/ТекГод/gi,i);
      //считаем индексы
      formula=this.calcindexes(formula);

     /* //считаем ЭффектПЭПлан
      if (formula.match(/(?<=ЭффектПЭ\[)(.*?)(?=\])/gi))
      {

        let matches=formula.match(/ЭффектПЭ(.*?)\]/gi)
        let matches2=formula.match(/(?<=ЭффектПЭ\[)(.*?)(?=\])/gi)
        let repl=''
        let searcher=''
        for (let j = 0; j <= matches2.length-1; j++)
        {
          repl=String(element.effect_plan[Number(matches2[j])]);
          searcher=String(matches[j]);
          formula=formula.replace(searcher,repl );
          this.log(formula);
        }

      }*/
      //считаем ЭффектПЭФакт
      if (formula.match(/(?<=ЭффектПЭ\[)(.*?)(?=\])/gi))
      {

        let matches=formula.match(/ЭффектПЭ(.*?)\]/gi)
        let matches2=formula.match(/(?<=ЭффектПЭ\[)(.*?)(?=\])/gi)
        let repl=''
        let searcher=''
        for (let j = 0; j <= matches2.length-1; j++)
        {
          repl=String(element.effect_fact[Number(matches2[j])]);
          searcher=String(matches[j]);
          formula=formula.replace(searcher,repl );
          this.log(formula);
        }

      }
      //считаем БазЗнач
      if (formula.match(/(?<=БазЗнач\[)(.*?)(?=\])/gi))
      {

        let matches=formula.match(/БазЗнач(.*?)\]/gi)
        let matches2=formula.match(/(?<=БазЗнач\[)(.*?)(?=\])/gi)
        let repl=''
        let searcher=''
        for (let j = 0; j <= matches2.length-1; j++)
        {
          repl=String(element.base[Number(matches2[j])]);
          searcher=String(matches[j]);
          formula=formula.replace(searcher,repl );
          this.log(formula);
        }

      }
      this.log(formula);

      //Названия переменных
      let matches=formula.match(/[А-Яа-яёЁ]{1,}(?=\[)/gi);
      //Их Индексы
      let matches2=formula.match(/(?<=\[)(.*?)(?=\])/gi);

      this.log(matches)
      this.log(matches2)


      //[А-Яа-яёЁ](.*?)\] искалка для названия переменной
      //[А-Яа-яёЁ]{1,}(?=\[) все переменные - названия

      if (formula.match(/[А-Яа-яёЁ]{1,}(?=\[)/gi))
      {
        for (let j = 0; j <= matches.length-1; j++) {

          for (let k = 0; k <= this.pe.celev.length-1; k++)
          {
            if (this.pe.celev[k].varname.toLowerCase()==matches[j].toLowerCase())
            {
              let repl=''
              let searcher=''

              repl=this.calc_cpp_formula_fact(this.pe.celev[k], matches2[j],k);
              searcher=String(matches[j])+'['+String(matches2[j])+']';

              this.log(searcher+'*****')
              this.log(repl+'*****')
              formula=formula.replace(searcher, repl);
              this.log(formula);
            }

          }

        }
      }
      this.log(formula+'-----------перед eval');
      try {
        rezultat=eval(formula);
      }
      catch {
        rezultat='ошибка!';
      }
      this.log(rezultat+'/// РЕЗУЛЬТАТ'+this.pe.celev[index].name+'//'+i)
      Vue.set(this.pe.celev[index].value_fact,i, String(rezultat));
      return String(rezultat)

    },


    saver () {
      if (this.peReadOnly) return;
      if (this.polling) clearInterval(this.polling);
      this.polling = setInterval(() => {
        this.saveDelo()
      }, 60000)
     },








    saveDelo() {
        var self = this;
        var timer;
        if (this.peReadOnly) {
            self.errtext = 'ПЭ открыта в режиме только чтения';
            self.snackbarErr = true;
            return;
        }
        if (this.kod == 0) {
            window.alert('неизвестный код');
            return;
        }
        Vue.set(self.pe,'trigger',Math.ceil(Math.random()*5+6*Math.random()+10+6*Math.random()));
        axios.post(
                'https://261.рф/SaveDelo',
                JSON.stringify({
                    enter: "123",
                    pe: JSON.stringify(self.pe),
                    kod: self.kod,
                    lock_token: self.peLockToken,
                })
            )
            .then(function(response) {

                if (response.data == "OK") {
                    self.oktext="Программа энергосбережения сохранена успешно"
                    self.snackbarOK = true;
                    timer=new Date();

                    self.lastsavetime= String(timer.getHours()).padStart(2,0)+':'+ String(timer.getMinutes()).padStart(2,0)+':'+ String(timer.getSeconds()).padStart(2,0);
                } else if (response.data == "LOCKED") {
                    self.peReadOnly = true;
                    if (self.polling) {
                        clearInterval(self.polling);
                        self.polling = null;
                    }
                    self.errtext="ПЭ открыта другим пользователем. Включён режим только чтения."
                    self.snackbarErr = true;
                } else {
                    self.errtext="Не удалось сохранить материалы программы"
                    self.snackbarErr = true;
                }

            })

        .catch(function(error) {
            window.console.log(error);
        })
    },

    createsmeta() {
        var self = this;
        axios.post(
                'https://261.рф/NewSMETA',
                JSON.stringify({
                    enter: "123",
                    name:self.nazvsmeta,
                    smeta:self.smeta,
                    dv:self.dv,
                    summa:self.summasmeta,

                })
            )
            .then(function(response) {

                if (response.data == "OK") {
                    self.oktext="ОК"
                    self.snackbarOK = true;



                } else {
                    self.errtext="Не ОК"
                    self.snackbarErr = true;
                }

            })

        .catch(function(error) {
            window.console.log(error);
        })
    },
    createcp() {
        var self = this;
        axios.post(
                'https://261.рф/NewCP',
                JSON.stringify({
                    enter: "123",
                    name:self.nazvcp,
                    model:JSON.stringify(self.pe.celev),


                })
            )
            .then(function(response) {

                if (response.data == "OK") {
                    self.oktext="ОК"
                    self.snackbarOK = true;



                } else {
                    self.errtext="Не ОК"
                    self.snackbarErr = true;
                }

            })

        .catch(function(error) {
            window.console.log(error);
        })
    },

    createmer() {
        var self = this;
        axios.post(
                'https://261.рф/NewMER',
                JSON.stringify({
                    enter: "123",
                    name:self.nazvmer,
                    mer:JSON.stringify(self.pe.mer.find(x=>x.name==self.merselect)),


                })
            )
            .then(function(response) {

                if (response.data == "OK") {
                    self.oktext="ОК"
                    self.snackbarOK = true;



                } else {
                    self.errtext="Не ОК"
                    self.snackbarErr = true;
                }

            })

        .catch(function(error) {
            window.console.log(error);
        })
    },







    autofillplan(autofil, object, index, maxindex, value) {

      if (autofil) {

        for (var i = index + 1; i < maxindex + 1; i++) {

          Vue.set(object, i, value)
          this.log(value)
        }

      }


    },




    addter(item) {
      //let yearcount = this.pe.god_do - this.pe.god_ot + 1 + this.pe.god_ot - this.pe.fact_god;

      this.pe.ter.push({
        name: item.name,
        ed: item.ed,
        autoplan: true,
        pk_plan: new Array(this.yearsprognoz.length).fill(parseFloat(item.per_koef)),
        pk_fact: new Array(this.yearsprognoz.length).fill(parseFloat(item.per_koef)),
        tut_plan_do_mr: new Array(this.yearsprognoz.length).fill(0),
        tut_plan_posle_mer: new Array(this.yearsprognoz.length).fill(0),
        tut_fact: new Array(this.yearsprognoz.length).fill(0),
        rub_plan_do_mer: new Array(this.yearsprognoz.length).fill(0),
        rub_plan_posle_mer: new Array(this.yearsprognoz.length).fill(0),
        rub_fact: new Array(this.yearsprognoz.length).fill(0),
        price: new Array(this.yearsprognoz.length).fill(0),
        edit:false,
        price_fact:new Array(this.yearsprognoz.length).fill(0),
        index: (new Array(this.yearsprognoz.length)).fill(parseFloat(this.pe.inflation)),
        volume_plan_do_mer: new Array(this.yearsprognoz.length).fill(0),
        volume_plan_posle_mer: new Array(this.yearsprognoz.length).fill(0),
        volume_fact: new Array(this.yearsprognoz.length).fill(0),
        economy_volume_plan: new Array(this.yearsprognoz.length).fill(0),
        economy_tut_plan: new Array(this.yearsprognoz.length).fill(0),
        economy_rub_plan: new Array(this.yearsprognoz.length).fill(0),
        economy_volume_fact: new Array(this.yearsprognoz.length).fill(0),
        economy_tut_fact: new Array(this.yearsprognoz.length).fill(0),
        economy_rub_fact: new Array(this.yearsprognoz.length).fill(0),

      })

    },

    addcpp() {
      //let yearcount = this.pe.god_do - this.pe.god_ot + 1 + this.pe.god_ot - this.pe.fact_god;

      this.pe.celev.push({
        name: '',
        ed: '',
        varname:'',
        decimal:'2',
        kind:'Целевой',
        sred_otrasl: '0',
        sred_otrasl_formula:'0',
        best_mir: '0',
        best_mir_formula:'0',
        showinform: true,
        value_plan:new Array(this.yearsprognoz.length).fill('0'),
        value_fact:new Array(this.yearsprognoz.length).fill('0'),
        formula_plan:new Array(this.yearsprognoz.length).fill(this.cpformula_plan?this.cpformula_plan:'=БазЗнач[ТекГод]+ЭффектПЭ[ТекГод]'),
        formula_fact:new Array(this.yearsprognoz.length).fill(this.cpformula_fact?this.cpformula_fact:'=БазЗнач[ТекГод]+ЭффектПЭ[ТекГод]'),
        base:new Array(this.yearsprognoz.length).fill('0'),
        base_formula:new Array(this.yearsprognoz.length).fill('0'),
        effect_plan:new Array(this.yearsprognoz.length).fill('0'),
        effect_fact:new Array(this.yearsprognoz.length).fill('0')

      })

      /*this.pe.celev.push({
        name: this.cpname,
        ed: this.cped,
        varname:this.cpvar,
        decimal:this.cpdecimal,
        kind:this.cppkind,
        sred_otrasl: this.cppsred_otrasl,
        sred_otrasl_formula:'0',
        best_mir: this.cppbest_mir,
        best_mir_formula:'0',
        showinform:this.cpformvisible,
        peinfluence:this.cpmerpe,
        value_plan:new Array(yearcount).fill('0'),
        value_fact:new Array(yearcount).fill('0'),
        formula_plan:new Array(yearcount).fill(this.cpformula_plan?this.cpformula_plan:'0'),
        formula_fact:new Array(yearcount).fill(this.cpformula_fact?this.cpformula_fact:'0'),
        visformulaselector_plan:new Array(yearcount).fill(true),
        visformulaselector_fact:new Array(yearcount).fill(true),
        base:new Array(yearcount).fill(0),
        base_formula:new Array(yearcount).fill('0'),
        effect_plan:new Array(yearcount).fill('5'),
        effect_fact:new Array(yearcount).fill(10)

      })*/

    },

    fillfromegrul() {
      if ('c' in this.egruldata['rows'][0]) { this.pe.org = this.egruldata['rows'][0].c }
      if ('o' in this.egruldata['rows'][0]) { this.pe.ogrn = this.egruldata['rows'][0].o }
      if ('i' in this.egruldata['rows'][0]) { this.pe.inn = this.egruldata['rows'][0].i }
      if ('p' in this.egruldata['rows'][0]) { this.pe.kpp = this.egruldata['rows'][0].p }
      if ('okpo' in this.rosstatdata) { this.pe.okpo = this.rosstatdata.okpo }
      if ('vd' in this.fnsdata) { this.pe.osn_vd = this.fnsdata.vd }

      if ('a' in this.egruldata['rows'][0]) { this.pe.pocht_address = this.egruldata['rows'][0].a }

      this.pe.ruk_sokr = ''
      this.pe.ruk_fio = ''
      this.pe.ruk_dolg = ''


      if ('g' in this.egruldata['rows'][0]) {
        if (this.egruldata['rows'][0].g.indexOf(':') > -1) {

          this.pe.ruk_fio = this.egruldata['rows'][0].g.split(': ')[1];
          this.pe.ruk_sokr = this.sokr_fio_make(this.pe.ruk_fio);
          this.pe.ruk_dolg = this.egruldata['rows'][0].g.split(': ')[0][0].toUpperCase() + this.egruldata['rows'][0].g.split(': ')[0].substr(1).toLowerCase();
        }
      }


    },

    show_pe_vd() {
      let res = [];
      this.VD.forEach((item) => {
        res.push({
          text: item.name,
          value: item.name
        })

      });


      return res;

    },

    show_pe_topl() {
      let res = [];
      this.TOPL.forEach((item) => {
        res.push({
          text: item.name + ' (' + item.ed + ')',
          value: item.name
        })

      });




      return res;

    },

    getVD() {
      var self = this;

      axios.post(
        'https://261.рф/GetVD',
        JSON.stringify({
          enter: "123",
        })
      )
        .then(function(response) {

          self.VD = response.data;


        })

        .catch(function(error) {
          window.console.log(error);
        })
    },
    toplmerinfo(topl)
    {
      let rez=''
      try {
        let f=this.TOPL.find(x=>x.name==topl)
        rez=f.sokr_name+', '+f.ed;
      }
      catch {
        //
      }

      return rez
    },

    getTOPL() {
      var self = this;

      axios.post(
        'https://261.рф/GetTOPL',
        JSON.stringify({
          enter: "123",
        })
      )
        .then(function(response) {

          self.TOPL = response.data;


        })

        .catch(function(error) {
          window.console.log(error);
        })
    },

    sokr_fio_make(value) {
      let zn = value.replace(/(.+) (.).+ (.).+/, '$2.$3. $1');
      return zn;

    },












    exportAsExcel() {
      const format = 'xlsx'
      const exportSelectedOnly = false
      const filename = 'test'
      this.$refs.grid.exportTable(format, exportSelectedOnly, filename)
    },
    exportAsCsv() {
      const format = 'csv'
      const exportSelectedOnly = false
      const filename = 'test'
      this.$refs.grid.exportTable(format, exportSelectedOnly, filename)
    },



    printoutcalendar() {
      //
      // let divToPrint = window.document.getElementById("calendarprint");
      // let newWin = window.open('');
      // newWin.document.write(divToPrint.outerHTML);
      // newWin.print();



      window.setTimeout(() => {
        const prtHtml = document.getElementById('calendarprint').innerHTML;

        // Get all stylesheets HTML
        let stylesHtml = '';

        for (const node of [...document.querySelectorAll('link[rel="stylesheet"]')]) {
          stylesHtml += node.outerHTML;
        }


        // Open the print window

        const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

        WinPrint.document.write(`<!DOCTYPE html>
                <html>
                  <head>
                    ${stylesHtml}
                  </head>
                  <body style="background: rgb(255, 255, 255);">
                    ${prtHtml}
                  </body>
                </html>`);



        WinPrint.document.close();
        WinPrint.focus();

        window.setTimeout(() => { WinPrint.focus(); WinPrint.print() }, 2000)
        this.printvisible = false;
      }, 1000)
      //WinPrint.print();
      //WinPrint.close();



    },

    validateInn(inn, error) {
      var result = false;
      if (typeof inn === 'number') {
        inn = inn.toString();
      } else if (typeof inn !== 'string') {
        inn = '';
      }
      if (!inn.length) {

        error.message = 'ИНН пуст';
      } else if (/[^0-9]/.test(inn)) {

        error.message = 'ИНН может состоять только из цифр';
      } else if ([10, 12].indexOf(inn.length) === -1) {

        error.message = 'ИНН может состоять только из 10 или 12 цифр';
      } else {
        var checkDigit = function(inn, coefficients) {
          var n = 0;
          for (var i in coefficients) {
            n += coefficients[i] * inn[i];
          }
          return parseInt(n % 11 % 10);
        };
        switch (inn.length) {
          case 10:
            var n10 = checkDigit(inn, [2, 4, 10, 3, 5, 9, 4, 6, 8]);
            if (n10 === parseInt(inn[9])) {
              result = true;
            }
            break;
          case 12:
            var n11 = checkDigit(inn, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
            var n12 = checkDigit(inn, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
            if ((n11 === parseInt(inn[10])) && (n12 === parseInt(inn[11]))) {
              result = true;
            }
            break;
        }
        if (!result) {

          error.message = 'Неправильное контрольное число';
        }
      }
      if (result) {
        this.girbozero = false; this.rizero = false; this.egruldata = []; this.mspdata = { 'data': [] }; this.fnsdata = []; this.rosstatdata = []; this.prikazieedata = []; this.full = ''; this.short = ''; this.mo = ''
        this.prikazidata = []; this.RI = [];
        this.egrul();
        this.rosstat();
        this.girbo();
        this.err.message = ""
      }
      else {
        this.err.message = error.message
      }

      return result;
    },

    rosstat() {
      var self = this;
      self.rosstatprogress = true;
      axios.post(
        'https://261.рф/Getrosstat',
        JSON.stringify({
          enter: "123",
          inn: self.inn,
        })
      )
        .then(function(response) {
          if (
            response.data != "ERROR") {
            self.rosstatdata.okpo = response.data;
            self.rosstatprogress = false;

          } else {
            self.rosstatprogress = false;
          }
        })
        .catch(function(error) {
          window.console.log(error);
          self.rosstatprogress = false;
        });
    },


    prikazi() {



      var self = this;
      var short = '--';
      var full = '--';
      var mo = "--";
      self.prikaziprogress = true;

      if (self.short != '') {
        if (self.short.indexOf('"') > -1) {
          short = '«' + self.short.match(/"(.+)"/)[1] + '»'
        }
        else {
          short = '«' + self.short + '»'
        }

      }

      if (self.full != '') {
        if (self.full.indexOf('"') > -1) {
          full = '«' + self.full.match(/"(.+)"/)[1] + '»'
        }
        else {
          full = '«' + self.full + '»'
        }

      }

      if (self.fnsdata.okopf.name.indexOf('Муниц') > -1) {

        if (self.fnsdata.city) {
          mo = self.fnsdata.city.slice(0, -3)
        }
        else {
          mo = self.fnsdata.district.slice(0, -3)
        }



      }

      axios.post(
        'https://calendar.btr-online.ru/prikazi',
        JSON.stringify({
          enter: "123",
          inn: self.inn,
          short: short,
          mo: mo,
          full: full,
        })
      )
        .then(function(response) {
          if (
            response.data != "ERROR") {
            self.prikazidata = response.data;
            self.prikaziprogress = false;

          } else {
            self.prikaziprogress = false;
          }
        })
        .catch(function(error) {
          window.console.log(error);
          self.prikaziprogress = false;
        });
    },
    prikazi2() {



      window.setTimeout(() => {



        var self = this;
        var short = '--';
        var full = '--';
        var mo = '--';

        this.log('prikazi2');
        self.prikaziprogress = true;
        if (self.egruldata) {

          if ((self.egruldata['rows'][0].k == 'fl')) {


            self.short = self.egruldata['rows'][0].n.split(" ")[0].slice(0, -2);
            self.full = self.egruldata['rows'][0].n.split(" ")[1].slice(0, 1) + '.' + self.egruldata['rows'][0].n.split(" ")[2].slice(0, 1) + '.';
            self.prikazi3();
            return;


          }

          else {



            if (self.egruldata['rows'][0].c != '') {
              if (self.egruldata['rows'][0].c.indexOf('"') > -1) {
                short = '«' + self.egruldata['rows'][0].c.match(/"(.+)"/)[1] + '»'
              }
              else {
                short = '«' + self.egruldata['rows'][0].c + '»'
              }

            }

            if (self.egruldata['rows'][0].n != '') {
              if (self.egruldata['rows'][0].n.indexOf('"') > -1) {
                full = '«' + self.egruldata['rows'][0].n.match(/"(.+)"/)[1] + '»'
              }
              else {
                full = '«' + self.egruldata['rows'][0].n + '»'
              }

            }

          }
        }






        axios.post(
          'https://calendar.btr-online.ru/prikazi',
          JSON.stringify({
            enter: "123",
            inn: self.inn,
            short: short,
            mo: mo,
            full: full,

          })
        )
          .then(function(response) {
            if (
              response.data != "ERROR") {
              self.prikazidata = response.data;
              self.prikaziprogress = false;

            } else {
              self.prikaziprogress = false;
            }
          })
          .catch(function(error) {
            window.console.log(error);
            self.prikaziprogress = false;
          });


      }, 3000)


    },

    prikazi3() {
      var self = this;
      self.prikaziprogress = true;

      axios.post(
        'https://calendar.btr-online.ru/prikaziip',
        JSON.stringify({
          enter: "123",
          inn: self.inn,
          short: self.short,
          full: self.full
        })
      )
        .then(function(response) {
          if (
            response.data != "ERROR") {
            self.prikazidata = response.data;
            self.prikaziprogress = false;

          } else {
            self.prikaziprogress = false;
          }
        })
        .catch(function(error) {
          window.console.log(error);
          self.prikaziprogress = false;
        });
    },
    prikaziee() {
      var self = this;
      self.prikaziprogress = true;

      axios.post(
        'https://calendar.btr-online.ru/prikaziee',
        JSON.stringify({
          enter: "123",
          inn: self.inn,

        })
      )
        .then(function(response) {
          if (
            response.data != "ERROR") {
            self.prikazieedata = response.data;
            self.prikaziprogress = false;

          } else {
            self.prikaziprogress = false;
          }
        })
        .catch(function(error) {
          window.console.log(error);
          self.prikaziprogress = false;
        });
    },
    getRI() {
      var self = this;
      self.prikaziprogress = true;

      axios.post(
        'https://calendar.btr-online.ru/GetRINFO',
        JSON.stringify({
          enter: "123",
          inn: self.inn,

        })
      )
        .then(function(response) {
          if (
            response.data != "ERROR") {
            self.RI = response.data;
            self.RIprogress = false;
            if (self.RI.length === 0) {
              self.rizero = true;

            }

          } else {
            self.RIprogress = false;

          }
        })
        .catch(function(error) {
          window.console.log(error);
          self.RIprogress = false;
        });
    },

    girbo() {
      var self = this;
      self.fnsprogress = true;
      axios.post(
        'https://261.рф/girbo',
        JSON.stringify({
          enter: "123",
          inn: self.inn,
        })
      )
        .then(function(response) {
          if (response.data != "ERROR") {
            self.fnsdata.vd = response.data.content[0].okved2.id +" - "+ response.data.content[0].okved2.name;
            self.fnsprogress = false;


          } else {
            self.fnsprogress = false;




          }
        })
        .catch(function(error) {
          window.console.log(error);
          self.fnsprogress = false;
          self.prikazi2();

        });
    },

    egrul() {
      var self = this;
      self.egrulprogress = true;
      axios.post(
        'https://261.рф/egrul',
        JSON.stringify({
          enter: "123",
          inn: self.inn,
        })
      )
        .then(function(response) {
          if (
            response.data != "ERROR") {
            self.egruldata = response.data;
            self.egrulprogress = false;

          } else {

            self.egrulprogress = false;
          }
        })
        .catch(function(error) {
          window.console.log(error);
          self.egrulprogress = false;
        });
    },
    msp() {
      var self = this;
      self.ermspprogress = true;
      axios.post(
        'https://calendar.btr-online.ru/Getmsp',
        JSON.stringify({
          enter: "123",
          inn: self.inn,
        })
      )
        .then(function(response) {


          try {


            if ((response.data !== "ERROR") && (('ERROR' in response.data) == false)) {
              self.mspdata = response.data;
              self.ermspprogress = false;

            } else {
              self.ermspprogress = false;
            }
          }
          catch (error) {
            window.console.log(error);
            self.ermspprogress = false;
          }
        })

    },

    refresh() {
      window.location.reload();
    },
    convertToBoolean(sss) {
      try {
        return JSON.parse(sss.toLowerCase());
      }
      catch (e) {
        return undefined;
      }
    },

    savecookie() {

      this.vd.forEach((item) => {
        this.$cookies.set(item, this[item], 31556926);
      });

    },


    showwidth() {
      return window.document.documentElement.clientWidth
    },


    reportfilter(elem) {
      var result = false;



      for (var i = 2; i < 9; i++) {
        result = result || (((this[this.vd[i]] + 0) + (elem[this.vd[i]] + 0)) === 2)

      }


      if ((this['te'] + 0) === 1) {
        if ((this['tereg'] + 0) === 1) {
          result = result || ((elem['tereg'] + 0) === 1)
        }
        else {
          result = result || ((elem['tenereg'] + 0) === 1)
        }
      }

      if ((this['tn'] + 0) === 1) {
        if ((this['tereg'] + 0) === 1) {
          result = result || (((elem['tereg'] + 0) === 1) && ((elem['tn'] + 0) === 1))
        }
        else {
          result = result || (((elem['tenereg'] + 0) === 1) && ((elem['tn'] + 0) === 1))
        }
      }


      for (var j = 9; j < 19; j++) {

        if ((this[this.vd[j]] + 0) === 1) {
          if (((elem[this.vd[j]] + 0) === 1)) {
            result = result && ((elem[this.vd[j]] + 0) === 1)
          }
          else {
            result = false;
            break;
          }
        }



      }



      return (result)
    },

    calcreports(massiv) {
      let sum = 0

      massiv.forEach((item) => {

        for (var i = 1; i < 13; i++) {
          sum = sum + ((item['MON' + i] !== null) + 0)
        }
        sum = sum + ((item['specdata'] !== null) + 0)

      });

      return sum
    },













    Isnoproblem(str) {
      try {
        str.trim();
      } catch (e) {
        return true;
      }
      return false;
    },

    log(dd) {
      window.console.log(dd)
    },


    getid() {

      var self = this;
      axios.post(
        'https://261.рф/Getpe',
        JSON.stringify({
          enter: "123",
        })
      )
        .then(function(response) {
          if (
            response.data != "ERROR") {
            self.pe = (response.data);
            if (!('hide_industry_benchmarks' in self.pe)) self.$set(self.pe, 'hide_industry_benchmarks', false);
            if (!('show_economy_targets' in self.pe)) self.$set(self.pe, 'show_economy_targets', true);
            if (!('economy_targets_unit' in self.pe)) self.$set(self.pe, 'economy_targets_unit', 'thousand');
            if (!('economy_targets_decimals' in self.pe)) self.$set(self.pe, 'economy_targets_decimals', self.pe.economy_targets_unit === 'million' ? 5 : 2);

          } else {
            window.alert("Код не найден!");
          }
        })
        .catch(function(error) {
          window.console.log(error);
        });

    },
    getfirms() {

      var self = this;
      axios.post(
        'https://calendar.btr-online.ru/Getfirms',
        JSON.stringify({
          enter: "123",
        })
      )
        .then(function(response) {
          if (
            response.data != "ERROR") {
            self.firms = (response.data);

          } else {
            window.alert("Код не найден!");
          }
        })
        .catch(function(error) {
          window.console.log(error);
        });

    },
    getSMETA() {

      var self = this;
      axios.post(
        'https://261.рф/GetSMETA',
        JSON.stringify({
          enter: "123",
        })
      )
        .then(function(response) {
          if (
            response.data != "ERROR") {
            self.smeti = (response.data);

          } else {
            window.alert("Ошибка!");
          }
        })
        .catch(function(error) {
          window.console.log(error);
        });

    },
    getCP() {

      var self = this;
      axios.post(
        'https://261.рф//GetCP',
        JSON.stringify({
          enter: "123",
        })
      )
        .then(function(response) {
          if (
            response.data != "ERROR") {
            self.cps = (response.data);

          } else {
            window.alert("Ошибка!");
          }
        })
        .catch(function(error) {
          window.console.log(error);
        });

    },
    getMER() {

      var self = this;
      axios.post(
        'https://261.рф//GetMER',
        JSON.stringify({
          enter: "123",
        })
      )
        .then(function(response) {
          if (
            response.data != "ERROR") {
            self.mers = (response.data);

          } else {
            window.alert("Ошибка!");
          }
        })
        .catch(function(error) {
          window.console.log(error);
        });

    },




    styleDoc(i, img) {

      return "backgroundImage: url(" + img + "); width: " + 680 * this.zoom[i] / 100 + "px; height: " + 963 * this.zoom[i] / 100 + "px; transform: rotate(" + this.rot[i] + "deg);"
    },
    setBorderWidth() {
      let i = this.$refs.drawer.$el.querySelector(
        ".v-navigation-drawer__border"
      );
      i.style.width = this.navigation.borderSize + "px";
      i.style.cursor = "ew-resize";
    },
    setEvents() {
      const minSize = this.navigation.borderSize;
      const el = this.$refs.drawer.$el;
      const drawerBorder = el.querySelector(".v-navigation-drawer__border");
      const vm = this;
      const direction = el.classList.contains("v-navigation-drawer--right") ?
        "right" :
        "left";

      function resize(e) {
        document.body.style.cursor = "ew-resize";
        let f = direction === "right" ?
          document.body.scrollWidth - e.clientX :
          e.clientX;
        el.style.width = f + "px";
      }

      drawerBorder.addEventListener(
        "mousedown",
        function(e) {
          if (e.offsetX < minSize) {
            ///m_pos = e.x;
            el.style.transition = 'initial';
            document.addEventListener("mousemove", resize, false);
          }
        },
        false
      );

      document.addEventListener(
        "mouseup",
        function() {
          el.style.transition = '';
          vm.navigation.width = el.style.width;
          document.body.style.cursor = "";
          document.removeEventListener("mousemove", resize, false);
        },
        false
      );
    },



  },


  beforeDestroy() {
    if (this.polling) clearInterval(this.polling);
    if (this.peLockPolling) clearInterval(this.peLockPolling);
    window.removeEventListener('pagehide', this.releasePELock);
    window.removeEventListener('beforeunload', this.releasePELock);
    this.releasePELock();
  },

  mounted() {



    this.mounted = true;
    this.khdel= document.getElementById('khd');

    this.getfirms();
    this.getVD();
    this.getTOPL();
    let self = this;
    self.ensurePELockToken();
    window.addEventListener('pagehide', self.releasePELock);
    window.addEventListener('beforeunload', self.releasePELock);

    self.overlayer = true;

    axios.post(
      'https://261.рф/checkkod',
      JSON.stringify({
        enter: "123",
        kod: self.kod

      })
    )
      .then(function(response) {

        if (
          self.Isnoproblem(response.data)) {

            self.acquirePELock()
              .then(function() {
                return self.loadPEFromServer();
              })
              .then(function() {
                self.overlayer = false;
                self.startPELockPolling();
                if (!self.peReadOnly) self.saver();
              })
              .catch(function(error) {
                self.overlayer = false;
                window.console.log(error);
                self.errtext = "Не удалось открыть ПЭ";
                self.snackbarErr = true;
              });









          window.console.log(response.data[0]);


          if (response.data[0]['CHECK'] !== "1") {

            self.overlayer = false;
            self.errtext = "Ошибка! Код не найден.";
            self.snackbarErr = true;


            setTimeout(function() { self.$router.push('/'); }, 3000)

          }
          else {

            self.overlayer = false;
            self.dialogpe = true;


          }

        }
        else {
          self.overlayer = false;
          self.errtext = "Ошибка! Попробуйте повторить позднее.";
          self.snackbarErr = true;
        }

      })

      .catch(function(error) {
        self.overlayer = false;
        window.console.log(error);
      })


      this.$nextTick(function () {
                 window.addEventListener('keyup', event => {
                     if(event.altKey && event.keyCode === 78){

                      this.setform=true;
                     }
                 })
             });





  },

};
</script>
